function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? t(exports, require("@payment/link-monitor")) : "function" == typeof define && define.amd ? define(["exports", "@payment/link-monitor"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).paymentSdkEC1 = {}, e.paymentLinkMonitor);
}(this, function (e, t) {
  "use strict";

  function n(e, t, n, r, o, i, a) {
    try {
      var c = e[i](a),
        s = c.value;
    } catch (e) {
      return void n(e);
    }
    c.done ? t(s) : Promise.resolve(s).then(r, o);
  }
  function r(e) {
    return function () {
      var t = this,
        r = arguments;
      return new Promise(function (o, i) {
        var a = e.apply(t, r);
        function c(e) {
          n(a, o, i, c, s, "next", e);
        }
        function s(e) {
          n(a, o, i, c, s, "throw", e);
        }
        c(void 0);
      });
    };
  }
  function o(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function i(e) {
    return i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, i(e);
  }
  function a(e) {
    var t = function (e, t) {
      if ("object" !== i(e) || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t || "default");
        if ("object" !== i(r)) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === i(t) ? t : String(t);
  }
  function c(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, a(r.key), r);
    }
  }
  function s(e, t, n) {
    return t && c(e.prototype, t), n && c(e, n), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function u(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function l(e, t) {
    return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e;
    }, l(e, t);
  }
  function p(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && l(e, t);
  }
  function d(e, t) {
    if (t && ("object" === i(t) || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return u(e);
  }
  function f(e) {
    return f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, f(e);
  }
  function h(e, t, n) {
    return (t = a(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  var y = {
      exports: {}
    },
    m = {
      exports: {}
    };
  !function (e) {
    function t(n) {
      return e.exports = t = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, e.exports.__esModule = !0, e.exports["default"] = e.exports, t(n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }(m), function (e) {
    var t = m.exports["default"];
    function n() {
      e.exports = n = function n() {
        return r;
      }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
      var r = {},
        o = Object.prototype,
        i = o.hasOwnProperty,
        a = Object.defineProperty || function (e, t, n) {
          e[t] = n.value;
        },
        c = "function" == typeof Symbol ? Symbol : {},
        s = c.iterator || "@@iterator",
        u = c.asyncIterator || "@@asyncIterator",
        l = c.toStringTag || "@@toStringTag";
      function p(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        p({}, "");
      } catch (e) {
        p = function p(e, t, n) {
          return e[t] = n;
        };
      }
      function d(e, t, n, r) {
        var o = t && t.prototype instanceof y ? t : y,
          i = Object.create(o.prototype),
          c = new S(r || []);
        return a(i, "_invoke", {
          value: _(e, n, c)
        }), i;
      }
      function f(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      r.wrap = d;
      var h = {};
      function y() {}
      function m() {}
      function v() {}
      var g = {};
      p(g, s, function () {
        return this;
      });
      var b = Object.getPrototypeOf,
        w = b && b(b(P([])));
      w && w !== o && i.call(w, s) && (g = w);
      var k = v.prototype = y.prototype = Object.create(g);
      function x(e) {
        ["next", "throw", "return"].forEach(function (t) {
          p(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function O(e, n) {
        function r(o, a, c, s) {
          var u = f(e[o], e, a);
          if ("throw" !== u.type) {
            var l = u.arg,
              p = l.value;
            return p && "object" == t(p) && i.call(p, "__await") ? n.resolve(p.__await).then(function (e) {
              r("next", e, c, s);
            }, function (e) {
              r("throw", e, c, s);
            }) : n.resolve(p).then(function (e) {
              l.value = e, c(l);
            }, function (e) {
              return r("throw", e, c, s);
            });
          }
          s(u.arg);
        }
        var o;
        a(this, "_invoke", {
          value: function value(e, t) {
            function i() {
              return new n(function (n, o) {
                r(e, t, n, o);
              });
            }
            return o = o ? o.then(i, i) : i();
          }
        });
      }
      function _(e, t, n) {
        var r = "suspendedStart";
        return function (o, i) {
          if ("executing" === r) throw new Error("Generator is already running");
          if ("completed" === r) {
            if ("throw" === o) throw i;
            return D();
          }
          for (n.method = o, n.arg = i;;) {
            var a = n.delegate;
            if (a) {
              var c = C(a, n);
              if (c) {
                if (c === h) continue;
                return c;
              }
            }
            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if ("suspendedStart" === r) throw r = "completed", n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            r = "executing";
            var s = f(e, t, n);
            if ("normal" === s.type) {
              if (r = n.done ? "completed" : "suspendedYield", s.arg === h) continue;
              return {
                value: s.arg,
                done: n.done
              };
            }
            "throw" === s.type && (r = "completed", n.method = "throw", n.arg = s.arg);
          }
        };
      }
      function C(e, t) {
        var n = t.method,
          r = e.iterator[n];
        if (void 0 === r) return t.delegate = null, "throw" === n && e.iterator["return"] && (t.method = "return", t.arg = void 0, C(e, t), "throw" === t.method) || "return" !== n && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + n + "' method")), h;
        var o = f(r, e.iterator, t.arg);
        if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, h;
        var i = o.arg;
        return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
      }
      function E(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function I(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function S(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(E, this), this.reset(!0);
      }
      function P(e) {
        if (e) {
          var t = e[s];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var n = -1,
              r = function t() {
                for (; ++n < e.length;) {
                  if (i.call(e, n)) return t.value = e[n], t.done = !1, t;
                }
                return t.value = void 0, t.done = !0, t;
              };
            return r.next = r;
          }
        }
        return {
          next: D
        };
      }
      function D() {
        return {
          value: void 0,
          done: !0
        };
      }
      return m.prototype = v, a(k, "constructor", {
        value: v,
        configurable: !0
      }), a(v, "constructor", {
        value: m,
        configurable: !0
      }), m.displayName = p(v, l, "GeneratorFunction"), r.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === m || "GeneratorFunction" === (t.displayName || t.name));
      }, r.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, v) : (e.__proto__ = v, p(e, l, "GeneratorFunction")), e.prototype = Object.create(k), e;
      }, r.awrap = function (e) {
        return {
          __await: e
        };
      }, x(O.prototype), p(O.prototype, u, function () {
        return this;
      }), r.AsyncIterator = O, r.async = function (e, t, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new O(d(e, t, n, o), i);
        return r.isGeneratorFunction(t) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, x(k), p(k, l, "Generator"), p(k, s, function () {
        return this;
      }), p(k, "toString", function () {
        return "[object Generator]";
      }), r.keys = function (e) {
        var t = Object(e),
          n = [];
        for (var r in t) {
          n.push(r);
        }
        return n.reverse(), function e() {
          for (; n.length;) {
            var r = n.pop();
            if (r in t) return e.value = r, e.done = !1, e;
          }
          return e.done = !0, e;
        };
      }, r.values = P, S.prototype = {
        constructor: S,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(I), !e) for (var t in this) {
            "t" === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;
          function n(n, r) {
            return a.type = "throw", a.arg = e, t.next = n, r && (t.method = "next", t.arg = void 0), !!r;
          }
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r],
              a = o.completion;
            if ("root" === o.tryLoc) return n("end");
            if (o.tryLoc <= this.prev) {
              var c = i.call(o, "catchLoc"),
                s = i.call(o, "finallyLoc");
              if (c && s) {
                if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return n(o.finallyLoc);
              } else if (c) {
                if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return n(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var r = this.tryEntries[n];
            if (r.tryLoc <= this.prev && i.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
              var o = r;
              break;
            }
          }
          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, h) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), h;
          }
        },
        "catch": function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.tryLoc === e) {
              var r = n.completion;
              if ("throw" === r.type) {
                var o = r.arg;
                I(n);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: P(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = void 0), h;
        }
      }, r;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }(y);
  var v,
    g,
    b,
    w,
    k,
    x,
    O,
    _,
    C,
    E,
    I,
    S,
    P,
    D,
    j,
    T = y.exports(),
    A = T;
  try {
    regeneratorRuntime = T;
  } catch (e) {
    "object" === ("undefined" == typeof globalThis ? "undefined" : i(globalThis)) ? globalThis.regeneratorRuntime = T : Function("r", "regeneratorRuntime = r")(T);
  }
  function R(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }
    return r;
  }
  function L(e) {
    return function (e) {
      if (Array.isArray(e)) return R(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return R(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? R(e, t) : void 0;
      }
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function N(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function M(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function B(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function F(e, t, n) {
    return t && B(e.prototype, t), n && B(e, n), e;
  }
  function H(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function U(e) {
    return (U = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function V(e, t, n) {
    return (V = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
      var r = function (e, t) {
        for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = U(e));) {
          ;
        }
        return e;
      }(e, t);
      if (r) {
        var o = Object.getOwnPropertyDescriptor(r, t);
        return o.get ? o.get.call(n) : o.value;
      }
    })(e, t, n || e);
  }
  function z(e, t) {
    return (z = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function q(e) {
    return (q = "function" == typeof Symbol && "symbol" == i(Symbol.iterator) ? function (e) {
      return i(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : i(e);
    })(e);
  }
  e.PaymentMethod = void 0, (v = e.PaymentMethod || (e.PaymentMethod = {})).CreditCard = "CreditCard", v.OVO = "OVO", v.FPX = "FPX", function (e) {
    e.OVO = "OVO";
  }(g || (g = {})), function (e) {
    e.Google = "googleFont", e.System = "system";
  }(b || (b = {})), e.ReportUrlType = void 0, (w = e.ReportUrlType || (e.ReportUrlType = {})).Business = "business", w.BuiltIn = "builtIn", function (e) {
    e.CreditCard = "CreditCard", e.Block = "block", e.Simple = "simple", e.Default = "default", e.Form = "form", e.KoreaCard = "KoreaCard";
  }(k || (k = {})), function (e) {
    e.STANDARD_EC = "standard_ec", e.BOGUS_GATEWAY = "bogus_gateway";
  }(x || (x = {})), e.RedirectActionType = void 0, (O = e.RedirectActionType || (e.RedirectActionType = {})).REDIRECT = "REDIRECT", O.OPEN = "OPEN", function (e) {
    e.Redirect = "Redirect", e.Confirm = "Confirm", e.WorldPayGather = "WorldPayGather", e.WorldPayChallenge = "WorldPayChallenge", e.UseepayGather = "UseepayGather", e.UseepayChallenge = "UseepayChallenge", e.Challenge = "Challenge", e.Gather = "Gather", e.ThreeDSChannelProcessing = "ThreeDSChannelProcessing", e.ContinueGetNextAction = "ContinueGetNextAction", e.ChannelInfoUpdate = "ChannelInfoUpdate", e.ChannelConfirm = "ChannelConfirm", e.QrCode = "QrCode";
  }(_ || (_ = {})), function (e) {
    e.Request = "Request";
  }(C || (C = {})), function (e) {
    e.Form = "Form", e.Direct = "Direct", e.Both = "Both";
  }(E || (E = {})), function (e) {
    e.Hidden = "Hidden", e.Visible = "Visible";
  }(I || (I = {})), function (e) {
    e.RenderCode = "RenderCode";
  }(S || (S = {})), function (e) {
    e.GET = "GET", e.POST = "POST";
  }(P || (P = {})), function (e) {
    e.SL_PCI = "sl_pci", e.ADYEN = "adyen";
  }(D || (D = {})), function (e) {
    e.LTR = "ltr", e.RTL = "rtl";
  }(j || (j = {})), "function" != typeof Object.assign && (Object.assign = function (e) {
    for (var t = arguments.length, n = 1; n < t; n++) {
      var r = arguments[n];
      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
      }
    }
    return e;
  });
  var G = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
    W = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
    K = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
    J = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
  function Y(e) {
    return (e && e.message || "No error message").split("\n").filter(function (e) {
      return !!e;
    })[0];
  }
  function X(e) {
    try {
      var t = function (e) {
        if (!e.stack) return null;
        for (var t, n, r = [], o = e.stack.split("\n"), i = 0; i < o.length; ++i) {
          if (t = G.exec(o[i])) n = {
            filename: t[2] && 0 === t[2].indexOf("address at ") ? t[2].substr("address at ".length) : t[2],
            "function": t[1] || "?",
            lineno: t[3] ? +t[3] : null,
            colno: t[4] ? +t[4] : null
          };else if (t = K.exec(o[i])) n = {
            filename: t[2],
            "function": t[1] || "?",
            lineno: +t[3],
            colno: t[4] ? +t[4] : null
          };else {
            if (!(t = W.exec(o[i]))) continue;
            0 !== i || t[5] || void 0 === e.columnNumber || (r[0].column = e.columnNumber + 1), n = {
              filename: t[3],
              "function": t[1] || "?",
              lineno: t[4] ? +t[4] : null,
              colno: t[5] ? +t[5] : null
            };
          }
          !n["function"] && n.lineno && (n["function"] = "?"), r.push(n);
        }
        return r.length ? {
          value: Y(e),
          type: e.name,
          stacktrace: {
            frames: r.reverse()
          }
        } : null;
      }(e);
      if (t) return t;
    } catch (e) {}
    return {
      value: Y(e),
      type: e && e.name,
      stacktrace: {
        frames: []
      }
    };
  }
  var Z = Object.assign || function (e) {
      for (var t = arguments.length, n = 1; n < t; n++) {
        var r = arguments[n];
        for (var o in r) {
          Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
        }
      }
      return e;
    },
    $ = function () {
      function e(t) {
        if (M(this, e), t.dsn) {
          var n = J.exec(t.dsn),
            r = n ? n.slice(1) : [],
            o = r[5].split("/"),
            i = o.slice(0, -1).join("/");
          this.apiUrl = r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (i ? "/" + i : "") + "/api/" + o.pop() + "/store/", this.authHeader = "Sentry sentry_version=7,sentry_key=" + r[1] + (r[2] ? ",sentry_secret=" + r[2] : "");
        }
        this.environment = t.environment;
      }
      return F(e, [{
        key: "prepare",
        value: function value(e) {
          return Z(this.getRequestBlank(), {
            exception: {
              values: [X(e)]
            }
          });
        }
      }, {
        key: "report",
        value: function value(e) {
          this.send(this.prepare(e));
        }
      }, {
        key: "send",
        value: function value(e) {
          if (this.apiUrl) {
            var t = new XMLHttpRequest();
            t.open("POST", this.apiUrl, !0), t.setRequestHeader("Content-type", "application/json"), t.setRequestHeader("X-Sentry-Auth", this.authHeader || ""), t.send(JSON.stringify(e));
          }
        }
      }, {
        key: "getRequestBlank",
        value: function value() {
          return {
            platform: "javascript",
            sdk: {
              name: "micro-sentry.javascript.browser",
              version: "0.0.0"
            },
            timestamp: Date.now() / 1e3,
            request: {
              url: window.location.toString(),
              headers: {
                "User-Agent": window.navigator.userAgent
              }
            },
            environment: this.environment
          };
        }
      }]), e;
    }();
  function Q(e, t) {
    return "[object RegExp]" === Object.prototype.toString.call(t) ? t.test(e) : "string" == typeof t && -1 !== e.indexOf(t);
  }
  function ee(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = U(e);
      if (t) {
        var o = U(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);
      return function (e, t) {
        return !t || "object" !== q(t) && "function" != typeof t ? H(e) : t;
      }(this, n);
    };
  }
  var te = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && z(e, t);
    }(n, $);
    var t = ee(n);
    function n(e) {
      var r;
      M(this, n), (r = t.call(this, e)).options = e, r.destroyed = !1, r._state = {};
      var o = r.options || {},
        i = o.plugins,
        a = void 0 === i ? [] : i,
        c = o.beforeSend,
        s = void 0 === c ? function (e) {
          return e;
        } : c,
        u = o.beforeBreadcrumb,
        l = void 0 === u ? function (e) {
          return e;
        } : u,
        p = o.blacklistUrls,
        d = void 0 === p ? [] : p,
        f = o.ignoreErrors,
        h = void 0 === f ? [] : f,
        y = o.release,
        m = void 0 === y ? void 0 : y;
      return r.plugins = a.map(function (e) {
        return new e(H(r));
      }), r.beforeSend = s, r.beforeBreadcrumb = l, r.blacklistUrls = d, r.ignoreErrors = h, r.release = m, r;
    }
    return F(n, [{
      key: "state",
      get: function get() {
        return this._state;
      }
    }, {
      key: "clearState",
      value: function value() {
        this._state = {};
      }
    }, {
      key: "setTags",
      value: function value(e) {
        return this.setKeyState("tags", Object.assign({}, e)), this;
      }
    }, {
      key: "setTag",
      value: function value(e, t) {
        return this.extendState({
          tags: N({}, e, t)
        }), this;
      }
    }, {
      key: "setExtra",
      value: function value(e, t) {
        return this.extendState({
          extra: N({}, e, t)
        }), this;
      }
    }, {
      key: "setExtras",
      value: function value(e) {
        return this.setKeyState("extra", Object.assign({}, e)), this;
      }
    }, {
      key: "setUser",
      value: function value(e) {
        return this.setKeyState("user", Object.assign({}, e)), this;
      }
    }, {
      key: "clone",
      value: function value() {
        var e = new n(Object.assign(Object.assign({}, this.options), {
          plugins: []
        }));
        return e.extendState(this.state), e;
      }
    }, {
      key: "withScope",
      value: function value(e) {
        var t = this.clone();
        e(t), t.destroy(), this.setBreadcrumbs(void 0);
      }
    }, {
      key: "addBreadcrumb",
      value: function value(e) {
        this.extendState({
          breadcrumbs: [Object.assign({
            timestamp: Date.now() / 1e3
          }, this.beforeBreadcrumb(e))]
        });
      }
    }, {
      key: "setBreadcrumbs",
      value: function value(e) {
        this.setKeyState("breadcrumbs", e);
      }
    }, {
      key: "captureMessage",
      value: function value(e, t) {
        this.send(Object.assign(Object.assign({}, this.getRequestBlank()), {
          message: e,
          level: t
        }));
      }
    }, {
      key: "destroy",
      value: function value() {
        this.destroyed = !0, this.plugins.forEach(function (e) {
          e.destroy && e.destroy();
        });
      }
    }, {
      key: "isIgnoredError",
      value: function value(e) {
        var t = this;
        return !!this.ignoreErrors.length && this.getPossibleEventMessages(e).some(function (e) {
          return t.ignoreErrors.some(function (t) {
            return Q(e, t);
          });
        });
      }
    }, {
      key: "getRequestBlank",
      value: function value() {
        return Object.assign(Object.assign({}, V(U(n.prototype), "getRequestBlank", this).call(this)), this.state);
      }
    }, {
      key: "send",
      value: function value(e) {
        this.destroyed || this.isDeniedUrl(e) || this.isIgnoredError(e) || (V(U(n.prototype), "send", this).call(this, this.beforeSend(Object.assign({
          release: this.release
        }, e))), this.setBreadcrumbs(void 0));
      }
    }, {
      key: "getPossibleEventMessages",
      value: function value(e) {
        if (e.message) return [e.message];
        if (e.exception) try {
          var t = e.exception.values && e.exception.values[0] || {},
            n = t.type,
            r = void 0 === n ? "" : n,
            o = t.value,
            i = void 0 === o ? "" : o;
          return ["".concat(i), "".concat(r, ": ").concat(i)];
        } catch (e) {
          return [];
        }
        return [];
      }
    }, {
      key: "isDeniedUrl",
      value: function value(e) {
        if (!this.blacklistUrls.length) return !1;
        var t = this.getEventFilterUrl(e);
        return !!t && this.blacklistUrls.some(function (e) {
          return Q(t, e);
        });
      }
    }, {
      key: "getEventFilterUrl",
      value: function value(e) {
        try {
          if (e.exception) {
            var t = e.exception.values && e.exception.values[0].stacktrace && e.exception.values[0].stacktrace.frames;
            return t && t[t.length - 1].filename || null;
          }
          return null;
        } catch (e) {
          return null;
        }
      }
    }, {
      key: "extendState",
      value: function value(e) {
        var t = this;
        this._state = Object.keys(e).reduce(function (n, r) {
          var o = t.state[r],
            i = Array.isArray(o) ? o : null,
            a = e[r],
            c = Array.isArray(a) ? a : null;
          return Object.assign(Object.assign({}, n), N({}, r, i || c ? [].concat(L(i || []), L(c || [])) : Object.assign(Object.assign({}, "string" != typeof o ? o : {}), "string" != typeof a ? a : {})));
        }, {});
      }
    }, {
      key: "setKeyState",
      value: function value(e, t) {
        this._state[e] = t;
      }
    }]), n;
  }();
  function ne(e, t, n) {
    var r = e[t],
      o = n(r);
    if ("function" == typeof o) try {
      o.prototype = o.prototype || {}, Object.defineProperties(o, {
        __original__: {
          enumerable: !1,
          value: r
        }
      });
    } catch (e) {}
    e[t] = o;
  }
  function re(e) {
    if (!e) return {};
    var t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!t) return {};
    var n = t[6] || "",
      r = t[8] || "";
    return {
      host: t[4],
      path: t[5],
      protocol: t[2],
      relative: t[5] + n + r
    };
  }
  function oe() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    return "Request" in window && e[0] instanceof Request && e[0].method ? String(e[0].method).toUpperCase() : e[1] && e[1].method ? String(e[1].method).toUpperCase() : "GET";
  }
  function ie() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    return "string" == typeof e[0] ? e[0] : "Request" in window && e[0] instanceof Request ? e[0].url : String(e[0]);
  }
  function ae(e) {
    return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
  }
  function ce(e) {
    var t = e,
      n = [];
    if (!t || !t.tagName) return "";
    n.push(t.tagName.toLowerCase()), t.id && n.push("#".concat(t.id));
    var r = t.className;
    if (r && "string" == typeof r) {
      var o = r.split(/\s+/);
      n.concat(o.map(function (e) {
        return ".".concat(e);
      }));
    }
    return ["type", "name", "title", "alt", "automation-id"].forEach(function (e) {
      var r = t.getAttribute(e);
      r && n.push("[".concat(e, '="').concat(r, '"]'));
    }), n.join("");
  }
  function se(e) {
    try {
      for (var t, n = e, r = [], o = 0, i = 0, a = " > ".length; n && o++ < 5 && !("html" === (t = ce(n)) || o > 1 && i + r.length * a + t.length >= 80);) {
        r.push(t), i += t.length, n = n.parentNode;
      }
      return r.reverse().join(" > ");
    } catch (e) {
      return "<unknown>";
    }
  }
  function ue(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
    return Array.isArray(e) ? e.map(function (e) {
      try {
        return String(e);
      } catch (e) {
        return "";
      }
    }).filter(function (e) {
      return "" !== e;
    }).join(t) : "";
  }
  function le(e, t, n, r, o, i, a) {
    try {
      var c = e[i](a),
        s = c.value;
    } catch (e) {
      return void n(e);
    }
    c.done ? t(s) : Promise.resolve(s).then(r, o);
  }
  function pe(e) {
    return function () {
      var t = this,
        n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);
        function a(e) {
          le(i, r, o, a, c, "next", e);
        }
        function c(e) {
          le(i, r, o, a, c, "throw", e);
        }
        a(void 0);
      });
    };
  }
  function de(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function fe(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function he(e, t, n) {
    return t && fe(e.prototype, t), n && fe(e, n), e;
  }
  function ye(e, t) {
    return (ye = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function me(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && ye(e, t);
  }
  function ve(e) {
    return (ve = "function" == typeof Symbol && "symbol" == i(Symbol.iterator) ? function (e) {
      return i(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : i(e);
    })(e);
  }
  function ge(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function be(e, t) {
    return !t || "object" !== ve(t) && "function" != typeof t ? ge(e) : t;
  }
  function we(e) {
    return (we = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function ke(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  !function () {
    function e(t) {
      M(this, e), this.client = t, this.subscriptions = [], this.initDOM(), this.initConsole(), this.initFetch(), this.initHistory(), this.initXHR();
    }
    F(e, [{
      key: "initXHR",
      value: function value() {
        if ("XMLHttpRequest" in window) {
          var e = this,
            t = XMLHttpRequest.prototype;
          ne(t, "open", function (t) {
            return function () {
              for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
                r[o] = arguments[o];
              }
              var i = this,
                a = r[1];
              i.__sentry_xhr__ = {
                method: "string" == typeof r[0] ? r[0].toUpperCase() : r[0],
                url: r[1]
              }, "string" == typeof a && "POST" === i.__sentry_xhr__.method && a.match(/sentry_key/) && (i.__sentry_own_request__ = !0);
              var c = function c() {
                if (4 === i.readyState) {
                  try {
                    i.__sentry_xhr__ && (i.__sentry_xhr__.status_code = i.status);
                  } catch (e) {}
                  e.xhrBreadcrumb({
                    args: r,
                    endTimestamp: Date.now(),
                    startTimestamp: Date.now(),
                    xhr: i
                  });
                }
              };
              return "onreadystatechange" in i && "function" == typeof i.onreadystatechange ? ne(i, "onreadystatechange", function (e) {
                return function () {
                  c();
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                    n[r] = arguments[r];
                  }
                  e.apply(i, n);
                };
              }) : i.addEventListener("readystatechange", c), t.apply(i, r);
            };
          }), ne(t, "send", function (t) {
            return function () {
              for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
                r[o] = arguments[o];
              }
              return e.xhrBreadcrumb({
                args: r,
                startTimestamp: Date.now(),
                xhr: this
              }), t.apply(this, r);
            };
          });
        }
      }
    }, {
      key: "initHistory",
      value: function value() {
        var e = this,
          t = window.onpopstate;
        function n(t) {
          return function () {
            for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
              r[o] = arguments[o];
            }
            var i = r.length > 2 ? r[2] : void 0;
            if (i) {
              var a = e.lastHref,
                c = String(i);
              e.lastHref = c, e.historyBreadcrumb({
                from: a,
                to: c
              });
            }
            return t.apply(this, r);
          };
        }
        window.onpopstate = function () {
          var n = window.location.href,
            r = e.lastHref;
          if (e.lastHref = n, e.historyBreadcrumb({
            from: r,
            to: n
          }), t) {
            for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++) {
              i[a] = arguments[a];
            }
            return t.apply(this, i);
          }
        }, ne(window.history, "pushState", n), ne(window.history, "replaceState", n);
      }
    }, {
      key: "destroy",
      value: function value() {
        this.subscriptions.forEach(function (e) {
          return e();
        });
      }
    }, {
      key: "initDOM",
      value: function value() {
        var e = this,
          t = function t(_t2) {
            return e.prepareDomEvent("click", _t2);
          },
          n = function n(t) {
            return e.prepareDomEvent("keypress", t);
          };
        window.document.addEventListener("click", t, !1), window.document.addEventListener("keypress", n, !1), this.subscriptions.push(function () {
          window.document.removeEventListener("click", t, !1), window.document.removeEventListener("keypress", n, !1);
        });
      }
    }, {
      key: "prepareDomEvent",
      value: function value(e, t) {
        var n;
        try {
          n = t.target ? se(t.target) : se(t);
        } catch (e) {
          n = "<unknown>";
        }
        0 !== n.length && this.client.addBreadcrumb({
          category: "ui.".concat(e),
          message: n
        });
      }
    }, {
      key: "initFetch",
      value: function value() {
        var e = this;
        (function () {
          if (!function () {
            if (!("fetch" in window)) return !1;
            try {
              return new Headers(), new Request(""), new Response(), !0;
            } catch (e) {
              return !1;
            }
          }()) return !1;
          if (ae(window.fetch)) return !0;
          var e = !1,
            t = window.document;
          if (t && "function" == typeof t.createElement) try {
            var n = t.createElement("iframe");
            n.sandbox.add("allow-scripts"), n.sandbox.add("allow-same-origin"), n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = ae(n.contentWindow.fetch)), t.head.removeChild(n);
          } catch (e) {}
          return e;
        })() && ne(window, "fetch", function (t) {
          return function () {
            for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
              r[o] = arguments[o];
            }
            var i = {
              args: r,
              fetchData: {
                method: oe(r),
                url: ie(r)
              },
              startTimestamp: Date.now()
            };
            return e.fetchBreadcrumb(Object.assign({}, i)), t.apply(window, r).then(function (t) {
              return e.fetchBreadcrumb(Object.assign(Object.assign({}, i), {
                endTimestamp: Date.now(),
                response: t
              })), t;
            }, function (t) {
              throw e.fetchBreadcrumb(Object.assign(Object.assign({}, i), {
                endTimestamp: Date.now(),
                error: t
              })), t;
            });
          };
        });
      }
    }, {
      key: "fetchBreadcrumb",
      value: function value(e) {
        e.endTimestamp && (e.fetchData.url.match(/sentry_key/) && "POST" === e.fetchData.method || (e.error ? this.client.addBreadcrumb({
          category: "fetch",
          data: e.fetchData,
          level: "error",
          type: "http"
        }) : this.client.addBreadcrumb({
          category: "fetch",
          data: Object.assign(Object.assign({}, e.fetchData), {
            status_code: e.response.status
          }),
          type: "http"
        })));
      }
    }, {
      key: "xhrBreadcrumb",
      value: function value(e) {
        if (e.endTimestamp) {
          if (e.xhr.__sentry_own_request__) return;
          this.client.addBreadcrumb({
            category: "xhr",
            data: e.xhr.__sentry_xhr__,
            type: "http"
          });
        }
      }
    }, {
      key: "initConsole",
      value: function value() {
        var e = this;
        ["debug", "info", "warn", "error", "log", "assert"].forEach(function (t) {
          t in window[window.__sl_console__ ? "__sl_console__" : "console"] && ne(window[window.__sl_console__ ? "__sl_console__" : "console"], t, function (n) {
            return function () {
              for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
                o[i] = arguments[i];
              }
              var a = {
                category: "console",
                data: {
                  arguments: o.map(function (e) {
                    try {
                      return JSON.stringify(e), e;
                    } catch (t) {
                      return Object.prototype.toString.call(e);
                    }
                  }),
                  logger: "console"
                },
                level: t,
                message: ue(o, " ")
              };
              if ("assert" === t) {
                if (!1 !== o[0]) return;
                a.message = "Assertion failed: ".concat(ue(o.slice(1), " ") || "console.assert"), a.data.arguments = o.slice(1);
              }
              e.client.addBreadcrumb(a), n && Function.prototype.apply.call(n, window[window.__sl_console__ ? "__sl_console__" : "console"], o);
            };
          });
        });
      }
    }, {
      key: "historyBreadcrumb",
      value: function value(e) {
        var t = e.from,
          n = e.to,
          r = re(window.location.href),
          o = re(t),
          i = re(n);
        o.path || (o = r), r.protocol === i.protocol && r.host === i.host && (n = i.relative), r.protocol === o.protocol && r.host === o.host && (t = o.relative), this.client.addBreadcrumb({
          category: "navigation",
          data: {
            from: t,
            to: n
          }
        });
      }
    }]);
  }();
  var xe = {
    exports: {}
  };
  !function (e) {
    var t = function (e) {
      var t,
        n = Object.prototype,
        r = n.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        a = o.iterator || "@@iterator",
        c = o.asyncIterator || "@@asyncIterator",
        s = o.toStringTag || "@@toStringTag";
      function u(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        u({}, "");
      } catch (e) {
        u = function u(e, t, n) {
          return e[t] = n;
        };
      }
      function l(e, t, n, r) {
        var o = t && t.prototype instanceof v ? t : v,
          i = Object.create(o.prototype),
          a = new P(r || []);
        return i._invoke = function (e, t, n) {
          var r = d;
          return function (o, i) {
            if (r === h) throw new Error("Generator is already running");
            if (r === y) {
              if ("throw" === o) throw i;
              return j();
            }
            for (n.method = o, n.arg = i;;) {
              var a = n.delegate;
              if (a) {
                var c = E(a, n);
                if (c) {
                  if (c === m) continue;
                  return c;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (r === d) throw r = y, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = h;
              var s = p(e, t, n);
              if ("normal" === s.type) {
                if (r = n.done ? y : f, s.arg === m) continue;
                return {
                  value: s.arg,
                  done: n.done
                };
              }
              "throw" === s.type && (r = y, n.method = "throw", n.arg = s.arg);
            }
          };
        }(e, n, a), i;
      }
      function p(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      e.wrap = l;
      var d = "suspendedStart",
        f = "suspendedYield",
        h = "executing",
        y = "completed",
        m = {};
      function v() {}
      function g() {}
      function b() {}
      var w = {};
      w[a] = function () {
        return this;
      };
      var k = Object.getPrototypeOf,
        x = k && k(k(D([])));
      x && x !== n && r.call(x, a) && (w = x);
      var O = b.prototype = v.prototype = Object.create(w);
      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          u(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function C(e, t) {
        function n(o, a, c, s) {
          var u = p(e[o], e, a);
          if ("throw" !== u.type) {
            var l = u.arg,
              d = l.value;
            return d && "object" == i(d) && r.call(d, "__await") ? t.resolve(d.__await).then(function (e) {
              n("next", e, c, s);
            }, function (e) {
              n("throw", e, c, s);
            }) : t.resolve(d).then(function (e) {
              l.value = e, c(l);
            }, function (e) {
              return n("throw", e, c, s);
            });
          }
          s(u.arg);
        }
        var o;
        this._invoke = function (e, r) {
          function i() {
            return new t(function (t, o) {
              n(e, r, t, o);
            });
          }
          return o = o ? o.then(i, i) : i();
        };
      }
      function E(e, n) {
        var r = e.iterator[n.method];
        if (r === t) {
          if (n.delegate = null, "throw" === n.method) {
            if (e.iterator["return"] && (n.method = "return", n.arg = t, E(e, n), "throw" === n.method)) return m;
            n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return m;
        }
        var o = p(r, e.iterator, n.arg);
        if ("throw" === o.type) return n.method = "throw", n.arg = o.arg, n.delegate = null, m;
        var i = o.arg;
        return i ? i.done ? (n[e.resultName] = i.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, m) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, m);
      }
      function I(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function S(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function P(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(I, this), this.reset(!0);
      }
      function D(e) {
        if (e) {
          var n = e[a];
          if (n) return n.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var o = -1,
              i = function n() {
                for (; ++o < e.length;) {
                  if (r.call(e, o)) return n.value = e[o], n.done = !1, n;
                }
                return n.value = t, n.done = !0, n;
              };
            return i.next = i;
          }
        }
        return {
          next: j
        };
      }
      function j() {
        return {
          value: t,
          done: !0
        };
      }
      return g.prototype = O.constructor = b, b.constructor = g, g.displayName = u(b, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, b) : (e.__proto__ = b, u(e, s, "GeneratorFunction")), e.prototype = Object.create(O), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, _(C.prototype), C.prototype[c] = function () {
        return this;
      }, e.AsyncIterator = C, e.async = function (t, n, r, o, i) {
        void 0 === i && (i = Promise);
        var a = new C(l(t, n, r, o), i);
        return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, _(O), u(O, s, "Generator"), O[a] = function () {
        return this;
      }, O.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];
        for (var n in e) {
          t.push(n);
        }
        return t.reverse(), function n() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return n.value = r, n.done = !1, n;
          }
          return n.done = !0, n;
        };
      }, e.values = D, P.prototype = {
        constructor: P,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(S), !e) for (var n in this) {
            "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var n = this;
          function o(r, o) {
            return c.type = "throw", c.arg = e, n.next = r, o && (n.method = "next", n.arg = t), !!o;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
              c = a.completion;
            if ("root" === a.tryLoc) return o("end");
            if (a.tryLoc <= this.prev) {
              var s = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");
              if (s && u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (s) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];
            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), S(n), m;
          }
        },
        "catch": function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.tryLoc === e) {
              var r = n.completion;
              if ("throw" === r.type) {
                var o = r.arg;
                S(n);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, n, r) {
          return this.delegate = {
            iterator: D(e),
            resultName: n,
            nextLoc: r
          }, "next" === this.method && (this.arg = t), m;
        }
      }, e;
    }(e.exports);
    try {
      regeneratorRuntime = t;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(t);
    }
  }(xe);
  var Oe,
    _e,
    Ce,
    Ee,
    Ie = xe.exports;
  function Se(e, t, n) {
    return (Se = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && ye(o, n.prototype), o;
    }).apply(null, arguments);
  }
  function Pe(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (Pe = function Pe(e) {
      if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
      var n;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, r);
      }
      function r() {
        return Se(e, arguments, we(this).constructor);
      }
      return r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), ye(r, e);
    })(e);
  }
  function De(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = we(e);
      if (t) {
        var o = we(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);
      return be(this, n);
    };
  }
  !function (e) {
    e.NotSupportBrowser = "1026", e.InnerSDKError = "1027", e.RenderFail = "1028", e.NetworkError = "1109", e.FrequentRequest = "1904", e.AbnormalTrade = "4205";
  }(Oe || (Oe = {})), function (e) {
    e.AbnormalTrade = "TRANSACTION_ABNORMAL", e.NetworkError = "Network error";
  }(_e || (_e = {})), function (e) {
    e.Fatal = "fatal", e.Error = "error";
  }(Ce || (Ce = {})), function (e) {
    e.IframeError = "PciIframeError", e.NoDom = "NoDomError";
  }(Ee || (Ee = {}));
  var je = function (e) {
      me(n, Pe(Error));
      var t = De(n);
      function n(e) {
        var r,
          o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Oe.InnerSDKError,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "UnknownError",
          a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Ce.Error;
        return de(this, n), ke(ge(r = t.call(this, e)), "code", void 0), ke(ge(r), "isReported", !1), ke(ge(r), "data", void 0), ke(ge(r), "errorLevel", void 0), r.name = i, r.code = o, r.errorLevel = a, r;
      }
      return he(n, [{
        key: "setIsReported",
        value: function value() {
          this.isReported = !0;
        }
      }]), n;
    }(),
    Te = function (e) {
      me(n, je);
      var t = De(n);
      function n(e) {
        var r,
          o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Oe.InnerSDKError,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "SilenceError",
          a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Ce.Error;
        return de(this, n), ke(ge(r = t.call(this, e, o, i, a)), "statusCode", void 0), r;
      }
      return n;
    }();
  function Ae(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Re(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ae(Object(n), !0).forEach(function (t) {
        ke(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ae(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var Le = new te({
    dsn: "https://820fe9124d6a4b4d8ef0ee1e44a29c4b@sentry-new.myshopline.com/305",
    release: "3.6.1",
    environment: "production",
    beforeSend: function beforeSend(e) {
      return e;
    }
  });
  function Ne(e, t) {
    var n = JSON.stringify(Re(Re({}, e || {}), {}, {
        originErrorMessage: null == t ? void 0 : t.message,
        originErrorData: t ? JSON.stringify(t) : void 0,
        errorLevel: (null == t ? void 0 : t.errorLevel) || (null == e ? void 0 : e.errorLevel) || Ce.Error
      })),
      r = new Error(n);
    if (null != t && t.stack) try {
      r.stack = t.stack;
    } catch (e) {
      Le.report(e), Le.report(t);
    }
    Le.report(r);
  }
  function Me(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10;
    return e ? function (e, t) {
      for (var n = "", r = 0; r < t; r++) {
        n += e;
      }
      return n;
    }("*", t) + e.slice(t) : e;
  }
  function Be(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Fe(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Be(Object(n), !0).forEach(function (t) {
        ke(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Be(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var He,
    Ue,
    Ve,
    ze,
    qe = new t.Monitor("webpaymentsdk"),
    Ge = function () {
      function e() {
        de(this, e);
      }
      return he(e, null, [{
        key: "init",
        value: function value(e) {
          qe.init({
            projectName: "pcisdk",
            environment: "production",
            version: "3.6.1"
          }, e.eventTrackingConfig), Le.setTag("pvId", t.pvId);
        }
      }, {
        key: "setHost",
        value: function value(e) {
          Le.setTag("host", e);
        }
      }, {
        key: "reportError",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "report_error",
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          e instanceof Te || e.name === Ee.IframeError || (e instanceof je ? e.isReported || (Ne(Fe({
            eventName: t
          }, n), e), e.setIsReported()) : Ne(Fe({
            eventName: t
          }, n), e));
        }
      }, {
        key: "handleError",
        value: function value(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "pci_sdk_default_error",
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (e.reportData(n, Fe(Fe({}, t), r)), e.reportError(t, n, r), t instanceof Te || t instanceof je) throw t;
          var o = "".concat(n, " ").concat(t.message || "pci sdk inner error"),
            i = new Te(o);
          throw i.statusCode = t.statusCode, i.name = t.name || "Error", i.code = t.code || i.code, i.errorLevel = t.errorLevel || Ce.Error, i.data = Fe({
            code: Oe.InnerSDKError,
            msg: o
          }, t.data || {}), i;
        }
      }, {
        key: "formatReportData",
        value: function value(e) {
          if (!e) return {};
          var t = Fe({}, e);
          return t.customerToken && (t.customerToken = Me(t.customerToken, 30)), t.payToken && (t.payToken = Me(t.payToken, 10)), t;
        }
      }, {
        key: "reportData",
        value: function value(t, n) {
          try {
            qe.report(t, n ? {
              extraData: JSON.stringify(n)
            } : {});
          } catch (r) {
            e.reportError(r, "".concat(t, "_report_data_error"), n);
          }
        }
      }, {
        key: "reportErrorData",
        value: function value(t, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Ce.Error;
          e.reportData(t, n), Ne(Fe({
            eventName: t,
            errorLevel: r
          }, n));
        }
      }]), e;
    }();
  !function (e) {
    e.Redirect = "Redirect", e.Confirm = "Confirm", e.QrCode = "QrCode", e.WorldPayGather = "WorldPayGather", e.ExchangeTicket = "ExchangeTicket";
  }(He || (He = {})), function (e) {
    e.Success = "success", e.Fail = "fail";
  }(Ue || (Ue = {})), function (e) {
    e.Number = "number", e.Cvc = "cvc", e.FirstName = "firstName", e.ExpDate = "expDate";
  }(Ve || (Ve = {})), function (e) {
    e.Hidden = "hidden-iframe", e.Cache = "cache-iframe";
  }(ze || (ze = {})), Ve.Number, Ve.Cvc, Ve.ExpDate;
  var We,
    Ke,
    Je,
    Ye,
    Xe = [Ve.Number, Ve.Cvc, Ve.ExpDate, Ve.FirstName];
  function Ze(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function $e(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ze(Object(n), !0).forEach(function (t) {
        ke(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ze(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  !function (e) {
    e.CN = "CN";
  }(We || (We = {})), function (e) {
    e.SL2 = "shopline2", e.SLP = "slp";
  }(Ke || (Ke = {})), function (e) {
    e.validate = "getValidate", e.pay = "pay", e.getBeforePayData = "getBeforePayData", e.getCardToken = "getCardToken", e.updateCardToken = "updateCardToken", e.getCurrentCardInfo = "getCurrentCardInfo", e.getCardTokenInfoByCardToken = "getCardTokenInfoByCardToken";
  }(Je || (Je = {})), function (e) {
    e.validate = "validate", e.pay = "payResult", e.getBeforePayData = "getBeforePayData", e.getCardToken = "cardTokenResult", e.updateCardToken = "updateCardTokenResult", e.getCurrentCardInfo = "cardInfoResult", e.getCardTokenInfoByCardToken = "getCardTokenInfoByCardTokenResult";
  }(Ye || (Ye = {}));
  var Qe = function () {
      function e(n) {
        var r = this,
          o = n.uuid,
          i = n.host,
          a = n.channelId,
          c = n.env,
          s = n.receiveMessageHandler;
        de(this, e), ke(this, "uuid", void 0), ke(this, "iframeHost", "https://cashiers.myshopline.com"), ke(this, "isDev", !1), ke(this, "env", void 0), ke(this, "config", {}), ke(this, "channelId", void 0), ke(this, "mainIframe", Ve.Number), ke(this, "receiveMessageHandler", void 0), ke(this, "onIframeLoaded", function (e) {
          var n = e.name,
            o = e.mainIframe,
            i = e.displayFieldNames,
            a = r.config.placeholder;
          r.postToIframe(n, "initData", {
            pvId: t.pvId,
            env: r.env,
            mainIframe: o,
            displayFieldNames: i,
            parentUrl: window.location.href,
            parentOrigin: window.location.origin,
            channelId: r.channelId
          }), a && a[n] && r.postToIframe(n, "setAttr", {
            attr: {
              placeholder: a[n]
            }
          });
        }), this.uuid = o, this.channelId = a, this.env = c, this.receiveMessageHandler = s, i && !this.isDev && (this.iframeHost = i);
      }
      return he(e, [{
        key: "setConfig",
        value: function value(e) {
          this.config = e;
        }
      }, {
        key: "setIframeStatus",
        value: function value(e) {
          this.mainIframe = e.mainIframe;
        }
      }, {
        key: "handleApi",
        value: function value(e, t, n) {
          var r = this,
            o = Je[e];
          return Ge.reportData("pci_sdk_".concat(o, "_start"), {
            eventData: null != t && t.nextAction ? $e($e({}, t), {}, {
              nextAction: Ge.formatReportData(t.nextAction)
            }) : t
          }), new Promise(function (n, i) {
            r.receiveMessageHandler.setApiHandlerMap(e, n, i), r.postToMainIframe(o, t);
          }).then(function (e) {
            var t = n ? n(e) : {
              result: e
            };
            return Ge.reportData("pci_sdk_".concat(o, "_end"), t), e;
          })["catch"](function (e) {
            return Ge.handleError(e, "pci_sdk_".concat(o, "_error"));
          });
        }
      }, {
        key: "handleApiWithKey",
        value: function value(e, t, n) {
          var r = this,
            o = Je[e];
          return Ge.reportData("pci_sdk_".concat(o, "_start"), {
            eventData: t ? t("") : void 0
          }), new Promise(function (n, i) {
            var a = r.receiveMessageHandler.setApiHandlerMapWithKey(e, n, i),
              c = t ? t(a) : void 0;
            r.postToMainIframe(o, c);
          }).then(function (e) {
            var t = e.key,
              r = e.result,
              i = n ? n({
                key: t,
                result: r
              }) : {
                key: t,
                result: r
              };
            return Ge.reportData("pci_sdk_".concat(o, "_end"), i), r;
          })["catch"](function (e) {
            return Ge.handleError(e, "pci_sdk_".concat(o, "_error"));
          });
        }
      }, {
        key: "postToMainIframe",
        value: function value(e, t) {
          this.postToIframe(this.mainIframe, e, t);
        }
      }, {
        key: "postToIframe",
        value: function value(e, t, n) {
          var r,
            o = $e({
              eventType: t,
              uuid: this.uuid
            }, n || {}),
            i = "".concat(e).concat(this.uuid);
          (null === (r = window.frames[i]) || void 0 === r ? void 0 : r.postMessage) && window.frames[i].postMessage(o, this.iframeHost);
        }
      }]), e;
    }(),
    et = function () {
      var e = pe(Ie.mark(function e(t) {
        return Ie.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", new Promise(function (e) {
                  setTimeout(function () {
                    e();
                  }, t);
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    tt = function () {
      function e(t) {
        var n = t.uuid,
          r = t.host,
          o = t.receiveMessageHandler,
          i = t.cdn;
        de(this, e), ke(this, "uuid", void 0), ke(this, "iframePath", "https://cashiers.myshopline.com/pci-sdk"), ke(this, "innerDisplayIframeNames", []), ke(this, "cdn", void 0), ke(this, "renderIframeDomMap", {}), ke(this, "innerMainIframe", Ve.Number), ke(this, "receiveMessageHandler", void 0), ke(this, "destroyed", !1), ke(this, "isDev", !1), this.uuid = n, this.receiveMessageHandler = o, r && !this.isDev && (this.iframePath = "".concat(r, "/pci-sdk")), this.cdn = i, this.createCacheIframe();
      }
      var t;
      return he(e, [{
        key: "displayIframeNames",
        get: function get() {
          return this.innerDisplayIframeNames;
        }
      }, {
        key: "mainIframe",
        get: function get() {
          return this.innerMainIframe;
        }
      }, {
        key: "mountIframe",
        value: function value(e, t, n, r) {
          if (!e) throw new je("Can't find the related dom node to mount the iframe", Oe.InnerSDKError, Ee.NoDom);
          var o = document.createElement("iframe");
          o.onload = r, o.src = n, o.name = t, o.id = t, o.style.width = "100%", o.style.height = "100%", o.style.border = "none", e.innerHTML = "", e.appendChild(o);
        }
      }, {
        key: "getIframeLink",
        value: function value(e) {
          var t = this.isDev ? "" : "v".concat("3.6.1".split(".")[0], "/");
          return "".concat(this.iframePath, "/").concat(t, "iframe").concat(this.cdn === We.CN ? "-oss" : "", ".html#name=").concat(e, "&uuid=").concat(this.uuid);
        }
      }, {
        key: "createHiddenMountDom",
        value: function value(e) {
          var t = document.createElement("div");
          return t.setAttribute("data-pci", e), t.setAttribute("style", "display: none !important"), t.hidden = !0, document.body.appendChild(t), t;
        }
      }, {
        key: "doRenderIframe",
        value: function value(e, t) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
          this.destroyed || e.forEach(function (e) {
            n.mountIframe(n.renderIframeDomMap[e], "".concat(e).concat(n.uuid), n.getIframeLink(e), function () {
              return t({
                name: e,
                mainIframe: n.innerMainIframe,
                displayFieldNames: r
              });
            });
          });
        }
      }, {
        key: "createHiddenIframeDom",
        value: function value(e) {
          var t = ze.Hidden,
            n = this.createHiddenMountDom(t);
          this.innerDisplayIframeNames.push(t), this.renderIframeDomMap[t] = n, this.innerMainIframe = t, this.doRenderIframe(this.innerDisplayIframeNames, e), this.startIframeReloadTiming(e);
        }
      }, {
        key: "createCacheIframe",
        value: function value() {
          var e = ze.Cache,
            t = document.querySelector("div[data-pci=".concat(e, "]"));
          if (!t || !t.querySelector("iframe[id=".concat(e, "]"))) {
            var n = this.createHiddenMountDom(e);
            this.mountIframe(n, e, this.getIframeLink(e), function () {
              Ge.reportData("pci_sdk_cache_iframe_onload");
            });
          }
        }
      }, {
        key: "renderIframe",
        value: function value(e, t) {
          var n = this,
            r = [];
          if (e.querySelectorAll("[data-pci]").forEach(function (e, t) {
            var o = e.getAttribute("data-pci");
            0 !== t && o !== Ve.Number || (n.innerMainIframe = o), Xe.indexOf(o) > -1 && (n.innerDisplayIframeNames.push(o), n.renderIframeDomMap[o] = e, r.push(o));
          }), 0 === this.innerDisplayIframeNames.length) throw new je("Can't find any dom node to mount the iframe", Oe.InnerSDKError, Ee.NoDom);
          this.doRenderIframe(this.innerDisplayIframeNames, t, r), this.startIframeReloadTiming(t, r);
        }
      }, {
        key: "startIframeReloadTiming",
        value: (t = pe(Ie.mark(function e(t) {
          var n,
            r,
            o,
            i,
            a,
            c = this,
            s = arguments;
          return Ie.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  n = s.length > 1 && void 0 !== s[1] ? s[1] : [], r = 3, o = Ie.mark(function e(o) {
                    var i, a;
                    return Ie.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            if (!c.destroyed) {
                              e.next = 2;
                              break;
                            }
                            return e.abrupt("return", {
                              v: void 0
                            });
                          case 2:
                            return e.next = 4, et(15e3);
                          case 4:
                            if (!c.destroyed) {
                              e.next = 6;
                              break;
                            }
                            return e.abrupt("return", {
                              v: void 0
                            });
                          case 6:
                            if (i = c.receiveMessageHandler.getIframeLoadedStatus(), a = Object.keys(i).filter(function (e) {
                              return !i[e];
                            }), Ge.reportData("pci_sdk_check_iframe_status", {
                              loadFailIframeNames: a
                            }), a.length) {
                              e.next = 13;
                              break;
                            }
                            return e.abrupt("return", {
                              v: void 0
                            });
                          case 13:
                            if (!(o < r - 1)) {
                              e.next = 19;
                              break;
                            }
                            Ge.reportData("pci_sdk_reload_iframe"), a.forEach(function (e) {
                              var t = c.renderIframeDomMap[e];
                              t && (t.innerHTML = "");
                            }), c.doRenderIframe(a, t, n), e.next = 23;
                            break;
                          case 19:
                            return c.unmountIframe(), c.receiveMessageHandler.triggerEvent("onError", {}), Ge.reportError(new Error("failed to load iframe"), "pci_sdk_load_iframe_failed"), e.abrupt("return", {
                              v: void 0
                            });
                          case 23:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }), i = 0;
                case 4:
                  if (!(i < r)) {
                    e.next = 12;
                    break;
                  }
                  return e.delegateYield(o(i), "t0", 6);
                case 6:
                  if ("object" !== ve(a = e.t0)) {
                    e.next = 9;
                    break;
                  }
                  return e.abrupt("return", a.v);
                case 9:
                  i++, e.next = 4;
                  break;
                case 12:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function (e) {
          return t.apply(this, arguments);
        })
      }, {
        key: "unmountDom",
        value: function value(e) {
          if (e) {
            var t = this.renderIframeDomMap[e];
            t && (Ge.reportData("pci_sdk_unmount_dom", {
              name: e
            }), e === ze.Hidden ? t.parentNode.removeChild(t) : t.innerHTML = "", this.renderIframeDomMap[e] = null);
          }
        }
      }, {
        key: "unmountIframe",
        value: function value() {
          var e = this;
          Ge.reportData("pci_sdk_unmount_iframe"), this.innerDisplayIframeNames.forEach(function (t) {
            return e.unmountDom(t);
          });
        }
      }, {
        key: "destroy",
        value: function value() {
          this.destroyed = !0, this.unmountIframe();
        }
      }]), e;
    }();
  function nt(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  var rt,
    ot,
    it = function () {
      function e(t) {
        var n,
          r = this;
        de(this, e), ke(this, "uuid", void 0), ke(this, "config", void 0), ke(this, "iframeLoaded", {}), ke(this, "ApiHandlerMap", {}), ke(this, "ReceiveMessageHandler", (ke(n = {
          loadFinished: function loadFinished(e) {
            r.iframeLoaded[e.name] = !0, Ge.reportData("pci_sdk_iframe_loadFinished", e), Object.keys(r.iframeLoaded).every(function (e) {
              return r.iframeLoaded[e];
            }) && (Ge.reportData("pci_sdk_onInit"), r.triggerEvent("onInit", {}));
          },
          focus: function focus(e) {
            r.triggerEvent("onFocus", {
              fieldName: e.name,
              isEmpty: e.isEmpty,
              isFocus: e.isFocus
            });
          },
          input: function input(e) {
            r.triggerEvent("onFieldValidChange", {
              fieldName: e.name,
              isValid: e.isValid,
              isEmpty: e.isEmpty
            });
          },
          cardBinChange: function cardBinChange(e) {
            r.triggerEvent("onCardBinChange", e.value);
          }
        }, Ye.validate, function (e) {
          Ge.reportData("pci_sdk_validate_credit_card_cache", e.reportData), r.resolveApiHandler("validate", e.isValid);
        }), ke(n, Ye.pay, function (e) {
          Ge.reportData("pci_sdk_pay_credit_card_cache", e.reportData), e.status === Ue.Success ? r.resolveApiHandler("pay", e.value) : r.rejectApiHandler("pay", e.value);
        }), ke(n, Ye.getBeforePayData, function (e) {
          r.resolveApiHandler("getBeforePayData", e.value);
        }), ke(n, Ye.getCardToken, function (e) {
          var t = (e.extraOptions || {}).key;
          t && (e.status === Ue.Success ? r.resolveApiHandlerWithKey("getCardToken", e.value, t) : r.rejectApiHandlerWithKey("getCardToken", e.value, t));
        }), ke(n, Ye.updateCardToken, function (e) {
          var t = (e.extraOptions || {}).key;
          t && (e.status === Ue.Success ? r.resolveApiHandlerWithKey("updateCardToken", e.value, t) : r.rejectApiHandlerWithKey("updateCardToken", e.value, t));
        }), ke(n, Ye.getCardTokenInfoByCardToken, function (e) {
          var t = (e.extraOptions || {}).key;
          t && (e.status === Ue.Success ? r.resolveApiHandlerWithKey("getCardTokenInfoByCardToken", e.value, t) : r.rejectApiHandlerWithKey("getCardTokenInfoByCardToken", e.value, t));
        }), ke(n, Ye.getCurrentCardInfo, function (e) {
          e.status === Ue.Success ? r.resolveApiHandler("getCurrentCardInfo", e.value) : r.rejectApiHandler("getCurrentCardInfo", e.value);
        }), n)), this.uuid = t;
      }
      return he(e, [{
        key: "init",
        value: function value(e, t) {
          var n = this;
          this.config = t, e.forEach(function (e) {
            return n.iframeLoaded[e] = !1;
          }), this.listenMessage();
        }
      }, {
        key: "getIframeLoadedStatus",
        value: function value() {
          return function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? nt(Object(n), !0).forEach(function (t) {
                ke(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nt(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }({}, this.iframeLoaded);
        }
      }, {
        key: "listenMessage",
        value: function value() {
          var e = this;
          window.addEventListener("message", function (t) {
            var n = t.data,
              r = n.uuid,
              o = n.eventType;
            r === e.uuid && e.ReceiveMessageHandler[o] && e.ReceiveMessageHandler[o](t.data);
          });
        }
      }, {
        key: "setApiHandlerMap",
        value: function value(e, t, n) {
          this.ApiHandlerMap[e] = {
            resolve: t,
            reject: n
          };
        }
      }, {
        key: "setApiHandlerMapWithKey",
        value: function value(e, t, n) {
          var r = (new Date().getTime() + Math.floor(Math.random() * Math.pow(10, 13))).toString();
          return this.ApiHandlerMap[e] || (this.ApiHandlerMap[e] = {}), this.ApiHandlerMap[e][r] = {
            resolve: t,
            reject: n
          }, r;
        }
      }, {
        key: "resolveApiHandler",
        value: function value(e, t) {
          var n;
          (null === (n = this.ApiHandlerMap[e]) || void 0 === n ? void 0 : n.resolve) && this.ApiHandlerMap[e].resolve(t);
        }
      }, {
        key: "rejectApiHandler",
        value: function value(e, t) {
          var n;
          (null === (n = this.ApiHandlerMap[e]) || void 0 === n ? void 0 : n.reject) && this.ApiHandlerMap[e].reject(t);
        }
      }, {
        key: "resolveApiHandlerWithKey",
        value: function value(e, t, n) {
          var r, o;
          null !== (r = this.ApiHandlerMap[e]) && void 0 !== r && null !== (o = r[n]) && void 0 !== o && o.resolve && (this.ApiHandlerMap[e][n].resolve({
            key: n,
            result: t
          }), delete this.ApiHandlerMap[e][n]);
        }
      }, {
        key: "rejectApiHandlerWithKey",
        value: function value(e, t, n) {
          var r, o;
          null !== (r = this.ApiHandlerMap[e]) && void 0 !== r && null !== (o = r[n]) && void 0 !== o && o.reject && (this.ApiHandlerMap[e][n].reject(t), delete this.ApiHandlerMap[e][n]);
        }
      }, {
        key: "triggerEvent",
        value: function value(e, t) {
          try {
            this.config[e] && this.config[e](t);
          } catch (n) {
            Ge.handleError(n, "pci_sdk_triggerEvent_".concat(e, "_error"), t);
          }
        }
      }]), e;
    }();
  !function (e) {
    e.Test1 = "test1", e.Test2 = "test2", e.Test3 = "test3", e.Alpha = "alpha", e.Prod = "prod";
  }(rt || (rt = {}));
  var at = (ke(ot = {}, rt.Test1, {
    host: "https://cashiers-test1.myshoplinestg.com"
  }), ke(ot, rt.Test2, {
    host: "https://cashiers-test2.myshoplinestg.com"
  }), ke(ot, rt.Test3, {
    host: "https://cashiers-test3.myshoplinestg.com"
  }), ke(ot, rt.Alpha, {
    host: "https://cashiers-alpha.myshopline.com"
  }), ke(ot, rt.Prod, {
    host: "https://cashiers.myshopline.com"
  }), ot);
  function ct(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function st(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ct(Object(n), !0).forEach(function (t) {
        ke(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ct(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var ut = function () {
    function e(t) {
      de(this, e), ke(this, "apiInstance", void 0), ke(this, "iframeInstance", void 0), ke(this, "receiveMessageInstance", void 0), ke(this, "cardToken", void 0), ke(this, "config", void 0), this.initReporter(t);
      try {
        var n;
        Ge.reportData("pci_sdk_constructor_start", Ge.formatReportData(t));
        var r = (null === (n = at[t.env]) || void 0 === n ? void 0 : n.host) || "";
        Ge.setHost(r);
        var o = (i = new Date().getTime(), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
          var t = (i + 16 * Math.random()) % 16 | 0;
          return i = Math.floor(i / 16), ("x" === e ? t : 3 & t | 8).toString(16);
        }));
        this.cardToken = t.cardToken, this.receiveMessageInstance = new it(o), this.apiInstance = new Qe({
          uuid: o,
          host: r,
          channelId: null == t ? void 0 : t.channelId,
          env: t.env,
          receiveMessageHandler: this.receiveMessageInstance
        }), this.iframeInstance = new tt({
          uuid: o,
          host: r,
          receiveMessageHandler: this.receiveMessageInstance,
          cdn: t.cdn
        }), Ge.reportData("pci_sdk_constructor_end");
      } catch (e) {
        Ge.handleError(e, "pci_sdk_constructor_error");
      }
      var i;
    }
    var t;
    return he(e, [{
      key: "initReporter",
      value: function value(e) {
        try {
          Ge.init(e);
        } catch (e) {
          Ge.handleError(e, "pci_sdk_init_reporter_error");
        }
      }
    }, {
      key: "update",
      value: (t = pe(Ie.mark(function e() {
        var t,
          n = arguments;
        return Ie.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                t = n.length > 0 && void 0 !== n[0] ? n[0] : {}, Ge.reportData("pci_sdk_update_start", Ge.formatReportData(t)), t.cardToken && (this.cardToken = t.cardToken), Ge.reportData("pci_sdk_update_end");
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "setConfig",
      value: function value(e) {
        this.apiInstance.setConfig(e);
      }
    }, {
      key: "getCardToken",
      value: function value(e) {
        return this.apiInstance.handleApiWithKey("getCardToken", function (t) {
          return {
            options: e,
            extraOptions: {
              key: t
            }
          };
        }, function (t) {
          var n = t.key,
            r = t.result;
          return st(st({}, e), {}, {
            token: (r.token || "").slice(-6),
            key: n
          });
        });
      }
    }, {
      key: "checkCardToken",
      value: function value() {
        if (!this.cardToken) return Ge.handleError(new je("Empty CardToken", Oe.InnerSDKError, "EmptyCardToken"), "pci_sdk_getCardTokenInfoByCardToken_empty_cardToken_error");
      }
    }, {
      key: "getCardTokenInfoByCardToken",
      value: function value(e) {
        var t = this;
        return this.checkCardToken(), this.apiInstance.handleApiWithKey("getCardTokenInfoByCardToken", function (n) {
          return {
            options: st(st({}, e), {}, {
              token: t.cardToken
            }),
            extraOptions: {
              key: n
            }
          };
        }, function (t) {
          var n = t.key,
            r = t.result;
          return st(st({}, e), {}, {
            token: Me(r.token),
            key: n
          });
        });
      }
    }, {
      key: "pay",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return this.apiInstance.handleApi("pay", {
          nextAction: e,
          requestParams: st(st({}, t), {}, {
            cardToken: this.cardToken
          })
        });
      }
    }, {
      key: "destroy",
      value: function value() {
        try {
          Ge.reportData("pci_sdk_destroy_start"), this.iframeInstance.destroy(), Ge.reportData("pci_sdk_destroy_end");
        } catch (e) {
          Ge.handleError(e, "pci_sdk_destroy_error");
        }
      }
    }]), e;
  }();
  var lt = function (e) {
    me(n, ut);
    var t = function (e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = we(e);
        if (t) {
          var o = we(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return be(this, n);
      };
    }(n);
    function n() {
      return de(this, n), t.apply(this, arguments);
    }
    return he(n, [{
      key: "create",
      value: function value(e) {
        try {
          Ge.reportData("api_only_pci_sdk_create_start"), this.config = e, this.setConfig(e), this.iframeInstance.createHiddenIframeDom(this.apiInstance.onIframeLoaded), this.receiveMessageInstance.init(this.iframeInstance.displayIframeNames, this.config), this.apiInstance.setIframeStatus({
            mainIframe: this.iframeInstance.mainIframe
          }), Ge.reportData("api_only_pci_sdk_create_end");
        } catch (e) {
          Ge.handleError(e, "api_only_pci_sdk_create_error");
        }
      }
    }]), n;
  }();
  function pt(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function dt(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? pt(Object(n), !0).forEach(function (t) {
        ke(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pt(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var ft = function (e) {
    me(r, ut);
    var t,
      n = function (e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var n,
            r = we(e);
          if (t) {
            var o = we(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);
          return be(this, n);
        };
      }(r);
    function r() {
      return de(this, r), n.apply(this, arguments);
    }
    return he(r, [{
      key: "create",
      value: function value(e) {
        try {
          Ge.reportData("pci_sdk_create_start", {
            config: e
          }), this.config = e, this.apiInstance.setConfig(e), Ge.reportData("pci_sdk_create_end");
        } catch (e) {
          Ge.handleError(e, "pci_sdk_create_error");
        }
      }
    }, {
      key: "mount",
      value: function value(e) {
        try {
          Ge.reportData("pci_sdk_mount_start");
          var t = "string" == typeof e ? document.querySelector(e) : e;
          if (!t) throw new je("Can't find the mount dom", Oe.InnerSDKError, Ee.NoDom);
          this.iframeInstance.renderIframe(t, this.apiInstance.onIframeLoaded), this.receiveMessageInstance.init(this.iframeInstance.displayIframeNames, this.config), this.apiInstance.setIframeStatus({
            mainIframe: this.iframeInstance.mainIframe
          }), Ge.reportData("pci_sdk_mount_end", {
            displayIframeNames: this.iframeInstance.displayIframeNames,
            mainIframe: this.iframeInstance.mainIframe
          });
        } catch (e) {
          Ge.handleError(e, "pci_sdk_mount_error");
        }
      }
    }, {
      key: "setStyle",
      value: function value(e) {
        try {
          Ge.reportData("pci_sdk_setStyle_start", {
            params: e
          });
          var t = e.type,
            n = e.fieldName,
            r = e.style;
          this.apiInstance.postToIframe(n, "setStyle", {
            style: r,
            type: t
          }), Ge.reportData("pci_sdk_setStyle_end");
        } catch (e) {
          Ge.handleError(e, "pci_sdk_setStyle_error");
        }
      }
    }, {
      key: "validate",
      value: function value(e) {
        return this.apiInstance.handleApi("validate", {
          validateItems: e
        });
      }
    }, {
      key: "getBeforePayData",
      value: function value(e) {
        return this.apiInstance.handleApi("getBeforePayData", {
          nextAction: e
        });
      }
    }, {
      key: "updateCardToken",
      value: function value(e) {
        var t = this;
        return this.checkCardToken(), this.apiInstance.handleApiWithKey("updateCardToken", function (n) {
          return {
            options: dt(dt({}, e), {}, {
              token: t.cardToken
            }),
            extraOptions: {
              key: n
            }
          };
        }, function (t) {
          var n = t.key,
            r = t.result;
          return dt(dt({}, e), {}, {
            token: Me(r.token),
            key: n
          });
        }).then(function (e) {
          return t.cardToken = e.token, Ge.reportData("pci_sdk_updateCardToken_update_token"), e;
        });
      }
    }, {
      key: "getCurrentCardInfo",
      value: (t = pe(Ie.mark(function e() {
        return Ie.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.apiInstance.handleApi("getCurrentCardInfo"));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }]), r;
  }();
  function ht(e, t, n, r, o, i, a) {
    try {
      var c = e[i](a),
        s = c.value;
    } catch (e) {
      return void n(e);
    }
    c.done ? t(s) : Promise.resolve(s).then(r, o);
  }
  function yt(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  ke(ft, "ApiOnly", lt);
  var mt = {};
  !function (e) {
    var t = function (e) {
      var t,
        n = Object.prototype,
        r = n.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        a = o.iterator || "@@iterator",
        c = o.asyncIterator || "@@asyncIterator",
        s = o.toStringTag || "@@toStringTag";
      function u(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        u({}, "");
      } catch (e) {
        u = function u(e, t, n) {
          return e[t] = n;
        };
      }
      function l(e, t, n, r) {
        var o = t && t.prototype instanceof v ? t : v,
          i = Object.create(o.prototype),
          a = new P(r || []);
        return i._invoke = function (e, t, n) {
          var r = d;
          return function (o, i) {
            if (r === h) throw new Error("Generator is already running");
            if (r === y) {
              if ("throw" === o) throw i;
              return j();
            }
            for (n.method = o, n.arg = i;;) {
              var a = n.delegate;
              if (a) {
                var c = E(a, n);
                if (c) {
                  if (c === m) continue;
                  return c;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (r === d) throw r = y, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = h;
              var s = p(e, t, n);
              if ("normal" === s.type) {
                if (r = n.done ? y : f, s.arg === m) continue;
                return {
                  value: s.arg,
                  done: n.done
                };
              }
              "throw" === s.type && (r = y, n.method = "throw", n.arg = s.arg);
            }
          };
        }(e, n, a), i;
      }
      function p(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      e.wrap = l;
      var d = "suspendedStart",
        f = "suspendedYield",
        h = "executing",
        y = "completed",
        m = {};
      function v() {}
      function g() {}
      function b() {}
      var w = {};
      u(w, a, function () {
        return this;
      });
      var k = Object.getPrototypeOf,
        x = k && k(k(D([])));
      x && x !== n && r.call(x, a) && (w = x);
      var O = b.prototype = v.prototype = Object.create(w);
      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          u(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function C(e, t) {
        function n(o, a, c, s) {
          var u = p(e[o], e, a);
          if ("throw" !== u.type) {
            var l = u.arg,
              d = l.value;
            return d && "object" == i(d) && r.call(d, "__await") ? t.resolve(d.__await).then(function (e) {
              n("next", e, c, s);
            }, function (e) {
              n("throw", e, c, s);
            }) : t.resolve(d).then(function (e) {
              l.value = e, c(l);
            }, function (e) {
              return n("throw", e, c, s);
            });
          }
          s(u.arg);
        }
        var o;
        this._invoke = function (e, r) {
          function i() {
            return new t(function (t, o) {
              n(e, r, t, o);
            });
          }
          return o = o ? o.then(i, i) : i();
        };
      }
      function E(e, n) {
        var r = e.iterator[n.method];
        if (r === t) {
          if (n.delegate = null, "throw" === n.method) {
            if (e.iterator["return"] && (n.method = "return", n.arg = t, E(e, n), "throw" === n.method)) return m;
            n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return m;
        }
        var o = p(r, e.iterator, n.arg);
        if ("throw" === o.type) return n.method = "throw", n.arg = o.arg, n.delegate = null, m;
        var i = o.arg;
        return i ? i.done ? (n[e.resultName] = i.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, m) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, m);
      }
      function I(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function S(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function P(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(I, this), this.reset(!0);
      }
      function D(e) {
        if (e) {
          var n = e[a];
          if (n) return n.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var o = -1,
              i = function n() {
                for (; ++o < e.length;) {
                  if (r.call(e, o)) return n.value = e[o], n.done = !1, n;
                }
                return n.value = t, n.done = !0, n;
              };
            return i.next = i;
          }
        }
        return {
          next: j
        };
      }
      function j() {
        return {
          value: t,
          done: !0
        };
      }
      return g.prototype = b, u(O, "constructor", b), u(b, "constructor", g), g.displayName = u(b, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, b) : (e.__proto__ = b, u(e, s, "GeneratorFunction")), e.prototype = Object.create(O), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, _(C.prototype), u(C.prototype, c, function () {
        return this;
      }), e.AsyncIterator = C, e.async = function (t, n, r, o, i) {
        void 0 === i && (i = Promise);
        var a = new C(l(t, n, r, o), i);
        return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, _(O), u(O, s, "Generator"), u(O, a, function () {
        return this;
      }), u(O, "toString", function () {
        return "[object Generator]";
      }), e.keys = function (e) {
        var t = [];
        for (var n in e) {
          t.push(n);
        }
        return t.reverse(), function n() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return n.value = r, n.done = !1, n;
          }
          return n.done = !0, n;
        };
      }, e.values = D, P.prototype = {
        constructor: P,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(S), !e) for (var n in this) {
            "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var n = this;
          function o(r, o) {
            return c.type = "throw", c.arg = e, n.next = r, o && (n.method = "next", n.arg = t), !!o;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
              c = a.completion;
            if ("root" === a.tryLoc) return o("end");
            if (a.tryLoc <= this.prev) {
              var s = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");
              if (s && u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (s) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];
            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), S(n), m;
          }
        },
        "catch": function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.tryLoc === e) {
              var r = n.completion;
              if ("throw" === r.type) {
                var o = r.arg;
                S(n);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, n, r) {
          return this.delegate = {
            iterator: D(e),
            resultName: n,
            nextLoc: r
          }, "next" === this.method && (this.arg = t), m;
        }
      }, e;
    }(mt);
    try {
      regeneratorRuntime = t;
    } catch (e) {
      "object" == ("undefined" == typeof globalThis ? "undefined" : i(globalThis)) ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
    }
  }();
  var vt,
    gt = mt;
  !function (e) {
    e.Google = "googleFont", e.ShopLine = "slFont", e.System = "system";
  }(vt || (vt = {}));
  var bt = ["Helvetica Neue", "Arial", "sans-serif"];
  !function () {
    var e, t, n, r;
    e = function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : vt.System,
        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : bt;
      (function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      })(this, e), yt(this, "fontLib", void 0), yt(this, "fontFamily", void 0), this.fontLib = t, this.fontFamily = n;
    }, (t = [{
      key: "setFontFamily",
      value: (n = gt.mark(function e(t) {
        var n;
        return gt.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.fontLib !== vt.Google) {
                  e.next = 5;
                  break;
                }
                return e.next = 3, this.injectGoogleFontCss();
              case 3:
                e.next = 8;
                break;
              case 5:
                if (this.fontLib !== vt.ShopLine) {
                  e.next = 8;
                  break;
                }
                return e.next = 8, this.injectSLPFontCss();
              case 8:
                n = t.getAttribute("style") || "", t.setAttribute("style", "".concat(n, "font-family:").concat(this.fontFamily.join(",")));
              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      }), r = function r() {
        var e = this,
          t = arguments;
        return new Promise(function (r, o) {
          var i = n.apply(e, t);
          function a(e) {
            ht(i, r, o, a, c, "next", e);
          }
          function c(e) {
            ht(i, r, o, a, c, "throw", e);
          }
          a(void 0);
        });
      }, function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "injectCss",
      value: function value(e) {
        var t = document.getElementsByTagName("head")[0],
          n = document.createElement("link");
        return n.rel = "stylesheet", n.href = e, t.appendChild(n), new Promise(function (t, r) {
          n.onerror = function () {
            r({
              message: "inject css failed",
              url: e
            });
          }, n.onload = function () {
            t();
          };
        });
      }
    }, {
      key: "injectGoogleFontCss",
      value: function value() {
        var e = this.fontFamily.map(function (e) {
          return "family=".concat(e.replace(/\s/g, "+"));
        });
        return this.injectCss("https://fonts.googleapis.com/css?".concat(e.join("&"), "&display=swap"));
      }
    }, {
      key: "injectSLPFontCss",
      value: function value() {
        var e = this,
          t = this.fontFamily.map(function (t) {
            return e.injectCss("https://cdn-theme.myshopline.com/cdn/shop/fonts/".concat(t, ".css"));
          });
        return Promise.all(t);
      }
    }]) && function (e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }(e.prototype, t), Object.defineProperty(e, "prototype", {
      writable: !1
    });
  }();
  var wt = "en",
    kt = "SLPayments",
    xt = [Ve.Number, Ve.FirstName, Ve.ExpDate, Ve.Cvc],
    Ot = function Ot(e) {
      return e ? xt.filter(function (e) {
        return e !== Ve.FirstName;
      }) : xt;
    };
  function _t(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }
    return r;
  }
  function Ct(e, t) {
    if (e) {
      if ("string" == typeof e) return _t(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _t(e, t) : void 0;
    }
  }
  function Et(e) {
    return function (e) {
      if (Array.isArray(e)) return _t(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || Ct(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function It(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  var St,
    Pt,
    Dt = {
      splitReg: "!\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
      matchReg: /!\[([^\]]+)\]\(([^)]+)\)/,
      replaceReg: "(!\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
    },
    jt = {
      splitReg: "\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
      matchReg: /\[([^\]]+)\]\(([^)]+)\)/,
      replaceReg: "(\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
    },
    Tt = {
      splitReg: "\\\\?\\*\\\\?\\*[^\\s]+\\\\?\\*\\\\?\\*",
      matchReg: /\*\*([^\s]+)\*\*/,
      replaceReg: "\\\\\\*\\\\\\*([^\\s]+)\\\\\\*\\\\\\*"
    },
    At = function At(e) {
      return {
        tagName: e,
        content: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
        property: arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}
      };
    },
    Rt = function Rt(e, t, n, r) {
      return t + (n ? n.slice(1) : "") + r;
    },
    Lt = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), It(this, "handleStrong", function (e, t) {
          var n = t.match(e);
          return At("strong", n[1]);
        }), It(this, "handleStrongReplace", function (e, t) {
          var n = t.replace(new RegExp(e, "g"), "**$1**");
          return At("text", n);
        });
      }
      var t;
      return (t = [{
        key: "parseToTagConfig",
        value: function value(e) {
          var t = this,
            n = [],
            r = jt,
            o = Dt,
            i = Tt;
          if (!e || 0 !== e.indexOf("$RT$")) return [At("text", e)];
          e = e.slice("$RT$".length);
          var a = "(".concat(o.splitReg, ")|(").concat(r.splitReg, ")|(").concat(i.splitReg, ")");
          return e.split(new RegExp(a)).filter(function (e) {
            return !!e;
          }).forEach(function (e) {
            var a;
            if (new RegExp(o.matchReg).test(e)) {
              var c = e.match(o.matchReg);
              a = At("img", "", {
                alt: c[1],
                src: c[2]
              });
            } else if (new RegExp(r.matchReg).test(e)) {
              var s = e.match(r.matchReg);
              a = At("a", s[1], {
                href: s[2],
                target: "_blank"
              });
            } else if (i.matchReg.test(e)) a = t.handleStrong(i.matchReg, e);else if (new RegExp(o.replaceReg).test(e)) {
              var u = e.replace(new RegExp(o.replaceReg, "g"), Rt);
              a = At("text", u);
            } else if (new RegExp(r.replaceReg).test(e)) {
              var l = e.replace(new RegExp(r.replaceReg, "g"), Rt);
              a = At("text", l);
            } else a = new RegExp(i.replaceReg).test(e) ? t.handleStrongReplace(i.replaceReg, e) : At("text", e);
            n.push(a);
          }), n;
        }
      }, {
        key: "parseToDom",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
            n = document.createElement(t);
          return e.forEach(function (e) {
            var t = document.createElement("text" === e.tagName ? "span" : e.tagName);
            t.textContent = e.content, e.property && Object.keys(e.property).forEach(function (n) {
              return t.setAttribute(n, e.property[n]);
            }), n.appendChild(t);
          }), n;
        }
      }, {
        key: "autoParseToDom",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
            n = this.parseToTagConfig(e);
          return this.parseToDom(n, t);
        }
      }]) && function (e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }(e.prototype, t), e;
    }(),
    Nt = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM9.45298 7.94043C8.86649 8.2889 8.60666 8.62269 8.59923 9.33797C8.59563 9.68549 8.31985 9.94303 7.89582 9.94303C7.49737 9.94303 7.1924 9.68549 7.1924 9.33797C7.19612 8.05414 7.54504 7.66166 8.16865 7.27285C8.62522 6.98674 8.97785 6.66762 8.97785 6.1871C8.97785 5.67724 8.57325 5.34712 8.07214 5.34712C7.58587 5.34712 7.15624 5.63856 7.11445 6.26413C7.0902 6.62714 6.78059 6.98126 6.35721 6.98126C5.93369 6.98126 5.59998 6.61104 5.59998 6.26413C5.59998 4.80823 6.73212 4.09998 8.07956 4.09998C9.55321 4.09998 10.6 4.84826 10.6 6.13208C10.6 6.99407 10.1471 7.53328 9.45298 7.94043ZM7.92373 12.4033C8.39886 12.4033 8.81089 12.0109 8.8146 11.523C8.81089 11.0425 8.39886 10.65 7.92373 10.65C7.43375 10.65 7.02915 11.0425 7.03286 11.523C7.02915 12.0109 7.43375 12.4033 7.92373 12.4033Z" fill="currentColor"/></svg>',
    Mt = '\n<svg width="200" height="113" viewBox="0 0 200 113" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M151 70.0171C151 67.5027 152.704 66 154.704 66C156.703 66 158.407 67.5027 158.407 70.0171C158.407 70.9936 157.942 71.9062 157.125 72.6701C156.29 73.4516 155.231 73.9322 154.406 74.0565C153.427 74.204 152.704 75.0447 152.704 76.0342V78.6658C152.704 79.7705 153.599 80.6667 154.704 80.6667C155.808 80.6667 156.704 79.7712 156.704 78.6666V77.558C157.829 77.1301 158.932 76.4571 159.857 75.5915C161.269 74.2717 162.407 72.3637 162.407 70.0171C162.407 65.3862 159.004 62 154.704 62C150.403 62 147 65.3862 147 70.0171C147 71.1217 147.895 72.0171 149 72.0171C150.105 72.0171 151 71.1217 151 70.0171Z" fill="currentColor"/>\n<path d="M154.5 88C155.881 88 157 86.8807 157 85.5C157 84.1193 155.881 83 154.5 83C153.119 83 152 84.1193 152 85.5C152 86.8807 153.119 88 154.5 88Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M25 13.219C25 12.1144 25.8954 11.219 27 11.219H64.022C68.8042 11.219 73.3899 13.122 76.7669 16.508L90.3001 30.0773H154.24C159.763 30.0773 164.24 34.5544 164.24 40.0773V54.2006L172.334 56.0079C173.248 56.2119 173.898 57.0229 173.898 57.9595L173.9 69.8512C173.9 72.8249 173.9 75.7995 173.9 78.0324C173.9 79.1488 173.9 80.0799 173.899 80.7328L173.899 81.6964L173.898 81.7537L173.898 81.777L173.898 81.7984L173.897 81.8294C173.896 81.8515 173.887 81.9744 173.874 82.0747C173.866 82.125 173.856 82.175 173.844 82.2246C171.338 92.7681 161.454 97.3662 157.263 98.8897C155.45 99.549 153.511 99.4864 151.773 98.8716C150.089 98.2761 148.567 97.6263 147.191 96.9382H69.4814C63.9586 96.9382 59.4814 92.4611 59.4814 86.9382V66.8548H54.4261C50.2409 66.8548 46.2278 65.1894 43.2723 62.2261C41.0674 60.0152 38.0732 58.7727 34.9508 58.7727H28.791C27.6864 58.7727 26.791 57.8773 26.791 56.7727C26.791 55.6681 27.6864 54.7727 28.791 54.7727H34.9508C39.1359 54.7727 43.1491 56.4381 46.1045 59.4014C48.3095 61.6123 51.3036 62.8548 54.4261 62.8548H59.4814V52.1721C53.7323 50.0648 49.6299 44.5436 49.6299 38.0642C49.6299 36.9596 50.5253 36.0642 51.6299 36.0642C52.7345 36.0642 53.6299 36.9596 53.6299 38.0642C53.6299 44.151 58.5642 49.0854 64.6511 49.0854H69.9975C72.4759 49.0854 74.8529 50.0697 76.6057 51.8219L82.4235 57.6377C84.0397 59.2533 86.2314 60.1609 88.5166 60.1609C91.465 60.1609 92.9414 56.5958 90.8561 54.5113L67.5836 31.2469C66.8024 30.4659 66.8022 29.1996 67.5831 28.4184C68.364 27.6372 69.6303 27.637 70.4115 28.4179L72.0714 30.0773H84.6508L73.9347 19.3327C71.3081 16.6991 67.7415 15.219 64.022 15.219H27C25.8954 15.219 25 14.3236 25 13.219ZM141.086 92.9382C139.585 91.6448 138.415 90.3244 137.505 89.0513C136.653 87.8588 136.041 86.7235 135.602 85.7129H63.4814V86.9382C63.4814 90.2519 66.1677 92.9382 69.4814 92.9382H141.086ZM134.495 81.7129C134.481 81.5365 134.48 81.3835 134.48 81.2737V71.3447H63.4814V81.7129H134.495ZM134.48 67.3447V57.96C134.48 57.0176 135.138 56.2031 136.059 56.0048L152.379 52.4923C153.791 52.1884 155.252 52.194 156.662 52.5087L160.24 53.3075V40.0773C160.24 36.7636 157.553 34.0773 154.24 34.0773H76.0728L93.6841 51.6824C98.2898 56.2866 95.029 64.1609 88.5166 64.1609C85.1707 64.1609 81.9619 62.832 79.5956 60.4666L73.7778 54.6508C72.7751 53.6485 71.4153 53.0854 69.9975 53.0854H64.6511C64.2575 53.0854 63.8674 53.0702 63.4814 53.0405V67.3447H134.48ZM169.898 59.5625L155.791 56.4126C154.945 56.2238 154.068 56.2204 153.221 56.4028L138.48 59.5754V81.2737C138.48 81.3715 138.482 81.396 138.483 81.4037C138.525 81.8111 138.835 84.0307 140.76 86.7262C142.673 89.4047 146.275 92.684 153.107 95.1005C154.053 95.4352 155.034 95.4443 155.897 95.1305C159.872 93.6852 167.813 89.7797 169.899 81.5182L169.899 80.7311C169.9 80.0789 169.9 79.1483 169.9 78.032C169.9 75.7996 169.9 72.8252 169.9 69.8515L169.898 59.5625Z" fill="currentColor"/>\n</svg>\n',
    Bt = '<svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.23682 1.5L4.73682 5L8.23682 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
    Ft = (h(St = {}, k.CreditCard, {
      inputBackground: "#fff",
      formItemGutter: "12px",
      inputHeight: "46px",
      cardNumberIconSvg: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99998 2.70002C6.70211 2.70002 5.64998 3.75216 5.64998 5.05002V5.79999H10.35V5.05002C10.35 3.75216 9.29784 2.70002 7.99998 2.70002ZM4.34998 5.05002V5.79999H4C2.89543 5.79999 2 6.69542 2 7.79999V12.8C2 13.9046 2.89543 14.8 4 14.8H12C13.1046 14.8 14 13.9046 14 12.8V7.79999C14 6.69542 13.1046 5.79999 12 5.79999H11.65V5.05002C11.65 3.03418 10.0158 1.40002 7.99998 1.40002C5.98414 1.40002 4.34998 3.03418 4.34998 5.05002ZM4 7.09999H12C12.3866 7.09999 12.7 7.41339 12.7 7.79999V12.8C12.7 13.1866 12.3866 13.5 12 13.5H4C3.6134 13.5 3.3 13.1866 3.3 12.8V7.79999C3.3 7.41339 3.6134 7.09999 4 7.09999ZM8.59998 10.5395C8.9587 10.332 9.20005 9.94419 9.20005 9.49999C9.20005 8.83725 8.66279 8.29999 8.00005 8.29999C7.33731 8.29999 6.80005 8.83725 6.80005 9.49999C6.80005 9.94413 7.04134 10.3319 7.39998 10.5394V11.9C7.39998 12.2314 7.6686 12.5 7.99998 12.5C8.33135 12.5 8.59998 12.2314 8.59998 11.9V10.5395Z" fill="currentColor"/></svg>',
      holderNameIconSvg: Nt,
      securityCodeIconSvg: Nt,
      inputBorderColor: "rgba(142, 142, 142, 0.3)",
      inputBorderType: "full",
      inputBorderRadius: "4px",
      inputFocusBorderColor: "#276EAF",
      inputErrorBorderColor: "#F04949",
      inputErrorFontColor: "#F04949",
      inputTipGutter: "6px",
      inputLabelColor: "rgba(44, 44, 44, 0.75)",
      inputLabelPosition: "inside",
      inputFontColor: "#2C2C2C",
      inputTipColor: "rgba(44, 44, 44, 0.5)",
      inputIconColor: "rgba(44, 44, 44, 0.75)",
      inputLabelLineHeight: "16px",
      inputLabelSmallLineHeight: "14px",
      inputLabelGutter: "0px",
      inputPaddingTop: "5px",
      inputPaddingRight: "16px",
      inputPaddingBottom: "0",
      inputPaddingLeft: "16px",
      inputLabelFocusFontSize: "10px",
      footerFontColor: "rgba(44, 44, 44, 0.5)",
      footerIconColor: "#35C08E",
      footerLinkColor: "#466c63",
      footerIconSvg: '\n<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.8773 5.33337H10.1557C9.99882 5.33337 9.84958 5.40529 9.75727 5.52856L7.33873 8.72793L6.24331 7.27795C6.151 7.15613 6.0033 7.08275 5.84484 7.08275H5.12328C5.02327 7.08275 4.96481 7.19136 5.02327 7.26914L6.94026 9.80515C6.98554 9.86545 7.04524 9.91458 7.11441 9.94847C7.18357 9.98236 7.26021 10 7.33796 10C7.41572 10 7.49235 9.98236 7.56152 9.94847C7.63068 9.91458 7.69038 9.86545 7.73567 9.80515L10.9758 5.51976C11.0358 5.44198 10.9773 5.33337 10.8773 5.33337V5.33337Z" fill="currentColor"/>\n<path d="M13.25 3.46888V9.59634C13.25 10.0143 13.0411 10.4046 12.6934 10.6364L8.13867 13.6729C8.0547 13.7289 7.9453 13.7289 7.86132 13.6729L3.30662 10.6364C2.95888 10.4046 2.75 10.0143 2.75 9.59634V3.46888C2.75 3.3517 2.83138 3.25025 2.94577 3.22483L7.94577 2.11372C7.98149 2.10578 8.01851 2.10578 8.05423 2.11372L13.0542 3.22483C13.1686 3.25025 13.25 3.3517 13.25 3.46888Z" stroke="currentColor" stroke-width="1.5"/>\n</svg>\n'
    }), h(St, "block", {
      imgColor: "rgba(44, 44, 44, 0.5)",
      fontColor: "#1E1E1E"
    }), h(St, "simple", {
      fontColor: "rgba(44, 44, 44, 0.5)"
    }), h(St, "default", {
      fontFamily: ["Helvetica Neue", " Arial", " sans-serif"],
      fontLib: b.System,
      inputLabelLineHeight: "16px",
      inputLabelSmallLineHeight: "14px",
      inputLabelGutter: "0px",
      inputPaddingTop: "5px",
      inputPaddingRight: "16px",
      inputPaddingBottom: "0",
      inputPaddingLeft: "16px",
      inputLabelFocusFontSize: "10px",
      selectPaddingTop: "12px",
      selectPaddingRight: "14px",
      selectPaddingBottom: "12px",
      selectPaddingLeft: "14px"
    }), h(St, k.Form, {
      inputPaddingTop: "5px",
      inputPaddingRight: "16px",
      inputPaddingBottom: "0",
      inputPaddingLeft: "16px",
      inputLabelFocusFontSize: "10px",
      selectPaddingTop: "12px",
      selectPaddingRight: "14px",
      selectPaddingBottom: "12px",
      selectPaddingLeft: "14px"
    }), h(St, k.KoreaCard, {
      headerFontColor: "rgba(44, 44, 44, 0.75)",
      cardHeight: "100px",
      cardBorderRadius: "4px",
      cardBorderColor: "#DDDDD8",
      cardHoverBorderColor: "#276EAF",
      cardSelectedBorderColor: "#276EAF",
      cardPaddingTop: "12px",
      cardPaddingBottom: "12px",
      cardPaddingLeft: "20px",
      cardPaddingRight: "20px",
      cardImgHeight: "30px",
      cardFontColor: "#2C2C2C",
      cardItemGutter: "4px",
      cardBackgroundColor: "#FFFFFF"
    }), St),
    Ht = (h(Pt = {}, k.CreditCard, ["inputBackground", "formItemGutter", "inputHeight", "inputTipGutter", "inputLabelColor", "inputFontColor", "inputBorderColor", "inputBorderRadius", "inputIconColor", "inputFocusBorderColor", "inputErrorBorderColor", "inputErrorFontColor", "inputTipColor", "footerFontColor", "footerIconColor", "footerLinkColor", "inputLabelLineHeight", "inputLabelSmallLineHeight", "inputLabelGutter", "inputPaddingTop", "inputPaddingRight", "inputPaddingBottom", "inputPaddingLeft", "inputLabelFocusFontSize", "inputFontLetterSpacing", "inputFontWeight"]), h(Pt, k.Form, ["fontFamily", "inputPaddingTop", "inputPaddingRight", "inputPaddingBottom", "inputPaddingLeft", "inputLabelFocusFontSize", "selectPaddingTop", "selectPaddingRight", "selectPaddingBottom", "selectPaddingLeft", "selectDividingLineColor"]), h(Pt, k.Block, ["imgColor", "fontColor"]), h(Pt, k.Simple, ["fontColor"]), h(Pt, k.Default, ["fontFamily", "fontLib", "inputLabelLineHeight", "inputLabelSmallLineHeight", "inputLabelGutter", "inputPaddingTop", "inputPaddingRight", "inputPaddingBottom", "inputPaddingLeft", "inputLabelFocusFontSize", "selectPaddingTop", "selectPaddingRight", "selectPaddingBottom", "selectPaddingLeft"]), h(Pt, k.KoreaCard, ["headerFontColor", "cardBorderColor", "cardBorderRadius", "cardFontColor", "cardBackgroundColor", "cardItemGutter", "cardHeight", "cardHoverBorderColor", "cardImgHeight", "cardPaddingBottom", "cardPaddingLeft", "cardPaddingRight", "cardPaddingTop", "cardSelectedBorderColor"]), Pt),
    Ut = {
      number: "cardNumberIcon",
      cvc: "securityCodeIcon",
      firstName: "holderNameIcon",
      footer: "footerIcon"
    };
  var Vt,
    zt,
    qt = function () {
      function e(t) {
        o(this, e), this.theme = this.combineTheme(t);
      }
      return s(e, [{
        key: "combineTheme",
        value: function value(e) {
          if (!e || "object" !== i(e) || 0 === Object.keys(e).length) return Ft;
          var t = JSON.parse(JSON.stringify(Ft));
          return Object.keys(e).forEach(function (n) {
            Object.keys(e[n]).forEach(function (r) {
              var o = e[n][r];
              null != o && (["string", "boolean"].includes(i(o)) || Array.isArray(o)) && (t[n] || (t[n] = {}), t[n][r] = o);
            });
          }), t;
        }
      }, {
        key: "getTheme",
        value: function value() {
          return this.theme;
        }
      }, {
        key: "get",
        value: function value(e, t) {
          var n,
            r,
            o,
            i,
            a,
            c,
            s = t,
            u = (null === (n = this.theme) || void 0 === n || null === (r = n[e]) || void 0 === r ? void 0 : r[s]) || (null === (o = this.theme) || void 0 === o || null === (i = o["default"]) || void 0 === i ? void 0 : i[s]);
          return u && "string" == typeof u ? u : (null === (a = Ft[e]) || void 0 === a ? void 0 : a[s]) || (null === (c = Ft["default"]) || void 0 === c ? void 0 : c[s]) || "";
        }
      }, {
        key: "getCreditCardThemeValue",
        value: function value(e) {
          return this.get(k.CreditCard, e);
        }
      }, {
        key: "getInputIcon",
        value: function value(e) {
          var t = Ut[e],
            n = this.getCreditCardThemeValue(t);
          if (n) return {
            imgSrc: n
          };
          var r = this.getCreditCardThemeValue("".concat(t, "Svg"));
          return r ? {
            svg: r
          } : {};
        }
      }, {
        key: "getStyle",
        value: function value(e) {
          var t = this,
            n = function n(e) {
              return Ht[e].map(function (n) {
                var r,
                  o = n.replace(/([A-Z])/g, "-$1").toLowerCase();
                return e === k.CreditCard ? (r = t.getCreditCardThemeValue(n), "--".concat(o, ": ").concat(r, ";")) : (r = t.get(e, n), "--".concat(e, "-").concat(o, ": ").concat(r, ";"));
              }).join("");
            };
          return Array.isArray(e) ? e.map(function (e) {
            return n(e);
          }).join("") : n(e);
        }
      }, {
        key: "getDefaultFontFamily",
        value: function value() {
          var e;
          return null === (e = this.theme[k.Default]) || void 0 === e ? void 0 : e.fontFamily;
        }
      }, {
        key: "getDefaultFontLib",
        value: function value() {
          var e;
          return null === (e = this.theme[k.Default]) || void 0 === e ? void 0 : e.fontLib;
        }
      }, {
        key: "handleDefaultThemeValidate",
        value: function value() {
          var e = this.theme[k.Default] || {},
            t = e.fontLib,
            n = e.fontFamily;
          return !(!Array.isArray(n) || 0 === n.length) && (t === b.Google || t === b.System);
        }
      }]), e;
    }();
  function Gt(e, t, n) {
    return Gt = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }() ? Reflect.construct.bind() : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && l(o, n.prototype), o;
    }, Gt.apply(null, arguments);
  }
  function Wt(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return Wt = function Wt(e) {
      if (null === e || !function (e) {
        return -1 !== Function.toString.call(e).indexOf("[native code]");
      }(e)) return e;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, n);
      }
      function n() {
        return Gt(e, arguments, f(this).constructor);
      }
      return n.prototype = Object.create(e.prototype, {
        constructor: {
          value: n,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), l(n, e);
    }, Wt(e);
  }
  function Kt(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = f(e);
      if (t) {
        var o = f(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);
      return d(this, n);
    };
  }
  !function (e) {
    e.NotSupportBrowser = "1026", e.InnerSDKError = "1027", e.RenderFail = "1028", e.RevealError = "2905", e.NetworkError = "1109", e.CreatePayClientFail = "4108", e.InitResultError = "1102", e.CancelPayClient = "4550";
  }(Vt || (Vt = {})), function (e) {
    e.Fatal = "fatal", e.Error = "error";
  }(zt || (zt = {}));
  var Jt = function (e) {
      p(r, e);
      var n = Kt(r);
      function r(e) {
        var i,
          a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Vt.InnerSDKError,
          c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "SilenceError",
          s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : zt.Error;
        return o(this, r), h(u(i = n.call(this, e)), "data", {}), i.name = c, i.code = a, i.errorLevel = s, i.pvId = t.pvId, i;
      }
      return s(r);
    }(Wt(Error)),
    Yt = function (e) {
      p(n, e);
      var t = Kt(n);
      function n(e) {
        var r,
          i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Vt.InnerSDKError,
          a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "UnknownError",
          c = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : zt.Error;
        return o(this, n), h(u(r = t.call(this, e)), "isReported", !1), h(u(r), "data", {}), r.name = a, r.code = i, r.errorLevel = c, r;
      }
      return s(n, [{
        key: "setIsReported",
        value: function value() {
          this.isReported = !0;
        }
      }]), n;
    }(Wt(Error));
  function Xt() {
    return "2.26.0";
  }
  function Zt(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }
    return r;
  }
  function $t(e) {
    return function (e) {
      if (Array.isArray(e)) return Zt(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return Zt(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Zt(e, t) : void 0;
      }
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function Qt(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function en(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function tn(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function nn(e, t, n) {
    return t && tn(e.prototype, t), n && tn(e, n), e;
  }
  function rn(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function on(e) {
    return (on = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function an(e, t, n) {
    return (an = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
      var r = function (e, t) {
        for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = on(e));) {
          ;
        }
        return e;
      }(e, t);
      if (r) {
        var o = Object.getOwnPropertyDescriptor(r, t);
        return o.get ? o.get.call(n) : o.value;
      }
    })(e, t, n || e);
  }
  function cn(e, t) {
    return (cn = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function sn(e) {
    return (sn = "function" == typeof Symbol && "symbol" == i(Symbol.iterator) ? function (e) {
      return i(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : i(e);
    })(e);
  }
  var un = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
    ln = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
    pn = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
    dn = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
  function fn(e) {
    return (e && e.message || "No error message").split("\n").filter(function (e) {
      return !!e;
    })[0];
  }
  function hn(e) {
    try {
      var t = function (e) {
        if (!e.stack) return null;
        for (var t, n, r = [], o = e.stack.split("\n"), i = 0; i < o.length; ++i) {
          if (t = un.exec(o[i])) n = {
            filename: t[2] && 0 === t[2].indexOf("address at ") ? t[2].substr("address at ".length) : t[2],
            "function": t[1] || "?",
            lineno: t[3] ? +t[3] : null,
            colno: t[4] ? +t[4] : null
          };else if (t = pn.exec(o[i])) n = {
            filename: t[2],
            "function": t[1] || "?",
            lineno: +t[3],
            colno: t[4] ? +t[4] : null
          };else {
            if (!(t = ln.exec(o[i]))) continue;
            0 !== i || t[5] || void 0 === e.columnNumber || (r[0].column = e.columnNumber + 1), n = {
              filename: t[3],
              "function": t[1] || "?",
              lineno: t[4] ? +t[4] : null,
              colno: t[5] ? +t[5] : null
            };
          }
          !n["function"] && n.lineno && (n["function"] = "?"), r.push(n);
        }
        return r.length ? {
          value: fn(e),
          type: e.name,
          stacktrace: {
            frames: r.reverse()
          }
        } : null;
      }(e);
      if (t) return t;
    } catch (e) {}
    return {
      value: fn(e),
      type: e && e.name,
      stacktrace: {
        frames: []
      }
    };
  }
  var yn = Object.assign || function (e) {
      for (var t = arguments.length, n = 1; n < t; n++) {
        var r = arguments[n];
        for (var o in r) {
          Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
        }
      }
      return e;
    },
    mn = function () {
      function e(t) {
        if (en(this, e), t.dsn) {
          var n = dn.exec(t.dsn),
            r = n ? n.slice(1) : [],
            o = r[5].split("/"),
            i = o.slice(0, -1).join("/");
          this.apiUrl = r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (i ? "/" + i : "") + "/api/" + o.pop() + "/store/", this.authHeader = "Sentry sentry_version=7,sentry_key=" + r[1] + (r[2] ? ",sentry_secret=" + r[2] : "");
        }
        this.environment = t.environment;
      }
      return nn(e, [{
        key: "prepare",
        value: function value(e) {
          return yn(this.getRequestBlank(), {
            exception: {
              values: [hn(e)]
            }
          });
        }
      }, {
        key: "report",
        value: function value(e) {
          this.send(this.prepare(e));
        }
      }, {
        key: "send",
        value: function value(e) {
          if (this.apiUrl) {
            var t = new XMLHttpRequest();
            t.open("POST", this.apiUrl, !0), t.setRequestHeader("Content-type", "application/json"), t.setRequestHeader("X-Sentry-Auth", this.authHeader || ""), t.send(JSON.stringify(e));
          }
        }
      }, {
        key: "getRequestBlank",
        value: function value() {
          return {
            platform: "javascript",
            sdk: {
              name: "micro-sentry.javascript.browser",
              version: "0.0.0"
            },
            timestamp: Date.now() / 1e3,
            request: {
              url: window.location.toString(),
              headers: {
                "User-Agent": window.navigator.userAgent
              }
            },
            environment: this.environment
          };
        }
      }]), e;
    }();
  function vn(e, t) {
    return "[object RegExp]" === Object.prototype.toString.call(t) ? t.test(e) : "string" == typeof t && -1 !== e.indexOf(t);
  }
  function gn(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = on(e);
      if (t) {
        var o = on(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);
      return function (e, t) {
        return !t || "object" !== sn(t) && "function" != typeof t ? rn(e) : t;
      }(this, n);
    };
  }
  var bn = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && cn(e, t);
    }(n, mn);
    var t = gn(n);
    function n(e) {
      var r;
      en(this, n), (r = t.call(this, e)).options = e, r.destroyed = !1, r._state = {};
      var o = r.options || {},
        i = o.plugins,
        a = void 0 === i ? [] : i,
        c = o.beforeSend,
        s = void 0 === c ? function (e) {
          return e;
        } : c,
        u = o.beforeBreadcrumb,
        l = void 0 === u ? function (e) {
          return e;
        } : u,
        p = o.blacklistUrls,
        d = void 0 === p ? [] : p,
        f = o.ignoreErrors,
        h = void 0 === f ? [] : f,
        y = o.release,
        m = void 0 === y ? void 0 : y;
      return r.plugins = a.map(function (e) {
        return new e(rn(r));
      }), r.beforeSend = s, r.beforeBreadcrumb = l, r.blacklistUrls = d, r.ignoreErrors = h, r.release = m, r;
    }
    return nn(n, [{
      key: "state",
      get: function get() {
        return this._state;
      }
    }, {
      key: "clearState",
      value: function value() {
        this._state = {};
      }
    }, {
      key: "setTags",
      value: function value(e) {
        return this.setKeyState("tags", Object.assign({}, e)), this;
      }
    }, {
      key: "setTag",
      value: function value(e, t) {
        return this.extendState({
          tags: Qt({}, e, t)
        }), this;
      }
    }, {
      key: "setExtra",
      value: function value(e, t) {
        return this.extendState({
          extra: Qt({}, e, t)
        }), this;
      }
    }, {
      key: "setExtras",
      value: function value(e) {
        return this.setKeyState("extra", Object.assign({}, e)), this;
      }
    }, {
      key: "setUser",
      value: function value(e) {
        return this.setKeyState("user", Object.assign({}, e)), this;
      }
    }, {
      key: "clone",
      value: function value() {
        var e = new n(Object.assign(Object.assign({}, this.options), {
          plugins: []
        }));
        return e.extendState(this.state), e;
      }
    }, {
      key: "withScope",
      value: function value(e) {
        var t = this.clone();
        e(t), t.destroy(), this.setBreadcrumbs(void 0);
      }
    }, {
      key: "addBreadcrumb",
      value: function value(e) {
        this.extendState({
          breadcrumbs: [Object.assign({
            timestamp: Date.now() / 1e3
          }, this.beforeBreadcrumb(e))]
        });
      }
    }, {
      key: "setBreadcrumbs",
      value: function value(e) {
        this.setKeyState("breadcrumbs", e);
      }
    }, {
      key: "captureMessage",
      value: function value(e, t) {
        this.send(Object.assign(Object.assign({}, this.getRequestBlank()), {
          message: e,
          level: t
        }));
      }
    }, {
      key: "destroy",
      value: function value() {
        this.destroyed = !0, this.plugins.forEach(function (e) {
          e.destroy && e.destroy();
        });
      }
    }, {
      key: "isIgnoredError",
      value: function value(e) {
        var t = this;
        return !!this.ignoreErrors.length && this.getPossibleEventMessages(e).some(function (e) {
          return t.ignoreErrors.some(function (t) {
            return vn(e, t);
          });
        });
      }
    }, {
      key: "getRequestBlank",
      value: function value() {
        return Object.assign(Object.assign({}, an(on(n.prototype), "getRequestBlank", this).call(this)), this.state);
      }
    }, {
      key: "send",
      value: function value(e) {
        this.destroyed || this.isDeniedUrl(e) || this.isIgnoredError(e) || (an(on(n.prototype), "send", this).call(this, this.beforeSend(Object.assign({
          release: this.release
        }, e))), this.setBreadcrumbs(void 0));
      }
    }, {
      key: "getPossibleEventMessages",
      value: function value(e) {
        if (e.message) return [e.message];
        if (e.exception) try {
          var t = e.exception.values && e.exception.values[0] || {},
            n = t.type,
            r = void 0 === n ? "" : n,
            o = t.value,
            i = void 0 === o ? "" : o;
          return ["".concat(i), "".concat(r, ": ").concat(i)];
        } catch (e) {
          return [];
        }
        return [];
      }
    }, {
      key: "isDeniedUrl",
      value: function value(e) {
        if (!this.blacklistUrls.length) return !1;
        var t = this.getEventFilterUrl(e);
        return !!t && this.blacklistUrls.some(function (e) {
          return vn(t, e);
        });
      }
    }, {
      key: "getEventFilterUrl",
      value: function value(e) {
        try {
          if (e.exception) {
            var t = e.exception.values && e.exception.values[0].stacktrace && e.exception.values[0].stacktrace.frames;
            return t && t[t.length - 1].filename || null;
          }
          return null;
        } catch (e) {
          return null;
        }
      }
    }, {
      key: "extendState",
      value: function value(e) {
        var t = this;
        this._state = Object.keys(e).reduce(function (n, r) {
          var o = t.state[r],
            i = Array.isArray(o) ? o : null,
            a = e[r],
            c = Array.isArray(a) ? a : null;
          return Object.assign(Object.assign({}, n), Qt({}, r, i || c ? [].concat($t(i || []), $t(c || [])) : Object.assign(Object.assign({}, "string" != typeof o ? o : {}), "string" != typeof a ? a : {})));
        }, {});
      }
    }, {
      key: "setKeyState",
      value: function value(e, t) {
        this._state[e] = t;
      }
    }]), n;
  }();
  function wn(e, t, n) {
    var r = e[t],
      o = n(r);
    if ("function" == typeof o) try {
      o.prototype = o.prototype || {}, Object.defineProperties(o, {
        __original__: {
          enumerable: !1,
          value: r
        }
      });
    } catch (e) {}
    e[t] = o;
  }
  function kn(e) {
    if (!e) return {};
    var t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!t) return {};
    var n = t[6] || "",
      r = t[8] || "";
    return {
      host: t[4],
      path: t[5],
      protocol: t[2],
      relative: t[5] + n + r
    };
  }
  function xn() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    return "Request" in window && e[0] instanceof Request && e[0].method ? String(e[0].method).toUpperCase() : e[1] && e[1].method ? String(e[1].method).toUpperCase() : "GET";
  }
  function On() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    return "string" == typeof e[0] ? e[0] : "Request" in window && e[0] instanceof Request ? e[0].url : String(e[0]);
  }
  function _n(e) {
    return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
  }
  function Cn(e) {
    var t = e,
      n = [];
    if (!t || !t.tagName) return "";
    n.push(t.tagName.toLowerCase()), t.id && n.push("#".concat(t.id));
    var r = t.className;
    if (r && "string" == typeof r) {
      var o = r.split(/\s+/);
      n.concat(o.map(function (e) {
        return ".".concat(e);
      }));
    }
    return ["type", "name", "title", "alt", "automation-id"].forEach(function (e) {
      var r = t.getAttribute(e);
      r && n.push("[".concat(e, '="').concat(r, '"]'));
    }), n.join("");
  }
  function En(e) {
    try {
      for (var t, n = e, r = [], o = 0, i = 0, a = " > ".length; n && o++ < 5 && !("html" === (t = Cn(n)) || o > 1 && i + r.length * a + t.length >= 80);) {
        r.push(t), i += t.length, n = n.parentNode;
      }
      return r.reverse().join(" > ");
    } catch (e) {
      return "<unknown>";
    }
  }
  function In(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
    return Array.isArray(e) ? e.map(function (e) {
      try {
        return String(e);
      } catch (e) {
        return "";
      }
    }).filter(function (e) {
      return "" !== e;
    }).join(t) : "";
  }
  function Sn(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Pn(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Sn(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Sn(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  !function () {
    function e(t) {
      en(this, e), this.client = t, this.subscriptions = [], this.initDOM(), this.initConsole(), this.initFetch(), this.initHistory(), this.initXHR();
    }
    nn(e, [{
      key: "initXHR",
      value: function value() {
        if ("XMLHttpRequest" in window) {
          var e = this,
            t = XMLHttpRequest.prototype;
          wn(t, "open", function (t) {
            return function () {
              for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
                r[o] = arguments[o];
              }
              var i = this,
                a = r[1];
              i.__sentry_xhr__ = {
                method: "string" == typeof r[0] ? r[0].toUpperCase() : r[0],
                url: r[1]
              }, "string" == typeof a && "POST" === i.__sentry_xhr__.method && a.match(/sentry_key/) && (i.__sentry_own_request__ = !0);
              var c = function c() {
                if (4 === i.readyState) {
                  try {
                    i.__sentry_xhr__ && (i.__sentry_xhr__.status_code = i.status);
                  } catch (e) {}
                  e.xhrBreadcrumb({
                    args: r,
                    endTimestamp: Date.now(),
                    startTimestamp: Date.now(),
                    xhr: i
                  });
                }
              };
              return "onreadystatechange" in i && "function" == typeof i.onreadystatechange ? wn(i, "onreadystatechange", function (e) {
                return function () {
                  c();
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                    n[r] = arguments[r];
                  }
                  e.apply(i, n);
                };
              }) : i.addEventListener("readystatechange", c), t.apply(i, r);
            };
          }), wn(t, "send", function (t) {
            return function () {
              for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
                r[o] = arguments[o];
              }
              return e.xhrBreadcrumb({
                args: r,
                startTimestamp: Date.now(),
                xhr: this
              }), t.apply(this, r);
            };
          });
        }
      }
    }, {
      key: "initHistory",
      value: function value() {
        var e = this,
          t = window.onpopstate;
        function n(t) {
          return function () {
            for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
              r[o] = arguments[o];
            }
            var i = r.length > 2 ? r[2] : void 0;
            if (i) {
              var a = e.lastHref,
                c = String(i);
              e.lastHref = c, e.historyBreadcrumb({
                from: a,
                to: c
              });
            }
            return t.apply(this, r);
          };
        }
        window.onpopstate = function () {
          var n = window.location.href,
            r = e.lastHref;
          if (e.lastHref = n, e.historyBreadcrumb({
            from: r,
            to: n
          }), t) {
            for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++) {
              i[a] = arguments[a];
            }
            return t.apply(this, i);
          }
        }, wn(window.history, "pushState", n), wn(window.history, "replaceState", n);
      }
    }, {
      key: "destroy",
      value: function value() {
        this.subscriptions.forEach(function (e) {
          return e();
        });
      }
    }, {
      key: "initDOM",
      value: function value() {
        var e = this,
          t = function t(_t3) {
            return e.prepareDomEvent("click", _t3);
          },
          n = function n(t) {
            return e.prepareDomEvent("keypress", t);
          };
        window.document.addEventListener("click", t, !1), window.document.addEventListener("keypress", n, !1), this.subscriptions.push(function () {
          window.document.removeEventListener("click", t, !1), window.document.removeEventListener("keypress", n, !1);
        });
      }
    }, {
      key: "prepareDomEvent",
      value: function value(e, t) {
        var n;
        try {
          n = t.target ? En(t.target) : En(t);
        } catch (e) {
          n = "<unknown>";
        }
        0 !== n.length && this.client.addBreadcrumb({
          category: "ui.".concat(e),
          message: n
        });
      }
    }, {
      key: "initFetch",
      value: function value() {
        var e = this;
        (function () {
          if (!function () {
            if (!("fetch" in window)) return !1;
            try {
              return new Headers(), new Request(""), new Response(), !0;
            } catch (e) {
              return !1;
            }
          }()) return !1;
          if (_n(window.fetch)) return !0;
          var e = !1,
            t = window.document;
          if (t && "function" == typeof t.createElement) try {
            var n = t.createElement("iframe");
            n.sandbox.add("allow-scripts"), n.sandbox.add("allow-same-origin"), n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = _n(n.contentWindow.fetch)), t.head.removeChild(n);
          } catch (e) {}
          return e;
        })() && wn(window, "fetch", function (t) {
          return function () {
            for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
              r[o] = arguments[o];
            }
            var i = {
              args: r,
              fetchData: {
                method: xn(r),
                url: On(r)
              },
              startTimestamp: Date.now()
            };
            return e.fetchBreadcrumb(Object.assign({}, i)), t.apply(window, r).then(function (t) {
              return e.fetchBreadcrumb(Object.assign(Object.assign({}, i), {
                endTimestamp: Date.now(),
                response: t
              })), t;
            }, function (t) {
              throw e.fetchBreadcrumb(Object.assign(Object.assign({}, i), {
                endTimestamp: Date.now(),
                error: t
              })), t;
            });
          };
        });
      }
    }, {
      key: "fetchBreadcrumb",
      value: function value(e) {
        e.endTimestamp && (e.fetchData.url.match(/sentry_key/) && "POST" === e.fetchData.method || (e.error ? this.client.addBreadcrumb({
          category: "fetch",
          data: e.fetchData,
          level: "error",
          type: "http"
        }) : this.client.addBreadcrumb({
          category: "fetch",
          data: Object.assign(Object.assign({}, e.fetchData), {
            status_code: e.response.status
          }),
          type: "http"
        })));
      }
    }, {
      key: "xhrBreadcrumb",
      value: function value(e) {
        if (e.endTimestamp) {
          if (e.xhr.__sentry_own_request__) return;
          this.client.addBreadcrumb({
            category: "xhr",
            data: e.xhr.__sentry_xhr__,
            type: "http"
          });
        }
      }
    }, {
      key: "initConsole",
      value: function value() {
        var e = this;
        ["debug", "info", "warn", "error", "log", "assert"].forEach(function (t) {
          t in window[window.__sl_console__ ? "__sl_console__" : "console"] && wn(window[window.__sl_console__ ? "__sl_console__" : "console"], t, function (n) {
            return function () {
              for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
                o[i] = arguments[i];
              }
              var a = {
                category: "console",
                data: {
                  arguments: o.map(function (e) {
                    try {
                      return JSON.stringify(e), e;
                    } catch (t) {
                      return Object.prototype.toString.call(e);
                    }
                  }),
                  logger: "console"
                },
                level: t,
                message: In(o, " ")
              };
              if ("assert" === t) {
                if (!1 !== o[0]) return;
                a.message = "Assertion failed: ".concat(In(o.slice(1), " ") || "console.assert"), a.data.arguments = o.slice(1);
              }
              e.client.addBreadcrumb(a), n && Function.prototype.apply.call(n, window[window.__sl_console__ ? "__sl_console__" : "console"], o);
            };
          });
        });
      }
    }, {
      key: "historyBreadcrumb",
      value: function value(e) {
        var t = e.from,
          n = e.to,
          r = kn(window.location.href),
          o = kn(t),
          i = kn(n);
        o.path || (o = r), r.protocol === i.protocol && r.host === i.host && (n = i.relative), r.protocol === o.protocol && r.host === o.host && (t = o.relative), this.client.addBreadcrumb({
          category: "navigation",
          data: {
            from: t,
            to: n
          }
        });
      }
    }]);
  }();
  var Dn,
    jn = new bn({
      dsn: "https://1cb148972c2b4276b0a48df3e26f43a7@sentry-new.myshopline.com/381",
      release: "2.26.0",
      environment: "development",
      beforeSend: function beforeSend(e) {
        return e;
      }
    });
  function Tn(e, t) {
    var n = JSON.stringify(Pn(Pn({}, e || {}), {}, {
        originErrorMessage: null == t ? void 0 : t.message,
        originErrorData: JSON.stringify(t || {}),
        errorLevel: (null == t ? void 0 : t.errorLevel) || (null == e ? void 0 : e.errorLevel) || zt.Error
      })),
      r = new Error(n);
    if (null != t && t.stack) try {
      r.stack = t.stack;
    } catch (e) {
      jn.report(e), jn.report(t);
    }
    jn.report(r);
  }
  function An(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Rn(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? An(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : An(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  jn.setTag("pvId", t.pvId);
  var Ln = (h(Dn = {}, e.ReportUrlType.Business, "/eclytics/i"), h(Dn, e.ReportUrlType.BuiltIn, "https://slp-events.myshopline.com/eclytics/i"), Dn),
    Nn = new t.Monitor("webpaymentsdk"),
    Mn = {
      url: Ln[e.ReportUrlType.Business],
      mode: "ajax",
      method: "post"
    },
    Bn = function () {
      function t() {
        o(this, t);
      }
      return s(t, null, [{
        key: "getEventTrackingConfig",
        value: function value(t) {
          var n = Ln[(null == t ? void 0 : t.reportUrlType) || e.ReportUrlType.Business];
          return Object.freeze(Rn(Rn({}, Mn), {}, {
            url: (null == t ? void 0 : t.url) || n
          }));
        }
      }, {
        key: "init",
        value: function value(e) {
          var n = t.getEventTrackingConfig(null == e ? void 0 : e.eventTrackingConfig),
            r = {
              consumer: e.clientId,
              version: "2.26.0",
              projectName: "ecpaymentsdk",
              merchantId: e.merchantId,
              channelId: e.channelId,
              paymentMethod: e.paymentMethod,
              countryCode: e.countryCode,
              currency: e.currency,
              environment: "development",
              orderId: e.orderId
            },
            o = n;
          this.initData = {
            businessDefaultOptions: r,
            reportNetworkConfig: o
          }, Nn.init(r, o);
        }
      }, {
        key: "addReportData",
        value: function value(e) {
          Nn.init(e, this.initData.reportNetworkConfig);
        }
      }, {
        key: "reportError",
        value: function value(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "report_error",
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          e instanceof Yt && (Tn(Object.assign({
            eventName: n
          }, t.formatReportData(r)), e), e.isReported || e.setIsReported());
        }
      }, {
        key: "handleError",
        value: function value(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default_error",
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (t.reportData(n, r), t.reportError(e, n, r), e instanceof Jt || e instanceof Yt) throw e;
          var o = "".concat(n, " ").concat(e.message || "sdk inner error"),
            i = new Jt(o);
          throw i.name = e.name || "Error", i.code = e.code || i.code, i.errorLevel = e.errorLevel || zt.Error, i.data = Rn({
            code: Vt.InnerSDKError,
            msg: o
          }, e.data || {}), i;
        }
      }, {
        key: "formatReportData",
        value: function value(e) {
          if (!e) return {};
          var t = Rn({}, e);
          return t.plugins && delete t.plugins, t.payToken && (t.payToken = [t.payToken].slice(4)), t;
        }
      }, {
        key: "reportData",
        value: function value(e, n) {
          try {
            Nn.report(e, n ? {
              extraData: JSON.stringify(t.formatReportData(n))
            } : {}), o = (r = {
              msg: e,
              extra: n || {}
            }).msg, i = r.level, a = void 0 === i ? "info" : i, c = r.extra, jn.captureMessage("[".concat(o, "]").concat(c ? JSON.stringify(c) : ""), a);
          } catch (r) {
            t.reportError(r, "".concat(e, "_report_data_error"), {
              data: n
            });
          }
          var r, o, i, a, c;
        }
      }, {
        key: "reportErrorData",
        value: function value(e, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : zt.Error;
          t.reportData(e, n), Tn(Object.assign({
            eventName: e,
            errorLevel: r
          }, t.formatReportData(n)));
        }
      }]), t;
    }();
  h(Bn, "initData", {
    businessDefaultOptions: {},
    reportNetworkConfig: {}
  });
  var Fn,
    Hn = s(function e(t) {
      var n = this;
      o(this, e), h(this, "addReportData", function (e) {
        var t = Bn.formatReportData(e);
        Bn.addReportData(t), Object.assign(n.originData, t);
      }), h(this, "reportData", function (e, t) {
        return Bn.reportData(e, t);
      }), h(this, "reportErrorData", function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : zt.Error;
        return Bn.reportErrorData(e, Object.assign({
          originData: n.originData
        }, t), r);
      }), h(this, "reportError", function (e, t, r) {
        return Bn.reportError(e, t, Rn({
          eventName: t,
          originData: n.originData
        }, r || {}));
      }), h(this, "handleError", function (e, t, r) {
        return Bn.handleError(e, t, Rn({
          originData: n.originData
        }, r));
      }), this.originData = Bn.formatReportData(t);
    });
  function Un(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          o,
          i,
          a,
          c = [],
          s = !0,
          u = !1;
        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            s = !1;
          } else for (; !(s = (r = i.call(n)).done) && (c.push(r.value), c.length !== t); s = !0) {
            ;
          }
        } catch (e) {
          u = !0, o = e;
        } finally {
          try {
            if (!s && null != n["return"] && (a = n["return"](), Object(a) !== a)) return;
          } finally {
            if (u) throw o;
          }
        }
        return c;
      }
    }(e, t) || Ct(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  var Vn,
    zn = function () {
      function e() {
        o(this, e), h(this, "handlers", []);
      }
      return s(e, [{
        key: "use",
        value: function value(e, t) {
          return this.handlers.push({
            fulfilled: e,
            rejected: t
          }), this.handlers.length - 1;
        }
      }, {
        key: "eject",
        value: function value(e) {
          this.handlers[e] && (this.handlers[e] = null);
        }
      }, {
        key: "clear",
        value: function value() {
          this.handlers && (this.handlers = []);
        }
      }, {
        key: "forEach",
        value: function value(e) {
          this.handlers.forEach(function (t) {
            null !== t && e(t);
          });
        }
      }]), e;
    }();
  function qn(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Gn(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? qn(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qn(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  !function (e) {
    e.Confirm = "Confirm", e.Init = "Init", e.I18n = "I18n";
  }(Vn || (Vn = {}));
  var Wn = function Wn(e, t) {
      switch (e) {
        case Vn.Init:
          return !!t && 400 !== t.statusCode;
        case Vn.I18n:
          return !0;
        default:
          return !1;
      }
    },
    Kn = {
      maxCount: 3,
      interval: 1e3
    },
    Jn = {};
  function Yn(e, t) {
    if (!e) return null;
    var n = Jn[e] || {};
    return n = Gn(Gn(Gn(Gn({}, n), Kn), t), {}, {
      retryCount: n.retryCount || 0
    }), Jn[e] = n, n;
  }
  var Xn = function Xn(e) {
    return e.useRetry && e.action;
  };
  function Zn(e) {
    return "[object Object]" === Object.prototype.toString.call(e);
  }
  function $n(e) {
    return !e || !!e.nodeType || "object" !== i(e) ? e : JSON.parse(JSON.stringify(e));
  }
  var Qn = function Qn(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "xhr";
    return JSON.parse(JSON.stringify(e, function (e, n) {
      if (e !== t) return n;
    }));
  };
  function er(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function tr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? er(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : er(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var nr,
    rr,
    or,
    ir,
    ar = ["/payment-sdk/assets/i18n/"],
    cr = function () {
      function e(t) {
        var n = this;
        o(this, e), h(this, "options", {}), h(this, "pvIdBlackList", ar), h(this, "interceptors", {}), h(this, "serialize", function (e) {
          var t = Object.prototype.toString.call(e);
          return e && "[object Object]" === t ? Object.keys(e).map(function (t) {
            return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
          }).join("&") : "";
        }), h(this, "isInPvIdBlackList", function (e) {
          if (!e) return !0;
          for (var t = 0; t < n.pvIdBlackList.length; t++) {
            var r = n.pvIdBlackList[t];
            if (e.indexOf(r || "") > -1) return !0;
          }
          return !1;
        }), this.options = t || {}, this.interceptors = {
          request: new zn(),
          response: new zn()
        };
      }
      return s(e, [{
        key: "setOptions",
        value: function value(e) {
          this.options = e;
        }
      }, {
        key: "get",
        value: function value(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          e = this.buildUrl(e, null == n ? void 0 : n.params);
          var r = {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
          };
          return this.isInPvIdBlackList(e) || (r["x-pvid"] = t.pvId), this.http(e, tr(tr({
            headers: r,
            method: "GET"
          }, this.options), n));
        }
      }, {
        key: "post",
        value: function value(e, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = {
              Accept: "application/json"
            },
            i = n || r.data || null;
          return "form" === r.requestType ? (o["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8", i = this.serialize(i)) : (o["Content-Type"] = "application/json;charset=UTF-8", i = i ? JSON.stringify(i) : null), this.isInPvIdBlackList(e) || (o["x-pvid"] = t.pvId), this.http(e, tr(tr({
            headers: o,
            method: "POST",
            body: i
          }, this.options), r));
        }
      }, {
        key: "dispatchRequest",
        value: function value(e, t) {
          var n = this;
          return new Promise(function (r, o) {
            var i = new window.XMLHttpRequest(),
              a = !1,
              c = t.body,
              s = n.options.baseUrl && !/^(https?:)?(\/\/)/.test(e) ? "".concat(n.options.baseUrl).concat(e) : e;
            i.open(t.method || "", s), t.headers && Object.keys(t.headers).forEach(function (e) {
              var n;
              i.setRequestHeader(e, (null === (n = t.headers) || void 0 === n ? void 0 : n[e]) || "");
            });
            var u = {
              options: t,
              url: s
            };
            if (i.onreadystatechange = function () {
              if (4 === i.readyState) {
                u.statusCode = i.status;
                var e = "";
                try {
                  e = JSON.parse(i.responseText);
                } catch (t) {
                  e = i.responseText;
                }
                if (/^(2|3)\d{2}$/.test(i.status.toString())) {
                  try {
                    r(tr({
                      data: e
                    }, u));
                  } catch (t) {
                    r(tr({
                      data: e
                    }, u));
                  }
                  return;
                }
                o(tr({
                  data: e
                }, u));
              }
            }, i.send(c), i.onabort = function (t) {
              a = !0, Bn.reportErrorData("xhr_onabort", {
                url: e,
                readyState: i.readyState,
                status: i.status,
                statusText: i.statusText,
                timeout: i.timeout,
                withCredentials: i.withCredentials
              }), u.statusCode = i.status, t = Qn(t), o(tr({
                error: t
              }, u));
            }, i.onerror = function (t) {
              Bn.reportErrorData("xhr_onerror", {
                url: e,
                readyState: i.readyState,
                status: i.status,
                statusText: i.statusText,
                timeout: i.timeout,
                withCredentials: i.withCredentials
              }), u.statusCode = i.status, t = Qn(t), o(tr({
                error: t
              }, u));
            }, i.ontimeout = function () {
              Bn.reportErrorData("xhr_ontimeout", {
                url: e,
                readyState: i.readyState,
                status: i.status,
                statusText: i.statusText,
                timeout: i.timeout,
                withCredentials: i.withCredentials
              });
            }, t.timeout) {
              if (a) return;
              setTimeout(function () {
                i.abort();
                var t = new Error("XMLHttpRequest timeout");
                t.code = "ETIMEDOUT", Bn.reportErrorData("xhr_timeout", {
                  url: e
                }), u.statusCode = i.status, o(tr({
                  error: t
                }, u));
              }, t.timeout);
            }
          });
        }
      }, {
        key: "http",
        value: function value(e, t) {
          var n,
            r,
            o,
            i,
            a = [];
          null === (n = this.interceptors) || void 0 === n || null === (r = n.request) || void 0 === r || r.forEach(function (e) {
            a.unshift(e.fulfilled, e.rejected);
          });
          var c,
            s = [];
          null === (o = this.interceptors) || void 0 === o || null === (i = o.response) || void 0 === i || i.forEach(function (e) {
            s.push(e.fulfilled, e.rejected);
          });
          for (var u = t; a.length;) {
            var l = a.shift(),
              p = a.shift();
            try {
              l && (u = l(u));
            } catch (e) {
              p && p(e);
              break;
            }
          }
          try {
            c = this.dispatchRequest(e, u);
          } catch (e) {
            return Promise.reject(e);
          }
          for (; s.length;) {
            var d = s.shift(),
              f = s.shift();
            c = c.then(d, f);
          }
          return c;
        }
      }, {
        key: "buildUrl",
        value: function value(e, t) {
          var n = Object.prototype.toString.call(t);
          if (!t || "[object Object]" !== n) return e;
          var r = Object.keys(t);
          return (e = decodeURIComponent(e).indexOf("?") > -1 ? "".concat(e, "&") : "".concat(e, "?")) + r.map(function (e) {
            return "".concat(e, "=").concat(t[e]);
          }).join("&");
        }
      }]), e;
    }(),
    sr = new cr();
  function ur(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : wt;
    return "https://cdn.myshopline.com/t/i18n/payment-sdk/".concat(e, "/").concat(t, ".raw.tree.json");
  }
  function lr(e) {
    return lr = "function" == typeof Symbol && "symbol" == i(Symbol.iterator) ? function (e) {
      return i(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : i(e);
    }, lr(e);
  }
  function pr(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }
    return r;
  }
  function dr(e, t) {
    if (e) {
      if ("string" == typeof e) return pr(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? pr(e, t) : void 0;
    }
  }
  function fr(e) {
    return function (e) {
      if (Array.isArray(e)) return pr(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || dr(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function hr(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function yr(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function mr(e, t, n) {
    return t && yr(e.prototype, t), n && yr(e, n), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function vr(e) {
    return vr = "function" == typeof Symbol && "symbol" == lr(Symbol.iterator) ? function (e) {
      return lr(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : lr(e);
    }, vr(e);
  }
  function gr(e, t, n, r) {
    var o,
      i = arguments.length,
      a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
    if ("object" === ("undefined" == typeof Reflect ? "undefined" : vr(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var c = e.length - 1; c >= 0; c--) {
      (o = e[c]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
    }
    return i > 3 && a && Object.defineProperty(t, n, a), a;
  }
  function br(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function wr(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          o,
          i = [],
          a = !0,
          c = !1;
        try {
          for (n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0) {
            ;
          }
        } catch (e) {
          c = !0, o = e;
        } finally {
          try {
            a || null == n["return"] || n["return"]();
          } finally {
            if (c) throw o;
          }
        }
        return i;
      }
    }(e, t) || dr(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  !function (e) {
    var t, n, r, o;
    null == e || null === (t = e.interceptors) || void 0 === t || null === (n = t.request) || void 0 === n || n.use(function (e) {
      var t = Yn(e.action);
      return Xn(e) && t ? (t.lastRequestTime = Date.now(), e) : e;
    }), null == e || null === (r = e.interceptors) || void 0 === r || null === (o = r.response) || void 0 === o || o.use(null, function (t) {
      var n = t.options,
        r = t.url;
      if (!n) return Promise.reject(t);
      var o = Yn(n.action, n.retryOptions);
      if (!Xn(n) || !o) return Promise.reject(t);
      var i = function (e, t, n) {
        return !!e && !!Wn(e, n) && t.retryCount < (null == t ? void 0 : t.maxCount);
      }(n.action, o, t);
      if (i) {
        if (o.retryCount += 1, n.timeout && o.lastRequestTime) {
          var a = Date.now() - o.lastRequestTime;
          n.timeout = Math.max(n.timeout - a - o.interval, 1);
        }
        return new Promise(function (t) {
          return setTimeout(function () {
            t(e.http(r, n));
          }, o.interval);
        });
      }
      return Promise.reject(t);
    });
  }(sr), function (e) {
    e.P0 = "P0", e.P1 = "P1", e.P2 = "P2";
  }(nr || (nr = {})), function (e) {
    e.Start = "Start", e.Success = "Success", e.Failure = "Failure";
  }(rr || (rr = {})), function (e) {
    e.Info = "info", e.Log = "log", e.Warn = "warn", e.Error = "error";
  }(or || (or = {}));
  var kr = new Uint8Array(16);
  function xr() {
    if (!ir && !(ir = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return ir(kr);
  }
  for (var Or = [], _r = 0; _r < 256; ++_r) {
    Or.push((_r + 256).toString(16).slice(1));
  }
  var Cr = {
    randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto)
  };
  function Er(e, t, n) {
    if (Cr.randomUUID && !t && !e) return Cr.randomUUID();
    var r = (e = e || {}).random || (e.rng || xr)();
    if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
      n = n || 0;
      for (var o = 0; o < 16; ++o) {
        t[n + o] = r[o];
      }
      return t;
    }
    return function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return (Or[e[t + 0]] + Or[e[t + 1]] + Or[e[t + 2]] + Or[e[t + 3]] + "-" + Or[e[t + 4]] + Or[e[t + 5]] + "-" + Or[e[t + 6]] + Or[e[t + 7]] + "-" + Or[e[t + 8]] + Or[e[t + 9]] + "-" + Or[e[t + 10]] + Or[e[t + 11]] + Or[e[t + 12]] + Or[e[t + 13]] + Or[e[t + 14]] + Or[e[t + 15]]).toLowerCase();
    }(r);
  }
  var Ir = function Ir(e) {
      return function (t, n, r) {
        var o = r.value;
        r.value = function () {
          try {
            for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++) {
              r[i] = arguments[i];
            }
            return o.apply(this, r);
          } catch (t) {
            return window[window.__sl_console__ ? "__sl_console__" : "console"].error("logger: There is an error in the execution of method ".concat(n), t), e;
          }
        };
      };
    },
    Sr = function Sr(e) {
      return e.reduce(function (e, t) {
        var n = {};
        try {
          n = t();
        } catch (e) {
          window[window.__sl_console__ ? "__sl_console__" : "console"].error("There is an error in the calculation list results.", e);
        }
        return Object.assign(Object.assign({}, e), n);
      }, {});
    },
    Pr = function Pr(e) {
      var t = window.__SL_LOGGER__;
      if (t) return t[e];
    },
    Dr = function Dr(e, t) {
      window.__SL_LOGGER__ || (window.__SL_LOGGER__ = {}), window.__SL_LOGGER__[e] = t;
    },
    jr = function jr(e) {
      return "string" == typeof e ? e : "Request" in window && e instanceof Request ? e.url : String(e);
    },
    Tr = function Tr(e) {
      return e instanceof Request;
    },
    Ar = function Ar() {
      var e,
        t = null,
        n = {},
        r = arguments.length <= 0 ? void 0 : arguments[0];
      return e = jr(r), Tr(r) && (t = r), (arguments.length <= 1 ? void 0 : arguments[1]) && (n = arguments.length <= 1 ? void 0 : arguments[1]), [e, t, n];
    },
    Rr = function Rr() {
      return Er();
    },
    Lr = ["localhost", /^\/(?!\/).*$/],
    Nr = function () {
      function e() {
        hr(this, e), this.fnList = [], this.get();
      }
      return mr(e, [{
        key: "get",
        value: function value() {
          var e,
            t,
            n = sessionStorage.getItem("SL_LOGGER_SESSION_ID"),
            r = (e = document.cookie.split("; "), t = {}, e.forEach(function (e) {
              var n = wr(e.split("="), 2),
                r = n[0],
                o = n[1];
              r && (t[r] = o || "");
            }), t.log_session_id || "");
          if (n) return n !== r && this.updateId(n), n;
          var o = Er();
          return this.updateId(o), o;
        }
      }, {
        key: "set",
        value: function value(e) {
          return !!e && (this.updateId(e), this.fnList.forEach(function (t) {
            return t(e);
          }), !0);
        }
      }, {
        key: "refresh",
        value: function value() {
          var e = Er();
          return this.updateId(e), this.fnList.forEach(function (t) {
            return t(e);
          }), !0;
        }
      }, {
        key: "onChange",
        value: function value(e) {
          this.fnList.push(e);
        }
      }, {
        key: "updateId",
        value: function value(e) {
          sessionStorage.setItem("SL_LOGGER_SESSION_ID", e), function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "/",
              r = "".concat(e, "=").concat(t);
            n && (r += "; path=".concat(n)), document.cookie = r;
          }("log_session_id", e);
        }
      }]), e;
    }();
  gr([Ir("")], Nr.prototype, "get", null), gr([Ir(!1)], Nr.prototype, "set", null), gr([Ir(!1)], Nr.prototype, "refresh", null), gr([Ir()], Nr.prototype, "onChange", null), gr([Ir()], Nr.prototype, "updateId", null);
  var Mr = new Nr(),
    Br = function () {
      function e() {
        hr(this, e), this.fnList = [], this.get();
      }
      return mr(e, [{
        key: "get",
        value: function value() {
          var e = localStorage.getItem("SL_LOGGER_CLIENT_ID");
          if (e) return e;
          var t = Er();
          return this.set(t), t;
        }
      }, {
        key: "set",
        value: function value(e) {
          return !!e && (localStorage.setItem("SL_LOGGER_CLIENT_ID", e), this.fnList.forEach(function (t) {
            return t(e);
          }), !0);
        }
      }, {
        key: "refresh",
        value: function value() {
          var e = Er();
          return this.set(e), !0;
        }
      }, {
        key: "onChange",
        value: function value(e) {
          this.fnList.push(e);
        }
      }]), e;
    }();
  gr([Ir("")], Br.prototype, "get", null), gr([Ir(!1)], Br.prototype, "set", null), gr([Ir(!1)], Br.prototype, "refresh", null), gr([Ir()], Br.prototype, "onChange", null);
  var Fr,
    Hr = new Br();
  !function (e) {
    e.InstrumentFetch = "instrumentFetch", e.InstrumentXHR = "instrumentXHR";
  }(Fr || (Fr = {}));
  var Ur = function () {
    function e(t, n) {
      hr(this, e), this.idType = "sessionId", this.sessionId = t, this.clientId = n, this.instrumentFetch(), this.instrumentXHR();
    }
    return mr(e, [{
      key: "setIdType",
      value: function value(e) {
        this.idType = e;
      }
    }, {
      key: "getSessionId",
      value: function value() {
        return "sessionId" === this.idType ? this.sessionId.get() : this.clientId.get();
      }
    }, {
      key: "instrumentFetch",
      value: function value() {
        if (window.fetch && "function" == typeof window.fetch && !0 !== Pr(Fr.InstrumentFetch)) {
          Dr(Fr.InstrumentFetch, !0);
          var e = this,
            t = window.fetch;
          window.fetch = function () {
            for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
              r[o] = arguments[o];
            }
            try {
              var i = wr(Ar.apply(void 0, r), 3),
                a = i[0],
                c = i[1],
                s = i[2],
                u = e.getSessionId(),
                l = Rr();
              if (e.needAddHeader(a)) {
                var p,
                  d = s.headers;
                if (c && (d = c.headers), d) {
                  if ("function" == typeof d.append) d.append("Log-Session-Id", u), d.append("X-Request-Id", l);else if (Array.isArray(d)) d = [].concat(fr(d), [["Log-Session-Id", u], ["X-Request-Id", l]]);else {
                    var f;
                    d = Object.assign(Object.assign({}, d), (br(f = {}, "Log-Session-Id", u), br(f, "X-Request-Id", l), f));
                  }
                } else br(p = {}, "Log-Session-Id", u), br(p, "X-Request-Id", l), d = p;
                s.headers = d;
              }
            } catch (e) {
              window[window.__sl_console__ ? "__sl_console__" : "console"].error("instrumentFetch error", e);
            }
            return t.apply(window, r);
          };
        }
      }
    }, {
      key: "instrumentXHR",
      value: function value() {
        if (window.XMLHttpRequest && "function" == typeof window.XMLHttpRequest && !0 !== Pr(Fr.InstrumentXHR)) {
          Dr(Fr.InstrumentXHR, !0);
          var e = window.XMLHttpRequest.prototype.open;
          window.XMLHttpRequest.prototype.open = function () {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
              n[r] = arguments[r];
            }
            try {
              var o = n[1],
                i = "string" == typeof o ? o : o.toString();
              this.__logger_xhr_info__ = {
                url: i
              };
            } catch (e) {
              window[window.__sl_console__ ? "__sl_console__" : "console"].error("instrumentXHR open error", e);
            }
            return e.apply(this, n);
          };
          var t = this,
            n = window.XMLHttpRequest.prototype.send;
          window.XMLHttpRequest.prototype.send = function () {
            var e;
            try {
              var r = t.getSessionId(),
                o = Rr();
              t.needAddHeader((null === (e = this.__logger_xhr_info__) || void 0 === e ? void 0 : e.url) || "") && (this.setRequestHeader("Log-Session-Id", r), this.setRequestHeader("X-Request-Id", o));
            } catch (e) {
              window[window.__sl_console__ ? "__sl_console__" : "console"].error("instrumentXHR send error", e);
            }
            for (var i = arguments.length, a = new Array(i), c = 0; c < i; c++) {
              a[c] = arguments[c];
            }
            return n.apply(this, a);
          };
        }
      }
    }, {
      key: "needAddHeader",
      value: function value(e) {
        return Lr.some(function (t) {
          return t instanceof RegExp ? t.test(e) : "string" == typeof t && -1 !== e.indexOf(t);
        });
      }
    }]), e;
  }();
  new Ur(Mr, Hr);
  var Vr = function () {
    function e(t) {
      hr(this, e), this.options = {
        owner: "",
        action: "",
        tags: {},
        getTagsFn: [],
        data: {},
        getDataFn: [],
        transports: []
      }, this.options = Object.assign(Object.assign({}, this.options), t);
    }
    return mr(e, [{
      key: "withOwner",
      value: function value(e) {
        return new this.constructor(Object.assign(Object.assign({}, this.options), {
          owner: e
        }));
      }
    }, {
      key: "pipeOwner",
      value: function value(e) {
        return e ? (t = this.options.owner ? "".concat(this.options.owner, ".").concat(e) : e, new this.constructor(Object.assign(Object.assign({}, this.options), {
          owner: t
        }))) : this;
        var t;
      }
    }, {
      key: "withAction",
      value: function value(e) {
        return new this.constructor(Object.assign(Object.assign({}, this.options), {
          action: e
        }));
      }
    }, {
      key: "pipeTags",
      value: function value(e) {
        return e ? "function" == typeof e ? new this.constructor(Object.assign(Object.assign({}, this.options), {
          getTagsFn: [].concat(fr(this.options.getTagsFn), [e])
        })) : new this.constructor(Object.assign(Object.assign({}, this.options), {
          tags: Object.assign(Object.assign({}, this.options.tags), e)
        })) : this;
      }
    }, {
      key: "pipeData",
      value: function value(e) {
        return e ? "function" == typeof e ? new this.constructor(Object.assign(Object.assign({}, this.options), {
          getDataFn: [].concat(fr(this.options.getDataFn), [e])
        })) : new this.constructor(Object.assign(Object.assign({}, this.options), {
          data: Object.assign(Object.assign({}, this.options.data), e)
        })) : this;
      }
    }, {
      key: "pipeTransport",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }
        var r = this.options.transports.concat(t);
        return new this.constructor(Object.assign(Object.assign({}, this.options), {
          transports: r
        }));
      }
    }, {
      key: "report",
      value: function value(e, t, n) {
        var r = function (e) {
          var t,
            n = e.level,
            r = e.message,
            o = e.context,
            i = e.options,
            a = Sr(i.getTagsFn),
            c = Sr(i.getDataFn),
            s = Object.assign(Object.assign({
              level: n,
              owner: i.owner,
              action: i.action
            }, o), {
              tags: Object.assign(Object.assign({}, i.tags), a),
              data: Object.assign(Object.assign({}, i.data), c),
              message: r
            });
          return (null == o ? void 0 : o.data) && (t = o.data, "[object Object]" === Object.prototype.toString.call(t)) ? s.data = Object.assign(Object.assign({}, s.data), o.data) : void 0 !== (null == o ? void 0 : o.data) && (s.data = Object.assign(Object.assign({}, s.data), {
            custom_data: o.data
          })), o && "tags" in o && o.tags && (s.tags = Object.assign(Object.assign({}, s.tags), o.tags)), o && "errorLevel" in o && o.errorLevel && (s.tags = Object.assign(Object.assign({}, s.tags), {
            errorLevel: o.errorLevel
          })), s;
        }({
          level: e,
          message: t,
          context: n,
          options: this.options
        });
        !function (e, t) {
          var n = e;
          t.forEach(function (e) {
            var t = e(n);
            t && (n = t);
          });
        }(r, this.options.transports);
      }
    }, {
      key: "info",
      value: function value(e, t) {
        this.report(or.Info, e, t);
      }
    }, {
      key: "log",
      value: function value(e, t) {
        this.report(or.Log, e, t);
      }
    }, {
      key: "warn",
      value: function value(e, t) {
        this.report(or.Warn, e, t);
      }
    }, {
      key: "error",
      value: function value(e, t) {
        this.report(or.Error, e, t);
      }
    }]), e;
  }();
  gr([Ir(new Vr())], Vr.prototype, "withOwner", null), gr([Ir(new Vr())], Vr.prototype, "pipeOwner", null), gr([Ir(new Vr())], Vr.prototype, "withAction", null), gr([Ir(new Vr())], Vr.prototype, "pipeTags", null), gr([Ir(new Vr())], Vr.prototype, "pipeData", null), gr([Ir(new Vr())], Vr.prototype, "pipeTransport", null), gr([Ir(new Vr())], Vr.prototype, "info", null), gr([Ir(new Vr())], Vr.prototype, "log", null), gr([Ir(new Vr())], Vr.prototype, "warn", null), gr([Ir(new Vr())], Vr.prototype, "error", null);
  var zr = new Vr();
  Object.defineProperty(zr, "options", {
    writable: !1,
    configurable: !1
  });
  var qr = new Vr(),
    Gr = {
      get: function get() {
        return qr;
      },
      set: function set(e) {
        e && (qr = e);
      }
    };
  function Wr(e, t, n, r, o, i, a) {
    try {
      var c = e[i](a),
        s = c.value;
    } catch (e) {
      return void n(e);
    }
    c.done ? t(s) : Promise.resolve(s).then(r, o);
  }
  function Kr(e) {
    return function () {
      var t = this,
        n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);
        function a(e) {
          Wr(i, r, o, a, c, "next", e);
        }
        function c(e) {
          Wr(i, r, o, a, c, "throw", e);
        }
        a(void 0);
      });
    };
  }
  function Jr(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function Yr(e) {
    var t = function (e, t) {
      if ("object" !== lr(e) || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, "string");
        if ("object" !== lr(r)) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return String(e);
    }(e);
    return "symbol" === lr(t) ? t : String(t);
  }
  function Xr(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Yr(r.key), r);
    }
  }
  function Zr(e, t, n) {
    return t && Xr(e.prototype, t), n && Xr(e, n), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function $r(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function Qr(e, t) {
    return Qr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e;
    }, Qr(e, t);
  }
  function eo(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && Qr(e, t);
  }
  function to(e, t) {
    if (t && ("object" === lr(t) || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return $r(e);
  }
  function no(e) {
    return no = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, no(e);
  }
  function ro(e, t, n) {
    return (t = Yr(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  var oo = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
  var io = {
      exports: {}
    },
    ao = {
      exports: {}
    };
  !function (e) {
    function t(n) {
      return e.exports = t = "function" == typeof Symbol && "symbol" == i(Symbol.iterator) ? function (e) {
        return i(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : i(e);
      }, e.exports.__esModule = !0, e.exports["default"] = e.exports, t(n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }(ao), function (e) {
    var t = ao.exports["default"];
    function n() {
      e.exports = n = function n() {
        return r;
      }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
      var r = {},
        o = Object.prototype,
        i = o.hasOwnProperty,
        a = Object.defineProperty || function (e, t, n) {
          e[t] = n.value;
        },
        c = "function" == typeof Symbol ? Symbol : {},
        s = c.iterator || "@@iterator",
        u = c.asyncIterator || "@@asyncIterator",
        l = c.toStringTag || "@@toStringTag";
      function p(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        p({}, "");
      } catch (e) {
        p = function p(e, t, n) {
          return e[t] = n;
        };
      }
      function d(e, t, n, r) {
        var o = t && t.prototype instanceof y ? t : y,
          i = Object.create(o.prototype),
          c = new S(r || []);
        return a(i, "_invoke", {
          value: _(e, n, c)
        }), i;
      }
      function f(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      r.wrap = d;
      var h = {};
      function y() {}
      function m() {}
      function v() {}
      var g = {};
      p(g, s, function () {
        return this;
      });
      var b = Object.getPrototypeOf,
        w = b && b(b(P([])));
      w && w !== o && i.call(w, s) && (g = w);
      var k = v.prototype = y.prototype = Object.create(g);
      function x(e) {
        ["next", "throw", "return"].forEach(function (t) {
          p(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function O(e, n) {
        function r(o, a, c, s) {
          var u = f(e[o], e, a);
          if ("throw" !== u.type) {
            var l = u.arg,
              p = l.value;
            return p && "object" == t(p) && i.call(p, "__await") ? n.resolve(p.__await).then(function (e) {
              r("next", e, c, s);
            }, function (e) {
              r("throw", e, c, s);
            }) : n.resolve(p).then(function (e) {
              l.value = e, c(l);
            }, function (e) {
              return r("throw", e, c, s);
            });
          }
          s(u.arg);
        }
        var o;
        a(this, "_invoke", {
          value: function value(e, t) {
            function i() {
              return new n(function (n, o) {
                r(e, t, n, o);
              });
            }
            return o = o ? o.then(i, i) : i();
          }
        });
      }
      function _(e, t, n) {
        var r = "suspendedStart";
        return function (o, i) {
          if ("executing" === r) throw new Error("Generator is already running");
          if ("completed" === r) {
            if ("throw" === o) throw i;
            return {
              value: void 0,
              done: !0
            };
          }
          for (n.method = o, n.arg = i;;) {
            var a = n.delegate;
            if (a) {
              var c = C(a, n);
              if (c) {
                if (c === h) continue;
                return c;
              }
            }
            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if ("suspendedStart" === r) throw r = "completed", n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            r = "executing";
            var s = f(e, t, n);
            if ("normal" === s.type) {
              if (r = n.done ? "completed" : "suspendedYield", s.arg === h) continue;
              return {
                value: s.arg,
                done: n.done
              };
            }
            "throw" === s.type && (r = "completed", n.method = "throw", n.arg = s.arg);
          }
        };
      }
      function C(e, t) {
        var n = t.method,
          r = e.iterator[n];
        if (void 0 === r) return t.delegate = null, "throw" === n && e.iterator["return"] && (t.method = "return", t.arg = void 0, C(e, t), "throw" === t.method) || "return" !== n && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + n + "' method")), h;
        var o = f(r, e.iterator, t.arg);
        if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, h;
        var i = o.arg;
        return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
      }
      function E(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function I(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function S(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(E, this), this.reset(!0);
      }
      function P(e) {
        if (e) {
          var t = e[s];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var n = -1,
              r = function t() {
                for (; ++n < e.length;) {
                  if (i.call(e, n)) return t.value = e[n], t.done = !1, t;
                }
                return t.value = void 0, t.done = !0, t;
              };
            return r.next = r;
          }
        }
        return {
          next: D
        };
      }
      function D() {
        return {
          value: void 0,
          done: !0
        };
      }
      return m.prototype = v, a(k, "constructor", {
        value: v,
        configurable: !0
      }), a(v, "constructor", {
        value: m,
        configurable: !0
      }), m.displayName = p(v, l, "GeneratorFunction"), r.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === m || "GeneratorFunction" === (t.displayName || t.name));
      }, r.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, v) : (e.__proto__ = v, p(e, l, "GeneratorFunction")), e.prototype = Object.create(k), e;
      }, r.awrap = function (e) {
        return {
          __await: e
        };
      }, x(O.prototype), p(O.prototype, u, function () {
        return this;
      }), r.AsyncIterator = O, r.async = function (e, t, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new O(d(e, t, n, o), i);
        return r.isGeneratorFunction(t) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, x(k), p(k, l, "Generator"), p(k, s, function () {
        return this;
      }), p(k, "toString", function () {
        return "[object Generator]";
      }), r.keys = function (e) {
        var t = Object(e),
          n = [];
        for (var r in t) {
          n.push(r);
        }
        return n.reverse(), function e() {
          for (; n.length;) {
            var r = n.pop();
            if (r in t) return e.value = r, e.done = !1, e;
          }
          return e.done = !0, e;
        };
      }, r.values = P, S.prototype = {
        constructor: S,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(I), !e) for (var t in this) {
            "t" === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;
          function n(n, r) {
            return a.type = "throw", a.arg = e, t.next = n, r && (t.method = "next", t.arg = void 0), !!r;
          }
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r],
              a = o.completion;
            if ("root" === o.tryLoc) return n("end");
            if (o.tryLoc <= this.prev) {
              var c = i.call(o, "catchLoc"),
                s = i.call(o, "finallyLoc");
              if (c && s) {
                if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return n(o.finallyLoc);
              } else if (c) {
                if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return n(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var r = this.tryEntries[n];
            if (r.tryLoc <= this.prev && i.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
              var o = r;
              break;
            }
          }
          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, h) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), h;
          }
        },
        "catch": function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.tryLoc === e) {
              var r = n.completion;
              if ("throw" === r.type) {
                var o = r.arg;
                I(n);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: P(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = void 0), h;
        }
      }, r;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }(io);
  var co = io.exports(),
    so = co;
  try {
    regeneratorRuntime = co;
  } catch (ep) {
    "object" === ("undefined" == typeof globalThis ? "undefined" : lr(globalThis)) ? globalThis.regeneratorRuntime = co : Function("r", "regeneratorRuntime = r")(co);
  }
  var uo = {
    exports: {}
  };
  uo.exports = function () {
    var e = function e() {},
      t = {},
      n = {},
      r = {};
    function o(e, t) {
      if (e) {
        var o = r[e];
        if (n[e] = t, o) for (; o.length;) {
          o[0](e, t), o.splice(0, 1);
        }
      }
    }
    function i(t, n) {
      t.call && (t = {
        success: t
      }), n.length ? (t.error || e)(n) : (t.success || e)(t);
    }
    function a(t, n, r, o) {
      var i,
        c,
        s = document,
        u = r.async,
        l = (r.numRetries || 0) + 1,
        p = r.before || e,
        d = t.replace(/[\?|#].*$/, ""),
        f = t.replace(/^(css|img)!/, "");
      o = o || 0, /(^css!|\.css$)/.test(d) ? ((c = s.createElement("link")).rel = "stylesheet", c.href = f, (i = "hideFocus" in c) && c.relList && (i = 0, c.rel = "preload", c.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d) ? (c = s.createElement("img")).src = f : ((c = s.createElement("script")).src = t, c.async = void 0 === u || u), c.onload = c.onerror = c.onbeforeload = function (e) {
        var s = e.type[0];
        if (i) try {
          c.sheet.cssText.length || (s = "e");
        } catch (e) {
          18 != e.code && (s = "e");
        }
        if ("e" == s) {
          if ((o += 1) < l) return a(t, n, r, o);
        } else if ("preload" == c.rel && "style" == c.as) return c.rel = "stylesheet";
        n(t, s, e.defaultPrevented);
      }, !1 !== p(t, c) && s.head.appendChild(c);
    }
    function c(e, t, n) {
      var r,
        o,
        i = (e = e.push ? e : [e]).length,
        c = i,
        s = [];
      for (r = function r(e, n, _r2) {
        if ("e" == n && s.push(e), "b" == n) {
          if (!_r2) return;
          s.push(e);
        }
        --i || t(s);
      }, o = 0; o < c; o++) {
        a(e[o], r, n);
      }
    }
    function s(e, n, r) {
      var a, s;
      if (n && n.trim && (a = n), s = (a ? r : n) || {}, a) {
        if (a in t) throw "LoadJS";
        t[a] = !0;
      }
      function u(t, n) {
        c(e, function (e) {
          i(s, e), t && i({
            success: t,
            error: n
          }, e), o(a, e);
        }, s);
      }
      if (s.returnPromise) return new Promise(u);
      u();
    }
    return s.ready = function (e, t) {
      return function (e, t) {
        e = e.push ? e : [e];
        var o,
          i,
          a,
          c = [],
          s = e.length,
          u = s;
        for (o = function o(e, n) {
          n.length && c.push(e), --u || t(c);
        }; s--;) {
          i = e[s], (a = n[i]) ? o(i, a) : (r[i] = r[i] || []).push(o);
        }
      }(e, function (e) {
        i(t, e);
      }), s;
    }, s.done = function (e) {
      o(e, []);
    }, s.reset = function () {
      t = {}, n = {}, r = {};
    }, s.isDefined = function (e) {
      return e in t;
    }, s;
  }();
  var lo,
    po,
    fo,
    ho,
    yo,
    mo,
    vo,
    go,
    bo,
    wo,
    ko,
    xo,
    Oo,
    _o,
    Co,
    Eo,
    Io,
    So = uo.exports;
  !function (e) {
    e.Init = "init", e.PullUpChannel = "pullUpChannel", e.CreateOrder = "createOrder", e.Pay = "pay", e.Hooks = "Hooks", e.CreateExpected = "createExpected", e.ReRender = "rerender";
  }(lo || (lo = {})), function (e) {
    e.Continue = "continue", e.PayNow = "pay_now", e.All = "all";
  }(po || (po = {})), function (e) {
    e.AdyenExpress = "AdyenExpress", e.Paypal = "Paypal", e.SLpayments = "SLpayments", e.StripeOther = "StripeOther", e.Tyro = "TyroWindows", e.CybsOther = "CybsOther";
  }(fo || (fo = {})), function (e) {
    e.Paypal = "Paypal", e.GooglePay = "GooglePay", e.ApplePay = "ApplePay";
  }(ho || (ho = {})), function (e) {
    e.StandardEC = "standard_ec";
  }(yo || (yo = {})), function (e) {
    e.Prod = "prod";
  }(mo || (mo = {})), function (e) {
    e.Done = "done", e.Pending = "pending", e.Await = "await", e.Fail = "fail";
  }(vo || (vo = {})), function (e) {
    e[e.Fail = 0] = "Fail", e[e.Success = 1] = "Success";
  }(go || (go = {})), function (e) {
    e.Ordinary = "ordinary", e.ChangeAddress = "change_address", e.ChangeDeliveryMethod = "change_delivery_method", e.UseDiscountCode = "use_discount_code";
  }(bo || (bo = {})), function (e) {
    e.PAYMENT_OPEN = "PAYMENT_OPEN";
  }(wo || (wo = {})), function (e) {
    e.NetworkUnstable = "networkUnstable", e.RateLimited = "rateLimited", e.Other = "other";
  }(ko || (ko = {})), function (e) {
    e.Init = "init", e.RedirectOrPopup = "RedirectOrPopup", e.Redirect = "Redirect", e.ChannelInfoUpdate = "ChannelInfoUpdate", e.ChannelConfirm = "ChannelConfirm", e.OpenIframe = "OpenIframe", e.Confirm = "Confirm", e.Challenge = "Challenge", e.Gather = "Gather";
  }(xo || (xo = {})), function (e) {
    e.GET = "GET", e.POST = "POST";
  }(Oo || (Oo = {})), function (e) {
    e.PAY_AND_BIND = "PAY_AND_BIND", e.PAY_NORMAL = "PAY_NORMAL";
  }(_o || (_o = {})), function (e) {
    e.Hidden = "Hidden", e.Visible = "Visible";
  }(Co || (Co = {})), function (e) {
    e.Form = "Form", e.Direct = "Direct", e.Both = "Both";
  }(Eo || (Eo = {})), function (e) {
    e.Confirm = "Confirm", e.Init = "Init", e.I18n = "I18n", e.SaveAbandonOrder = "SaveAbandonOrder", e.ExpressFirstLoad = "ExpressFirstLoad", e.ExpressUpdateDetail = "ExpressUpdateDetail";
  }(Io || (Io = {}));
  var Po = "paypal",
    Do = "rememberedCb",
    jo = {
      props: {
        payMode: po.Continue,
        buttonTimeoutConfig: {
          enable: !1,
          timeoutMillis: 5e3
        },
        styleOptions: {
          layout: "horizontal",
          color: "gold",
          shape: "rect",
          label: "paypal",
          tagline: !1,
          height: 55
        },
        timing: !1,
        currency: "USD"
      }
    };
  function To(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Ao(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? To(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : To(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var Ro,
    Lo = function () {
      function e(t) {
        var n;
        Jr(this, e), ro(this, "initialData", void 0), ro(this, "paypalInstanceName", void 0), this.initialData = t, this.paypalInstanceName = (null == t || null === (n = t.scriptParams) || void 0 === n ? void 0 : n["data-namespace"]) || Po, window.__PAYPALSPB_LOADJS || (window.__PAYPALSPB_LOADJS = So, window.__PAYPALSPB_LOADJS.ids = {});
      }
      var t;
      return Zr(e, [{
        key: "render",
        value: (t = Kr(so.mark(function e() {
          var t,
            n,
            r,
            o,
            i,
            a,
            c,
            s = this;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return r = "https://www.paypal.com/sdk/js", null !== (t = this.initialData) && void 0 !== t && t.queryParams && (r += "".concat(this.initialData.queryParams)), o = r, i = {}, null !== (n = this.initialData) && void 0 !== n && n.scriptParams && (c = (null === (a = this.initialData) || void 0 === a ? void 0 : a.scriptParams) || {}, i.before = function (e, t) {
                    Object.keys(c).forEach(function (e) {
                      var n = c[e];
                      n && t.setAttribute(e, n);
                    });
                  }, null != c && c["data-namespace"] && (this.paypalInstanceName = c["data-namespace"]), Object.keys(c).forEach(function (e) {
                    var t = c[e];
                    o += "".concat(e, "&").concat(t);
                  })), window.__PAYPALSPB_LOADJS.ids[o] || (window.__PAYPALSPB_LOADJS.ids[o] = window.__PAYPALSPB_LOADJS([r], Ao(Ao({}, i), {}, {
                    returnPromise: !0
                  }))), e.abrupt("return", window.__PAYPALSPB_LOADJS.ids[o].then(function () {
                    s.initPaypal();
                  })["catch"](function (e) {
                    throw window.__PAYPALSPB_LOADJS.ids[o] = !1, e;
                  }));
                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return t.apply(this, arguments);
        })
      }]), e;
    }(),
    No = function (e) {
      eo(n, Lo);
      var t = function (e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var n,
            r = no(e);
          if (t) {
            var o = no(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);
          return to(this, n);
        };
      }(n);
      function n(e) {
        return Jr(this, n), t.call(this, e);
      }
      return Zr(n, [{
        key: "initPaypal",
        value: function value() {
          var e,
            t = null === (e = this.initialData.style) || void 0 === e ? void 0 : e["border-radius"],
            n = Ao({}, this.initialData);
          n.style || (n.style = {}), n.style.shape = t >= 10 ? "pill" : "rect";
          var r = document.querySelector("#".concat(this.initialData.domId, " .").concat("paypal-buttons"));
          r && r.remove(), window[this.paypalInstanceName].Buttons(this.initialData).render("#".concat(this.initialData.domId));
        }
      }]), n;
    }(),
    Mo = function () {
      function e() {
        Jr(this, e), ro(this, "handlers", []);
      }
      return Zr(e, [{
        key: "use",
        value: function value(e, t) {
          return this.handlers.push({
            fulfilled: e,
            rejected: t
          }), this.handlers.length - 1;
        }
      }, {
        key: "eject",
        value: function value(e) {
          this.handlers[e] && (this.handlers[e] = null);
        }
      }, {
        key: "clear",
        value: function value() {
          this.handlers && (this.handlers = []);
        }
      }, {
        key: "forEach",
        value: function value(e) {
          this.handlers.forEach(function (t) {
            null !== t && e(t);
          });
        }
      }]), e;
    }();
  function Bo(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Fo(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Bo(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bo(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var Ho = {
      maxCount: 3,
      interval: 1e3
    },
    Uo = {};
  function Vo(e, t) {
    if (!e) return null;
    var n = Uo[e] || {};
    return n = Fo(Fo(Fo(Fo({}, n), Ho), t), {}, {
      retryCount: n.retryCount || 0
    }), Uo[e] = n, n;
  }
  var zo = function zo(e) {
      return e.useRetry && e.action;
    },
    qo = function qo(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "xhr";
      return JSON.parse(JSON.stringify(e, function (e, n) {
        if (e !== t) return n;
      }));
    };
  function Go(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Wo(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Go(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Go(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var Ko = function () {
      function e(t) {
        Jr(this, e), ro(this, "options", {}), ro(this, "interceptors", {}), ro(this, "getLogData", function (e) {
          return {
            readyState: e.readyState,
            status: e.status,
            statusText: e.statusText,
            timeout: e.timeout,
            withCredentials: e.withCredentials
          };
        }), ro(this, "serialize", function (e) {
          var t = Object.prototype.toString.call(e);
          return e && "[object Object]" === t ? Object.keys(e).map(function (t) {
            return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
          }).join("&") : "";
        }), this.options = t || {}, this.interceptors = {
          request: new Mo(),
          response: new Mo()
        };
      }
      return Zr(e, [{
        key: "logger",
        get: function get() {
          return Gr.get().pipeOwner("payment-common.request");
        }
      }, {
        key: "setOptions",
        value: function value(e) {
          this.options = e;
        }
      }, {
        key: "get",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return e = this.buildUrl(e, null == t ? void 0 : t.params), this.http(e, Wo(Wo(Wo({
            method: "GET"
          }, this.options), t), {}, {
            headers: Wo(Wo({}, {
              Accept: "application/json",
              "Content-Type": "application/json;charset=UTF-8"
            }), t.headers)
          }));
        }
      }, {
        key: "post",
        value: function value(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = {
              Accept: "application/json"
            },
            o = t || n.data || null;
          return "form" === n.requestType ? (r["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8", o = this.serialize(o)) : (r["Content-Type"] = "application/json;charset=UTF-8", o = o ? JSON.stringify(o) : null), this.http(e, Wo(Wo(Wo({
            method: "POST",
            body: o
          }, this.options), n), {}, {
            headers: Wo(Wo({}, r), n.headers)
          }));
        }
      }, {
        key: "dispatchRequest",
        value: function value(e, t) {
          var n = this;
          return new Promise(function (r, o) {
            var i = new window.XMLHttpRequest(),
              a = !1,
              c = t.body,
              s = n.options.baseUrl && !/^(https?:)?(\/\/)/.test(e) ? "".concat(n.options.baseUrl).concat(e) : e;
            i.open(t.method || "", s), t.headers && Object.keys(t.headers).forEach(function (e) {
              var n;
              i.setRequestHeader(e, (null === (n = t.headers) || void 0 === n ? void 0 : n[e]) || "");
            });
            var u = {
              options: t,
              url: s
            };
            if (i.onreadystatechange = function () {
              if (4 === i.readyState) {
                u.statusCode = i.status;
                var e = "";
                try {
                  e = JSON.parse(i.responseText);
                } catch (t) {
                  e = i.responseText;
                }
                if (/^(2|3)\d{2}$/.test(i.status.toString())) {
                  try {
                    r(Wo({
                      data: e
                    }, u));
                  } catch (t) {
                    r(Wo({
                      data: e
                    }, u));
                  }
                  return;
                }
                o(Wo({
                  data: e
                }, u));
              }
            }, i.send(c), i.onabort = function (t) {
              a = !0, n.logger.error("xhr_onabort", {
                data: Wo(Wo({}, n.getLogData(i)), {}, {
                  url: e
                })
              }), u.statusCode = i.status, t = qo(t), o(Wo({
                error: t
              }, u));
            }, i.onerror = function (t) {
              n.logger.error("xhr_onerror", {
                data: Wo(Wo({}, n.getLogData(i)), {}, {
                  url: e
                })
              }), u.statusCode = i.status, t = qo(t), o(Wo({
                error: t
              }, u));
            }, i.ontimeout = function () {
              n.logger.error("xhr_ontimeout", {
                data: Wo(Wo({}, n.getLogData(i)), {}, {
                  url: e,
                  withCredentials: i.withCredentials
                })
              });
            }, t.timeout) {
              if (a) return;
              setTimeout(function () {
                i.abort();
                var t = new Error("XMLHttpRequest timeout");
                t.code = "ETIMEDOUT", n.logger.error("xhr_timeout", {
                  data: {
                    url: e
                  }
                }), u.statusCode = i.status, o(Wo({
                  error: t
                }, u));
              }, t.timeout);
            }
          });
        }
      }, {
        key: "http",
        value: function value(e, t) {
          var n,
            r,
            o,
            i,
            a = [];
          null === (n = this.interceptors) || void 0 === n || null === (r = n.request) || void 0 === r || r.forEach(function (e) {
            a.unshift(e.fulfilled, e.rejected);
          });
          var c,
            s = [];
          null === (o = this.interceptors) || void 0 === o || null === (i = o.response) || void 0 === i || i.forEach(function (e) {
            s.push(e.fulfilled, e.rejected);
          });
          for (var u = t; a.length;) {
            var l = a.shift(),
              p = a.shift();
            try {
              l && (u = l(u));
            } catch (e) {
              p && p(e);
              break;
            }
          }
          try {
            c = this.dispatchRequest(e, u);
          } catch (e) {
            return Promise.reject(e);
          }
          for (; s.length;) {
            var d = s.shift(),
              f = s.shift();
            c = c.then(d, f);
          }
          return c;
        }
      }, {
        key: "buildUrl",
        value: function value(e, t) {
          var n = Object.prototype.toString.call(t);
          if (!t || "[object Object]" !== n) return e;
          var r = Object.keys(t);
          return (e = decodeURIComponent(e).indexOf("?") > -1 ? "".concat(e, "&") : "".concat(e, "?")) + r.map(function (e) {
            return "".concat(e, "=").concat(t[e]);
          }).join("&");
        }
      }]), e;
    }(),
    Jo = new Ko();
  function Yo(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  !function (e) {
    var t, n, r, o;
    null == e || null === (t = e.interceptors) || void 0 === t || null === (n = t.request) || void 0 === n || n.use(function (e) {
      Ro || (Ro = Gr.get().pipeOwner("payment-common.retry"));
      var t = Vo(e.action);
      return zo(e) && t ? (t.lastRequestTime = Date.now(), e) : e;
    }), null == e || null === (r = e.interceptors) || void 0 === r || null === (o = r.response) || void 0 === o || o.use(null, function (t) {
      var n = t.options,
        r = t.url;
      if (!n) return Promise.reject(t);
      var o = Vo(n.action, n.retryOptions);
      if (!zo(n) || !o) return Promise.reject(t);
      var i = function (e, t, n) {
        if (!e) return !1;
        if (!function (e, t) {
          switch (e) {
            case Io.Init:
            case Io.SaveAbandonOrder:
            case Io.ExpressFirstLoad:
            case Io.ExpressUpdateDetail:
              return function (e) {
                return !!e && 400 !== e.statusCode;
              }(t);
            case Io.I18n:
              return !0;
            default:
              return !1;
          }
        }(e, n)) return !1;
        var r,
          o,
          i = t.retryCount < (null == t ? void 0 : t.maxCount),
          a = n.statusCode,
          c = {
            action: e,
            statusCode: a,
            url: n.url
          };
        return i ? null === (r = Ro) || void 0 === r || r.log("start_retry", {
          data: Fo(Fo({}, c), {}, {
            retryCount: t.retryCount
          })
        }) : (null === (o = Ro) || void 0 === o || o.error("retry_max_times", {
          data: c,
          errorLevel: 0 === a ? nr.P2 : nr.P1
        }), t.retryCount = 0), i;
      }(n.action, o, t);
      if (i) {
        if (o.retryCount += 1, n.timeout && o.lastRequestTime) {
          var a = Date.now() - o.lastRequestTime;
          n.timeout = Math.max(n.timeout - a - o.interval, 1);
        }
        return new Promise(function (t) {
          return setTimeout(function () {
            t(e.http(r, n));
          }, o.interval);
        });
      }
      return Promise.reject(t);
    });
  }(Jo);
  var Xo = function Xo(e) {
    return Jo.post("/leproxy/api/trade/center/pay/fast-checkout/prepare-pay", function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Yo(Object(n), !0).forEach(function (t) {
          ro(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Yo(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }({}, e));
  };
  function Zo(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }
    return r;
  }
  function $o(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          o,
          i,
          a,
          c = [],
          s = !0,
          u = !1;
        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            s = !1;
          } else for (; !(s = (r = i.call(n)).done) && (c.push(r.value), c.length !== t); s = !0) {
            ;
          }
        } catch (e) {
          u = !0, o = e;
        } finally {
          try {
            if (!s && null != n["return"] && (a = n["return"](), Object(a) !== a)) return;
          } finally {
            if (u) throw o;
          }
        }
        return c;
      }
    }(e, t) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return Zo(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Zo(e, t) : void 0;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  var Qo = function Qo(e) {
    return "function" == typeof e;
  };
  function ei(e) {
    return "[object Object]" === Object.prototype.toString.call(e);
  }
  function ti(e) {
    return !e || e.nodeType || "object" !== lr(e) ? e : JSON.parse(JSON.stringify(e));
  }
  function ni(e, t) {
    if (function (e) {
      return function (e) {
        return void 0 === e;
      }(e) || function (e) {
        return null === e;
      }(e);
    }(t)) return ti(e);
    if (!ei(t) || !ei(e)) return ti(t);
    var n = {};
    return Object.keys(e).map(function (r) {
      n[r] = ni(e[r], t[r]);
    }), Object.keys(t).map(function (e) {
      n[e] || (n[e] = ti(t[e]));
    }), n;
  }
  var ri = window.performance && "function" == typeof window.performance.now ? window.performance : Date,
    oi = function e(t) {
      t instanceof Array ? t.forEach(function (t) {
        return e(t);
      }) : "object" === lr(t) && null !== t && Object.entries(t).forEach(function (n) {
        var r = $o(n, 2),
          o = r[0],
          i = r[1];
        null === i ? delete t[o] : i instanceof Array ? i.forEach(function (t) {
          return e(t);
        }) : "object" === lr(i) && e(i);
      });
    },
    ii = function () {
      var e = Kr(so.mark(function e(t) {
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", new Promise(function (e) {
                  return setTimeout(e, t);
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    ai = function ai(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
          retries: 5,
          interval: 1e3
        },
        n = function () {
          var r = Kr(so.mark(function r() {
            var o,
              i = arguments;
            return so.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.prev = 0, r.next = 3, e.apply(void 0, i);
                  case 3:
                    return o = r.sent, r.abrupt("return", o);
                  case 7:
                    if (r.prev = 7, r.t0 = r["catch"](0), 0 !== t.retries) {
                      r.next = 11;
                      break;
                    }
                    throw r.t0;
                  case 11:
                    return t.retries--, r.next = 14, ii(t.interval);
                  case 14:
                    return r.abrupt("return", n.apply(void 0, i));
                  case 15:
                  case "end":
                    return r.stop();
                }
              }
            }, r, null, [[0, 7]]);
          }));
          return function () {
            return r.apply(this, arguments);
          };
        }();
      return n;
    },
    ci = Gr.get();
  var si,
    ui = "smart-payment-hide",
    li = "smart-payment-button-disabled",
    pi = "smart-payment-button-loading",
    di = Zr(function e(t) {
      var n = this;
      Jr(this, e), ro(this, "config", void 0), ro(this, "isVisible", !0), ro(this, "showButton", function () {
        var e = document.getElementById(n.config.paymentInfo.currentDomId);
        null == e || e.classList.remove(ui), n.isVisible = !0;
      }), ro(this, "hideButton", function () {
        var e = document.getElementById(n.config.paymentInfo.currentDomId);
        null == e || e.classList.add(ui), n.isVisible = !1;
      }), this.config = t;
    }),
    fi = function fi(e, t) {
      var n = Object.entries(t).filter(function (e) {
        var t = $o(e, 2),
          n = t[0],
          r = t[1];
        return n && null != r && "" !== r;
      }).map(function (e) {
        var t = $o(e, 2),
          n = t[0],
          r = t[1];
        return "".concat(encodeURIComponent(n), "=").concat(encodeURIComponent(String(r)));
      });
      if (!n.length) return e;
      var r = -1 === e.search(/\?/) ? "?" : "&";
      return e + r + n.join("&");
    },
    hi = function hi(e) {
      return /^https:\/\/([^.]+)?\.myshopline([^.]+)?\.com$/.test(e);
    },
    yi = function yi(e) {
      return new URL(e).origin;
    },
    mi = function () {
      function e(t, n) {
        var r = this;
        Jr(this, e), ro(this, "type", void 0), ro(this, "domId", void 0), ro(this, "payOptions", void 0), ro(this, "timer", null), ro(this, "resolveFn", void 0), ro(this, "rejectFn", void 0), ro(this, "logger", Gr.get().pipeOwner("payment-common.3DS")), ro(this, "handlePostmessage", function (e) {
          var t = e.data,
            n = e.origin;
          if (!1 !== hi(n)) {
            r.logger.log("3DS_handlePostmessage", {
              data: {
                data: t,
                origin: n,
                domId: r.domId
              }
            });
            var o = t.success,
              i = t.nextAction || {},
              a = t.nextAction || {},
              c = a.url,
              s = a.type;
            if (o) {
              if (s === xo.Redirect && c) {
                if (window.removeEventListener("message", r.handlePostmessage, !1), r.domId) {
                  var u = document.getElementById(r.domId);
                  u && u.parentElement && u.parentElement.removeChild(u);
                }
                return zi(i), void (r.resolveFn && r.resolveFn());
              }
              if (s === xo.OpenIframe) return r.openIframe(t.nextAction), void (r.resolveFn && r.resolveFn());
              r.logger.error("do not match nextAction type", {
                data: {
                  nextAction: i
                },
                error: new Error("")
              }), r.rejectFn && r.rejectFn(new Error("do not match nextAction type"));
            }
          }
        }), this.type = t, this.payOptions = n;
      }
      return Zr(e, [{
        key: "handleIframe",
        value: function value(e) {
          var t,
            n = e.type,
            r = e.iframeType,
            o = e.url,
            i = void 0 === o ? "" : o,
            a = e.size,
            c = "".concat(n, "Iframe-").concat(Date.now());
          return this.domId = c, r === Co.Hidden ? t = function (e, t) {
            var n = document.createElement("iframe");
            return n.src = e, n.name = t, n.style.width = "1px", n.style.height = "1px", n.style.display = "none", n.style.border = "none", document.body.appendChild(n), n;
          }(i, c) : r === Co.Visible && (t = function (e, t, n) {
            var r,
              o,
              i = document.createElement("iframe");
            i.src = e, i.name = t, i.style.width = (null == n || null === (r = n.size) || void 0 === r ? void 0 : r.width) || "100%", i.style.height = (null == n || null === (o = n.size) || void 0 === o ? void 0 : o.height) || "100%", i.style.display = "block", i.style.border = "none", i.style.zIndex = "1000", i.style.position = "fixed", i.style.top = "0", i.style.left = "0", i.style.bottom = "0", i.style.right = "0", i.style.margin = "auto", i.style.background = "#fff";
            var a = document.createElement("div");
            return a.style.position = "fixed", a.style.zIndex = "999", a.style.width = "100%", a.style.height = "100%", a.style.top = "0", a.style.left = "0", a.style.background = "rgba(0, 0, 0, 0.5)", document.body.appendChild(a), document.body.appendChild(i), i;
          }(i, c, {
            size: a
          })), t;
        }
      }, {
        key: "handleForm",
        value: function value(e) {
          var t = this,
            n = e.urlAccessType,
            r = e.url,
            o = e.method,
            i = e.channelData,
            a = e.iframeName,
            c = e.formField;
          return (n === Eo.Form || n === Eo.Both && o === Oo.POST) && function () {
            var e = function (e) {
              var t = e.action,
                n = e.method,
                r = void 0 === n ? "POST" : n,
                o = e.channelData,
                i = e.formField,
                a = e.iframeName,
                c = document.createElement("form");
              for (var s in c.action = t, c.method = r, a && (c.target = a), o) {
                var u = document.createElement("input");
                u.name = s, u.value = o[s], u.type = "hidden", c.appendChild(u);
              }
              return i && i.forEach(function (e) {
                var t = document.createElement(e.element);
                Object.keys(e.attribute).forEach(function (n) {
                  var r = e.attribute[n];
                  r && t.setAttribute(n, r);
                }), c.appendChild(t);
              }), document.body.appendChild(c), c;
            }({
              action: r,
              method: o,
              channelData: i,
              iframeName: a,
              formField: c
            });
            t.logger.log("3DS_handleForm_about_to_trigger_form_submission"), e.submit();
          }(), new Promise(function (e) {
            e();
          });
        }
      }, {
        key: "gather",
        value: function value(e) {
          var t = this;
          return new Promise(function (n, r) {
            t.resolveFn = n, t.rejectFn = r, t.logger.log("3DS_gather_start", {
              data: {
                nextAction: e
              }
            });
            var o = e.data,
              i = e.method,
              a = void 0 === i ? Oo.GET : i,
              c = e.url,
              s = e.type,
              u = JSON.parse((null == o ? void 0 : o.additionalData) || "")[s] || {},
              l = u.urlAccessType,
              p = u.iframeType,
              d = u.formField,
              f = u.closePolling,
              h = void 0 !== f && f,
              y = u.listenMessageFromChannel,
              m = void 0 !== y && y,
              v = u.channelMessageTimeout,
              g = t.handleIframe({
                type: s,
                iframeType: p,
                url: c,
                method: a
              }),
              b = null == g ? void 0 : g.getAttribute("name");
            if (!h) {
              var w = e.nextAction;
              !0 === m && w ? t.gatherFromChannel(w, {
                timeout: v,
                origin: yi(c)
              }) : (window.removeEventListener("message", t.handlePostmessage, !1), window.addEventListener("message", t.handlePostmessage, !1));
            }
            t.handleForm({
              urlAccessType: l,
              url: c,
              method: a,
              channelData: null == o ? void 0 : o.channelData,
              iframeName: b,
              formField: d
            });
          });
        }
      }, {
        key: "gatherFromChannel",
        value: function value(e, t) {
          var n = this,
            r = function () {
              var r = Kr(so.mark(function r(o) {
                var i, a;
                return so.wrap(function (r) {
                  for (;;) {
                    switch (r.prev = r.next) {
                      case 0:
                        if (i = o.data, (a = o.origin) === t.origin) {
                          r.next = 3;
                          break;
                        }
                        return r.abrupt("return");
                      case 3:
                        if (n.logger.log("3DS_handleChannelMessage", {
                          data: {
                            data: i,
                            origin: a
                          }
                        }), n.timer && (clearTimeout(n.timer), n.timer = null), !n.resolveFn) {
                          r.next = 9;
                          break;
                        }
                        return r.next = 8, Zi(e, {
                          channelInfoData: i
                        });
                      case 8:
                        n.resolveFn();
                      case 9:
                      case "end":
                        return r.stop();
                    }
                  }
                }, r);
              }));
              return function (e) {
                return r.apply(this, arguments);
              };
            }();
          t.timeout > 0 && (this.timer = window.setTimeout(Kr(so.mark(function t() {
            return so.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (window.removeEventListener("message", r, !1), !n.resolveFn) {
                      t.next = 5;
                      break;
                    }
                    return t.next = 4, Zi(e, {
                      channelInfoData: {}
                    });
                  case 4:
                    n.resolveFn();
                  case 5:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          })), t.timeout)), window.removeEventListener("message", r, !1), window.addEventListener("message", r, !1);
        }
      }, {
        key: "challenge",
        value: function value(e) {
          var t = this;
          return new Promise(function (n, r) {
            t.resolveFn = n, t.rejectFn = r, t.logger.log("3DS_challenge_start", {
              data: {
                nextAction: e
              }
            });
            var o = e.data,
              i = e.method,
              a = void 0 === i ? Oo.GET : i,
              c = e.url,
              s = e.type,
              u = JSON.parse((null == o ? void 0 : o.additionalData) || "")[s] || {},
              l = u.urlAccessType,
              p = u.iframeType,
              d = u.formField,
              f = u.closePolling,
              h = void 0 !== f && f,
              y = t.handleIframe({
                type: s,
                iframeType: p,
                url: c,
                method: a,
                size: null == o ? void 0 : o.size
              }),
              m = null == y ? void 0 : y.getAttribute("name");
            h || (window.removeEventListener("message", t.handlePostmessage, !1), window.addEventListener("message", t.handlePostmessage, !1)), t.handleForm({
              urlAccessType: l,
              url: c,
              method: a,
              channelData: null == o ? void 0 : o.channelData,
              iframeName: m,
              formField: d
            });
          });
        }
      }, {
        key: "openIframe",
        value: function value(e) {
          var t;
          this.logger.log("3DS_openIframe_start", {
            data: {
              nextAction: e,
              domId: this.domId
            }
          });
          var n = e.url,
            r = e.type,
            o = e.header,
            i = null != o && null !== (t = o.openIframeOptions) && void 0 !== t && t.hidden ? Co.Hidden : Co.Visible;
          this.handleIframe({
            type: r,
            iframeType: i,
            url: n
          }), window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1);
        }
      }]), e;
    }(),
    vi = {
      exports: {}
    },
    gi = {
      exports: {}
    },
    bi = function (e) {
      if (e.__esModule) return e;
      var t = Object.defineProperty({}, "__esModule", {
        value: !0
      });
      return Object.keys(e).forEach(function (n) {
        var r = Object.getOwnPropertyDescriptor(e, n);
        Object.defineProperty(t, n, r.get ? r : {
          enumerable: !0,
          get: function get() {
            return e[n];
          }
        });
      }), t;
    }(Object.freeze({
      __proto__: null,
      "default": {}
    }));
  gi.exports = (si = si || function (e, t) {
    var n;
    if ("undefined" != typeof window && window.crypto && (n = window.crypto), "undefined" != typeof self && self.crypto && (n = self.crypto), "undefined" != typeof globalThis && globalThis.crypto && (n = globalThis.crypto), !n && "undefined" != typeof window && window.msCrypto && (n = window.msCrypto), !n && void 0 !== oo && oo.crypto && (n = oo.crypto), !n) try {
      n = bi;
    } catch (e) {}
    var r = function r() {
        if (n) {
          if ("function" == typeof n.getRandomValues) try {
            return n.getRandomValues(new Uint32Array(1))[0];
          } catch (e) {}
          if ("function" == typeof n.randomBytes) try {
            return n.randomBytes(4).readInt32LE();
          } catch (e) {}
        }
        throw new Error("Native crypto module could not be used to get secure random number.");
      },
      o = Object.create || function () {
        function e() {}
        return function (t) {
          var n;
          return e.prototype = t, n = new e(), e.prototype = null, n;
        };
      }(),
      i = {},
      a = i.lib = {},
      c = a.Base = {
        extend: function extend(e) {
          var t = o(this);
          return e && t.mixIn(e), t.hasOwnProperty("init") && this.init !== t.init || (t.init = function () {
            t.$super.init.apply(this, arguments);
          }), t.init.prototype = t, t.$super = this, t;
        },
        create: function create() {
          var e = this.extend();
          return e.init.apply(e, arguments), e;
        },
        init: function init() {},
        mixIn: function mixIn(e) {
          for (var t in e) {
            e.hasOwnProperty(t) && (this[t] = e[t]);
          }
          e.hasOwnProperty("toString") && (this.toString = e.toString);
        },
        clone: function clone() {
          return this.init.prototype.extend(this);
        }
      },
      s = a.WordArray = c.extend({
        init: function init(e, t) {
          e = this.words = e || [], this.sigBytes = null != t ? t : 4 * e.length;
        },
        toString: function toString(e) {
          return (e || l).stringify(this);
        },
        concat: function concat(e) {
          var t = this.words,
            n = e.words,
            r = this.sigBytes,
            o = e.sigBytes;
          if (this.clamp(), r % 4) for (var i = 0; i < o; i++) {
            var a = n[i >>> 2] >>> 24 - i % 4 * 8 & 255;
            t[r + i >>> 2] |= a << 24 - (r + i) % 4 * 8;
          } else for (var c = 0; c < o; c += 4) {
            t[r + c >>> 2] = n[c >>> 2];
          }
          return this.sigBytes += o, this;
        },
        clamp: function clamp() {
          var t = this.words,
            n = this.sigBytes;
          t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, t.length = e.ceil(n / 4);
        },
        clone: function clone() {
          var e = c.clone.call(this);
          return e.words = this.words.slice(0), e;
        },
        random: function random(e) {
          for (var t = [], n = 0; n < e; n += 4) {
            t.push(r());
          }
          return new s.init(t, e);
        }
      }),
      u = i.enc = {},
      l = u.Hex = {
        stringify: function stringify(e) {
          for (var t = e.words, n = e.sigBytes, r = [], o = 0; o < n; o++) {
            var i = t[o >>> 2] >>> 24 - o % 4 * 8 & 255;
            r.push((i >>> 4).toString(16)), r.push((15 & i).toString(16));
          }
          return r.join("");
        },
        parse: function parse(e) {
          for (var t = e.length, n = [], r = 0; r < t; r += 2) {
            n[r >>> 3] |= parseInt(e.substr(r, 2), 16) << 24 - r % 8 * 4;
          }
          return new s.init(n, t / 2);
        }
      },
      p = u.Latin1 = {
        stringify: function stringify(e) {
          for (var t = e.words, n = e.sigBytes, r = [], o = 0; o < n; o++) {
            var i = t[o >>> 2] >>> 24 - o % 4 * 8 & 255;
            r.push(String.fromCharCode(i));
          }
          return r.join("");
        },
        parse: function parse(e) {
          for (var t = e.length, n = [], r = 0; r < t; r++) {
            n[r >>> 2] |= (255 & e.charCodeAt(r)) << 24 - r % 4 * 8;
          }
          return new s.init(n, t);
        }
      },
      d = u.Utf8 = {
        stringify: function stringify(e) {
          try {
            return decodeURIComponent(escape(p.stringify(e)));
          } catch (e) {
            throw new Error("Malformed UTF-8 data");
          }
        },
        parse: function parse(e) {
          return p.parse(unescape(encodeURIComponent(e)));
        }
      },
      f = a.BufferedBlockAlgorithm = c.extend({
        reset: function reset() {
          this._data = new s.init(), this._nDataBytes = 0;
        },
        _append: function _append(e) {
          "string" == typeof e && (e = d.parse(e)), this._data.concat(e), this._nDataBytes += e.sigBytes;
        },
        _process: function _process(t) {
          var n,
            r = this._data,
            o = r.words,
            i = r.sigBytes,
            a = this.blockSize,
            c = i / (4 * a),
            u = (c = t ? e.ceil(c) : e.max((0 | c) - this._minBufferSize, 0)) * a,
            l = e.min(4 * u, i);
          if (u) {
            for (var p = 0; p < u; p += a) {
              this._doProcessBlock(o, p);
            }
            n = o.splice(0, u), r.sigBytes -= l;
          }
          return new s.init(n, l);
        },
        clone: function clone() {
          var e = c.clone.call(this);
          return e._data = this._data.clone(), e;
        },
        _minBufferSize: 0
      });
    a.Hasher = f.extend({
      cfg: c.extend(),
      init: function init(e) {
        this.cfg = this.cfg.extend(e), this.reset();
      },
      reset: function reset() {
        f.reset.call(this), this._doReset();
      },
      update: function update(e) {
        return this._append(e), this._process(), this;
      },
      finalize: function finalize(e) {
        return e && this._append(e), this._doFinalize();
      },
      blockSize: 16,
      _createHelper: function _createHelper(e) {
        return function (t, n) {
          return new e.init(n).finalize(t);
        };
      },
      _createHmacHelper: function _createHmacHelper(e) {
        return function (t, n) {
          return new h.HMAC.init(e, n).finalize(t);
        };
      }
    });
    var h = i.algo = {};
    return i;
  }(Math), si), function (e) {
    (function () {
      var t = e,
        n = t.lib.WordArray;
      function r(e, t, r) {
        for (var o = [], i = 0, a = 0; a < t; a++) {
          if (a % 4) {
            var c = r[e.charCodeAt(a - 1)] << a % 4 * 2 | r[e.charCodeAt(a)] >>> 6 - a % 4 * 2;
            o[i >>> 2] |= c << 24 - i % 4 * 8, i++;
          }
        }
        return n.create(o, i);
      }
      t.enc.Base64 = {
        stringify: function stringify(e) {
          var t = e.words,
            n = e.sigBytes,
            r = this._map;
          e.clamp();
          for (var o = [], i = 0; i < n; i += 3) {
            for (var a = (t[i >>> 2] >>> 24 - i % 4 * 8 & 255) << 16 | (t[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 255) << 8 | t[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 255, c = 0; c < 4 && i + .75 * c < n; c++) {
              o.push(r.charAt(a >>> 6 * (3 - c) & 63));
            }
          }
          var s = r.charAt(64);
          if (s) for (; o.length % 4;) {
            o.push(s);
          }
          return o.join("");
        },
        parse: function parse(e) {
          var t = e.length,
            n = this._map,
            o = this._reverseMap;
          if (!o) {
            o = this._reverseMap = [];
            for (var i = 0; i < n.length; i++) {
              o[n.charCodeAt(i)] = i;
            }
          }
          var a = n.charAt(64);
          if (a) {
            var c = e.indexOf(a);
            -1 !== c && (t = c);
          }
          return r(e, t, o);
        },
        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
      };
    })(), e.enc.Base64;
  }(gi.exports), function (e) {
    (function (t) {
      var n = e,
        r = n.lib,
        o = r.WordArray,
        i = r.Hasher,
        a = n.algo,
        c = [];
      !function () {
        for (var e = 0; e < 64; e++) {
          c[e] = 4294967296 * t.abs(t.sin(e + 1)) | 0;
        }
      }();
      var s = a.MD5 = i.extend({
        _doReset: function _doReset() {
          this._hash = new o.init([1732584193, 4023233417, 2562383102, 271733878]);
        },
        _doProcessBlock: function _doProcessBlock(e, t) {
          for (var n = 0; n < 16; n++) {
            var r = t + n,
              o = e[r];
            e[r] = 16711935 & (o << 8 | o >>> 24) | 4278255360 & (o << 24 | o >>> 8);
          }
          var i = this._hash.words,
            a = e[t + 0],
            s = e[t + 1],
            f = e[t + 2],
            h = e[t + 3],
            y = e[t + 4],
            m = e[t + 5],
            v = e[t + 6],
            g = e[t + 7],
            b = e[t + 8],
            w = e[t + 9],
            k = e[t + 10],
            x = e[t + 11],
            O = e[t + 12],
            _ = e[t + 13],
            C = e[t + 14],
            E = e[t + 15],
            I = i[0],
            S = i[1],
            P = i[2],
            D = i[3];
          I = u(I, S, P, D, a, 7, c[0]), D = u(D, I, S, P, s, 12, c[1]), P = u(P, D, I, S, f, 17, c[2]), S = u(S, P, D, I, h, 22, c[3]), I = u(I, S, P, D, y, 7, c[4]), D = u(D, I, S, P, m, 12, c[5]), P = u(P, D, I, S, v, 17, c[6]), S = u(S, P, D, I, g, 22, c[7]), I = u(I, S, P, D, b, 7, c[8]), D = u(D, I, S, P, w, 12, c[9]), P = u(P, D, I, S, k, 17, c[10]), S = u(S, P, D, I, x, 22, c[11]), I = u(I, S, P, D, O, 7, c[12]), D = u(D, I, S, P, _, 12, c[13]), P = u(P, D, I, S, C, 17, c[14]), I = l(I, S = u(S, P, D, I, E, 22, c[15]), P, D, s, 5, c[16]), D = l(D, I, S, P, v, 9, c[17]), P = l(P, D, I, S, x, 14, c[18]), S = l(S, P, D, I, a, 20, c[19]), I = l(I, S, P, D, m, 5, c[20]), D = l(D, I, S, P, k, 9, c[21]), P = l(P, D, I, S, E, 14, c[22]), S = l(S, P, D, I, y, 20, c[23]), I = l(I, S, P, D, w, 5, c[24]), D = l(D, I, S, P, C, 9, c[25]), P = l(P, D, I, S, h, 14, c[26]), S = l(S, P, D, I, b, 20, c[27]), I = l(I, S, P, D, _, 5, c[28]), D = l(D, I, S, P, f, 9, c[29]), P = l(P, D, I, S, g, 14, c[30]), I = p(I, S = l(S, P, D, I, O, 20, c[31]), P, D, m, 4, c[32]), D = p(D, I, S, P, b, 11, c[33]), P = p(P, D, I, S, x, 16, c[34]), S = p(S, P, D, I, C, 23, c[35]), I = p(I, S, P, D, s, 4, c[36]), D = p(D, I, S, P, y, 11, c[37]), P = p(P, D, I, S, g, 16, c[38]), S = p(S, P, D, I, k, 23, c[39]), I = p(I, S, P, D, _, 4, c[40]), D = p(D, I, S, P, a, 11, c[41]), P = p(P, D, I, S, h, 16, c[42]), S = p(S, P, D, I, v, 23, c[43]), I = p(I, S, P, D, w, 4, c[44]), D = p(D, I, S, P, O, 11, c[45]), P = p(P, D, I, S, E, 16, c[46]), I = d(I, S = p(S, P, D, I, f, 23, c[47]), P, D, a, 6, c[48]), D = d(D, I, S, P, g, 10, c[49]), P = d(P, D, I, S, C, 15, c[50]), S = d(S, P, D, I, m, 21, c[51]), I = d(I, S, P, D, O, 6, c[52]), D = d(D, I, S, P, h, 10, c[53]), P = d(P, D, I, S, k, 15, c[54]), S = d(S, P, D, I, s, 21, c[55]), I = d(I, S, P, D, b, 6, c[56]), D = d(D, I, S, P, E, 10, c[57]), P = d(P, D, I, S, v, 15, c[58]), S = d(S, P, D, I, _, 21, c[59]), I = d(I, S, P, D, y, 6, c[60]), D = d(D, I, S, P, x, 10, c[61]), P = d(P, D, I, S, f, 15, c[62]), S = d(S, P, D, I, w, 21, c[63]), i[0] = i[0] + I | 0, i[1] = i[1] + S | 0, i[2] = i[2] + P | 0, i[3] = i[3] + D | 0;
        },
        _doFinalize: function _doFinalize() {
          var e = this._data,
            n = e.words,
            r = 8 * this._nDataBytes,
            o = 8 * e.sigBytes;
          n[o >>> 5] |= 128 << 24 - o % 32;
          var i = t.floor(r / 4294967296),
            a = r;
          n[15 + (o + 64 >>> 9 << 4)] = 16711935 & (i << 8 | i >>> 24) | 4278255360 & (i << 24 | i >>> 8), n[14 + (o + 64 >>> 9 << 4)] = 16711935 & (a << 8 | a >>> 24) | 4278255360 & (a << 24 | a >>> 8), e.sigBytes = 4 * (n.length + 1), this._process();
          for (var c = this._hash, s = c.words, u = 0; u < 4; u++) {
            var l = s[u];
            s[u] = 16711935 & (l << 8 | l >>> 24) | 4278255360 & (l << 24 | l >>> 8);
          }
          return c;
        },
        clone: function clone() {
          var e = i.clone.call(this);
          return e._hash = this._hash.clone(), e;
        }
      });
      function u(e, t, n, r, o, i, a) {
        var c = e + (t & n | ~t & r) + o + a;
        return (c << i | c >>> 32 - i) + t;
      }
      function l(e, t, n, r, o, i, a) {
        var c = e + (t & r | n & ~r) + o + a;
        return (c << i | c >>> 32 - i) + t;
      }
      function p(e, t, n, r, o, i, a) {
        var c = e + (t ^ n ^ r) + o + a;
        return (c << i | c >>> 32 - i) + t;
      }
      function d(e, t, n, r, o, i, a) {
        var c = e + (n ^ (t | ~r)) + o + a;
        return (c << i | c >>> 32 - i) + t;
      }
      n.MD5 = i._createHelper(s), n.HmacMD5 = i._createHmacHelper(s);
    })(Math), e.MD5;
  }(gi.exports), function (e) {
    (function () {
      var t = e,
        n = t.lib,
        r = n.WordArray,
        o = n.Hasher,
        i = t.algo,
        a = [],
        c = i.SHA1 = o.extend({
          _doReset: function _doReset() {
            this._hash = new r.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function _doProcessBlock(e, t) {
            for (var n = this._hash.words, r = n[0], o = n[1], i = n[2], c = n[3], s = n[4], u = 0; u < 80; u++) {
              if (u < 16) a[u] = 0 | e[t + u];else {
                var l = a[u - 3] ^ a[u - 8] ^ a[u - 14] ^ a[u - 16];
                a[u] = l << 1 | l >>> 31;
              }
              var p = (r << 5 | r >>> 27) + s + a[u];
              p += u < 20 ? 1518500249 + (o & i | ~o & c) : u < 40 ? 1859775393 + (o ^ i ^ c) : u < 60 ? (o & i | o & c | i & c) - 1894007588 : (o ^ i ^ c) - 899497514, s = c, c = i, i = o << 30 | o >>> 2, o = r, r = p;
            }
            n[0] = n[0] + r | 0, n[1] = n[1] + o | 0, n[2] = n[2] + i | 0, n[3] = n[3] + c | 0, n[4] = n[4] + s | 0;
          },
          _doFinalize: function _doFinalize() {
            var e = this._data,
              t = e.words,
              n = 8 * this._nDataBytes,
              r = 8 * e.sigBytes;
            return t[r >>> 5] |= 128 << 24 - r % 32, t[14 + (r + 64 >>> 9 << 4)] = Math.floor(n / 4294967296), t[15 + (r + 64 >>> 9 << 4)] = n, e.sigBytes = 4 * t.length, this._process(), this._hash;
          },
          clone: function clone() {
            var e = o.clone.call(this);
            return e._hash = this._hash.clone(), e;
          }
        });
      t.SHA1 = o._createHelper(c), t.HmacSHA1 = o._createHmacHelper(c);
    })(), e.SHA1;
  }(gi.exports), function (e) {
    !function () {
      var t = e,
        n = t.lib.Base,
        r = t.enc.Utf8;
      t.algo.HMAC = n.extend({
        init: function init(e, t) {
          e = this._hasher = new e.init(), "string" == typeof t && (t = r.parse(t));
          var n = e.blockSize,
            o = 4 * n;
          t.sigBytes > o && (t = e.finalize(t)), t.clamp();
          for (var i = this._oKey = t.clone(), a = this._iKey = t.clone(), c = i.words, s = a.words, u = 0; u < n; u++) {
            c[u] ^= 1549556828, s[u] ^= 909522486;
          }
          i.sigBytes = a.sigBytes = o, this.reset();
        },
        reset: function reset() {
          var e = this._hasher;
          e.reset(), e.update(this._iKey);
        },
        update: function update(e) {
          return this._hasher.update(e), this;
        },
        finalize: function finalize(e) {
          var t = this._hasher,
            n = t.finalize(e);
          return t.reset(), t.finalize(this._oKey.clone().concat(n));
        }
      });
    }();
  }(gi.exports), function (e) {
    (function () {
      var t = e,
        n = t.lib,
        r = n.Base,
        o = n.WordArray,
        i = t.algo,
        a = i.MD5,
        c = i.EvpKDF = r.extend({
          cfg: r.extend({
            keySize: 4,
            hasher: a,
            iterations: 1
          }),
          init: function init(e) {
            this.cfg = this.cfg.extend(e);
          },
          compute: function compute(e, t) {
            for (var n, r = this.cfg, i = r.hasher.create(), a = o.create(), c = a.words, s = r.keySize, u = r.iterations; c.length < s;) {
              n && i.update(n), n = i.update(e).finalize(t), i.reset();
              for (var l = 1; l < u; l++) {
                n = i.finalize(n), i.reset();
              }
              a.concat(n);
            }
            return a.sigBytes = 4 * s, a;
          }
        });
      t.EvpKDF = function (e, t, n) {
        return c.create(n).compute(e, t);
      };
    })(), e.EvpKDF;
  }(gi.exports), function (e) {
    e.lib.Cipher || function (t) {
      var n = e,
        r = n.lib,
        o = r.Base,
        i = r.WordArray,
        a = r.BufferedBlockAlgorithm,
        c = n.enc;
      c.Utf8;
      var s = c.Base64,
        u = n.algo.EvpKDF,
        l = r.Cipher = a.extend({
          cfg: o.extend(),
          createEncryptor: function createEncryptor(e, t) {
            return this.create(this._ENC_XFORM_MODE, e, t);
          },
          createDecryptor: function createDecryptor(e, t) {
            return this.create(this._DEC_XFORM_MODE, e, t);
          },
          init: function init(e, t, n) {
            this.cfg = this.cfg.extend(n), this._xformMode = e, this._key = t, this.reset();
          },
          reset: function reset() {
            a.reset.call(this), this._doReset();
          },
          process: function process(e) {
            return this._append(e), this._process();
          },
          finalize: function finalize(e) {
            return e && this._append(e), this._doFinalize();
          },
          keySize: 4,
          ivSize: 4,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          _createHelper: function () {
            function e(e) {
              return "string" == typeof e ? b : v;
            }
            return function (t) {
              return {
                encrypt: function encrypt(n, r, o) {
                  return e(r).encrypt(t, n, r, o);
                },
                decrypt: function decrypt(n, r, o) {
                  return e(r).decrypt(t, n, r, o);
                }
              };
            };
          }()
        });
      r.StreamCipher = l.extend({
        _doFinalize: function _doFinalize() {
          return this._process(!0);
        },
        blockSize: 1
      });
      var p = n.mode = {},
        d = r.BlockCipherMode = o.extend({
          createEncryptor: function createEncryptor(e, t) {
            return this.Encryptor.create(e, t);
          },
          createDecryptor: function createDecryptor(e, t) {
            return this.Decryptor.create(e, t);
          },
          init: function init(e, t) {
            this._cipher = e, this._iv = t;
          }
        }),
        f = p.CBC = function () {
          var e = d.extend();
          function n(e, n, r) {
            var o,
              i = this._iv;
            i ? (o = i, this._iv = t) : o = this._prevBlock;
            for (var a = 0; a < r; a++) {
              e[n + a] ^= o[a];
            }
          }
          return e.Encryptor = e.extend({
            processBlock: function processBlock(e, t) {
              var r = this._cipher,
                o = r.blockSize;
              n.call(this, e, t, o), r.encryptBlock(e, t), this._prevBlock = e.slice(t, t + o);
            }
          }), e.Decryptor = e.extend({
            processBlock: function processBlock(e, t) {
              var r = this._cipher,
                o = r.blockSize,
                i = e.slice(t, t + o);
              r.decryptBlock(e, t), n.call(this, e, t, o), this._prevBlock = i;
            }
          }), e;
        }(),
        h = (n.pad = {}).Pkcs7 = {
          pad: function pad(e, t) {
            for (var n = 4 * t, r = n - e.sigBytes % n, o = r << 24 | r << 16 | r << 8 | r, a = [], c = 0; c < r; c += 4) {
              a.push(o);
            }
            var s = i.create(a, r);
            e.concat(s);
          },
          unpad: function unpad(e) {
            var t = 255 & e.words[e.sigBytes - 1 >>> 2];
            e.sigBytes -= t;
          }
        };
      r.BlockCipher = l.extend({
        cfg: l.cfg.extend({
          mode: f,
          padding: h
        }),
        reset: function reset() {
          var e;
          l.reset.call(this);
          var t = this.cfg,
            n = t.iv,
            r = t.mode;
          this._xformMode == this._ENC_XFORM_MODE ? e = r.createEncryptor : (e = r.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == e ? this._mode.init(this, n && n.words) : (this._mode = e.call(r, this, n && n.words), this._mode.__creator = e);
        },
        _doProcessBlock: function _doProcessBlock(e, t) {
          this._mode.processBlock(e, t);
        },
        _doFinalize: function _doFinalize() {
          var e,
            t = this.cfg.padding;
          return this._xformMode == this._ENC_XFORM_MODE ? (t.pad(this._data, this.blockSize), e = this._process(!0)) : (e = this._process(!0), t.unpad(e)), e;
        },
        blockSize: 4
      });
      var y = r.CipherParams = o.extend({
          init: function init(e) {
            this.mixIn(e);
          },
          toString: function toString(e) {
            return (e || this.formatter).stringify(this);
          }
        }),
        m = (n.format = {}).OpenSSL = {
          stringify: function stringify(e) {
            var t = e.ciphertext,
              n = e.salt;
            return (n ? i.create([1398893684, 1701076831]).concat(n).concat(t) : t).toString(s);
          },
          parse: function parse(e) {
            var t,
              n = s.parse(e),
              r = n.words;
            return 1398893684 == r[0] && 1701076831 == r[1] && (t = i.create(r.slice(2, 4)), r.splice(0, 4), n.sigBytes -= 16), y.create({
              ciphertext: n,
              salt: t
            });
          }
        },
        v = r.SerializableCipher = o.extend({
          cfg: o.extend({
            format: m
          }),
          encrypt: function encrypt(e, t, n, r) {
            r = this.cfg.extend(r);
            var o = e.createEncryptor(n, r),
              i = o.finalize(t),
              a = o.cfg;
            return y.create({
              ciphertext: i,
              key: n,
              iv: a.iv,
              algorithm: e,
              mode: a.mode,
              padding: a.padding,
              blockSize: e.blockSize,
              formatter: r.format
            });
          },
          decrypt: function decrypt(e, t, n, r) {
            return r = this.cfg.extend(r), t = this._parse(t, r.format), e.createDecryptor(n, r).finalize(t.ciphertext);
          },
          _parse: function _parse(e, t) {
            return "string" == typeof e ? t.parse(e, this) : e;
          }
        }),
        g = (n.kdf = {}).OpenSSL = {
          execute: function execute(e, t, n, r, o) {
            if (r || (r = i.random(8)), o) a = u.create({
              keySize: t + n,
              hasher: o
            }).compute(e, r);else var a = u.create({
              keySize: t + n
            }).compute(e, r);
            var c = i.create(a.words.slice(t), 4 * n);
            return a.sigBytes = 4 * t, y.create({
              key: a,
              iv: c,
              salt: r
            });
          }
        },
        b = r.PasswordBasedCipher = v.extend({
          cfg: v.cfg.extend({
            kdf: g
          }),
          encrypt: function encrypt(e, t, n, r) {
            var o = (r = this.cfg.extend(r)).kdf.execute(n, e.keySize, e.ivSize, r.salt, r.hasher);
            r.iv = o.iv;
            var i = v.encrypt.call(this, e, t, o.key, r);
            return i.mixIn(o), i;
          },
          decrypt: function decrypt(e, t, n, r) {
            r = this.cfg.extend(r), t = this._parse(t, r.format);
            var o = r.kdf.execute(n, e.keySize, e.ivSize, t.salt, r.hasher);
            return r.iv = o.iv, v.decrypt.call(this, e, t, o.key, r);
          }
        });
    }();
  }(gi.exports), vi.exports = function (e) {
    return function () {
      var t = e,
        n = t.lib.BlockCipher,
        r = t.algo,
        o = [],
        i = [],
        a = [],
        c = [],
        s = [],
        u = [],
        l = [],
        p = [],
        d = [],
        f = [];
      !function () {
        for (var e = [], t = 0; t < 256; t++) {
          e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
        }
        var n = 0,
          r = 0;
        for (t = 0; t < 256; t++) {
          var h = r ^ r << 1 ^ r << 2 ^ r << 3 ^ r << 4;
          h = h >>> 8 ^ 255 & h ^ 99, o[n] = h, i[h] = n;
          var y = e[n],
            m = e[y],
            v = e[m],
            g = 257 * e[h] ^ 16843008 * h;
          a[n] = g << 24 | g >>> 8, c[n] = g << 16 | g >>> 16, s[n] = g << 8 | g >>> 24, u[n] = g, g = 16843009 * v ^ 65537 * m ^ 257 * y ^ 16843008 * n, l[h] = g << 24 | g >>> 8, p[h] = g << 16 | g >>> 16, d[h] = g << 8 | g >>> 24, f[h] = g, n ? (n = y ^ e[e[e[v ^ y]]], r ^= e[e[r]]) : n = r = 1;
        }
      }();
      var h = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54],
        y = r.AES = n.extend({
          _doReset: function _doReset() {
            if (!this._nRounds || this._keyPriorReset !== this._key) {
              for (var e = this._keyPriorReset = this._key, t = e.words, n = e.sigBytes / 4, r = 4 * ((this._nRounds = n + 6) + 1), i = this._keySchedule = [], a = 0; a < r; a++) {
                a < n ? i[a] = t[a] : (u = i[a - 1], a % n ? n > 6 && a % n == 4 && (u = o[u >>> 24] << 24 | o[u >>> 16 & 255] << 16 | o[u >>> 8 & 255] << 8 | o[255 & u]) : (u = o[(u = u << 8 | u >>> 24) >>> 24] << 24 | o[u >>> 16 & 255] << 16 | o[u >>> 8 & 255] << 8 | o[255 & u], u ^= h[a / n | 0] << 24), i[a] = i[a - n] ^ u);
              }
              for (var c = this._invKeySchedule = [], s = 0; s < r; s++) {
                if (a = r - s, s % 4) var u = i[a];else u = i[a - 4];
                c[s] = s < 4 || a <= 4 ? u : l[o[u >>> 24]] ^ p[o[u >>> 16 & 255]] ^ d[o[u >>> 8 & 255]] ^ f[o[255 & u]];
              }
            }
          },
          encryptBlock: function encryptBlock(e, t) {
            this._doCryptBlock(e, t, this._keySchedule, a, c, s, u, o);
          },
          decryptBlock: function decryptBlock(e, t) {
            var n = e[t + 1];
            e[t + 1] = e[t + 3], e[t + 3] = n, this._doCryptBlock(e, t, this._invKeySchedule, l, p, d, f, i), n = e[t + 1], e[t + 1] = e[t + 3], e[t + 3] = n;
          },
          _doCryptBlock: function _doCryptBlock(e, t, n, r, o, i, a, c) {
            for (var s = this._nRounds, u = e[t] ^ n[0], l = e[t + 1] ^ n[1], p = e[t + 2] ^ n[2], d = e[t + 3] ^ n[3], f = 4, h = 1; h < s; h++) {
              var y = r[u >>> 24] ^ o[l >>> 16 & 255] ^ i[p >>> 8 & 255] ^ a[255 & d] ^ n[f++],
                m = r[l >>> 24] ^ o[p >>> 16 & 255] ^ i[d >>> 8 & 255] ^ a[255 & u] ^ n[f++],
                v = r[p >>> 24] ^ o[d >>> 16 & 255] ^ i[u >>> 8 & 255] ^ a[255 & l] ^ n[f++],
                g = r[d >>> 24] ^ o[u >>> 16 & 255] ^ i[l >>> 8 & 255] ^ a[255 & p] ^ n[f++];
              u = y, l = m, p = v, d = g;
            }
            y = (c[u >>> 24] << 24 | c[l >>> 16 & 255] << 16 | c[p >>> 8 & 255] << 8 | c[255 & d]) ^ n[f++], m = (c[l >>> 24] << 24 | c[p >>> 16 & 255] << 16 | c[d >>> 8 & 255] << 8 | c[255 & u]) ^ n[f++], v = (c[p >>> 24] << 24 | c[d >>> 16 & 255] << 16 | c[u >>> 8 & 255] << 8 | c[255 & l]) ^ n[f++], g = (c[d >>> 24] << 24 | c[u >>> 16 & 255] << 16 | c[l >>> 8 & 255] << 8 | c[255 & p]) ^ n[f++], e[t] = y, e[t + 1] = m, e[t + 2] = v, e[t + 3] = g;
          },
          keySize: 8
        });
      t.AES = n._createHelper(y);
    }(), e.AES;
  }(gi.exports);
  var wi = vi.exports,
    ki = {
      exports: {}
    };
  ki.exports = function (e) {
    return e.mode.ECB = function () {
      var t = e.lib.BlockCipherMode.extend();
      return t.Encryptor = t.extend({
        processBlock: function processBlock(e, t) {
          this._cipher.encryptBlock(e, t);
        }
      }), t.Decryptor = t.extend({
        processBlock: function processBlock(e, t) {
          this._cipher.decryptBlock(e, t);
        }
      }), t;
    }(), e.mode.ECB;
  }(gi.exports);
  var xi = ki.exports,
    Oi = {
      exports: {}
    };
  Oi.exports = function (e) {
    return e.pad.Pkcs7;
  }(gi.exports);
  var _i = Oi.exports,
    Ci = {
      exports: {}
    };
  Ci.exports = function (e) {
    return e.enc.Utf8;
  }(gi.exports);
  var Ei,
    Ii,
    Si = Ci.exports;
  !function (e) {
    e.Channel = "channel", e.Custom = "custom";
  }(Ei || (Ei = {})), function (e) {
    e.RequestComplete = "payment.request.complete", e.PayResult = "payment.request.result", e.RefundResult = "refund.request.result";
  }(Ii || (Ii = {}));
  var Pi,
    Di = function () {
      var e = Kr(so.mark(function e(t, n) {
        var r;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = ai(Jo.post.bind(Jo), {
                  retries: 10,
                  interval: 1e3
                }), e.next = 3, r(t, n, {
                  timeout: 1e4
                });
              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t, n) {
        return e.apply(this, arguments);
      };
    }(),
    ji = {
      Android: ["(?:(?:Orca-)?Android|Adr)[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "Android|Silk-Accelerated=[a-z]{4,5}", "(?:TwitterAndroid).*[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "FB4A.*FBSV/(\\d+[\\.\\d]*);", "BeyondPod|AntennaPod|Podkicker|DoggCatcher|Player FM|okhttp|Podcatcher Deluxe"],
      Linux: ["Arch ?Linux(?:[ /\\-](\\d+[\\.\\d]+))?", "VectorLinux(?: package)?(?:[ /\\-](\\d+[\\.\\d]+))?", "Linux(?:OS)?[^a-z]"],
      iOS: ["CFNetwork/889", "CFNetwork/887", "CFNetwork/811", "CFNetwork/808\\.3", "CFNetwork/808\\.2", "CFNetwork/808\\.1", "CFNetwork/808\\.0", "CFNetwork/808", "CFNetwork/758\\.4\\.3", "CFNetwork/758\\.3\\.15", "CFNetwork/758\\.2\\.[78]", "CFNetwork/758\\.1\\.6", "CFNetwork/758\\.0\\.2", "CFNetwork/711\\.5\\.6", "CFNetwork/711\\.4\\.6", "CFNetwork/711\\.3\\.18", "CFNetwork/711\\.2\\.23", "CFNetwork/711\\.1\\.1[26]", "CFNetwork/711\\.0\\.6", "CFNetwork/672\\.1", "CFNetwork/672\\.0", "CFNetwork/609\\.1", "CFNetwork/60[29]", "CFNetwork/548\\.1", "CFNetwork/548\\.0", "CFNetwork/485\\.13", "CFNetwork/485\\.12", "CFNetwork/485\\.10", "CFNetwork/485\\.2", "CFNetwork/467\\.12", "CFNetwork/459", "(?:CPU OS|iPh(?:one)?[ _]OS|iOS)[ _/](\\d+(?:[_\\.]\\d+)*)", "FBIOS.*FBSV/(\\d+[\\.\\d]*);", "(?:Apple-)?(?:iPhone|iPad|iPod)(?:.*Mac OS X.*Version/(\\d+\\.\\d+)|; Opera)?", "Podcasts/(?:[\\d\\.]+)|Instacast(?:HD)?/(?:\\d\\.[\\d\\.abc]+)|Pocket Casts, iOS|Overcast|Castro|Podcat|i[cC]atcher|RSSRadio/", "iTunes-(iPod|iPad|iPhone)/(?:[\\d\\.]+)"],
      MacOS: ["CFNetwork/887.*(x86_64)", "CFNetwork/811.*(x86_64)", "CFNetwork/807", "CFNetwork/760", "CFNetwork/720", "CFNetwork/673", "CFNetwork/596", "CFNetwork/520", "CFNetwork/454", "CFNetwork/(?:438|422|339|330|221|220|217)", "CFNetwork/12[89]", "CFNetwork/1\\.2", "CFNetwork/1\\.1", "Mac[ +]OS[ +]X(?:[ /](?:Version )?(\\d+(?:[_\\.]\\d+)+))?", "Mac (\\d+(?:[_\\.]\\d+)+)", "Darwin|Macintosh|Mac_PowerPC|PPC|Mac PowerPC|iMac|MacBook"],
      Windows: ["CYGWIN_NT-10.0|Windows NT 10.0|Windows 10", "CYGWIN_NT-6.4|Windows NT 6.4|Windows 10", "CYGWIN_NT-6.3|Windows NT 6.3|Windows 8.1", "CYGWIN_NT-6.2|Windows NT 6.2|Windows 8", "CYGWIN_NT-6.1|Windows NT 6.1|Windows 7", "CYGWIN_NT-6.0|Windows NT 6.0|Windows Vista", "CYGWIN_NT-5.2|Windows NT 5.2|Windows Server 2003 / XP x64", "CYGWIN_NT-5.1|Windows NT 5.1|Windows XP", "CYGWIN_NT-5.0|Windows NT 5.0|Windows 2000", "CYGWIN_NT-4.0|Windows NT 4.0|WinNT|Windows NT", "CYGWIN_ME-4.90|Win 9x 4.90|Windows ME", "CYGWIN_98-4.10|Win98|Windows 98", "CYGWIN_95-4.0|Win32|Win95|Windows 95|Windows_95", "Windows 3.1", "Windows"],
      HarmonyOS: [],
      Other: []
    },
    Ti = (Pi = {}, {
      set: function set(e, t) {
        Pi[e] = t;
      },
      get: function get(e) {
        if (Object.prototype.hasOwnProperty.call(Pi, e)) return Pi[e];
      }
    }),
    Ai = function Ai(e, t) {
      try {
        var n = function (e) {
            var t = Ti.get(e);
            if (t) return t.value;
            var n = RegExp("(?:^|[^A-Z0-9-_]|[^A-Z0-9-]_|sprd-)(?:".concat(e, ")"), "i");
            return Ti.set(e, {
              value: n
            }), n;
          }(e),
          r = n.exec(t);
        return r ? r.slice(1) : null;
      } catch (e) {
        return null;
      }
    };
  function Ri(e, t) {
    var _n2 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!_n2) {
      if (Array.isArray(e) || (_n2 = function (e, t) {
        if (e) {
          if ("string" == typeof e) return Li(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Li(e, t) : void 0;
        }
      }(e)) || t && e && "number" == typeof e.length) {
        _n2 && (e = _n2);
        var r = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return r >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[r++]
            };
          },
          e: function e(_e2) {
            throw _e2;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var i,
      a = !0,
      c = !1;
    return {
      s: function s() {
        _n2 = _n2.call(e);
      },
      n: function n() {
        var e = _n2.next();
        return a = e.done, e;
      },
      e: function e(_e3) {
        c = !0, i = _e3;
      },
      f: function f() {
        try {
          a || null == _n2["return"] || _n2["return"]();
        } finally {
          if (c) throw i;
        }
      }
    };
  }
  function Li(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }
    return r;
  }
  var Ni = Zr(function e() {
      Jr(this, e), ro(this, "parse", function (e) {
        for (var t = null, n = 0, r = Object.keys(ji); n < r.length; n++) {
          var o = r[n];
          if (o && Object.prototype.hasOwnProperty.call(ji, o)) {
            var i,
              a = Ri(ji[o]);
            try {
              for (a.s(); !(i = a.n()).done;) {
                var c = i.value;
                if (Ai(c, e)) return t = o;
              }
            } catch (e) {
              a.e(e);
            } finally {
              a.f();
            }
          }
        }
        return t;
      }), ro(this, "getVersion", function (e, t) {
        switch (t) {
          case "MacOS":
            return e.replace(/^.*Mac OS X ([\d_]+).*$/, "$1").replace(/_/g, ".");
          case "iOS":
            return e.replace(/^.*OS ([\d_]+) like.*$/, "$1").replace(/_/g, ".");
          case "Windows":
            return e.replace(/^.*Windows NT ([\d.]+);.*$/, "$1");
          case "Android":
            return e.replace(/^.*Android ([\d.]+);.*$/, "$1");
        }
        return "";
      });
    }),
    Mi = function Mi() {
      var e,
        t,
        n = window.navigator,
        r = n.userAgent,
        o = n.language,
        i = window.screen,
        a = i.colorDepth,
        c = i.width,
        s = i.height,
        u = window.navigator.javaEnabled().toString(),
        l = (t = (e = new Ni()).parse(navigator.userAgent) || "Other", e.getVersion(navigator.userAgent, t));
      return {
        transactionWebSite: window.location.href,
        javaEnabled: u,
        colorDepth: a.toString(),
        screenHeight: c.toString(),
        screenWidth: s.toString(),
        timeZoneOffset: new Date().getTimezoneOffset().toString(),
        accept: "application/json",
        userAgent: r,
        language: o,
        javaScriptEnabled: "true",
        deviceOsVersion: l
      };
    };
  function Bi(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Fi(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Bi(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bi(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function Hi(e) {
    return Ui.apply(this, arguments);
  }
  function Ui() {
    return (Ui = Kr(so.mark(function e(t) {
      var n, r, o, i, a, c;
      return so.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r = t.method, o = void 0 === r ? "GET" : r, i = t.url, a = t.data, o !== Oo.GET) {
                e.next = 7;
                break;
              }
              return e.next = 4, Jo.get(i);
            case 4:
              c = e.sent, e.next = 11;
              break;
            case 7:
              if (o !== Oo.POST) {
                e.next = 11;
                break;
              }
              return e.next = 10, Jo.post(i, a || {});
            case 10:
              c = e.sent;
            case 11:
              return e.abrupt("return", null === (n = c) || void 0 === n ? void 0 : n.data);
            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function Vi(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "post",
      r = arguments.length > 3 ? arguments[3] : void 0,
      o = document.createElement("form");
    for (var i in o.style.display = "none", o.method = n, o.action = e, r && (o.target = r), t) {
      var a = document.createElement("input");
      a.name = i, a.value = t[i] || "", o.appendChild(a);
    }
    document.body.appendChild(o), o.submit();
  }
  function zi(e) {
    return qi.apply(this, arguments);
  }
  function qi() {
    return (qi = Kr(so.mark(function e(t) {
      var n, r, o, i;
      return so.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              n = t.method, r = void 0 === n ? "GET" : n, o = t.url, i = t.data, Gr.get().info("ready to redirect", {
                data: {
                  nextAction: t
                }
              }), "POST" === r ? Vi(o, i) : "GET" === r && window.location.assign(o);
            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  var Gi,
    Wi,
    Ki,
    Ji,
    Yi,
    Xi = function () {
      var e = Kr(so.mark(function e(t, n) {
        var r, o, i, a, c, s, u;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (r = t.data, o = r.needNotify, i = r.notifyUrl, a = r.notifySecretKey, c = (n || {}).data, o) {
                  e.next = 4;
                  break;
                }
                return e.abrupt("return");
              case 4:
                if (i && a && c) {
                  e.next = 6;
                  break;
                }
                throw {
                  message: "require props missed",
                  data: {
                    needNotify: o,
                    notifyUrl: i,
                    notifySecretKey: a,
                    data: c
                  }
                };
              case 6:
                return l = JSON.stringify(null == c ? void 0 : c.eventData), p = a, void 0, void 0, d = Si.parse(l), f = Si.parse(p), s = wi.encrypt(d, f, {
                  mode: xi,
                  padding: _i
                }).toString(), u = Fi(Fi({}, c), {}, {
                  eventData: s
                }), e.next = 10, Di(i, u);
              case 10:
              case "end":
                return e.stop();
            }
          }
          var l, p, d, f;
        }, e);
      }));
      return function (t, n) {
        return e.apply(this, arguments);
      };
    }(),
    Zi = function () {
      var e = Kr(so.mark(function e(t, n) {
        var r, o, i, a, c, s, u, l, p, d, f, h, y, m, v;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (r = t.type, o = t.url, r !== xo.Confirm) {
                  e.next = 11;
                  break;
                }
                return s = Fi(Fi({}, null == n ? void 0 : n.data), {}, {
                  additionalData: {
                    language: (null === (i = window) || void 0 === i || null === (a = i.Shopline) || void 0 === a ? void 0 : a.locale) || "en"
                  },
                  client: Mi()
                }), e.next = 5, Jo.post(o, s);
              case 5:
                if (200 === (u = e.sent).statusCode && null !== (c = u.data) && void 0 !== c && c.nextAction) {
                  e.next = 8;
                  break;
                }
                throw new Error("confirm return return error or no nextAction");
              case 8:
                Zi(u.data.nextAction), e.next = 54;
                break;
              case 11:
                if (r !== xo.Redirect) {
                  e.next = 15;
                  break;
                }
                zi(t), e.next = 54;
                break;
              case 15:
                if (r !== xo.ChannelInfoUpdate) {
                  e.next = 25;
                  break;
                }
                return t.data && (null != n && n.data && (t.data = Fi(Fi({}, t.data), n.data)), null != n && n.channelInfoData && null !== (l = t.data) && void 0 !== l && null !== (p = l.channelInfoJsonData) && void 0 !== p && p.includes("@@channelInfoData@@") && (d = null != n && n.channelInfoData ? JSON.stringify(n.channelInfoData) : "", t.data.channelInfoJsonData = t.data.channelInfoJsonData.replace("@@channelInfoData@@", d))), e.next = 19, Hi(t);
              case 19:
                if (null == (f = e.sent) || !f.nextAction) {
                  e.next = 23;
                  break;
                }
                return e.next = 23, Zi(f.nextAction, n);
              case 23:
                e.next = 54;
                break;
              case 25:
                if (r !== xo.ChannelConfirm) {
                  e.next = 32;
                  break;
                }
                if (null == (y = null == n || null === (h = n.payOptions) || void 0 === h ? void 0 : h.hooks) || !y.channelConfirm) {
                  e.next = 30;
                  break;
                }
                return e.next = 30, y.channelConfirm(t);
              case 30:
                e.next = 54;
                break;
              case 32:
                if (r !== xo.OpenIframe) {
                  e.next = 37;
                  break;
                }
                new mi(t.type).openIframe(t), e.next = 54;
                break;
              case 37:
                if (r !== xo.RedirectOrPopup) {
                  e.next = 42;
                  break;
                }
                return e.next = 40, Xi(t, n);
              case 40:
                e.next = 54;
                break;
              case 42:
                if (r !== xo.Gather) {
                  e.next = 47;
                  break;
                }
                return m = new mi(t.type, n), e.abrupt("return", m.gather(t));
              case 47:
                if (r !== xo.Challenge) {
                  e.next = 52;
                  break;
                }
                return v = new mi(t.type, n), e.abrupt("return", v.challenge(t));
              case 52:
                Gr.get().error("do not match nextAction type", {
                  data: {
                    nextAction: t
                  },
                  error: new Error("")
                });
              case 54:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t, n) {
        return e.apply(this, arguments);
      };
    }();
  !function (e) {
    e.TEST = "TEST", e.PRODUCTION = "PRODUCTION";
  }(Wi || (Wi = {})), function (e) {
    e.INITIALIZE = "INITIALIZE", e.SHIPPING_ADDRESS = "SHIPPING_ADDRESS", e.SHIPPING_OPTION = "SHIPPING_OPTION", e.OFFER = "OFFER";
  }(Ki || (Ki = {})), function (e) {
    e.NOT_CURRENTLY_KNOWN = "NOT_CURRENTLY_KNOWN", e.ESTIMATED = "ESTIMATED", e.FINAL = "FINAL";
  }(Ji || (Ji = {})), function (e) {
    e.DEFAULT = "DEFAULT", e.COMPLETE_IMMEDIATE_PURCHASE = "COMPLETE_IMMEDIATE_PURCHASE";
  }(Yi || (Yi = {}));
  var $i,
    Qi,
    ea,
    ta = (ro(Gi = {}, Ki.INITIALIZE, bo.Ordinary), ro(Gi, Ki.SHIPPING_ADDRESS, bo.ChangeAddress), ro(Gi, Ki.SHIPPING_OPTION, bo.ChangeDeliveryMethod), ro(Gi, Ki.OFFER, bo.UseDiscountCode), Gi);
  !function (e) {
    e.OFFER_INVALID = "OFFER_INVALID", e.PAYMENT_DATA_INVALID = "PAYMENT_DATA_INVALID", e.SHIPPING_ADDRESS_INVALID = "SHIPPING_ADDRESS_INVALID", e.SHIPPING_ADDRESS_UNSERVICEABLE = "SHIPPING_ADDRESS_UNSERVICEABLE", e.SHIPPING_OPTION_INVALID = "SHIPPING_OPTION_INVALID", e.OTHER_ERROR = "OTHER_ERROR";
  }($i || ($i = {})), function (e) {
    e[e.TimeoutToLoadPaymentData = 18] = "TimeoutToLoadPaymentData", e[e.UserCancel = 20] = "UserCancel";
  }(Qi || (Qi = {})), function (e) {
    e.CANCELED = "CANCELED";
  }(ea || (ea = {}));
  var na,
    ra,
    oa,
    ia,
    aa,
    ca = function () {
      function e(t, n, r) {
        var o = this;
        Jr(this, e), ro(this, "container", void 0), ro(this, "button", void 0), ro(this, "styleElement", null), ro(this, "options", void 0), ro(this, "insertStyle", function () {
          var e = document.createElement("style"),
            t = "\n      .gpay-card-info-container {\n        border-radius: 0;\n        min-width: 140px;\n        min-height: 36px;\n      }\n\n      .".concat(pi, " .gpay-card-info-container-fill {\n        display: none;\n      }\n    ");
          void 0 === o.options["border-radius"] && (t += "\n        #".concat(o.container.id, " .gpay-card-info-container {\n          border-radius: 4px;\n        }\n\n        [data-button_style=square] #").concat(o.container.id, " .gpay-card-info-container {\n          border-radius: 0;\n        }\n\n        [data-button_style=rounded] #").concat(o.container.id, " .gpay-card-info-container {\n          border-radius: 9999px;\n        }\n      ")), e.innerHTML = t;
          var n = 48;
          o.options.height && (n = o.options.height), o.container.style.height = "".concat(n, "px"), o.styleElement = e, o.container.appendChild(e);
        }), ro(this, "insertButton", function () {
          o.container.appendChild(o.button);
        }), ro(this, "removeElement", function () {
          o.container.removeChild(o.button), o.styleElement && o.container.removeChild(o.styleElement);
        }), ro(this, "destroy", function () {
          o.removeElement();
        }), this.container = t, this.button = n, this.options = r, this.insertStyle(), this.insertButton();
      }
      return Zr(e, [{
        key: "setDisabled",
        value: function value(e) {
          e ? this.container.classList.add(li) : this.container.classList.remove(li);
        }
      }, {
        key: "setLoading",
        value: function value(e) {
          e ? this.container.classList.add(pi) : this.container.classList.remove(pi);
        }
      }]), e;
    }();
  !function (e) {
    e.Dev = "dev", e.Test = "test", e.Test2 = "test2", e.Stg = "stg", e.Prev = "prev", e.Prod = "prod";
  }(ra || (ra = {})), function (e) {
    e.Dev = "stg", e.Test = "stg", e.Test2 = "stg", e.Prev = "prev", e.Prod = "prod";
  }(oa || (oa = {})), function (e) {
    e.Test1 = "test1", e.Test2 = "test2", e.Test3 = "test3", e.Alpha = "alpha", e.Prod = "prod";
  }(ia || (ia = {})), function (e) {
    e.Dev = "https://ec-pa-cashier.myshoplinedev.com", e.Test = "https://ec-pa-cashier.myshoplinestg.com", e.Test2 = "https://paygate-cashier-test.myshoplinestg.com", e.Stg = "https://ec-pa-cashier-stg.myshoplinestg.com", e.Prev = "https://ec-pa-cashier-prev.myshopline.com", e.Prod = "https://ec-pa-cashier.myshopline.com";
  }(aa || (aa = {}));
  var sa,
    ua = {
      host: "ec-pa-cashier.myshopline.com",
      staticHost: "https://cdn.myshopline.com/sl/payment-sdk"
    };
  function la(e) {
    return "".concat(ua.staticHost, "/").concat(e, "assets");
  }
  !function (e) {
    e.Dev = "dev/", e.Test = "test/", e.Test2 = "test/", e.Stg = "test/", e.Prev = "prev/", e.Prod = "";
  }(sa || (sa = {}));
  var pa = Object.freeze((ro(na = {}, ra.Dev, {
      env: ia.Test3,
      host: aa.Dev,
      slI18nEnv: oa.Dev,
      staticPath: la(sa.Dev)
    }), ro(na, ra.Test, {
      env: ia.Test3,
      host: aa.Test,
      slI18nEnv: oa.Test,
      staticPath: la(sa.Test)
    }), ro(na, ra.Test2, {
      env: ia.Test2,
      host: aa.Test2,
      slI18nEnv: oa.Test2,
      staticPath: la(sa.Test2)
    }), ro(na, ra.Stg, {
      env: ia.Test3,
      host: aa.Stg,
      slI18nEnv: oa.Test,
      staticPath: la(sa.Test)
    }), ro(na, ra.Prev, {
      env: ia.Test3,
      host: aa.Prev,
      slI18nEnv: oa.Prev,
      staticPath: la(sa.Prev)
    }), ro(na, ra.Prod, {
      env: ia.Prod,
      host: aa.Prod,
      slI18nEnv: oa.Prod,
      staticPath: la(sa.Prod)
    }), na)),
    da = function da(e) {
      return window.loadjs = So, new Promise(function (t, n) {
        var r = e;
        So.isDefined(r) ? t(!0) : So(e, r, {
          returnPromise: !0
        }).then(function () {
          t(!0);
        })["catch"](function (e) {
          n(e);
        });
      });
    };
  var fa = function fa() {
    if (/iphone|ipod|ipad/i.test(navigator.userAgent.toLowerCase())) return !1;
    var e = navigator.userAgent.match(/Chrome\/(\d+)/),
      t = e && e[1] && Number(e[1]) >= 61;
    return function () {
      var e = window.navigator.userAgent;
      return !!e.match("CriOS") || /Chrome/.test(e) && /Google Inc./.test(window.navigator.vendor) && !!window.chrome;
    }() && t;
  };
  function ha(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function ya(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ha(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ha(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var ma = function (e) {
    eo(i, di);
    var t,
      n,
      r,
      o = function (e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var n,
            r = no(e);
          if (t) {
            var o = no(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);
          return to(this, n);
        };
      }(i);
    function i(e) {
      var t, n, r;
      return Jr(this, i), ro($r(r = o.call(this, e)), "name", "GOOGLE_PAY"), ro($r(r), "config", void 0), ro($r(r), "paymentsClient", null), ro($r(r), "buttonElement", null), ro($r(r), "disabled", !1), ro($r(r), "loading", !1), ro($r(r), "initSuccess", !0), ro($r(r), "loadResourceFail", !1), ro($r(r), "initTime", 0), ro($r(r), "logger", void 0), ro($r(r), "onPaymentDataChanged", function () {
        var e = Kr(so.mark(function e(t) {
          var n, o, i, a, c, s, u, l, p;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return i = t.callbackTrigger, e.next = 3, null === (n = (o = r.config).onFormDataChange) || void 0 === n ? void 0 : n.call(o, t, ta[i])["catch"](function () {
                    r.handleError(new Error("Failed to update abandonedOrder info"), lo.Pay);
                  });
                case 3:
                  if (a = e.sent, r.logger.info("Order information updated, data received from business side", {
                    data: ya({}, a)
                  }), a && !a.error) {
                    e.next = 7;
                    break;
                  }
                  return e.abrupt("return", {
                    error: {
                      reason: $i.OTHER_ERROR,
                      intent: i === Ki.OFFER ? Ki.INITIALIZE : i,
                      message: (null == a || null === (c = a.error) || void 0 === c ? void 0 : c.message) || "update error"
                    }
                  });
                case 7:
                  return s = a.newOfferInfo, u = a.newTransactionInfo, l = a.newShippingOptionParameters, oi(p = {
                    newOfferInfo: s,
                    newTransactionInfo: u,
                    newShippingOptionParameters: l
                  }), r.logger.log("Order information updated, data returned to channel", {
                    data: ya({}, p)
                  }), e.abrupt("return", p);
                case 12:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }()), ro($r(r), "onPaymentAuthorized", function (e) {
        return new Promise(function (t, n) {
          var o, i;
          (null === (o = (i = r.config).createOrder) || void 0 === o ? void 0 : o.call(i, r.config.paymentInfo, {
            payChannelData: e,
            token: e
          })).then(function (e) {
            if (!e || e.error) throw e.error;
            r.afterCreateOrder(go.Success), t({
              transactionState: "SUCCESS"
            }), Zi(e.nextAction);
          })["catch"](function (e) {
            r.afterCreateOrder(go.Fail), n({
              reason: "PAYMENT_DATA_INVALID",
              intent: "PAYMENT_AUTHORIZATION",
              message: e.message || "pay error"
            });
          });
        });
      }), ro($r(r), "onGooglePaymentButtonClicked", Kr(so.mark(function e() {
        var t, n, o, i;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (r.paymentsClient && !r.loading && !r.disabled) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return");
              case 2:
                return r.setLoading(!0), e.next = 5, r.beforeCreateOrder()["catch"](function () {
                  return {
                    valid: !1
                  };
                });
              case 5:
                if (n = e.sent, r.setLoading(!1), !1 !== (null == n ? void 0 : n.valid)) {
                  e.next = 9;
                  break;
                }
                return e.abrupt("return");
              case 9:
                if (o = null == n || null === (t = n.paymentConfig) || void 0 === t ? void 0 : t.payChannelData) {
                  e.next = 12;
                  break;
                }
                return e.abrupt("return");
              case 12:
                oi(o), i = setTimeout(function () {
                  r.onChannelModalSuccess();
                }, 1e3), r.logger.log("User clicked GP button, launching payment modal", {
                  data: ya({}, o)
                }), r.paymentsClient.loadPaymentData(o)["catch"](function (e) {
                  clearTimeout(i), e.statusCode !== ea.CANCELED || e.code !== Qi.TimeoutToLoadPaymentData ? e.statusCode !== ea.CANCELED ? r.handleError(new Error("pay failed"), lo.Pay, {
                    error: e
                  }) : r.logger.log("loadPaymentData return cancel error", {
                    data: {
                      error: e
                    }
                  }) : r.handleError(new Error("Failed to pull up the channel"), lo.PullUpChannel, {
                    error: e
                  });
                });
              case 16:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }))), ro($r(r), "destroy", function () {
        var e;
        null === (e = r.buttonElement) || void 0 === e || e.destroy(), r.buttonElement = null, r.paymentsClient = null;
      }), r.config = e, Gr.set(null === (t = (n = r.config).loggerFn) || void 0 === t ? void 0 : t.call(n)), r.logger = Gr.get().pipeOwner("payment-common.SLP-GooglePay").pipeData({
        domId: "".concat(r.config.props.domId)
      }), r;
    }
    return Zr(i, [{
      key: "render",
      value: (r = Kr(so.mark(function e() {
        var t, n;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (fa()) {
                  e.next = 3;
                  break;
                }
                return this.handleError(new Error("The current browser does not support Google Pay"), lo.Init), e.abrupt("return");
              case 3:
                return this.beforeInit(), e.next = 6, this.loadChannelJs();
              case 6:
                if (e.sent) {
                  e.next = 9;
                  break;
                }
                return e.abrupt("return");
              case 9:
                if (t = this.createClient()) {
                  e.next = 12;
                  break;
                }
                return e.abrupt("return");
              case 12:
                if (n = {}, this.config.paymentInfo.channelSdkInitConfig) {
                  e.next = 16;
                  break;
                }
                return this.handleError(new Error("channelSdkInitConfig is empty"), lo.Init), e.abrupt("return");
              case 16:
                e.prev = 16, n = JSON.parse(this.config.paymentInfo.channelSdkInitConfig), e.next = 24;
                break;
              case 20:
                return e.prev = 20, e.t0 = e["catch"](16), this.handleError(new Error("Failure to parse channel configuration JSON string"), lo.Init, {
                  channelSdkInitConfig: this.config.paymentInfo.channelSdkInitConfig
                }), e.abrupt("return");
              case 24:
                return e.next = 26, this.canMakePayments(t, n.payChannelData);
              case 26:
                if (e.sent) {
                  e.next = 30;
                  break;
                }
                return this.handleError(new Error("The current browser does not support Google Pay"), lo.Init), e.abrupt("return");
              case 30:
                this.renderButton(), this.afterInit();
              case 32:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[16, 20]]);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "canMakePayments",
      value: (n = Kr(so.mark(function e(t, n) {
        var r;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, e.next = 3, t.isReadyToPay(n);
              case 3:
                return r = e.sent, e.abrupt("return", r.result);
              case 7:
                return e.prev = 7, e.t0 = e["catch"](0), e.abrupt("return", !1);
              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[0, 7]]);
      })), function (e, t) {
        return n.apply(this, arguments);
      })
    }, {
      key: "beforeInit",
      value: function value() {
        this.initTime = ri.now(), Qo(this.config.beforeInit) && this.config.beforeInit();
      }
    }, {
      key: "afterInit",
      value: function value() {
        this.initSuccess = !0, this.showButton();
        var e = ri.now() - this.initTime;
        this.logger.log("afterInit", {
          data: {
            duration: e
          }
        }), Qo(this.config.afterInit) && this.config.afterInit();
      }
    }, {
      key: "onChannelModalSuccess",
      value: function value() {
        Qo(this.config.onChannelModalSuccess) && this.config.onChannelModalSuccess(this.config.paymentInfo);
      }
    }, {
      key: "beforeCreateOrder",
      value: (t = Kr(so.mark(function e() {
        var t, n, r, o, i, a;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (Qo(this.config.beforeCreateOrder)) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return");
              case 2:
                return t = this.config.paymentInfo, n = t.channelCode, r = t.methodCode, o = t.paymentId, i = t.accessMode, e.next = 5, this.config.beforeCreateOrder({
                  channelCode: n,
                  methodCode: r,
                  paymentId: o,
                  accessMode: i
                });
              case 5:
                return a = e.sent, e.abrupt("return", a);
              case 7:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "afterCreateOrder",
      value: function value(e) {
        Qo(this.config.afterCreateOrder) && this.config.afterCreateOrder(e, {
          channelCode: this.config.paymentInfo.channelCode,
          methodCode: ho.GooglePay
        });
      }
    }, {
      key: "setDisabled",
      value: function value(e) {
        var t;
        this.disabled = e, null === (t = this.buttonElement) || void 0 === t || t.setDisabled(e);
      }
    }, {
      key: "setLoading",
      value: function value(e) {
        var t;
        this.loading = e, null === (t = this.buttonElement) || void 0 === t || t.setLoading(e);
      }
    }, {
      key: "loadChannelJs",
      value: function value() {
        var e = this;
        return new Promise(function (t) {
          da("https://pay.google.com/gp/p/js/pay.js").then(function () {
            e.loadResourceFail = !1, t(!0);
          })["catch"](function (n) {
            e.loadResourceFail = !0, e.handleError(new Error("Failed to load channel js resource:".concat(n)), lo.Init), t(!1);
          });
        });
      }
    }, {
      key: "createClient",
      value: function value() {
        var e = this.config.paymentInfo.sdkEnv === ra.Prod ? Wi.PRODUCTION : Wi.TEST;
        try {
          return this.paymentsClient = new window.google.payments.api.PaymentsClient({
            environment: e,
            paymentDataCallbacks: {
              onPaymentDataChanged: this.onPaymentDataChanged,
              onPaymentAuthorized: this.onPaymentAuthorized
            }
          }), this.paymentsClient;
        } catch (e) {
          this.handleError(new Error("Failed to create channel instance"), lo.Init, {
            channelMsg: e.message
          });
        }
      }
    }, {
      key: "renderButton",
      value: function value() {
        if (this.paymentsClient) try {
          var e,
            t,
            n = this.paymentsClient.createButton({
              onClick: this.onGooglePaymentButtonClicked,
              buttonSizeMode: "fill"
            }),
            r = document.getElementById(this.config.paymentInfo.currentDomId);
          if (!r) throw new Error("Container not found: #".concat(this.config.paymentInfo.currentDomId));
          this.buttonElement = new ca(r, n, {
            height: null === (e = this.config.props.styleOptions) || void 0 === e ? void 0 : e.height,
            "border-radius": null === (t = this.config.props.styleOptions) || void 0 === t ? void 0 : t["border-radius"]
          });
        } catch (e) {
          this.handleError(new Error("Failed to render button"), lo.Init, {
            channelMsg: e.message
          });
        }
      }
    }, {
      key: "handleError",
      value: function value(e, t, n) {
        window[window.__sl_console__ ? "__sl_console__" : "console"].error("GP unified error handling: ", {
          error: e,
          type: t,
          extData: n
        }), t !== lo.CreateExpected && this.logger.error("handleError", {
          action: t,
          error: e,
          data: ya({}, n)
        }), t === lo.Init && (this.initSuccess = !1, this.hideButton()), Qo(this.config.onError) && this.config.onError(e, t, n);
      }
    }]), i;
  }();
  function va(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function ga(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? va(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : va(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var ba = function ba(e) {
    var t = e;
    if (null != e && e.paymentInfo) {
      var n = e.paymentInfo.configData;
      t.props = ga(ga({}, e.props), n);
    }
    return t;
  };
  function wa(e) {
    return "object" === ("undefined" == typeof Node ? "undefined" : lr(Node)) ? e instanceof Node : e && "object" === lr(e) && "number" == typeof e.nodeType;
  }
  function ka() {
    var e = [];
    return {
      watch: e.push.bind(e),
      trigger: function trigger(t, n) {
        for (var r = !0, o = {
            detail: n,
            preventDefault: function preventDefault() {
              r = !1;
            }
          }, i = 0; i < e.length; i++) {
          e[i](t, o);
        }
        return r;
      }
    };
  }
  function xa(e) {
    return "none" === window.getComputedStyle(e).display;
  }
  function Oa(e) {
    this.elem = e;
  }
  function _a(e, t) {
    return Oa.make(e("parent")).clazz("pico-overlay").clazz(e("overlayClass", "")).stylize({
      display: "none",
      position: "fixed",
      top: "0px",
      left: "0px",
      height: "100%",
      width: "100%",
      zIndex: 1e4
    }).stylize(e("overlayStyles", {
      opacity: .5,
      background: "#000"
    })).onClick(function () {
      e("overlayClose", !0) && t();
    });
  }
  Oa.make = function (e, t) {
    "string" == typeof e && (e = document.querySelector(e));
    var n = document.createElement(t || "div");
    return (e || document.body).appendChild(n), new Oa(n);
  }, Oa.prototype = {
    child: function child(e) {
      return Oa.make(this.elem, e);
    },
    stylize: function stylize(e) {
      for (var t in void 0 !== (e = e || {}).opacity && (e.filter = "alpha(opacity=" + 100 * e.opacity + ")"), e) {
        e.hasOwnProperty(t) && (this.elem.style[t] = e[t]);
      }
      return this;
    },
    clazz: function clazz(e) {
      return this.elem.className += " " + e, this;
    },
    html: function html(e) {
      return wa(e) ? this.elem.appendChild(e) : this.elem.innerHTML = e, this;
    },
    onClick: function onClick(e) {
      return this.elem.addEventListener("click", e), this;
    },
    destroy: function destroy() {
      this.elem.parentNode.removeChild(this.elem);
    },
    hide: function hide() {
      this.elem.style.display = "none";
    },
    show: function show() {
      this.elem.style.display = "block";
    },
    attr: function attr(e, t) {
      return void 0 !== t && this.elem.setAttribute(e, t), this;
    },
    anyAncestor: function anyAncestor(e) {
      for (var t = this.elem; t;) {
        if (e(new Oa(t))) return !0;
        t = t.parentNode;
      }
      return !1;
    },
    isVisible: function isVisible() {
      return !xa(this.elem);
    }
  };
  var Ca = 1;
  function Ea(e, t) {
    if (t("closeButton", !0)) return e.child("button").html(t("closeHtml", "&#xD7;")).clazz("pico-close").clazz(t("closeClass", "")).stylize(t("closeStyles", {
      borderRadius: "2px",
      border: 0,
      padding: 0,
      cursor: "pointer",
      height: "15px",
      width: "15px",
      position: "absolute",
      top: "5px",
      right: "5px",
      fontSize: "16px",
      textAlign: "center",
      lineHeight: "15px",
      background: "#CCC"
    })).attr("aria-label", t("close-label", "Close"));
  }
  function Ia(e) {
    return function () {
      return e().elem;
    };
  }
  var Sa,
    Pa,
    Da,
    ja,
    Ta,
    Aa = ka(),
    Ra = ka();
  function La(e) {
    ("string" == typeof e || wa(e)) && (e = {
      content: e
    });
    var t = ka(),
      n = ka(),
      r = ka(),
      o = ka(),
      i = ka();
    function a(t, n) {
      var r = e[t];
      return "function" == typeof r && (r = r(n)), void 0 === r ? n : r;
    }
    var c,
      s,
      u = y.bind(window, "modal"),
      l = y.bind(window, "overlay"),
      p = y.bind(window, "close");
    function d(e) {
      l().hide(), u().hide(), i.trigger(c, e);
    }
    function f(e) {
      o.trigger(c, e) && d(e);
    }
    function h(e) {
      return function () {
        return e.apply(this, arguments), c;
      };
    }
    function y(e, n) {
      if (!s) {
        var r = function (e, t) {
          var n = e("width", "auto");
          "number" == typeof n && (n += "px");
          var r = e("modalId", "pico-" + Ca++);
          return Oa.make(e("parent")).clazz("pico-content").clazz(e("modalClass", "")).stylize({
            display: "none",
            position: "fixed",
            zIndex: 10001,
            left: "50%",
            top: "38.1966%",
            maxHeight: "90%",
            boxSizing: "border-box",
            width: n,
            "-ms-transform": "translate(-50%,-38.1966%)",
            "-moz-transform": "translate(-50%,-38.1966%)",
            "-webkit-transform": "translate(-50%,-38.1966%)",
            "-o-transform": "translate(-50%,-38.1966%)",
            transform: "translate(-50%,-38.1966%)"
          }).stylize(e("modalStyles", {
            overflow: "auto",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "5px"
          })).html(e("content")).attr("id", r).attr("role", "dialog").attr("aria-labelledby", e("ariaLabelledBy")).attr("aria-describedby", e("ariaDescribedBy", r)).onClick(function (e) {
            new Oa(e.target).anyAncestor(function (e) {
              return /\bpico-close\b/.test(e.elem.className);
            }) && t();
          });
        }(a, f);
        s = {
          modal: r,
          overlay: _a(a, f),
          close: Ea(r, a)
        }, t.trigger(c, n);
      }
      return s[e];
    }
    return function (e, t) {
      function n(e, t) {
        return (e.msMatchesSelector || e.webkitMatchesSelector || e.matches).call(e, t);
      }
      function r(e) {
        return !(xa(e) || n(e, ":disabled") || e.hasAttribute("contenteditable")) && (e.hasAttribute("tabindex") || n(e, "input,select,textarea,button,a[href],area[href],iframe"));
      }
      function o(e) {
        for (var t = e.getElementsByTagName("*"), n = 0; n < t.length; n++) {
          if (r(t[n])) return t[n];
        }
      }
      var i;
      e.beforeShow(function () {
        i = document.activeElement;
      }), e.afterShow(function () {
        if (t()) {
          var n = o(e.modalElem());
          n && n.focus();
        }
      }), e.afterClose(function () {
        t() && i && i.focus(), i = null;
      }), Ra.watch(function (n) {
        if (t() && e.isVisible()) {
          var i = o(e.modalElem()),
            a = function (e) {
              for (var t = e.getElementsByTagName("*"), n = t.length; n--;) {
                if (r(t[n])) return t[n];
              }
            }(e.modalElem());
          (n.shiftKey ? i : a) === document.activeElement && ((n.shiftKey ? a : i).focus(), n.preventDefault());
        }
      });
    }(c = {
      modalElem: Ia(u),
      closeElem: Ia(p),
      overlayElem: Ia(l),
      buildDom: h(y.bind(null, null)),
      isVisible: function isVisible() {
        return !!(s && u && u().isVisible());
      },
      show: function show(e) {
        return n.trigger(c, e) && (l().show(), p(), u().show(), r.trigger(c, e)), this;
      },
      close: h(f),
      forceClose: h(d),
      destroy: function destroy() {
        u().destroy(), l().destroy(), l = u = p = void 0;
      },
      options: function options(t) {
        Object.keys(t).map(function (n) {
          e[n] = t[n];
        });
      },
      afterCreate: h(t.watch),
      beforeShow: h(n.watch),
      afterShow: h(r.watch),
      beforeClose: h(o.watch),
      afterClose: h(i.watch)
    }, a.bind(null, "focus", !0)), function (e, t) {
      var n,
        r = new Oa(document.body);
      e.beforeShow(function () {
        n = r.elem.style.overflow, t() && r.stylize({
          overflow: "hidden"
        });
      }), e.afterClose(function () {
        r.stylize({
          overflow: n
        });
      });
    }(c, a.bind(null, "bodyOverflow", !0)), Aa.watch(function () {
      a("escCloses", !0) && c.isVisible() && c.close();
    }), c;
  }
  document.documentElement.addEventListener("keydown", function (e) {
    var t = e.which || e.keyCode;
    27 === t ? Aa.trigger() : 9 === t && Ra.trigger(e);
  }), function (e) {
    e.Validatemerchant = "validatemerchant", e.Paymentmethodselected = "paymentmethodselected", e.Cancel = "cancel", e.Shippingcontactselected = "shippingcontactselected", e.Authorize = "Authorize", e.Create = "create", e.Couponcodechanged = "couponcodechanged", e.Shippingmethodselected = "shippingmethodselected", e.Paymentauthorized = "paymentauthorized";
  }(Sa || (Sa = {})), function (e) {
    e.ShippingContactInvalid = "shippingContactInvalid", e.BillingContactInvalid = "billingContactInvalid", e.AddressUnserviceable = "addressUnserviceable", e.CouponCodeInvalid = "couponCodeInvalid", e.CouponCodeExpired = "couponCodeExpired", e.Unknown = "unknown";
  }(Pa || (Pa = {})), function (e) {
    e.Credit = "credit";
  }(Da || (Da = {})), function (e) {
    e.Unknown = "unknown";
  }(ja || (ja = {}));
  var Na,
    Ma = "applepay-confirm-modal",
    Ba = '<svg width="59" height="24" viewBox="0 0 59 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.6871 3.0942C10.002 3.90485 8.90594 4.54424 7.80985 4.4529C7.67283 3.3568 8.20947 2.1922 8.83744 1.47288C9.5225 0.639391 10.7214 0.0456708 11.6919 0C11.806 1.14177 11.3608 2.2607 10.6871 3.0942ZM11.6804 4.66984C10.0934 4.5785 8.73468 5.57184 7.98111 5.57184C7.21613 5.57184 6.06294 4.71551 4.80699 4.73834C3.17426 4.76118 1.65571 5.68601 0.822213 7.1589C-0.890442 10.1047 0.376923 14.4662 2.03249 16.8639C2.84315 18.0514 3.81365 19.353 5.09243 19.3073C6.30271 19.2617 6.78225 18.5195 8.24372 18.5195C9.7166 18.5195 10.1391 19.3073 11.4178 19.2845C12.7423 19.2617 13.5758 18.0971 14.3864 16.9096C15.3113 15.5623 15.6881 14.2493 15.7109 14.1808C15.6881 14.1579 13.1533 13.1874 13.1305 10.2645C13.1077 7.82112 15.1286 6.65652 15.2199 6.58801C14.0782 4.89819 12.297 4.71551 11.6804 4.66984ZM20.8489 1.35871V19.1589H23.6119V13.0733H27.4369C30.9307 13.0733 33.3855 10.6755 33.3855 7.20457C33.3855 3.73359 30.9764 1.35871 27.5282 1.35871H20.8489ZM23.6119 3.68792H26.7975C29.1952 3.68792 30.5653 4.9667 30.5653 7.21598C30.5653 9.46527 29.1952 10.7555 26.7861 10.7555H23.6119V3.68792ZM38.4321 19.2959C40.1676 19.2959 41.7775 18.4167 42.5082 17.0238H42.5653V19.1589H45.1229V10.2988C45.1229 7.72978 43.0677 6.07421 39.905 6.07421C36.9706 6.07421 34.8013 7.75262 34.7214 10.059H37.2104C37.4159 8.96289 38.4321 8.24358 39.8251 8.24358C41.5149 8.24358 42.4626 9.0314 42.4626 10.4814V11.4634L39.0144 11.6689C35.806 11.863 34.0706 13.176 34.0706 15.4596C34.0706 17.7659 35.8631 19.2959 38.4321 19.2959ZM39.1743 17.1836C37.7014 17.1836 36.7651 16.4757 36.7651 15.3911C36.7651 14.2721 37.6671 13.6213 39.3912 13.5186L42.4626 13.3245V14.3292C42.4626 15.9962 41.0468 17.1836 39.1743 17.1836ZM48.5368 24C51.2314 24 52.4987 22.9724 53.6062 19.8554L58.4588 6.24548H55.65L52.396 16.7612H52.3389L49.0848 6.24548H46.1962L50.8774 19.2046L50.6262 19.9924C50.2038 21.3283 49.5187 21.8421 48.297 21.8421C48.0801 21.8421 47.6576 21.8192 47.4864 21.7964V23.9315C47.6462 23.9772 48.3313 24 48.5368 24Z" fill="currentColor"/>\n</svg>',
    Fa = {
      props: {
        payMode: po.Continue,
        buttonTimeoutConfig: {
          enable: !1,
          timeoutMillis: 5e3
        },
        timing: !1
      }
    },
    Ha = (ro(Ta = {}, Sa.Paymentmethodselected, bo.Ordinary), ro(Ta, Sa.Shippingcontactselected, bo.ChangeAddress), ro(Ta, Sa.Cancel, bo.Ordinary), ro(Ta, Sa.Validatemerchant, bo.Ordinary), ro(Ta, Sa.Authorize, bo.Ordinary), ro(Ta, Sa.Create, bo.Ordinary), ro(Ta, Sa.Couponcodechanged, bo.UseDiscountCode), ro(Ta, Sa.Shippingmethodselected, bo.ChangeDeliveryMethod), ro(Ta, Sa.Paymentauthorized, bo.Ordinary), Ta),
    Ua = function () {
      var e = Kr(so.mark(function e(t) {
        var n, r, o, i, a;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = {
                  useRetry: !0,
                  action: Io.I18n,
                  retryOptions: {
                    maxCount: 3,
                    interval: 1e3
                  }
                }, r = t.project, o = t.env, i = t.lang, e.next = 4, Jo.get("https://cdn.myshopline.com/t/i18n/".concat(r, "/").concat(o, "/").concat(i, ".raw.tree.json"), n);
              case 4:
                return a = e.sent, e.abrupt("return", a.data);
              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }();
  !function (e) {
    e.Dev = "develop", e.Stg = "staging", e.Prev = "preview", e.Prod = "product";
  }(Na || (Na = {}));
  var Va,
    za = "pay-button";
  !function (e) {
    e.Stg = "stg", e.Prev = "prev", e.Prod = "prod";
  }(Va || (Va = {}));
  var qa = function qa(e, t) {
      var n = t.split(".").reduce(function (e, t) {
        var n;
        return null !== (n = e[t]) && void 0 !== n ? n : {};
      }, e);
      return function (e) {
        return function (e, t) {
          return "[object Object]" === Object.prototype.toString.call(e);
        }(e);
      }(n) ? "" : n;
    },
    Ga = function Ga(e) {
      var t;
      return (ro(t = {}, Na.Dev, Va.Stg), ro(t, Na.Stg, Va.Stg), ro(t, Na.Prev, Va.Prev), ro(t, Na.Prod, Va.Prod), t)[e];
    },
    Wa = {
      en: {
        applepay: {
          cancel: "Cancel",
          enquire: "Continue to place the order with Apple Pay?",
          paywith: "Pay with"
        },
        cart: {
          cart: {
            buy_now: "Buy now"
          },
          checkout: {
            max_amount_limit: "You exceeded the maximum amount for checkout"
          },
          couponCode: {
            existCode: "Discount code already exists"
          },
          error: {
            "default": "Failed to load resource",
            noshipping: "No available shipping rate plans",
            order: "Unable to place order",
            renew: "Failed to update data"
          }
        },
        general: {
          abandon: {
            Order: {
              risk: "You have sent too many requests"
            }
          }
        },
        products: {
          product_details: {
            link_preview_does_not_support: "The link preview does not support this action",
            more_payment_options: "More payment options"
          },
          product_list: {
            select_product_all_options: "Please select all options of this product"
          }
        },
        sdk: {
          button: {
            show: "More",
            unavailable: {
              network_unstable: "Network unstable. Try again to continue.",
              wait_and_retry: "There are currently too many customers. Please wait patiently and try again after {seconds} seconds."
            }
          }
        },
        transaction: {
          discount: {
            code_error: "Enter a valid discount code"
          }
        },
        unvisiable: {
          shopby: {
            button: {
              show: "Secured and Faster"
            }
          }
        }
      }
    },
    Ka = Zr(function e() {
      var t = this;
      Jr(this, e), ro(this, "locale", Wa.en), ro(this, "envLocal", window.__I18N__), ro(this, "language", ""), ro(this, "setLanguage", function () {
        var e = Kr(so.mark(function e(n) {
          var r, o, i, a;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (t.language !== n) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return");
                case 2:
                  return t.language = n, void 0, r = (null === (c = window.__ENV__) || void 0 === c ? void 0 : c.APP_ENV) || Na.Prod, o = Ga(r), i = Wa.en, a = Gr.get().withOwner("I18n"), e.prev = 7, a.info("get i18n json", {
                    data: {
                      project: za,
                      env: o,
                      lang: n
                    }
                  }), e.next = 11, Ua({
                    project: za,
                    env: o,
                    lang: n
                  });
                case 11:
                  i = e.sent, e.next = 17;
                  break;
                case 14:
                  e.prev = 14, e.t0 = e["catch"](7), a.error("get i18n json error", {
                    error: e.t0
                  });
                case 17:
                  t.locale = i;
                case 18:
                case "end":
                  return e.stop();
              }
            }
            var c;
          }, e, null, [[7, 14]]);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }()), ro(this, "useI18n", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        return function (n, r) {
          var o = qa(t.envLocal || {}, e ? [e, n].join(".") : n) || "";
          return o || (o = qa(t.locale || {}, e ? [e, n].join(".") : n) || ""), o || (o = qa(Wa.en || {}, e ? [e, n].join(".") : n) || ""), r && Object.entries(r).forEach(function (e) {
            var t = $o(e, 2),
              n = t[0],
              r = t[1];
            return o = o.replace(new RegExp("{".concat(n, "}"), "ig"), r);
          }), o;
        };
      });
    }),
    Ja = new Ka(),
    Ya = Ja.useI18n;
  Ja.setLanguage;
  var Xa = Ya(),
    Za = function () {
      var e = Kr(so.mark(function e(t) {
        var n, r, o, i, a;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = t.ok, r = t.cancel, o = "".concat(Ma, "-action-ok"), i = "".concat(Ma, "-action-cancel"), a = La({
                  content: '<div>\n        <div class="'.concat(Ma, '-header">').concat(Ba, '</div>\n        <div class="').concat(Ma, '-content">').concat(Xa("applepay.enquire"), '</div>\n        <div class="').concat(Ma, '-action">\n          <button class="').concat(o, '"><span>').concat(Xa("applepay.paywith"), "</span> ").concat(Ba, '</button>\n          <button class="').concat(i, '">').concat(Xa("applepay.cancel"), "</button>\n        </div>\n      </div>"),
                  modalStyles: function modalStyles(e) {
                    return e.width = "calc(100% - 32px)", e.maxWidth = "397px", e.padding = "24px", e.top = "45%", e.borderRadius = "8px", e.background = "rgba(255, 255, 255, 1)", e.backdropFilter = "blur(6px)", e;
                  },
                  overlayStyles: function overlayStyles(e) {
                    return e.backgroundColor = "rgba(0, 0, 0, 0.5)", e.opacity = "1", e;
                  },
                  modalClass: "sl-payment ".concat(Ma),
                  closeButton: !1,
                  overlayClose: !1,
                  escCloses: !1
                }).afterCreate(function (e) {
                  var t,
                    a,
                    c = e.modalElem();
                  if (!c) throw new Error("picoModal instantiated object not found");
                  null === (t = c.querySelector(".".concat(o))) || void 0 === t || t.addEventListener("click", function () {
                    e.close(), n(e);
                  }), null === (a = c.querySelector(".".concat(i))) || void 0 === a || a.addEventListener("click", function () {
                    e.close(), null == r || r();
                  });
                }), e.abrupt("return", a);
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    $a = function $a(e) {
      var t,
        n = e.node,
        r = e.domId,
        o = e.height,
        i = e.wrapperClass,
        a = document.createElement("div");
      a.classList.add("applepay__bg");
      var c = document.createElement("style");
      if (Qa({
        styleTag: c,
        domId: r,
        height: o
      }), n) return i && n.classList.add(i), null === (t = n.parentElement) || void 0 === t || t.insertBefore(c, n), n.appendChild(a), a;
    },
    Qa = function Qa(e) {
      var t = e.styleTag,
        n = e.domId,
        r = e.height;
      t.innerHTML = "\n    #".concat(n, " applepay__bg {\n        overflow: hidden;\n        text-align: center;\n        height: ").concat(r, "px;\n      }\n    ");
    };
  function ec(e, t) {
    if (null == e) return {};
    var n,
      r,
      o = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          o = {},
          i = Object.keys(e);
        for (r = 0; r < i.length; r++) {
          n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
        }
        return o;
      }(e, t);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);
      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }
    return o;
  }
  var tc = function tc(e) {
      return e.channelCode === fo.SLpayments;
    },
    nc = function nc(e) {
      return e.channelCode === fo.AdyenExpress;
    },
    rc = function rc(e) {
      return function (e) {
        return e.accessMode === wo.PAYMENT_OPEN;
      }(e) || e.channelCode === fo.CybsOther;
    };
  function oc(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  window.crypto || (window.crypto = window.msCrypto);
  var ic = function ic() {
      try {
        return function () {
          for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 21, t = "", n = crypto.getRandomValues(new Uint8Array(e)); e--;) {
            var r = 63 & n[e];
            t += r < 36 ? r.toString(36) : r < 62 ? (r - 26).toString(36).toUpperCase() : r < 63 ? "_" : "-";
          }
          return t;
        }(36);
      } catch (e) {
        return Date.now() + Math.random().toString(36).slice(2);
      }
    },
    ac = function e() {
      oc(this, e), this.pvId = ic();
    };
  ac.setPvIdInGlobal = function (e) {
    window.__PAYMENT_SDK_PVID__ = e;
  }, ac.getPvIdInGlobal = function () {
    return window.__PAYMENT_SDK_PVID__;
  };
  var cc = function () {
    var e = ac.getPvIdInGlobal();
    if (e) return e;
    var t = new ac().pvId;
    return ac.setPvIdInGlobal(t), t;
  }();
  function sc(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function uc(e, t, n) {
    return t && sc(e.prototype, t), n && sc(e, n), e;
  }
  var lc = "",
    pc = function () {
      function e() {
        oc(this, e);
        var t = navigator.userAgent;
        this.ua = t, this.os = this.detectOS(this.ua), this.os_version = this.detectOSVersion(this.ua, this.os), this.browser = this.detectBrowser(this.ua), this.browser_version = this.detectBrowserVersion(this.ua, this.browser);
      }
      return uc(e, [{
        key: "detectOS",
        value: function value(e) {
          switch (!0) {
            case /Android/.test(e):
              return "Android";
            case /iPhone|iPad|iPod/.test(e):
              return "iOS";
            case /Windows/.test(e):
              return "Windows";
            case /Mac OS X/.test(e):
              return "Mac";
            case /CrOS/.test(e):
              return "Chrome OS";
            case /Firefox/.test(e):
              return "Firefox OS";
          }
          return "";
        }
      }, {
        key: "detectOSVersion",
        value: function value(e, t) {
          switch (t) {
            case "Android":
              return this.getVersion(e, "Android");
            case "iOS":
              return this.getVersion(e, /OS /);
            case "Windows":
              return this.getVersion(e, /Phone/.test(e) ? /Windows Phone (?:OS )?/ : /Windows NT/);
            case "Mac":
              return this.getVersion(e, /Mac OS X /);
          }
          return "0.0.0";
        }
      }, {
        key: "getVersion",
        value: function value(e, t) {
          try {
            return this.normalizeSemverString(e.split(t)[1].trim().split(/[^\w.]/)[0]);
          } catch (e) {}
          return "0.0.0";
        }
      }, {
        key: "normalizeSemverString",
        value: function value(e) {
          var t = e.split(/[._]/);
          return (parseInt(t[0], 10) || 0) + "." + (parseInt(t[1], 10) || 0) + "." + (parseInt(t[2], 10) || 0);
        }
      }, {
        key: "detectBrowser",
        value: function value(e) {
          var t = /Android/.test(e);
          switch (!0) {
            case /CriOS/.test(e):
              return "Chrome for iOS";
            case /Edge/.test(e):
              return "Edge";
            case t && /Silk\//.test(e):
              return "Silk";
            case /Chrome/.test(e):
              return "Chrome";
            case /Firefox/.test(e):
              return "Firefox";
            case t:
              return "AOSP";
            case /MSIE|Trident/.test(e):
              return "IE";
            case /Safari\//.test(e):
              return "Safari";
            case /AppleWebKit/.test(e):
              return "WebKit";
          }
          return "";
        }
      }, {
        key: "detectBrowserVersion",
        value: function value(e, t) {
          switch (t) {
            case "Chrome for iOS":
              return this.getVersion(e, "CriOS/");
            case "Edge":
              return this.getVersion(e, "Edge/");
            case "Chrome":
              return this.getVersion(e, "Chrome/");
            case "Firefox":
              return this.getVersion(e, "Firefox/");
            case "Silk":
              return this.getVersion(e, "Silk/");
            case "AOSP":
            case "Safari":
              return this.getVersion(e, "Version/");
            case "IE":
              return /IEMobile/.test(e) ? this.getVersion(e, "IEMobile/") : /MSIE/.test(e) ? this.getVersion(e, "MSIE ") : this.getVersion(e, "rv:");
            case "WebKit":
              return this.getVersion(e, "WebKit/");
          }
          return "0.0.0";
        }
      }]), e;
    }();
  function dc(e) {
    return (dc = "function" == typeof Symbol && "symbol" == lr(Symbol.iterator) ? function (e) {
      return lr(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : lr(e);
    })(e);
  }
  function fc(e) {
    if ("object" !== dc(e)) return "";
    var t = [];
    for (var n in e) {
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        var r = encodeURIComponent(e[n]);
        t.push("".concat(n, "=").concat(r));
      }
    }
    return t.join("&");
  }
  var hc = new (function () {
      function e() {
        oc(this, e), this.buildUrl = function (e, t) {
          var n = Object.prototype.toString.call(t);
          return t && "[object Object]" === n ? (e = decodeURIComponent(e).indexOf("?") > -1 ? "".concat(e, "&") : "".concat(e, "?")) + fc(t) : e;
        };
      }
      return uc(e, [{
        key: "get",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return e = this.buildUrl(e, t.params), this.http(e, Object.assign(Object.assign({
            method: "GET"
          }, t), {
            headers: Object.assign(Object.assign({}, {
              Accept: "application/json",
              "Content-Type": "application/json;charset=UTF-8"
            }), t.headers)
          }));
        }
      }, {
        key: "post",
        value: function value(e, t) {
          var n,
            r,
            o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = {
              Accept: "application/json"
            },
            a = t || o.data;
          return "form" == ((null === (n = null == o ? void 0 : o.headers) || void 0 === n ? void 0 : n["Content-Type"]) && /application\/json/.test(null === (r = null == o ? void 0 : o.headers) || void 0 === r ? void 0 : r["Content-Type"]) ? "json" : "form") ? (i["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8", a = fc(a)) : (i["Content-Type"] = "application/json;charset=UTF-8", a = a ? JSON.stringify(a) : null), this.http(e, Object.assign(Object.assign({
            method: "POST",
            body: a
          }, o), {
            headers: Object.assign(Object.assign({}, i), o.headers)
          }));
        }
      }, {
        key: "http",
        value: function value(e, t) {
          return new Promise(function (n, r) {
            var o = new XMLHttpRequest(),
              i = t.body,
              a = function (e, t) {
                var n = {};
                for (var r in e) {
                  Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
                }
                if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                  var o = 0;
                  for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
                    t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
                  }
                }
                return n;
              }(t, ["body"]);
            for (var c in o.open(t.method, e), t.headers) {
              Object.prototype.hasOwnProperty.call(t.headers, c) && o.setRequestHeader(c, t.headers[c]);
            }
            o.onreadystatechange = function () {
              if (4 === o.readyState) {
                var t = {
                    options: a,
                    statusCode: o.status,
                    url: e
                  },
                  i = "";
                try {
                  i = JSON.parse(o.responseText);
                } catch (e) {
                  i = o.responseText;
                }
                if (/^(2|3)\d{2}$/.test(o.status.toString())) {
                  try {
                    n(Object.assign({
                      data: i
                    }, t));
                  } catch (e) {
                    n(Object.assign({
                      data: i
                    }, t));
                  }
                  return;
                }
                r(Object.assign({
                  data: i
                }, t));
              }
            }, o.send(i), o.onerror = function (e) {
              throw e;
            };
          });
        }
      }]), e;
    }())(),
    yc = 0;
  function mc(e, t) {
    return (mc = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function vc(e) {
    return (vc = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function gc(e, t, n) {
    return (gc = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && mc(o, n.prototype), o;
    }).apply(null, arguments);
  }
  function bc(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (bc = function bc(e) {
      if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
      var n;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, r);
      }
      function r() {
        return gc(e, arguments, vc(this).constructor);
      }
      return r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), mc(r, e);
    })(e);
  }
  var wc = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && mc(e, t);
      }(n, bc(Error));
      var t = function (e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var n,
            r = vc(e);
          if (t) {
            var o = vc(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);
          return function (e, t) {
            return !t || "object" !== dc(t) && "function" != typeof t ? function (e) {
              if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return e;
            }(e) : t;
          }(this, n);
        };
      }(n);
      function n(e) {
        var r;
        return oc(this, n), (r = t.call(this, e)).name = "LinkMonitorError", r.message = "[LinkMonitorError]: " + e || "[LinkMonitorError]: Error", r;
      }
      return n;
    }(),
    kc = function () {
      function e(t, n) {
        var r = this;
        if (oc(this, e), this.act = "", this.reportNetworkConfig = {}, this.defaultOptions = {}, this.bs_queue = 0, this.queue = [], this.queueIsRIFScheduled = !1, this.upload = function (e) {
          if (r.queueIsRIFScheduled = !1, e || (e = {
            didTimeout: !0,
            timeRemaining: function timeRemaining() {
              return Number.MAX_VALUE;
            }
          }), (null == e ? void 0 : e.timeRemaining()) > 0 || r.queue.length > 0) {
            var t = r.queue.shift();
            t && function (e, t) {
              var n = e.url,
                r = e.mode,
                o = e.method,
                i = e.headers,
                a = e.onError;
              if (n && !(yc >= 5)) if ("image" !== r) "ajax" !== r || "post" !== o ? "ajax" !== r || "get" !== o || hc.get(n, {
                params: t,
                headers: i
              })["catch"](function (e) {
                yc += 1, "function" == typeof a && a(e), window[window.__sl_console__ ? "__sl_console__" : "console"].log("linkMonitor:", e);
              }) : hc.post(n, t, {
                headers: i
              })["catch"](function (e) {
                yc += 1, "function" == typeof a && a(e), window[window.__sl_console__ ? "__sl_console__" : "console"].log("linkMonitor:", e);
              });else try {
                !function (e, t, n) {
                  var r = new Image(1, 1),
                    o = fc(t),
                    i = "".concat(e, "?").concat(o);
                  r.onerror = function () {
                    "function" == typeof n && n(new Error("linkMonitor: fail to get img"));
                  }, r.onload = function () {}, r.src = i;
                }(n, t, a);
              } catch (e) {
                yc += 1, window[window.__sl_console__ ? "__sl_console__" : "console"].log("linkMonitor:", e);
              }
            }(t.reportNetworkConfig, t.reportData);
          }
          r.queue.length > 0 && r.upload();
        }, this.sendBeacon = function (e) {
          !function (e, t) {
            var n = e.url,
              r = e.onError;
            if (n && !(yc >= 5)) try {
              navigator.sendBeacon(e.url, URLSearchParams ? new URLSearchParams(t) : fc(t));
            } catch (e) {
              yc += 1, "function" == typeof r && r(e);
            }
          }(e.reportNetworkConfig, e.reportData);
        }, !t) throw new wc("Core class initialization requires the act field");
        this.act = t, this.reportNetworkConfig = n, this.getDefaultOptions();
      }
      return uc(e, [{
        key: "updateReportNetworkConfig",
        value: function value(e) {
          this.reportNetworkConfig = Object.assign(Object.assign({}, this.reportNetworkConfig), e);
        }
      }, {
        key: "getDefaultOptions",
        value: function value() {
          var e,
            t = this.act,
            n = {
              bs_ua: (e = new pc()).ua,
              bs_os: e.os,
              bs_os_version: e.os_version,
              bs_browser: e.browser,
              bs_browser_version: e.browser_version
            },
            r = {
              bs_screen_height: window.screen.height,
              bs_screen_width: window.screen.width,
              bs_color_depth: window.screen.colorDepth.toString()
            },
            o = window.navigator.javaEnabled().toString(),
            i = new Date().getTimezoneOffset().toString(),
            a = window.navigator.language,
            c = function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "2021-12-08";
              try {
                var t = document.createElement("canvas"),
                  n = t.getContext("2d"),
                  r = e;
                if (!n) return Date.now() + Math.random().toString(36).slice(2);
                n.textBaseline = "top", n.font = "14px 'Arial'", n.textBaseline = "tencent", n.fillStyle = "#f60", n.fillRect(125, 1, 62, 20), n.fillStyle = "#069", n.fillText(r, 2, 15), n.fillStyle = "rgba(102, 204, 0, 0.7)", n.fillText(r, 4, 17);
                var o = t.toDataURL().replace("data:image/png;base64,", "");
                return function (e) {
                  var t,
                    n,
                    r,
                    o = "";
                  for (t = 0, n = (e += "").length; t < n; t++) {
                    o += (r = e.charCodeAt(t).toString(16)).length < 2 ? "0" + r : r;
                  }
                  return o;
                }(window.atob(o).slice(-16, -12));
              } catch (e) {
                return Date.now() + Math.random().toString(36).slice(2);
              }
            }();
          this.defaultOptions = Object.assign(Object.assign(Object.assign({
            act: t,
            bs_lib_plugin_version: "1.7.1"
          }, n), r), {
            bs_java_enabled: o,
            bs_time_zone_offset: i,
            bs_language: a,
            fg: c
          });
        }
      }, {
        key: "getDefaultDynamicOptions",
        value: function value() {
          var e = Date.now(),
            t = Math.floor(e / 1e3),
            n = document.title,
            r = window.location.href,
            o = document.referrer,
            i = {
              bs_viewport_height: document.documentElement.offsetHeight || document.body.offsetHeight,
              bs_viewport_width: document.documentElement.offsetWidth || document.body.offsetWidth
            },
            a = i.bs_viewport_height,
            c = i.bs_viewport_width,
            s = this.bs_queue++,
            u = ic();
          return {
            pvId: cc,
            time: t,
            bs_create_time: e,
            bs_title: n,
            bs_url: r,
            bs_referrer: o,
            bs_viewport_height: a,
            bs_viewport_width: c,
            bs_queue: s,
            bs_uuid: u
          };
        }
      }, {
        key: "send",
        value: function value(e, t) {
          var n = this.getDefaultDynamicOptions(),
            r = Object.assign(Object.assign(Object.assign(Object.assign({}, this.defaultOptions), n), {
              eventName: e
            }), t),
            o = function (e) {
              try {
                var t = "ajax" === e.mode && "post" === e.method,
                  n = !!e.headers && Object.keys(e.headers).length > 0;
                return t && !n && window.navigator && "function" == typeof window.navigator.sendBeacon;
              } catch (e) {
                return !1;
              }
            }(this.reportNetworkConfig),
            i = {
              reportNetworkConfig: this.reportNetworkConfig,
              reportData: r
            };
          o ? this.sendBeacon(i) : (this.queue.push(i), this.queueUpload());
        }
      }, {
        key: "queueUpload",
        value: function value() {
          var e, t;
          this.queueIsRIFScheduled || (this.queueIsRIFScheduled = !0, e = this.upload, t = {
            timeout: 2e3
          }, "requestIdleCallback" in window ? window.requestIdleCallback(e, t) : setTimeout(e, 0));
        }
      }]), e;
    }(),
    xc = {
      debug: !1,
      url: "",
      mode: "ajax",
      method: "post"
    },
    Oc = function () {
      function e(t, n) {
        oc(this, e), this.businessDefaultOptions = {
          version: "0.0.0",
          environment: "production"
        }, this.act = t, this.options = Object.assign(Object.assign({}, xc), n), this.options.debug && (this.options.url = lc), this.fedLog = new kc(t, {
          url: this.options.url,
          mode: this.options.mode,
          method: this.options.method,
          headers: this.options.headers
        });
      }
      return uc(e, [{
        key: "init",
        value: function value(e, t) {
          t && this.fedLog.updateReportNetworkConfig(t), this.businessDefaultOptions = Object.assign(Object.assign({}, this.businessDefaultOptions), e);
        }
      }, {
        key: "report",
        value: function value(e, t) {
          var n = function (e) {
              var t = {};
              for (var n in e) {
                if (Object.prototype.hasOwnProperty.call(e, n)) {
                  var r = e[n];
                  t[n] = r instanceof Object ? JSON.stringify(r) : r;
                }
              }
              return t;
            }(t),
            r = Object.assign(Object.assign({}, this.businessDefaultOptions), n);
          this.fedLog.send(e, r);
        }
      }]), e;
    }();
  function _c(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }
    return r;
  }
  function Cc(e) {
    return function (e) {
      if (Array.isArray(e)) return _c(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return _c(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _c(e, t) : void 0;
      }
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function Ec(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Ic(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function Sc(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function Pc(e, t, n) {
    return t && Sc(e.prototype, t), n && Sc(e, n), e;
  }
  function Dc(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function jc(e) {
    return (jc = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function Tc(e, t, n) {
    return (Tc = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
      var r = function (e, t) {
        for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = jc(e));) {
          ;
        }
        return e;
      }(e, t);
      if (r) {
        var o = Object.getOwnPropertyDescriptor(r, t);
        return o.get ? o.get.call(n) : o.value;
      }
    })(e, t, n || e);
  }
  function Ac(e, t) {
    return (Ac = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function Rc(e) {
    return (Rc = "function" == typeof Symbol && "symbol" == lr(Symbol.iterator) ? function (e) {
      return lr(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : lr(e);
    })(e);
  }
  "function" != typeof Object.assign && (Object.assign = function (e) {
    for (var t = arguments.length, n = 1; n < t; n++) {
      var r = arguments[n];
      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
      }
    }
    return e;
  });
  var Lc = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
    Nc = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
    Mc = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
    Bc = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
  function Fc(e) {
    return (e && e.message || "No error message").split("\n").filter(function (e) {
      return !!e;
    })[0];
  }
  function Hc(e) {
    try {
      var t = function (e) {
        if (!e.stack) return null;
        for (var t, n, r = [], o = e.stack.split("\n"), i = 0; i < o.length; ++i) {
          if (t = Lc.exec(o[i])) n = {
            filename: t[2] && 0 === t[2].indexOf("address at ") ? t[2].substr("address at ".length) : t[2],
            "function": t[1] || "?",
            lineno: t[3] ? +t[3] : null,
            colno: t[4] ? +t[4] : null
          };else if (t = Mc.exec(o[i])) n = {
            filename: t[2],
            "function": t[1] || "?",
            lineno: +t[3],
            colno: t[4] ? +t[4] : null
          };else {
            if (!(t = Nc.exec(o[i]))) continue;
            0 !== i || t[5] || void 0 === e.columnNumber || (r[0].column = e.columnNumber + 1), n = {
              filename: t[3],
              "function": t[1] || "?",
              lineno: t[4] ? +t[4] : null,
              colno: t[5] ? +t[5] : null
            };
          }
          !n["function"] && n.lineno && (n["function"] = "?"), r.push(n);
        }
        return r.length ? {
          value: Fc(e),
          type: e.name,
          stacktrace: {
            frames: r.reverse()
          }
        } : null;
      }(e);
      if (t) return t;
    } catch (e) {}
    return {
      value: Fc(e),
      type: e && e.name,
      stacktrace: {
        frames: []
      }
    };
  }
  var Uc = Object.assign || function (e) {
      for (var t = arguments.length, n = 1; n < t; n++) {
        var r = arguments[n];
        for (var o in r) {
          Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
        }
      }
      return e;
    },
    Vc = function () {
      function e(t) {
        if (Ic(this, e), t.dsn) {
          var n = Bc.exec(t.dsn),
            r = n ? n.slice(1) : [],
            o = r[5].split("/"),
            i = o.slice(0, -1).join("/");
          this.apiUrl = r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (i ? "/" + i : "") + "/api/" + o.pop() + "/store/", this.authHeader = "Sentry sentry_version=7,sentry_key=" + r[1] + (r[2] ? ",sentry_secret=" + r[2] : "");
        }
        this.environment = t.environment;
      }
      return Pc(e, [{
        key: "prepare",
        value: function value(e) {
          return Uc(this.getRequestBlank(), {
            exception: {
              values: [Hc(e)]
            }
          });
        }
      }, {
        key: "report",
        value: function value(e) {
          this.send(this.prepare(e));
        }
      }, {
        key: "send",
        value: function value(e) {
          if (this.apiUrl) {
            var t = new XMLHttpRequest();
            t.open("POST", this.apiUrl, !0), t.setRequestHeader("Content-type", "application/json"), t.setRequestHeader("X-Sentry-Auth", this.authHeader || ""), t.send(JSON.stringify(e));
          }
        }
      }, {
        key: "getRequestBlank",
        value: function value() {
          return {
            platform: "javascript",
            sdk: {
              name: "micro-sentry.javascript.browser",
              version: "0.0.0"
            },
            timestamp: Date.now() / 1e3,
            request: {
              url: window.location.toString(),
              headers: {
                "User-Agent": window.navigator.userAgent
              }
            },
            environment: this.environment
          };
        }
      }]), e;
    }();
  function zc(e, t) {
    return "[object RegExp]" === Object.prototype.toString.call(t) ? t.test(e) : "string" == typeof t && -1 !== e.indexOf(t);
  }
  var qc = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && Ac(e, t);
    }(n, Vc);
    var t = function (e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = jc(e);
        if (t) {
          var o = jc(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return function (e, t) {
          return !t || "object" !== Rc(t) && "function" != typeof t ? Dc(e) : t;
        }(this, n);
      };
    }(n);
    function n(e) {
      var r;
      Ic(this, n), (r = t.call(this, e)).options = e, r.destroyed = !1, r._state = {};
      var o = r.options || {},
        i = o.plugins,
        a = void 0 === i ? [] : i,
        c = o.beforeSend,
        s = void 0 === c ? function (e) {
          return e;
        } : c,
        u = o.beforeBreadcrumb,
        l = void 0 === u ? function (e) {
          return e;
        } : u,
        p = o.blacklistUrls,
        d = void 0 === p ? [] : p,
        f = o.ignoreErrors,
        h = void 0 === f ? [] : f,
        y = o.release,
        m = void 0 === y ? void 0 : y;
      return r.plugins = a.map(function (e) {
        return new e(Dc(r));
      }), r.beforeSend = s, r.beforeBreadcrumb = l, r.blacklistUrls = d, r.ignoreErrors = h, r.release = m, r;
    }
    return Pc(n, [{
      key: "state",
      get: function get() {
        return this._state;
      }
    }, {
      key: "clearState",
      value: function value() {
        this._state = {};
      }
    }, {
      key: "setTags",
      value: function value(e) {
        return this.setKeyState("tags", Object.assign({}, e)), this;
      }
    }, {
      key: "setTag",
      value: function value(e, t) {
        return this.extendState({
          tags: Ec({}, e, t)
        }), this;
      }
    }, {
      key: "setExtra",
      value: function value(e, t) {
        return this.extendState({
          extra: Ec({}, e, t)
        }), this;
      }
    }, {
      key: "setExtras",
      value: function value(e) {
        return this.setKeyState("extra", Object.assign({}, e)), this;
      }
    }, {
      key: "setUser",
      value: function value(e) {
        return this.setKeyState("user", Object.assign({}, e)), this;
      }
    }, {
      key: "clone",
      value: function value() {
        var e = new n(Object.assign(Object.assign({}, this.options), {
          plugins: []
        }));
        return e.extendState(this.state), e;
      }
    }, {
      key: "withScope",
      value: function value(e) {
        var t = this.clone();
        e(t), t.destroy(), this.setBreadcrumbs(void 0);
      }
    }, {
      key: "addBreadcrumb",
      value: function value(e) {
        this.extendState({
          breadcrumbs: [Object.assign({
            timestamp: Date.now() / 1e3
          }, this.beforeBreadcrumb(e))]
        });
      }
    }, {
      key: "setBreadcrumbs",
      value: function value(e) {
        this.setKeyState("breadcrumbs", e);
      }
    }, {
      key: "captureMessage",
      value: function value(e, t) {
        this.send(Object.assign(Object.assign({}, this.getRequestBlank()), {
          message: e,
          level: t
        }));
      }
    }, {
      key: "destroy",
      value: function value() {
        this.destroyed = !0, this.plugins.forEach(function (e) {
          e.destroy && e.destroy();
        });
      }
    }, {
      key: "isIgnoredError",
      value: function value(e) {
        var t = this;
        return !!this.ignoreErrors.length && this.getPossibleEventMessages(e).some(function (e) {
          return t.ignoreErrors.some(function (t) {
            return zc(e, t);
          });
        });
      }
    }, {
      key: "getRequestBlank",
      value: function value() {
        return Object.assign(Object.assign({}, Tc(jc(n.prototype), "getRequestBlank", this).call(this)), this.state);
      }
    }, {
      key: "send",
      value: function value(e) {
        this.destroyed || this.isDeniedUrl(e) || this.isIgnoredError(e) || (Tc(jc(n.prototype), "send", this).call(this, this.beforeSend(Object.assign({
          release: this.release
        }, e))), this.setBreadcrumbs(void 0));
      }
    }, {
      key: "getPossibleEventMessages",
      value: function value(e) {
        if (e.message) return [e.message];
        if (e.exception) try {
          var t = e.exception.values && e.exception.values[0] || {},
            n = t.type,
            r = void 0 === n ? "" : n,
            o = t.value,
            i = void 0 === o ? "" : o;
          return ["".concat(i), "".concat(r, ": ").concat(i)];
        } catch (e) {
          return [];
        }
        return [];
      }
    }, {
      key: "isDeniedUrl",
      value: function value(e) {
        if (!this.blacklistUrls.length) return !1;
        var t = this.getEventFilterUrl(e);
        return !!t && this.blacklistUrls.some(function (e) {
          return zc(t, e);
        });
      }
    }, {
      key: "getEventFilterUrl",
      value: function value(e) {
        try {
          if (e.exception) {
            var t = e.exception.values && e.exception.values[0].stacktrace && e.exception.values[0].stacktrace.frames;
            return t && t[t.length - 1].filename || null;
          }
          return null;
        } catch (e) {
          return null;
        }
      }
    }, {
      key: "extendState",
      value: function value(e) {
        var t = this;
        this._state = Object.keys(e).reduce(function (n, r) {
          var o = t.state[r],
            i = Array.isArray(o) ? o : null,
            a = e[r],
            c = Array.isArray(a) ? a : null;
          return Object.assign(Object.assign({}, n), Ec({}, r, i || c ? [].concat(Cc(i || []), Cc(c || [])) : Object.assign(Object.assign({}, "string" != typeof o ? o : {}), "string" != typeof a ? a : {})));
        }, {});
      }
    }, {
      key: "setKeyState",
      value: function value(e, t) {
        this._state[e] = t;
      }
    }]), n;
  }();
  function Gc(e, t, n) {
    var r = e[t],
      o = n(r);
    if ("function" == typeof o) try {
      o.prototype = o.prototype || {}, Object.defineProperties(o, {
        __original__: {
          enumerable: !1,
          value: r
        }
      });
    } catch (e) {}
    e[t] = o;
  }
  function Wc(e) {
    if (!e) return {};
    var t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!t) return {};
    var n = t[6] || "",
      r = t[8] || "";
    return {
      host: t[4],
      path: t[5],
      protocol: t[2],
      relative: t[5] + n + r
    };
  }
  function Kc() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    return "Request" in window && e[0] instanceof Request && e[0].method ? String(e[0].method).toUpperCase() : e[1] && e[1].method ? String(e[1].method).toUpperCase() : "GET";
  }
  function Jc() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    return "string" == typeof e[0] ? e[0] : "Request" in window && e[0] instanceof Request ? e[0].url : String(e[0]);
  }
  function Yc(e) {
    return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
  }
  function Xc(e) {
    var t = e,
      n = [];
    if (!t || !t.tagName) return "";
    n.push(t.tagName.toLowerCase()), t.id && n.push("#".concat(t.id));
    var r = t.className;
    if (r && "string" == typeof r) {
      var o = r.split(/\s+/);
      n.concat(o.map(function (e) {
        return ".".concat(e);
      }));
    }
    return ["type", "name", "title", "alt", "automation-id"].forEach(function (e) {
      var r = t.getAttribute(e);
      r && n.push("[".concat(e, '="').concat(r, '"]'));
    }), n.join("");
  }
  function Zc(e) {
    try {
      for (var t, n = e, r = [], o = 0, i = 0, a = " > ".length; n && o++ < 5 && !("html" === (t = Xc(n)) || o > 1 && i + r.length * a + t.length >= 80);) {
        r.push(t), i += t.length, n = n.parentNode;
      }
      return r.reverse().join(" > ");
    } catch (e) {
      return "<unknown>";
    }
  }
  function $c(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
    return Array.isArray(e) ? e.map(function (e) {
      try {
        return String(e);
      } catch (e) {
        return "";
      }
    }).filter(function (e) {
      return "" !== e;
    }).join(t) : "";
  }
  function Qc(e, t, n, r, o, i, a) {
    try {
      var c = e[i](a),
        s = c.value;
    } catch (e) {
      return void n(e);
    }
    c.done ? t(s) : Promise.resolve(s).then(r, o);
  }
  function es(e) {
    return function () {
      var t = this,
        n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);
        function a(e) {
          Qc(i, r, o, a, c, "next", e);
        }
        function c(e) {
          Qc(i, r, o, a, c, "throw", e);
        }
        a(void 0);
      });
    };
  }
  function ts(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function ns(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function rs(e, t, n) {
    return t && ns(e.prototype, t), n && ns(e, n), e;
  }
  function os(e, t) {
    return (os = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function is(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && os(e, t);
  }
  function as(e) {
    return (as = "function" == typeof Symbol && "symbol" == lr(Symbol.iterator) ? function (e) {
      return lr(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : lr(e);
    })(e);
  }
  function cs(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function ss(e, t) {
    return !t || "object" !== as(t) && "function" != typeof t ? cs(e) : t;
  }
  function us(e) {
    return (us = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function ls(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  Pc(function e(t) {
    Ic(this, e), this.client = t, this.subscriptions = [], this.initDOM(), this.initConsole(), this.initFetch(), this.initHistory(), this.initXHR();
  }, [{
    key: "initXHR",
    value: function value() {
      if ("XMLHttpRequest" in window) {
        var e = this,
          t = XMLHttpRequest.prototype;
        Gc(t, "open", function (t) {
          return function () {
            for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
              r[o] = arguments[o];
            }
            var i = this,
              a = r[1];
            i.__sentry_xhr__ = {
              method: "string" == typeof r[0] ? r[0].toUpperCase() : r[0],
              url: r[1]
            }, "string" == typeof a && "POST" === i.__sentry_xhr__.method && a.match(/sentry_key/) && (i.__sentry_own_request__ = !0);
            var c = function c() {
              if (4 === i.readyState) {
                try {
                  i.__sentry_xhr__ && (i.__sentry_xhr__.status_code = i.status);
                } catch (e) {}
                e.xhrBreadcrumb({
                  args: r,
                  endTimestamp: Date.now(),
                  startTimestamp: Date.now(),
                  xhr: i
                });
              }
            };
            return "onreadystatechange" in i && "function" == typeof i.onreadystatechange ? Gc(i, "onreadystatechange", function (e) {
              return function () {
                c();
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                  n[r] = arguments[r];
                }
                e.apply(i, n);
              };
            }) : i.addEventListener("readystatechange", c), t.apply(i, r);
          };
        }), Gc(t, "send", function (t) {
          return function () {
            for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
              r[o] = arguments[o];
            }
            return e.xhrBreadcrumb({
              args: r,
              startTimestamp: Date.now(),
              xhr: this
            }), t.apply(this, r);
          };
        });
      }
    }
  }, {
    key: "initHistory",
    value: function value() {
      var e = this,
        t = window.onpopstate;
      function n(t) {
        return function () {
          for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
            r[o] = arguments[o];
          }
          var i = r.length > 2 ? r[2] : void 0;
          if (i) {
            var a = e.lastHref,
              c = String(i);
            e.lastHref = c, e.historyBreadcrumb({
              from: a,
              to: c
            });
          }
          return t.apply(this, r);
        };
      }
      window.onpopstate = function () {
        var n = window.location.href,
          r = e.lastHref;
        if (e.lastHref = n, e.historyBreadcrumb({
          from: r,
          to: n
        }), t) {
          for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++) {
            i[a] = arguments[a];
          }
          return t.apply(this, i);
        }
      }, Gc(window.history, "pushState", n), Gc(window.history, "replaceState", n);
    }
  }, {
    key: "destroy",
    value: function value() {
      this.subscriptions.forEach(function (e) {
        return e();
      });
    }
  }, {
    key: "initDOM",
    value: function value() {
      var e = this,
        t = function t(_t4) {
          return e.prepareDomEvent("click", _t4);
        },
        n = function n(t) {
          return e.prepareDomEvent("keypress", t);
        };
      window.document.addEventListener("click", t, !1), window.document.addEventListener("keypress", n, !1), this.subscriptions.push(function () {
        window.document.removeEventListener("click", t, !1), window.document.removeEventListener("keypress", n, !1);
      });
    }
  }, {
    key: "prepareDomEvent",
    value: function value(e, t) {
      var n;
      try {
        n = t.target ? Zc(t.target) : Zc(t);
      } catch (e) {
        n = "<unknown>";
      }
      0 !== n.length && this.client.addBreadcrumb({
        category: "ui.".concat(e),
        message: n
      });
    }
  }, {
    key: "initFetch",
    value: function value() {
      var e = this;
      (function () {
        if (!function () {
          if (!("fetch" in window)) return !1;
          try {
            return new Headers(), new Request(""), new Response(), !0;
          } catch (e) {
            return !1;
          }
        }()) return !1;
        if (Yc(window.fetch)) return !0;
        var e = !1,
          t = window.document;
        if (t && "function" == typeof t.createElement) try {
          var n = t.createElement("iframe");
          n.sandbox.add("allow-scripts"), n.sandbox.add("allow-same-origin"), n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = Yc(n.contentWindow.fetch)), t.head.removeChild(n);
        } catch (e) {}
        return e;
      })() && Gc(window, "fetch", function (t) {
        return function () {
          for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
            r[o] = arguments[o];
          }
          var i = {
            args: r,
            fetchData: {
              method: Kc(r),
              url: Jc(r)
            },
            startTimestamp: Date.now()
          };
          return e.fetchBreadcrumb(Object.assign({}, i)), t.apply(window, r).then(function (t) {
            return e.fetchBreadcrumb(Object.assign(Object.assign({}, i), {
              endTimestamp: Date.now(),
              response: t
            })), t;
          }, function (t) {
            throw e.fetchBreadcrumb(Object.assign(Object.assign({}, i), {
              endTimestamp: Date.now(),
              error: t
            })), t;
          });
        };
      });
    }
  }, {
    key: "fetchBreadcrumb",
    value: function value(e) {
      e.endTimestamp && (e.fetchData.url.match(/sentry_key/) && "POST" === e.fetchData.method || (e.error ? this.client.addBreadcrumb({
        category: "fetch",
        data: e.fetchData,
        level: "error",
        type: "http"
      }) : this.client.addBreadcrumb({
        category: "fetch",
        data: Object.assign(Object.assign({}, e.fetchData), {
          status_code: e.response.status
        }),
        type: "http"
      })));
    }
  }, {
    key: "xhrBreadcrumb",
    value: function value(e) {
      if (e.endTimestamp) {
        if (e.xhr.__sentry_own_request__) return;
        this.client.addBreadcrumb({
          category: "xhr",
          data: e.xhr.__sentry_xhr__,
          type: "http"
        });
      }
    }
  }, {
    key: "initConsole",
    value: function value() {
      var e = this;
      ["debug", "info", "warn", "error", "log", "assert"].forEach(function (t) {
        t in window[window.__sl_console__ ? "__sl_console__" : "console"] && Gc(window[window.__sl_console__ ? "__sl_console__" : "console"], t, function (n) {
          return function () {
            for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
              o[i] = arguments[i];
            }
            var a = {
              category: "console",
              data: {
                arguments: o.map(function (e) {
                  try {
                    return JSON.stringify(e), e;
                  } catch (t) {
                    return Object.prototype.toString.call(e);
                  }
                }),
                logger: "console"
              },
              level: t,
              message: $c(o, " ")
            };
            if ("assert" === t) {
              if (!1 !== o[0]) return;
              a.message = "Assertion failed: ".concat($c(o.slice(1), " ") || "console.assert"), a.data.arguments = o.slice(1);
            }
            e.client.addBreadcrumb(a), n && Function.prototype.apply.call(n, window[window.__sl_console__ ? "__sl_console__" : "console"], o);
          };
        });
      });
    }
  }, {
    key: "historyBreadcrumb",
    value: function value(e) {
      var t = e.from,
        n = e.to,
        r = Wc(window.location.href),
        o = Wc(t),
        i = Wc(n);
      o.path || (o = r), r.protocol === i.protocol && r.host === i.host && (n = i.relative), r.protocol === o.protocol && r.host === o.host && (t = o.relative), this.client.addBreadcrumb({
        category: "navigation",
        data: {
          from: t,
          to: n
        }
      });
    }
  }]);
  var ps = {};
  !function (e) {
    var t = function (e) {
      var t,
        n = Object.prototype,
        r = n.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        c = o.toStringTag || "@@toStringTag";
      function s(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        s({}, "");
      } catch (e) {
        s = function s(e, t, n) {
          return e[t] = n;
        };
      }
      function u(e, t, n, r) {
        var o = t && t.prototype instanceof m ? t : m,
          i = Object.create(o.prototype),
          a = new S(r || []);
        return i._invoke = function (e, t, n) {
          var r = p;
          return function (o, i) {
            if (r === f) throw new Error("Generator is already running");
            if (r === h) {
              if ("throw" === o) throw i;
              return D();
            }
            for (n.method = o, n.arg = i;;) {
              var a = n.delegate;
              if (a) {
                var c = C(a, n);
                if (c) {
                  if (c === y) continue;
                  return c;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (r === p) throw r = h, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = f;
              var s = l(e, t, n);
              if ("normal" === s.type) {
                if (r = n.done ? h : d, s.arg === y) continue;
                return {
                  value: s.arg,
                  done: n.done
                };
              }
              "throw" === s.type && (r = h, n.method = "throw", n.arg = s.arg);
            }
          };
        }(e, n, a), i;
      }
      function l(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      e.wrap = u;
      var p = "suspendedStart",
        d = "suspendedYield",
        f = "executing",
        h = "completed",
        y = {};
      function m() {}
      function v() {}
      function g() {}
      var b = {};
      b[i] = function () {
        return this;
      };
      var w = Object.getPrototypeOf,
        k = w && w(w(P([])));
      k && k !== n && r.call(k, i) && (b = k);
      var x = g.prototype = m.prototype = Object.create(b);
      function O(e) {
        ["next", "throw", "return"].forEach(function (t) {
          s(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function _(e, t) {
        function n(o, i, a, c) {
          var s = l(e[o], e, i);
          if ("throw" !== s.type) {
            var u = s.arg,
              p = u.value;
            return p && "object" == lr(p) && r.call(p, "__await") ? t.resolve(p.__await).then(function (e) {
              n("next", e, a, c);
            }, function (e) {
              n("throw", e, a, c);
            }) : t.resolve(p).then(function (e) {
              u.value = e, a(u);
            }, function (e) {
              return n("throw", e, a, c);
            });
          }
          c(s.arg);
        }
        var o;
        this._invoke = function (e, r) {
          function i() {
            return new t(function (t, o) {
              n(e, r, t, o);
            });
          }
          return o = o ? o.then(i, i) : i();
        };
      }
      function C(e, n) {
        var r = e.iterator[n.method];
        if (r === t) {
          if (n.delegate = null, "throw" === n.method) {
            if (e.iterator["return"] && (n.method = "return", n.arg = t, C(e, n), "throw" === n.method)) return y;
            n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return y;
        }
        var o = l(r, e.iterator, n.arg);
        if ("throw" === o.type) return n.method = "throw", n.arg = o.arg, n.delegate = null, y;
        var i = o.arg;
        return i ? i.done ? (n[e.resultName] = i.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, y) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, y);
      }
      function E(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function I(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function S(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(E, this), this.reset(!0);
      }
      function P(e) {
        if (e) {
          var n = e[i];
          if (n) return n.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var o = -1,
              a = function n() {
                for (; ++o < e.length;) {
                  if (r.call(e, o)) return n.value = e[o], n.done = !1, n;
                }
                return n.value = t, n.done = !0, n;
              };
            return a.next = a;
          }
        }
        return {
          next: D
        };
      }
      function D() {
        return {
          value: t,
          done: !0
        };
      }
      return v.prototype = x.constructor = g, g.constructor = v, v.displayName = s(g, c, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === v || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, s(e, c, "GeneratorFunction")), e.prototype = Object.create(x), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, O(_.prototype), _.prototype[a] = function () {
        return this;
      }, e.AsyncIterator = _, e.async = function (t, n, r, o, i) {
        void 0 === i && (i = Promise);
        var a = new _(u(t, n, r, o), i);
        return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, O(x), s(x, c, "Generator"), x[i] = function () {
        return this;
      }, x.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];
        for (var n in e) {
          t.push(n);
        }
        return t.reverse(), function n() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return n.value = r, n.done = !1, n;
          }
          return n.done = !0, n;
        };
      }, e.values = P, S.prototype = {
        constructor: S,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(I), !e) for (var n in this) {
            "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var n = this;
          function o(r, o) {
            return c.type = "throw", c.arg = e, n.next = r, o && (n.method = "next", n.arg = t), !!o;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
              c = a.completion;
            if ("root" === a.tryLoc) return o("end");
            if (a.tryLoc <= this.prev) {
              var s = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");
              if (s && u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (s) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];
            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), y;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), y;
          }
        },
        "catch": function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.tryLoc === e) {
              var r = n.completion;
              if ("throw" === r.type) {
                var o = r.arg;
                I(n);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, n, r) {
          return this.delegate = {
            iterator: P(e),
            resultName: n,
            nextLoc: r
          }, "next" === this.method && (this.arg = t), y;
        }
      }, e;
    }(ps);
    try {
      regeneratorRuntime = t;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(t);
    }
  }();
  var ds,
    fs,
    hs,
    ys,
    ms = ps;
  function vs(e, t, n) {
    return (vs = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && os(o, n.prototype), o;
    }).apply(null, arguments);
  }
  function gs(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (gs = function gs(e) {
      if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
      var n;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, r);
      }
      function r() {
        return vs(e, arguments, us(this).constructor);
      }
      return r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), os(r, e);
    })(e);
  }
  function bs(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = us(e);
      if (t) {
        var o = us(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);
      return ss(this, n);
    };
  }
  !function (e) {
    e.NotSupportBrowser = "1026", e.InnerSDKError = "1027", e.RenderFail = "1028", e.NetworkError = "1109", e.FrequentRequest = "1904", e.AbnormalTrade = "4205";
  }(ds || (ds = {})), function (e) {
    e.AbnormalTrade = "TRANSACTION_ABNORMAL", e.NetworkError = "Network error";
  }(fs || (fs = {})), function (e) {
    e.Fatal = "fatal", e.Error = "error";
  }(hs || (hs = {})), function (e) {
    e.IframeError = "PciIframeError", e.NoDom = "NoDomError";
  }(ys || (ys = {}));
  var ws = function (e) {
      is(n, gs(Error));
      var t = bs(n);
      function n(e) {
        var r,
          o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ds.InnerSDKError,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "UnknownError",
          a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : hs.Error;
        return ts(this, n), ls(cs(r = t.call(this, e)), "code", void 0), ls(cs(r), "isReported", !1), ls(cs(r), "data", void 0), ls(cs(r), "errorLevel", void 0), r.name = i, r.code = o, r.errorLevel = a, r;
      }
      return rs(n, [{
        key: "setIsReported",
        value: function value() {
          this.isReported = !0;
        }
      }]), n;
    }(),
    ks = function (e) {
      is(n, ws);
      var t = bs(n);
      function n(e) {
        var r,
          o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ds.InnerSDKError,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "SilenceError",
          a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : hs.Error;
        return ts(this, n), ls(cs(r = t.call(this, e, o, i, a)), "statusCode", void 0), r;
      }
      return n;
    }();
  function xs(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Os(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? xs(Object(n), !0).forEach(function (t) {
        ls(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xs(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var _s = new qc({
    dsn: "https://820fe9124d6a4b4d8ef0ee1e44a29c4b@sentry-new.myshopline.com/305",
    release: "3.6.1",
    environment: "production",
    beforeSend: function beforeSend(e) {
      return e;
    }
  });
  function Cs(e, t) {
    var n = JSON.stringify(Os(Os({}, e || {}), {}, {
        originErrorMessage: null == t ? void 0 : t.message,
        originErrorData: t ? JSON.stringify(t) : void 0,
        errorLevel: (null == t ? void 0 : t.errorLevel) || (null == e ? void 0 : e.errorLevel) || hs.Error
      })),
      r = new Error(n);
    if (null != t && t.stack) try {
      r.stack = t.stack;
    } catch (e) {
      _s.report(e), _s.report(t);
    }
    _s.report(r);
  }
  function Es(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10;
    return e ? function (e, t) {
      for (var n = "", r = 0; r < t; r++) {
        n += "*";
      }
      return n;
    }(0, t) + e.slice(t) : e;
  }
  function Is(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Ss(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Is(Object(n), !0).forEach(function (t) {
        ls(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Is(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var Ps,
    Ds,
    js,
    Ts,
    As = new Oc("webpaymentsdk"),
    Rs = function () {
      function e() {
        ts(this, e);
      }
      return rs(e, null, [{
        key: "init",
        value: function value(e) {
          As.init({
            projectName: "pcisdk",
            environment: "production",
            version: "3.6.1"
          }, e.eventTrackingConfig), _s.setTag("pvId", cc);
        }
      }, {
        key: "setHost",
        value: function value(e) {
          _s.setTag("host", e);
        }
      }, {
        key: "reportError",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "report_error",
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          e instanceof ks || e.name === ys.IframeError || (e instanceof ws ? e.isReported || (Cs(Ss({
            eventName: t
          }, n), e), e.setIsReported()) : Cs(Ss({
            eventName: t
          }, n), e));
        }
      }, {
        key: "handleError",
        value: function value(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "pci_sdk_default_error",
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (e.reportData(n, Ss(Ss({}, t), r)), e.reportError(t, n, r), t instanceof ks || t instanceof ws) throw t;
          var o = "".concat(n, " ").concat(t.message || "pci sdk inner error"),
            i = new ks(o);
          throw i.statusCode = t.statusCode, i.name = t.name || "Error", i.code = t.code || i.code, i.errorLevel = t.errorLevel || hs.Error, i.data = Ss({
            code: ds.InnerSDKError,
            msg: o
          }, t.data || {}), i;
        }
      }, {
        key: "formatReportData",
        value: function value(e) {
          if (!e) return {};
          var t = Ss({}, e);
          return t.customerToken && (t.customerToken = Es(t.customerToken, 30)), t.payToken && (t.payToken = Es(t.payToken, 10)), t;
        }
      }, {
        key: "reportData",
        value: function value(t, n) {
          try {
            As.report(t, n ? {
              extraData: JSON.stringify(n)
            } : {});
          } catch (r) {
            e.reportError(r, "".concat(t, "_report_data_error"), n);
          }
        }
      }, {
        key: "reportErrorData",
        value: function value(t, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : hs.Error;
          e.reportData(t, n), Cs(Ss({
            eventName: t,
            errorLevel: r
          }, n));
        }
      }]), e;
    }();
  !function (e) {
    e.Redirect = "Redirect", e.Confirm = "Confirm", e.QrCode = "QrCode", e.WorldPayGather = "WorldPayGather", e.ExchangeTicket = "ExchangeTicket";
  }(Ps || (Ps = {})), function (e) {
    e.Success = "success", e.Fail = "fail";
  }(Ds || (Ds = {})), function (e) {
    e.Number = "number", e.Cvc = "cvc", e.FirstName = "firstName", e.ExpDate = "expDate";
  }(js || (js = {})), function (e) {
    e.Hidden = "hidden-iframe", e.Cache = "cache-iframe";
  }(Ts || (Ts = {})), js.Number, js.Cvc, js.ExpDate;
  var Ls,
    Ns,
    Ms,
    Bs,
    Fs = [js.Number, js.Cvc, js.ExpDate, js.FirstName];
  function Hs(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Us(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Hs(Object(n), !0).forEach(function (t) {
        ls(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hs(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  (Ls || (Ls = {})).CN = "CN", function (e) {
    e.SL2 = "shopline2", e.SLP = "slp";
  }(Ns || (Ns = {})), function (e) {
    e.validate = "getValidate", e.pay = "pay", e.getBeforePayData = "getBeforePayData", e.getCardToken = "getCardToken", e.updateCardToken = "updateCardToken", e.getCurrentCardInfo = "getCurrentCardInfo", e.getCardTokenInfoByCardToken = "getCardTokenInfoByCardToken";
  }(Ms || (Ms = {})), function (e) {
    e.validate = "validate", e.pay = "payResult", e.getBeforePayData = "getBeforePayData", e.getCardToken = "cardTokenResult", e.updateCardToken = "updateCardTokenResult", e.getCurrentCardInfo = "cardInfoResult", e.getCardTokenInfoByCardToken = "getCardTokenInfoByCardTokenResult";
  }(Bs || (Bs = {}));
  var Vs = function () {
      function e(t) {
        var n = this,
          r = t.uuid,
          o = t.host,
          i = t.channelId,
          a = t.env,
          c = t.receiveMessageHandler;
        ts(this, e), ls(this, "uuid", void 0), ls(this, "iframeHost", "https://cashiers.myshopline.com"), ls(this, "isDev", !1), ls(this, "env", void 0), ls(this, "config", {}), ls(this, "channelId", void 0), ls(this, "mainIframe", js.Number), ls(this, "receiveMessageHandler", void 0), ls(this, "onIframeLoaded", function (e) {
          var t = e.name,
            r = e.mainIframe,
            o = e.displayFieldNames,
            i = n.config.placeholder;
          n.postToIframe(t, "initData", {
            pvId: cc,
            env: n.env,
            mainIframe: r,
            displayFieldNames: o,
            parentUrl: window.location.href,
            parentOrigin: window.location.origin,
            channelId: n.channelId
          }), i && i[t] && n.postToIframe(t, "setAttr", {
            attr: {
              placeholder: i[t]
            }
          });
        }), this.uuid = r, this.channelId = i, this.env = a, this.receiveMessageHandler = c, o && !this.isDev && (this.iframeHost = o);
      }
      return rs(e, [{
        key: "setConfig",
        value: function value(e) {
          this.config = e;
        }
      }, {
        key: "setIframeStatus",
        value: function value(e) {
          this.mainIframe = e.mainIframe;
        }
      }, {
        key: "handleApi",
        value: function value(e, t, n) {
          var r = this,
            o = Ms[e];
          return Rs.reportData("pci_sdk_".concat(o, "_start"), {
            eventData: null != t && t.nextAction ? Us(Us({}, t), {}, {
              nextAction: Rs.formatReportData(t.nextAction)
            }) : t
          }), new Promise(function (n, i) {
            r.receiveMessageHandler.setApiHandlerMap(e, n, i), r.postToMainIframe(o, t);
          }).then(function (e) {
            var t = n ? n(e) : {
              result: e
            };
            return Rs.reportData("pci_sdk_".concat(o, "_end"), t), e;
          })["catch"](function (e) {
            return Rs.handleError(e, "pci_sdk_".concat(o, "_error"));
          });
        }
      }, {
        key: "handleApiWithKey",
        value: function value(e, t, n) {
          var r = this,
            o = Ms[e];
          return Rs.reportData("pci_sdk_".concat(o, "_start"), {
            eventData: t ? t("") : void 0
          }), new Promise(function (n, i) {
            var a = r.receiveMessageHandler.setApiHandlerMapWithKey(e, n, i),
              c = t ? t(a) : void 0;
            r.postToMainIframe(o, c);
          }).then(function (e) {
            var t = e.key,
              r = e.result,
              i = n ? n({
                key: t,
                result: r
              }) : {
                key: t,
                result: r
              };
            return Rs.reportData("pci_sdk_".concat(o, "_end"), i), r;
          })["catch"](function (e) {
            return Rs.handleError(e, "pci_sdk_".concat(o, "_error"));
          });
        }
      }, {
        key: "postToMainIframe",
        value: function value(e, t) {
          this.postToIframe(this.mainIframe, e, t);
        }
      }, {
        key: "postToIframe",
        value: function value(e, t, n) {
          var r,
            o = Us({
              eventType: t,
              uuid: this.uuid
            }, n || {}),
            i = "".concat(e).concat(this.uuid);
          (null === (r = window.frames[i]) || void 0 === r ? void 0 : r.postMessage) && window.frames[i].postMessage(o, this.iframeHost);
        }
      }]), e;
    }(),
    zs = function () {
      var e = es(ms.mark(function e(t) {
        return ms.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", new Promise(function (e) {
                  setTimeout(function () {
                    e();
                  }, t);
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    qs = function () {
      function e(t) {
        var n = t.uuid,
          r = t.host,
          o = t.receiveMessageHandler,
          i = t.cdn;
        ts(this, e), ls(this, "uuid", void 0), ls(this, "iframePath", "https://cashiers.myshopline.com/pci-sdk"), ls(this, "innerDisplayIframeNames", []), ls(this, "cdn", void 0), ls(this, "renderIframeDomMap", {}), ls(this, "innerMainIframe", js.Number), ls(this, "receiveMessageHandler", void 0), ls(this, "destroyed", !1), ls(this, "isDev", !1), this.uuid = n, this.receiveMessageHandler = o, r && !this.isDev && (this.iframePath = "".concat(r, "/pci-sdk")), this.cdn = i, this.createCacheIframe();
      }
      var t;
      return rs(e, [{
        key: "displayIframeNames",
        get: function get() {
          return this.innerDisplayIframeNames;
        }
      }, {
        key: "mainIframe",
        get: function get() {
          return this.innerMainIframe;
        }
      }, {
        key: "mountIframe",
        value: function value(e, t, n, r) {
          if (!e) throw new ws("Can't find the related dom node to mount the iframe", ds.InnerSDKError, ys.NoDom);
          var o = document.createElement("iframe");
          o.onload = r, o.src = n, o.name = t, o.id = t, o.style.width = "100%", o.style.height = "100%", o.style.border = "none", e.innerHTML = "", e.appendChild(o);
        }
      }, {
        key: "getIframeLink",
        value: function value(e) {
          var t = this.isDev ? "" : "v".concat("3.6.1".split(".")[0], "/");
          return "".concat(this.iframePath, "/").concat(t, "iframe").concat(this.cdn === Ls.CN ? "-oss" : "", ".html#name=").concat(e, "&uuid=").concat(this.uuid);
        }
      }, {
        key: "createHiddenMountDom",
        value: function value(e) {
          var t = document.createElement("div");
          return t.setAttribute("data-pci", e), t.setAttribute("style", "display: none !important"), t.hidden = !0, document.body.appendChild(t), t;
        }
      }, {
        key: "doRenderIframe",
        value: function value(e, t) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
          this.destroyed || e.forEach(function (e) {
            n.mountIframe(n.renderIframeDomMap[e], "".concat(e).concat(n.uuid), n.getIframeLink(e), function () {
              return t({
                name: e,
                mainIframe: n.innerMainIframe,
                displayFieldNames: r
              });
            });
          });
        }
      }, {
        key: "createHiddenIframeDom",
        value: function value(e) {
          var t = Ts.Hidden,
            n = this.createHiddenMountDom(t);
          this.innerDisplayIframeNames.push(t), this.renderIframeDomMap[t] = n, this.innerMainIframe = t, this.doRenderIframe(this.innerDisplayIframeNames, e), this.startIframeReloadTiming(e);
        }
      }, {
        key: "createCacheIframe",
        value: function value() {
          var e = Ts.Cache,
            t = document.querySelector("div[data-pci=".concat(e, "]"));
          if (!t || !t.querySelector("iframe[id=".concat(e, "]"))) {
            var n = this.createHiddenMountDom(e);
            this.mountIframe(n, e, this.getIframeLink(e), function () {
              Rs.reportData("pci_sdk_cache_iframe_onload");
            });
          }
        }
      }, {
        key: "renderIframe",
        value: function value(e, t) {
          var n = this,
            r = [];
          if (e.querySelectorAll("[data-pci]").forEach(function (e, t) {
            var o = e.getAttribute("data-pci");
            0 !== t && o !== js.Number || (n.innerMainIframe = o), Fs.indexOf(o) > -1 && (n.innerDisplayIframeNames.push(o), n.renderIframeDomMap[o] = e, r.push(o));
          }), 0 === this.innerDisplayIframeNames.length) throw new ws("Can't find any dom node to mount the iframe", ds.InnerSDKError, ys.NoDom);
          this.doRenderIframe(this.innerDisplayIframeNames, t, r), this.startIframeReloadTiming(t, r);
        }
      }, {
        key: "startIframeReloadTiming",
        value: (t = es(ms.mark(function e(t) {
          var n,
            r,
            o,
            i,
            a,
            c = this,
            s = arguments;
          return ms.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  n = s.length > 1 && void 0 !== s[1] ? s[1] : [], r = 3, o = ms.mark(function e(o) {
                    var i, a;
                    return ms.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            if (!c.destroyed) {
                              e.next = 2;
                              break;
                            }
                            return e.abrupt("return", {
                              v: void 0
                            });
                          case 2:
                            return e.next = 4, zs(15e3);
                          case 4:
                            if (!c.destroyed) {
                              e.next = 6;
                              break;
                            }
                            return e.abrupt("return", {
                              v: void 0
                            });
                          case 6:
                            if (i = c.receiveMessageHandler.getIframeLoadedStatus(), a = Object.keys(i).filter(function (e) {
                              return !i[e];
                            }), Rs.reportData("pci_sdk_check_iframe_status", {
                              loadFailIframeNames: a
                            }), a.length) {
                              e.next = 13;
                              break;
                            }
                            return e.abrupt("return", {
                              v: void 0
                            });
                          case 13:
                            if (!(o < r - 1)) {
                              e.next = 19;
                              break;
                            }
                            Rs.reportData("pci_sdk_reload_iframe"), a.forEach(function (e) {
                              var t = c.renderIframeDomMap[e];
                              t && (t.innerHTML = "");
                            }), c.doRenderIframe(a, t, n), e.next = 23;
                            break;
                          case 19:
                            return c.unmountIframe(), c.receiveMessageHandler.triggerEvent("onError", {}), Rs.reportError(new Error("failed to load iframe"), "pci_sdk_load_iframe_failed"), e.abrupt("return", {
                              v: void 0
                            });
                          case 23:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }), i = 0;
                case 4:
                  if (!(i < r)) {
                    e.next = 12;
                    break;
                  }
                  return e.delegateYield(o(i), "t0", 6);
                case 6:
                  if ("object" !== as(a = e.t0)) {
                    e.next = 9;
                    break;
                  }
                  return e.abrupt("return", a.v);
                case 9:
                  i++, e.next = 4;
                  break;
                case 12:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function (e) {
          return t.apply(this, arguments);
        })
      }, {
        key: "unmountDom",
        value: function value(e) {
          if (e) {
            var t = this.renderIframeDomMap[e];
            t && (Rs.reportData("pci_sdk_unmount_dom", {
              name: e
            }), e === Ts.Hidden ? t.parentNode.removeChild(t) : t.innerHTML = "", this.renderIframeDomMap[e] = null);
          }
        }
      }, {
        key: "unmountIframe",
        value: function value() {
          var e = this;
          Rs.reportData("pci_sdk_unmount_iframe"), this.innerDisplayIframeNames.forEach(function (t) {
            return e.unmountDom(t);
          });
        }
      }, {
        key: "destroy",
        value: function value() {
          this.destroyed = !0, this.unmountIframe();
        }
      }]), e;
    }();
  function Gs(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  var Ws,
    Ks,
    Js = function () {
      function e(t) {
        var n,
          r = this;
        ts(this, e), ls(this, "uuid", void 0), ls(this, "config", void 0), ls(this, "iframeLoaded", {}), ls(this, "ApiHandlerMap", {}), ls(this, "ReceiveMessageHandler", (ls(n = {
          loadFinished: function loadFinished(e) {
            r.iframeLoaded[e.name] = !0, Rs.reportData("pci_sdk_iframe_loadFinished", e), Object.keys(r.iframeLoaded).every(function (e) {
              return r.iframeLoaded[e];
            }) && (Rs.reportData("pci_sdk_onInit"), r.triggerEvent("onInit", {}));
          },
          focus: function focus(e) {
            r.triggerEvent("onFocus", {
              fieldName: e.name,
              isEmpty: e.isEmpty,
              isFocus: e.isFocus
            });
          },
          input: function input(e) {
            r.triggerEvent("onFieldValidChange", {
              fieldName: e.name,
              isValid: e.isValid,
              isEmpty: e.isEmpty
            });
          },
          cardBinChange: function cardBinChange(e) {
            r.triggerEvent("onCardBinChange", e.value);
          }
        }, Bs.validate, function (e) {
          Rs.reportData("pci_sdk_validate_credit_card_cache", e.reportData), r.resolveApiHandler("validate", e.isValid);
        }), ls(n, Bs.pay, function (e) {
          Rs.reportData("pci_sdk_pay_credit_card_cache", e.reportData), e.status === Ds.Success ? r.resolveApiHandler("pay", e.value) : r.rejectApiHandler("pay", e.value);
        }), ls(n, Bs.getBeforePayData, function (e) {
          r.resolveApiHandler("getBeforePayData", e.value);
        }), ls(n, Bs.getCardToken, function (e) {
          var t = (e.extraOptions || {}).key;
          t && (e.status === Ds.Success ? r.resolveApiHandlerWithKey("getCardToken", e.value, t) : r.rejectApiHandlerWithKey("getCardToken", e.value, t));
        }), ls(n, Bs.updateCardToken, function (e) {
          var t = (e.extraOptions || {}).key;
          t && (e.status === Ds.Success ? r.resolveApiHandlerWithKey("updateCardToken", e.value, t) : r.rejectApiHandlerWithKey("updateCardToken", e.value, t));
        }), ls(n, Bs.getCardTokenInfoByCardToken, function (e) {
          var t = (e.extraOptions || {}).key;
          t && (e.status === Ds.Success ? r.resolveApiHandlerWithKey("getCardTokenInfoByCardToken", e.value, t) : r.rejectApiHandlerWithKey("getCardTokenInfoByCardToken", e.value, t));
        }), ls(n, Bs.getCurrentCardInfo, function (e) {
          e.status === Ds.Success ? r.resolveApiHandler("getCurrentCardInfo", e.value) : r.rejectApiHandler("getCurrentCardInfo", e.value);
        }), n)), this.uuid = t;
      }
      return rs(e, [{
        key: "init",
        value: function value(e, t) {
          var n = this;
          this.config = t, e.forEach(function (e) {
            return n.iframeLoaded[e] = !1;
          }), this.listenMessage();
        }
      }, {
        key: "getIframeLoadedStatus",
        value: function value() {
          return function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? Gs(Object(n), !0).forEach(function (t) {
                ls(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gs(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }({}, this.iframeLoaded);
        }
      }, {
        key: "listenMessage",
        value: function value() {
          var e = this;
          window.addEventListener("message", function (t) {
            var n = t.data,
              r = n.uuid,
              o = n.eventType;
            r === e.uuid && e.ReceiveMessageHandler[o] && e.ReceiveMessageHandler[o](t.data);
          });
        }
      }, {
        key: "setApiHandlerMap",
        value: function value(e, t, n) {
          this.ApiHandlerMap[e] = {
            resolve: t,
            reject: n
          };
        }
      }, {
        key: "setApiHandlerMapWithKey",
        value: function value(e, t, n) {
          var r = (new Date().getTime() + Math.floor(Math.random() * Math.pow(10, 13))).toString();
          return this.ApiHandlerMap[e] || (this.ApiHandlerMap[e] = {}), this.ApiHandlerMap[e][r] = {
            resolve: t,
            reject: n
          }, r;
        }
      }, {
        key: "resolveApiHandler",
        value: function value(e, t) {
          var n;
          (null === (n = this.ApiHandlerMap[e]) || void 0 === n ? void 0 : n.resolve) && this.ApiHandlerMap[e].resolve(t);
        }
      }, {
        key: "rejectApiHandler",
        value: function value(e, t) {
          var n;
          (null === (n = this.ApiHandlerMap[e]) || void 0 === n ? void 0 : n.reject) && this.ApiHandlerMap[e].reject(t);
        }
      }, {
        key: "resolveApiHandlerWithKey",
        value: function value(e, t, n) {
          var r, o;
          null !== (r = this.ApiHandlerMap[e]) && void 0 !== r && null !== (o = r[n]) && void 0 !== o && o.resolve && (this.ApiHandlerMap[e][n].resolve({
            key: n,
            result: t
          }), delete this.ApiHandlerMap[e][n]);
        }
      }, {
        key: "rejectApiHandlerWithKey",
        value: function value(e, t, n) {
          var r, o;
          null !== (r = this.ApiHandlerMap[e]) && void 0 !== r && null !== (o = r[n]) && void 0 !== o && o.reject && (this.ApiHandlerMap[e][n].reject(t), delete this.ApiHandlerMap[e][n]);
        }
      }, {
        key: "triggerEvent",
        value: function value(e, t) {
          try {
            this.config[e] && this.config[e](t);
          } catch (n) {
            Rs.handleError(n, "pci_sdk_triggerEvent_".concat(e, "_error"), t);
          }
        }
      }]), e;
    }();
  !function (e) {
    e.Test1 = "test1", e.Test2 = "test2", e.Test3 = "test3", e.Alpha = "alpha", e.Prod = "prod";
  }(Ws || (Ws = {}));
  var Ys = (ls(Ks = {}, Ws.Test1, {
    host: "https://cashiers-test1.myshoplinestg.com"
  }), ls(Ks, Ws.Test2, {
    host: "https://cashiers-test2.myshoplinestg.com"
  }), ls(Ks, Ws.Test3, {
    host: "https://cashiers-test3.myshoplinestg.com"
  }), ls(Ks, Ws.Alpha, {
    host: "https://cashiers-alpha.myshopline.com"
  }), ls(Ks, Ws.Prod, {
    host: "https://cashiers.myshopline.com"
  }), Ks);
  function Xs(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Zs(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Xs(Object(n), !0).forEach(function (t) {
        ls(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xs(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var $s = function () {
      function e(t) {
        ts(this, e), ls(this, "apiInstance", void 0), ls(this, "iframeInstance", void 0), ls(this, "receiveMessageInstance", void 0), ls(this, "cardToken", void 0), ls(this, "config", void 0), this.initReporter(t);
        try {
          var n;
          Rs.reportData("pci_sdk_constructor_start", Rs.formatReportData(t));
          var r = (null === (n = Ys[t.env]) || void 0 === n ? void 0 : n.host) || "";
          Rs.setHost(r);
          var o = (i = new Date().getTime(), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
            var t = (i + 16 * Math.random()) % 16 | 0;
            return i = Math.floor(i / 16), ("x" === e ? t : 3 & t | 8).toString(16);
          }));
          this.cardToken = t.cardToken, this.receiveMessageInstance = new Js(o), this.apiInstance = new Vs({
            uuid: o,
            host: r,
            channelId: null == t ? void 0 : t.channelId,
            env: t.env,
            receiveMessageHandler: this.receiveMessageInstance
          }), this.iframeInstance = new qs({
            uuid: o,
            host: r,
            receiveMessageHandler: this.receiveMessageInstance,
            cdn: t.cdn
          }), Rs.reportData("pci_sdk_constructor_end");
        } catch (e) {
          Rs.handleError(e, "pci_sdk_constructor_error");
        }
        var i;
      }
      var t;
      return rs(e, [{
        key: "initReporter",
        value: function value(e) {
          try {
            Rs.init(e);
          } catch (e) {
            Rs.handleError(e, "pci_sdk_init_reporter_error");
          }
        }
      }, {
        key: "update",
        value: (t = es(ms.mark(function e() {
          var t,
            n = arguments;
          return ms.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  t = n.length > 0 && void 0 !== n[0] ? n[0] : {}, Rs.reportData("pci_sdk_update_start", Rs.formatReportData(t)), t.cardToken && (this.cardToken = t.cardToken), Rs.reportData("pci_sdk_update_end");
                case 4:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return t.apply(this, arguments);
        })
      }, {
        key: "setConfig",
        value: function value(e) {
          this.apiInstance.setConfig(e);
        }
      }, {
        key: "getCardToken",
        value: function value(e) {
          return this.apiInstance.handleApiWithKey("getCardToken", function (t) {
            return {
              options: e,
              extraOptions: {
                key: t
              }
            };
          }, function (t) {
            var n = t.key,
              r = t.result;
            return Zs(Zs({}, e), {}, {
              token: (r.token || "").slice(-6),
              key: n
            });
          });
        }
      }, {
        key: "checkCardToken",
        value: function value() {
          if (!this.cardToken) return Rs.handleError(new ws("Empty CardToken", ds.InnerSDKError, "EmptyCardToken"), "pci_sdk_getCardTokenInfoByCardToken_empty_cardToken_error");
        }
      }, {
        key: "getCardTokenInfoByCardToken",
        value: function value(e) {
          var t = this;
          return this.checkCardToken(), this.apiInstance.handleApiWithKey("getCardTokenInfoByCardToken", function (n) {
            return {
              options: Zs(Zs({}, e), {}, {
                token: t.cardToken
              }),
              extraOptions: {
                key: n
              }
            };
          }, function (t) {
            var n = t.key,
              r = t.result;
            return Zs(Zs({}, e), {}, {
              token: Es(r.token),
              key: n
            });
          });
        }
      }, {
        key: "pay",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return this.apiInstance.handleApi("pay", {
            nextAction: e,
            requestParams: Zs(Zs({}, t), {}, {
              cardToken: this.cardToken
            })
          });
        }
      }, {
        key: "destroy",
        value: function value() {
          try {
            Rs.reportData("pci_sdk_destroy_start"), this.iframeInstance.destroy(), Rs.reportData("pci_sdk_destroy_end");
          } catch (e) {
            Rs.handleError(e, "pci_sdk_destroy_error");
          }
        }
      }]), e;
    }(),
    Qs = function (e) {
      is(n, $s);
      var t = function (e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var n,
            r = us(e);
          if (t) {
            var o = us(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);
          return ss(this, n);
        };
      }(n);
      function n() {
        return ts(this, n), t.apply(this, arguments);
      }
      return rs(n, [{
        key: "create",
        value: function value(e) {
          try {
            Rs.reportData("api_only_pci_sdk_create_start"), this.config = e, this.setConfig(e), this.iframeInstance.createHiddenIframeDom(this.apiInstance.onIframeLoaded), this.receiveMessageInstance.init(this.iframeInstance.displayIframeNames, this.config), this.apiInstance.setIframeStatus({
              mainIframe: this.iframeInstance.mainIframe
            }), Rs.reportData("api_only_pci_sdk_create_end");
          } catch (e) {
            Rs.handleError(e, "api_only_pci_sdk_create_error");
          }
        }
      }]), n;
    }();
  function eu(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function tu(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? eu(Object(n), !0).forEach(function (t) {
        ls(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : eu(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var nu = function (e) {
    is(r, $s);
    var t,
      n = function (e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var n,
            r = us(e);
          if (t) {
            var o = us(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);
          return ss(this, n);
        };
      }(r);
    function r() {
      return ts(this, r), n.apply(this, arguments);
    }
    return rs(r, [{
      key: "create",
      value: function value(e) {
        try {
          Rs.reportData("pci_sdk_create_start", {
            config: e
          }), this.config = e, this.apiInstance.setConfig(e), Rs.reportData("pci_sdk_create_end");
        } catch (e) {
          Rs.handleError(e, "pci_sdk_create_error");
        }
      }
    }, {
      key: "mount",
      value: function value(e) {
        try {
          Rs.reportData("pci_sdk_mount_start");
          var t = "string" == typeof e ? document.querySelector(e) : e;
          if (!t) throw new ws("Can't find the mount dom", ds.InnerSDKError, ys.NoDom);
          this.iframeInstance.renderIframe(t, this.apiInstance.onIframeLoaded), this.receiveMessageInstance.init(this.iframeInstance.displayIframeNames, this.config), this.apiInstance.setIframeStatus({
            mainIframe: this.iframeInstance.mainIframe
          }), Rs.reportData("pci_sdk_mount_end", {
            displayIframeNames: this.iframeInstance.displayIframeNames,
            mainIframe: this.iframeInstance.mainIframe
          });
        } catch (e) {
          Rs.handleError(e, "pci_sdk_mount_error");
        }
      }
    }, {
      key: "setStyle",
      value: function value(e) {
        try {
          Rs.reportData("pci_sdk_setStyle_start", {
            params: e
          });
          var t = e.type,
            n = e.fieldName,
            r = e.style;
          this.apiInstance.postToIframe(n, "setStyle", {
            style: r,
            type: t
          }), Rs.reportData("pci_sdk_setStyle_end");
        } catch (e) {
          Rs.handleError(e, "pci_sdk_setStyle_error");
        }
      }
    }, {
      key: "validate",
      value: function value(e) {
        return this.apiInstance.handleApi("validate", {
          validateItems: e
        });
      }
    }, {
      key: "getBeforePayData",
      value: function value(e) {
        return this.apiInstance.handleApi("getBeforePayData", {
          nextAction: e
        });
      }
    }, {
      key: "updateCardToken",
      value: function value(e) {
        var t = this;
        return this.checkCardToken(), this.apiInstance.handleApiWithKey("updateCardToken", function (n) {
          return {
            options: tu(tu({}, e), {}, {
              token: t.cardToken
            }),
            extraOptions: {
              key: n
            }
          };
        }, function (t) {
          var n = t.key,
            r = t.result;
          return tu(tu({}, e), {}, {
            token: Es(r.token),
            key: n
          });
        }).then(function (e) {
          return t.cardToken = e.token, Rs.reportData("pci_sdk_updateCardToken_update_token"), e;
        });
      }
    }, {
      key: "getCurrentCardInfo",
      value: (t = es(ms.mark(function e() {
        return ms.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.apiInstance.handleApi("getCurrentCardInfo"));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }]), r;
  }();
  function ru(e, t, n, r, o, i, a) {
    try {
      var c = e[i](a),
        s = c.value;
    } catch (e) {
      return void n(e);
    }
    c.done ? t(s) : Promise.resolve(s).then(r, o);
  }
  function ou(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  ls(nu, "ApiOnly", Qs);
  var iu = {};
  !function (e) {
    var t = function (e) {
      var t,
        n = Object.prototype,
        r = n.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        c = o.toStringTag || "@@toStringTag";
      function s(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        s({}, "");
      } catch (e) {
        s = function s(e, t, n) {
          return e[t] = n;
        };
      }
      function u(e, t, n, r) {
        var o = t && t.prototype instanceof m ? t : m,
          i = Object.create(o.prototype),
          a = new S(r || []);
        return i._invoke = function (e, t, n) {
          var r = p;
          return function (o, i) {
            if (r === f) throw new Error("Generator is already running");
            if (r === h) {
              if ("throw" === o) throw i;
              return D();
            }
            for (n.method = o, n.arg = i;;) {
              var a = n.delegate;
              if (a) {
                var c = C(a, n);
                if (c) {
                  if (c === y) continue;
                  return c;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (r === p) throw r = h, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = f;
              var s = l(e, t, n);
              if ("normal" === s.type) {
                if (r = n.done ? h : d, s.arg === y) continue;
                return {
                  value: s.arg,
                  done: n.done
                };
              }
              "throw" === s.type && (r = h, n.method = "throw", n.arg = s.arg);
            }
          };
        }(e, n, a), i;
      }
      function l(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      e.wrap = u;
      var p = "suspendedStart",
        d = "suspendedYield",
        f = "executing",
        h = "completed",
        y = {};
      function m() {}
      function v() {}
      function g() {}
      var b = {};
      s(b, i, function () {
        return this;
      });
      var w = Object.getPrototypeOf,
        k = w && w(w(P([])));
      k && k !== n && r.call(k, i) && (b = k);
      var x = g.prototype = m.prototype = Object.create(b);
      function O(e) {
        ["next", "throw", "return"].forEach(function (t) {
          s(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function _(e, t) {
        function n(o, i, a, c) {
          var s = l(e[o], e, i);
          if ("throw" !== s.type) {
            var u = s.arg,
              p = u.value;
            return p && "object" == lr(p) && r.call(p, "__await") ? t.resolve(p.__await).then(function (e) {
              n("next", e, a, c);
            }, function (e) {
              n("throw", e, a, c);
            }) : t.resolve(p).then(function (e) {
              u.value = e, a(u);
            }, function (e) {
              return n("throw", e, a, c);
            });
          }
          c(s.arg);
        }
        var o;
        this._invoke = function (e, r) {
          function i() {
            return new t(function (t, o) {
              n(e, r, t, o);
            });
          }
          return o = o ? o.then(i, i) : i();
        };
      }
      function C(e, n) {
        var r = e.iterator[n.method];
        if (r === t) {
          if (n.delegate = null, "throw" === n.method) {
            if (e.iterator["return"] && (n.method = "return", n.arg = t, C(e, n), "throw" === n.method)) return y;
            n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return y;
        }
        var o = l(r, e.iterator, n.arg);
        if ("throw" === o.type) return n.method = "throw", n.arg = o.arg, n.delegate = null, y;
        var i = o.arg;
        return i ? i.done ? (n[e.resultName] = i.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, y) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, y);
      }
      function E(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function I(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function S(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(E, this), this.reset(!0);
      }
      function P(e) {
        if (e) {
          var n = e[i];
          if (n) return n.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var o = -1,
              a = function n() {
                for (; ++o < e.length;) {
                  if (r.call(e, o)) return n.value = e[o], n.done = !1, n;
                }
                return n.value = t, n.done = !0, n;
              };
            return a.next = a;
          }
        }
        return {
          next: D
        };
      }
      function D() {
        return {
          value: t,
          done: !0
        };
      }
      return v.prototype = g, s(x, "constructor", g), s(g, "constructor", v), v.displayName = s(g, c, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === v || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, s(e, c, "GeneratorFunction")), e.prototype = Object.create(x), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, O(_.prototype), s(_.prototype, a, function () {
        return this;
      }), e.AsyncIterator = _, e.async = function (t, n, r, o, i) {
        void 0 === i && (i = Promise);
        var a = new _(u(t, n, r, o), i);
        return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, O(x), s(x, c, "Generator"), s(x, i, function () {
        return this;
      }), s(x, "toString", function () {
        return "[object Generator]";
      }), e.keys = function (e) {
        var t = [];
        for (var n in e) {
          t.push(n);
        }
        return t.reverse(), function n() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return n.value = r, n.done = !1, n;
          }
          return n.done = !0, n;
        };
      }, e.values = P, S.prototype = {
        constructor: S,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(I), !e) for (var n in this) {
            "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var n = this;
          function o(r, o) {
            return c.type = "throw", c.arg = e, n.next = r, o && (n.method = "next", n.arg = t), !!o;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
              c = a.completion;
            if ("root" === a.tryLoc) return o("end");
            if (a.tryLoc <= this.prev) {
              var s = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");
              if (s && u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (s) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];
            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), y;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), y;
          }
        },
        "catch": function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.tryLoc === e) {
              var r = n.completion;
              if ("throw" === r.type) {
                var o = r.arg;
                I(n);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, n, r) {
          return this.delegate = {
            iterator: P(e),
            resultName: n,
            nextLoc: r
          }, "next" === this.method && (this.arg = t), y;
        }
      }, e;
    }(iu);
    try {
      regeneratorRuntime = t;
    } catch (e) {
      "object" == ("undefined" == typeof globalThis ? "undefined" : lr(globalThis)) ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
    }
  }();
  var au,
    cu = iu;
  !function (e) {
    e.Google = "googleFont", e.ShopLine = "slFont", e.System = "system";
  }(au || (au = {}));
  var su,
    uu = ["Helvetica Neue", "Arial", "sans-serif"];
  !function () {
    var e, t, n, r;
    e = function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : au.System,
        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : uu;
      (function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      })(this, e), ou(this, "fontLib", void 0), ou(this, "fontFamily", void 0), this.fontLib = t, this.fontFamily = n;
    }, (t = [{
      key: "setFontFamily",
      value: (n = cu.mark(function e(t) {
        var n;
        return cu.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.fontLib !== au.Google) {
                  e.next = 5;
                  break;
                }
                return e.next = 3, this.injectGoogleFontCss();
              case 3:
                e.next = 8;
                break;
              case 5:
                if (this.fontLib !== au.ShopLine) {
                  e.next = 8;
                  break;
                }
                return e.next = 8, this.injectSLPFontCss();
              case 8:
                n = t.getAttribute("style") || "", t.setAttribute("style", "".concat(n, "font-family:").concat(this.fontFamily.join(",")));
              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      }), r = function r() {
        var e = this,
          t = arguments;
        return new Promise(function (r, o) {
          var i = n.apply(e, t);
          function a(e) {
            ru(i, r, o, a, c, "next", e);
          }
          function c(e) {
            ru(i, r, o, a, c, "throw", e);
          }
          a(void 0);
        });
      }, function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "injectCss",
      value: function value(e) {
        var t = document.getElementsByTagName("head")[0],
          n = document.createElement("link");
        return n.rel = "stylesheet", n.href = e, t.appendChild(n), new Promise(function (t, r) {
          n.onerror = function () {
            r({
              message: "inject css failed",
              url: e
            });
          }, n.onload = function () {
            t();
          };
        });
      }
    }, {
      key: "injectGoogleFontCss",
      value: function value() {
        var e = this.fontFamily.map(function (e) {
          return "family=".concat(e.replace(/\s/g, "+"));
        });
        return this.injectCss("https://fonts.googleapis.com/css?".concat(e.join("&"), "&display=swap"));
      }
    }, {
      key: "injectSLPFontCss",
      value: function value() {
        var e = this,
          t = this.fontFamily.map(function (t) {
            return e.injectCss("https://cdn-theme.myshopline.com/cdn/shop/fonts/".concat(t, ".css"));
          });
        return Promise.all(t);
      }
    }]) && function (e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }(e.prototype, t), Object.defineProperty(e, "prototype", {
      writable: !1
    });
  }(), function (e) {
    e.SL = "sl_pci";
  }(su || (su = {}));
  var lu = function lu(e, t) {
      var n;
      return {
        card: {
          bin: e.bin,
          last4: null == e || null === (n = e.first6Last4) || void 0 === n ? void 0 : n.slice(-4),
          data: JSON.stringify({
            host: t,
            token: null == e ? void 0 : e.token
          }),
          type: su.SL
        },
        channelToken: e.extend
      };
    },
    pu = ["paymentRequest", "paymentOptions", "paymentSession", "version"],
    du = ["newTotal", "newLineItems", "newShippingMethods", "version", "paymentSession", "paymentRequest", "paymentOptions"];
  function fu(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function hu(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? fu(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fu(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var yu = function () {
    function e(t, n) {
      Jr(this, e), ro(this, "payClient", null), ro(this, "config", void 0), ro(this, "logger", void 0), ro(this, "payChannelData", void 0), ro(this, "isUsePciToken", !1), this.config = t, this.logger = n.logger, this.isUsePciToken = rc(t.paymentInfo);
    }
    var t, n;
    return Zr(e, [{
      key: "setPayChannelData",
      value: function value(e) {
        var t = e.payChannelData,
          n = t.paymentRequest,
          r = t.paymentOptions,
          o = t.paymentSession,
          i = t.version,
          a = ec(t, pu);
        this.payChannelData = {
          version: i,
          paymentRequest: n,
          paymentOptions: r,
          paymentSession: o,
          rest: hu({}, a)
        }, oi(this.payChannelData);
      }
    }, {
      key: "beforePay",
      value: function value(e) {
        this.logger.info("beforePay", {
          data: hu({}, e)
        }), this.setPayChannelData(e), this.payChannelData && (this.payClient = new window.ApplePaySession(this.payChannelData.version, this.payChannelData.paymentRequest, this.payChannelData.paymentOptions));
      }
    }, {
      key: "pay",
      value: (n = Kr(so.mark(function e(t) {
        var n = this;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return this.setPayChannelData(t), this.logger.info("pay", {
                  data: hu({}, t)
                }), e.abrupt("return", new Promise(function (e, t) {
                  var r,
                    o = Sa.Create,
                    i = function i(e) {
                      var t = e.type,
                        r = e.originalEvent,
                        i = e.updateEvent;
                      o = t, n.logger.info("handleLogUpdateCurrentEvent", {
                        data: {
                          eventName: t,
                          originalEvent: r,
                          updateEvent: i
                        }
                      });
                    },
                    a = function a(e, r) {
                      window[window.__sl_console__ ? "__sl_console__" : "console"].error("AP unified error handling:", {
                        error: e,
                        type: lo.Pay,
                        extData: r
                      }), n.logger.error("handleError", {
                        action: lo.Pay,
                        error: e,
                        data: hu({}, r)
                      }), t(e), Qo(n.config.onError) && n.config.onError(e, lo.Pay, r);
                    },
                    c = function () {
                      var e = Kr(so.mark(function e(t) {
                        var r, o, i, c, s, u, l, p, d, f, h, y, m, v, g, b, w, k, x, O, _, C, E, I;
                        return so.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                if (c = t.type, s = t.paymentMethod, u = t.shippingContact, l = t.couponCode, p = t.shippingMethod, d = hu(hu({}, n.payChannelData), null === (r = n.payChannelData) || void 0 === r ? void 0 : r.rest)) {
                                  e.next = 5;
                                  break;
                                }
                                return a(new Error("without payChannelData")), e.abrupt("return");
                              case 5:
                                f = "unknown", e.t0 = c, e.next = e.t0 === Sa.Paymentmethodselected ? 9 : e.t0 === Sa.Shippingcontactselected ? 11 : e.t0 === Sa.Couponcodechanged ? 14 : e.t0 === Sa.Shippingmethodselected ? 17 : 19;
                                break;
                              case 9:
                                return d.newPaymentMethod = s, e.abrupt("break", 20);
                              case 11:
                                return d.newShippingContact = u, f = "shippingContactInvalid", e.abrupt("break", 20);
                              case 14:
                                return d.newCouponCode = l, f = "couponCodeInvalid", e.abrupt("break", 20);
                              case 17:
                                return d.newShippingMethod = p, e.abrupt("break", 20);
                              case 19:
                                return e.abrupt("break", 20);
                              case 20:
                                if (Qo(n.config.onFormDataChange)) {
                                  e.next = 23;
                                  break;
                                }
                                return a(new Error("without onFormDataChange")), e.abrupt("return");
                              case 23:
                                return delete d.rest, e.next = 26, null === (o = (i = n.config).onFormDataChange) || void 0 === o ? void 0 : o.call(i, d, Ha[c])["catch"](function (e) {
                                  window[window.__sl_console__ ? "__sl_console__" : "console"].error("onPaymentDataChanged fetch error", e), a(new Error("onPaymentDataChanged fetch error"));
                                });
                              case 26:
                                if ((h = e.sent) && !h.error) {
                                  e.next = 29;
                                  break;
                                }
                                return e.abrupt("return", {
                                  errors: [new window.ApplePayError(f, void 0, (null == h || null === (y = h.error) || void 0 === y ? void 0 : y.message) || "update error")],
                                  newTotal: null === (m = n.payChannelData) || void 0 === m ? void 0 : m.rest.newTotal,
                                  newLineItems: null === (v = n.payChannelData) || void 0 === v ? void 0 : v.rest.newLineItems,
                                  newShippingMethods: null === (g = n.payChannelData) || void 0 === g ? void 0 : g.rest.newShippingMethods
                                });
                              case 29:
                                return b = h.newTotal, w = h.newLineItems, k = h.newShippingMethods, x = h.version, O = h.paymentSession, _ = h.paymentRequest, C = h.paymentOptions, E = ec(h, du), n.payChannelData = {
                                  version: x,
                                  paymentSession: O,
                                  paymentRequest: _,
                                  paymentOptions: C,
                                  rest: hu(hu({}, E), {}, {
                                    newTotal: b,
                                    newShippingMethods: k,
                                    newLineItems: w
                                  })
                                }, oi(n.payChannelData), I = {
                                  newTotal: b,
                                  newLineItems: w,
                                  newShippingMethods: k
                                }, e.abrupt("return", I);
                              case 34:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));
                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }();
                  if (!n.payChannelData || !n.payChannelData.paymentSession) return window[window.__sl_console__ ? "__sl_console__" : "console"].error("without payChannelData"), void a(new Error("without payChannelData"));
                  try {
                    var s = JSON.parse(window.atob(n.payChannelData.paymentSession)),
                      u = n.payClient,
                      l = n.logger;
                    if (!u) throw new Error("No payment instance found");
                    u.onvalidatemerchant = function () {
                      var e = Kr(so.mark(function e(t) {
                        return so.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                i({
                                  type: Sa.Validatemerchant,
                                  originalEvent: t,
                                  decodeMerchantSession: s
                                }), u.completeMerchantValidation(s);
                              case 2:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));
                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }(), u.onpaymentmethodselected = function () {
                      var e = Kr(so.mark(function e(t) {
                        var n, r;
                        return so.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return n = {
                                  type: Sa.Paymentmethodselected,
                                  paymentMethod: t.paymentMethod
                                }, i({
                                  type: Sa.Paymentmethodselected,
                                  originalEvent: t,
                                  updateEvent: n
                                }), e.next = 4, c(n);
                              case 4:
                                if (r = e.sent) {
                                  e.next = 7;
                                  break;
                                }
                                throw new Error("no update information");
                              case 7:
                                u.completePaymentMethodSelection(r);
                              case 8:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));
                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }(), u.onshippingcontactselected = function () {
                      var e = Kr(so.mark(function e(t) {
                        var n, r;
                        return so.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return n = {
                                  type: Sa.Shippingcontactselected,
                                  shippingContact: t.shippingContact
                                }, i({
                                  type: Sa.Shippingcontactselected,
                                  originalEvent: t,
                                  updateEvent: n
                                }), e.next = 4, c(n);
                              case 4:
                                if (r = e.sent) {
                                  e.next = 7;
                                  break;
                                }
                                throw new Error("no update information");
                              case 7:
                                r.status = window.ApplePaySession.STATUS_SUCCESS, u.completeShippingContactSelection(r);
                              case 9:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));
                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }(), u.onshippingmethodselected = function () {
                      var e = Kr(so.mark(function e(t) {
                        var n, r, o;
                        return so.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return n = {
                                  type: Sa.Shippingmethodselected,
                                  shippingMethod: hu(hu({}, t.shippingMethod), {}, {
                                    selected: !0
                                  })
                                }, i({
                                  type: Sa.Shippingmethodselected,
                                  originalEvent: t,
                                  updateEvent: n
                                }), e.next = 4, c(n);
                              case 4:
                                r = e.sent, o = hu(hu({}, r), {}, {
                                  status: window.ApplePaySession.STATUS_SUCCESS
                                }), u.completeShippingMethodSelection(o);
                              case 7:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));
                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }(), u.oncouponcodechanged = function () {
                      var e = Kr(so.mark(function e(t) {
                        var n, r;
                        return so.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return n = {
                                  type: Sa.Couponcodechanged,
                                  couponCode: t.couponCode
                                }, i({
                                  type: Sa.Couponcodechanged,
                                  originalEvent: t,
                                  updateEvent: n
                                }), e.next = 4, c(n);
                              case 4:
                                if (r = e.sent) {
                                  e.next = 7;
                                  break;
                                }
                                throw new Error("no update information");
                              case 7:
                                u.completeCouponCodeChange(r);
                              case 8:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));
                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }(), u.onpaymentauthorized = function () {
                      var t = Kr(so.mark(function t(r) {
                        var o, c, s, p, d, f, h, y, m, v, g, b, w, k, x;
                        return so.wrap(function (t) {
                          for (;;) {
                            switch (t.prev = t.next) {
                              case 0:
                                if (i({
                                  type: Sa.Paymentauthorized,
                                  originalEvent: r
                                }), o = function o(e) {
                                  var t = {
                                    status: e
                                  };
                                  l.info("pay", {
                                    data: {
                                      status: e
                                    }
                                  }), e === window.ApplePaySession.STATUS_SUCCESS && u.completePayment(t);
                                }, t.prev = 2, d = r.payment, f = d.billingContact, h = d.shippingContact, y = d.token, Qo(n.config.createOrder)) {
                                  t.next = 7;
                                  break;
                                }
                                return a(new Error("onPaymentAuthorized failed, createOrder not triggered")), t.abrupt("return");
                              case 7:
                                return null == (m = hu(hu(hu({}, n.payChannelData), null === (c = n.payChannelData) || void 0 === c ? void 0 : c.rest), {}, {
                                  newShippingContact: h,
                                  newBillingContact: f
                                })) || delete m.rest, t.next = 11, null === (s = (p = n.config).createOrder) || void 0 === s ? void 0 : s.call(p, n.config.paymentInfo, {
                                  payChannelData: m,
                                  token: {
                                    token: y
                                  }
                                });
                              case 11:
                                if ((v = t.sent) && (null == v || !v.error)) {
                                  t.next = 15;
                                  break;
                                }
                                throw o(window.ApplePaySession.STATUS_FAILURE), new Error("Failed to place order");
                              case 15:
                                if (o(window.ApplePaySession.STATUS_SUCCESS), n.afterCreateOrder(go.Success), !n.isUsePciToken) {
                                  t.next = 27;
                                  break;
                                }
                                return g = v.nextAction.pciInfo, t.next = 21, n.getCardToken(r.payment, g)["catch"](function (e) {
                                  a(e);
                                });
                              case 21:
                                if (b = t.sent) {
                                  t.next = 24;
                                  break;
                                }
                                return t.abrupt("return");
                              case 24:
                                return e("onpaymentauthorized"), w = lu(b, (null == g ? void 0 : g.host) || ""), k = w.card, x = w.channelToken, t.abrupt("return", Zi(v.nextAction, {
                                  data: {
                                    fastCheckout: !0,
                                    paymentMethodOptions: {
                                      paymentMethodInstrument: JSON.stringify(x)
                                    },
                                    paymentInstrument: {
                                      paymentMethod: n.config.paymentInfo.methodCode,
                                      card: n.config.channelCode === fo.CybsOther ? hu(hu({}, k), {}, {
                                        binInfo: b.binInfo
                                      }) : k
                                    }
                                  }
                                }));
                              case 27:
                                e("onpaymentauthorized"), Zi(v.nextAction), t.next = 37;
                                break;
                              case 31:
                                t.prev = 31, t.t0 = t["catch"](2), o(window.ApplePaySession.STATUS_FAILURE), n.afterCreateOrder(go.Fail), window[window.__sl_console__ ? "__sl_console__" : "console"].error("pay failed", t.t0), a(new Error("pay failed"));
                              case 37:
                              case "end":
                                return t.stop();
                            }
                          }
                        }, t, null, [[2, 31]]);
                      }));
                      return function (e) {
                        return t.apply(this, arguments);
                      };
                    }(), u.oncancel = function () {
                      var t = Kr(so.mark(function t(r) {
                        return so.wrap(function (t) {
                          for (;;) {
                            switch (t.prev = t.next) {
                              case 0:
                                if (o !== Sa.Paymentauthorized) {
                                  t.next = 3;
                                  break;
                                }
                                return window[window.__sl_console__ ? "__sl_console__" : "console"].warn("Cannot cancel payment after token has been received"), t.abrupt("return");
                              case 3:
                                i({
                                  type: Sa.Cancel,
                                  originalEvent: r
                                }), e("oncancel"), Qo(n.config.onCancel) && n.config.onCancel(null == r ? void 0 : r.sessionError);
                              case 6:
                              case "end":
                                return t.stop();
                            }
                          }
                        }, t);
                      }));
                      return function (e) {
                        return t.apply(this, arguments);
                      };
                    }(), r = setTimeout(function () {
                      Qo(n.config.onChannelModalSuccess) && n.config.onChannelModalSuccess(n.config.paymentInfo);
                    }, 1e3), u.begin(), n.logger.log("Final parameters for launching Apple Pay", {
                      data: {
                        payChannelData: n.payChannelData
                      }
                    });
                  } catch (e) {
                    clearTimeout(r), a(e);
                  }
                }));
              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return n.apply(this, arguments);
      })
    }, {
      key: "afterCreateOrder",
      value: function value(e) {
        Qo(this.config.afterCreateOrder) && this.config.afterCreateOrder(e, {
          channelCode: this.config.paymentInfo.channelCode,
          methodCode: ho.ApplePay
        });
      }
    }, {
      key: "getCardToken",
      value: (t = Kr(so.mark(function e(t, n) {
        var r,
          o,
          i,
          a,
          c = this;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (null != n && n.host && null != n && n.resourceId) {
                  e.next = 2;
                  break;
                }
                throw new Error("host or resourceId is required");
              case 2:
                return r = this.config.paymentInfo.sdkEnv, o = pa[r].env || ia.Prod, i = new nu.ApiOnly({
                  env: o,
                  channelId: this.config.paymentInfo.paymentId
                }), e.next = 7, new Promise(function (e, t) {
                  i.create({
                    onInit: function onInit() {
                      c.logger.info("hidden_iframe_has_loaded"), e("");
                    },
                    onError: function onError() {
                      c.logger.error("hidden_iframe_load_fail"), t(new Error("hidden_iframe_load_fail"));
                    }
                  });
                });
              case 7:
                return e.next = 9, i.getCardToken({
                  rawToken: t,
                  paymentMethod: "ApplePay",
                  partnerId: Ns.SL2,
                  pciHost: n.host,
                  resourceId: n.resourceId
                });
              case 9:
                return a = e.sent, e.abrupt("return", a);
              case 11:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, n) {
        return t.apply(this, arguments);
      })
    }]), e;
  }();
  function mu(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function vu(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? mu(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mu(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var gu,
    bu,
    wu,
    ku = function (e) {
      eo(i, di);
      var t,
        n,
        r,
        o = function (e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();
          return function () {
            var n,
              r = no(e);
            if (t) {
              var o = no(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);
            return to(this, n);
          };
        }(i);
      function i(e) {
        var t, n, r;
        return Jr(this, i), ro($r(r = o.call(this, e)), "name", "APPLE_PAY"), ro($r(r), "config", void 0), ro($r(r), "initTime", 0), ro($r(r), "element", void 0), ro($r(r), "domId", void 0), ro($r(r), "client", null), ro($r(r), "skeleton", void 0), ro($r(r), "disabled", void 0), ro($r(r), "orderData", void 0), ro($r(r), "loading", void 0), ro($r(r), "initSuccess", !0), ro($r(r), "loadResourceFail", !1), ro($r(r), "logger", void 0), ro($r(r), "handleClick", Kr(so.mark(function e() {
          var t, n, o, i, a;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!r.disabled && !r.loading) {
                    e.next = 3;
                    break;
                  }
                  return r.logger.warn("applepay is disabled or loading"), e.abrupt("return");
                case 3:
                  return r.logger.log("applepay onClick"), r.setLoading(!0), (t = r.config.props.expressOptimizationSwitch) && (n = r.channelSdkInitConfig, o = {
                    amount: "99.99",
                    label: "Total",
                    type: "pending"
                  }, i = vu(vu({}, n), {}, {
                    payChannelData: vu(vu({}, n.payChannelData), {}, {
                      paymentRequest: vu(vu({}, n.payChannelData.paymentRequest), {}, {
                        total: o,
                        lineItems: [o]
                      })
                    })
                  }), r.beforePay(i)), e.next = 9, r.getOrderData();
                case 9:
                  if ((a = e.sent) && a.paymentConfig) {
                    e.next = 12;
                    break;
                  }
                  return e.abrupt("return");
                case 12:
                  t ? r.pay(a.paymentConfig) : r.openModal(a.paymentConfig);
                case 13:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }))), ro($r(r), "destroy", function () {
          r.client = null, r.removeEvents();
        }), r.validate(), r.config = ba(ni(Fa, e)), Gr.set(null === (t = (n = r.config).loggerFn) || void 0 === t ? void 0 : t.call(n)), r.logger = Gr.get().pipeOwner("payment-common.SLP-ApplePay").pipeData({
          domId: "".concat(r.config.props.domId)
        }), r;
      }
      return Zr(i, [{
        key: "channelSdkInitConfig",
        get: function get() {
          var e;
          return JSON.parse((null === (e = this.config.paymentInfo) || void 0 === e ? void 0 : e.channelSdkInitConfig) || "{}");
        }
      }, {
        key: "validate",
        value: function value() {
          return !0;
        }
      }, {
        key: "onError",
        value: function value(e, t, n) {
          Qo(this.config.onError) && this.config.onError(e, t, n);
        }
      }, {
        key: "handleError",
        value: function value(e, t, n) {
          t !== lo.CreateExpected && this.logger.error("handleError", {
            action: t,
            data: {
              type: t
            },
            error: e
          }), t === lo.Init && (this.initSuccess = !1, this.hideButton()), this.onError(e, t, n);
        }
      }, {
        key: "beforeInit",
        value: function value() {
          this.initTime = ri.now(), Qo(this.config.beforeInit) && this.config.beforeInit();
        }
      }, {
        key: "afterInit",
        value: function value(e) {
          try {
            this.initSuccess = !0, this.showButton();
            var t = ri.now() - this.initTime;
            this.logger.log("afterInit", {
              data: {
                data: e,
                duration: t
              }
            }), Qo(this.config.afterInit) && this.config.afterInit();
          } catch (e) {
            this.handleError(e);
          }
        }
      }, {
        key: "beforeCreateOrder",
        value: (r = Kr(so.mark(function e() {
          var t, n, r, o, i, a;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (Qo(this.config.beforeCreateOrder)) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return");
                case 2:
                  return t = this.config.paymentInfo, n = t.channelCode, r = t.methodCode, o = t.paymentId, i = t.accessMode, e.next = 5, this.config.beforeCreateOrder({
                    channelCode: n,
                    methodCode: r,
                    paymentId: o,
                    accessMode: i
                  });
                case 5:
                  return a = e.sent, e.abrupt("return", a);
                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return r.apply(this, arguments);
        })
      }, {
        key: "loadResource",
        value: function value() {
          var e = this;
          return new Promise(function (t) {
            da("https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js").then(function () {
              e.loadResourceFail = !1, t(!0);
            })["catch"](function (n) {
              e.loadResourceFail = !0, e.handleError(new Error("Failed to load channel js resource:".concat(n)), lo.Init), t(!1);
            });
          });
        }
      }, {
        key: "canMakePayments",
        value: function value() {
          try {
            var e,
              t,
              n = window.ApplePaySession;
            return !!(n && n.canMakePayments() && n.supportsVersion((null === (e = this.channelSdkInitConfig) || void 0 === e || null === (t = e.payChannelData) || void 0 === t ? void 0 : t.version) || 4));
          } catch (e) {
            return !1;
          }
        }
      }, {
        key: "renderButton",
        value: function value() {
          var e, t;
          this.element && this.domId ? (function (e) {
            var t,
              n = e.domId,
              r = e.node,
              o = e.height,
              i = e.borderRadius,
              a = document.createElement("style"),
              c = document.createElement("div");
            r.style.height = "".concat(o || 43, "px"), c.innerHTML = "<apple-pay-button id=".concat(n, ' buttonstyle="black" type="plain" locale="en"></apple-pay-button>');
            var s = "\n    #".concat(n, " {\n      --apple-pay-button-width: 100%;\n      --apple-pay-button-height: ").concat(o || 43, "px;\n      --apple-pay-button-border-radius: 0px;\n      --apple-pay-button-padding: 0px 0px;\n      --apple-pay-button-box-sizing: border-box;\n    }\n\n    .").concat(pi, " apple-pay-button {\n      display: none;\n    }\n\n    ").concat("\n    .applepay-confirm-modal-header {\n      margin-bottom: 12px;\n    }\n\n    .applepay-confirm-modal-content {\n      font-family: 'Helvetica Neue';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      color: #2c2c2c;\n    }\n\n    .applepay-confirm-modal-action {\n      margin-top: 24px;\n      display: flex;\n      flex-direction: column;\n    }\n\n    .applepay-confirm-modal-action > button {\n      border: 0;\n      text-align: center;\n      border-radius: 4px;\n      cursor: pointer;\n      font-style: normal;\n      line-height: 24px;\n    }\n\n    .applepay-confirm-modal-action-ok {\n      padding: 9px 0;\n      color: #fff;\n      background: #000;\n      font-size: 19px;\n      font-weight: 500;\n    }\n\n    .applepay-confirm-modal-action-ok > span {\n      vertical-align: middle;\n      font-family: 'SF Pro', 'Helvetica Neue';\n    }\n\n    .applepay-confirm-modal-action-ok > svg {\n      vertical-align: middle;\n    }\n\n    .applepay-confirm-modal-action-cancel {\n      padding: 0;\n      margin-top: 24px;\n      color: rgba(44, 44, 44, 0.5);\n      background: transparent;\n      font-size: 16px;\n      font-weight: 500;\n      font-family: 'Helvetica Neue';\n    }\n  ", "\n  ");
            void 0 === i && (s += "\n      #".concat(n, " {\n        --apple-pay-button-border-radius: 4px;\n      }\n\n      [data-button_style=square] #").concat(n, " {\n        --apple-pay-button-border-radius: 0px;\n      }\n  \n      [data-button_style=rounded] #").concat(n, " {\n        --apple-pay-button-border-radius: 9999px;\n      }\n    ")), a.innerHTML = s, null === (t = r.parentElement) || void 0 === t || t.insertBefore(a, r), r.appendChild(c);
          }({
            node: this.element,
            domId: this.domId,
            height: null === (e = this.config.props.styleOptions) || void 0 === e ? void 0 : e.height,
            borderRadius: null === (t = this.config.props.styleOptions) || void 0 === t ? void 0 : t["border-radius"]
          }), this.removeSkeleton(this.element)) : window[window.__sl_console__ ? "__sl_console__" : "console"].error("applepay has no node");
        }
      }, {
        key: "removeSkeleton",
        value: function value(e) {
          var t = this,
            n = null;
          n && clearTimeout(n), n = setTimeout(function () {
            e && t.skeleton && e.removeChild(t.skeleton);
          }, 300);
        }
      }, {
        key: "openModal",
        value: function value(e) {
          var t = this;
          Za({
            ok: function ok(n) {
              t.beforePay(e), t.pay(e), null == n || n.close(), t.setLoading(!1);
            },
            cancel: function cancel() {
              t.setLoading(!1), t.logger.info("user cancelled payment");
            }
          }).then(function (e) {
            t.logger.info("Payment modal launched successfully"), e.show();
          })["catch"](function (e) {
            window[window.__sl_console__ ? "__sl_console__" : "console"].error("Failed to prepare order", e), t.handleError(e, lo.Pay);
          });
        }
      }, {
        key: "pay",
        value: function value(e) {
          var t,
            n = this;
          this.setLoading(!1), null === (t = this.client) || void 0 === t || t.pay(e).then(function (e) {
            n.logger.info("User payment completed without errors", {
              data: {
                res: e
              }
            });
          })["catch"](function (e) {
            window[window.__sl_console__ ? "__sl_console__" : "console"].error("User payment error", {
              error: e
            }), n.handleError(e, lo.Pay);
          });
        }
      }, {
        key: "beforePay",
        value: function value(e) {
          try {
            var t;
            null === (t = this.client) || void 0 === t || t.beforePay(e);
          } catch (e) {
            this.setLoading(!1), window[window.__sl_console__ ? "__sl_console__" : "console"].error("Failed to prepare order", e), this.handleError(e, lo.Pay);
          }
        }
      }, {
        key: "getOrderData",
        value: (n = Kr(so.mark(function e() {
          var t;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, this.beforeCreateOrder();
                case 2:
                  if (t = e.sent, this.logger.log("Requesting API to get order data", {
                    data: {
                      params: t
                    }
                  }), !1 !== (null == t ? void 0 : t.valid)) {
                    e.next = 8;
                    break;
                  }
                  return this.setLoading(!1), this.onError(new Error("create order data no found"), lo.Pay, {
                    params: t
                  }), e.abrupt("return");
                case 8:
                  if (t.paymentConfig) {
                    e.next = 13;
                    break;
                  }
                  return window[window.__sl_console__ ? "__sl_console__" : "console"].error("No payment information"), this.handleError(new Error("no payment information"), lo.Pay, {
                    params: t
                  }), this.setLoading(!1), e.abrupt("return");
                case 13:
                  return this.orderData = t, e.abrupt("return", t);
                case 15:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return n.apply(this, arguments);
        })
      }, {
        key: "getEle",
        value: function value() {
          var e,
            t = null === (e = this.element) || void 0 === e ? void 0 : e.querySelector("#".concat(this.domId));
          if (t) return t;
          window[window.__sl_console__ ? "__sl_console__" : "console"].error("Apple Pay node not found");
        }
      }, {
        key: "bindEvents",
        value: function value() {
          var e = this.getEle();
          e && e.addEventListener("click", this.handleClick);
        }
      }, {
        key: "removeEvents",
        value: function value() {
          var e = this.getEle();
          e && e.removeEventListener("click", this.handleClick);
        }
      }, {
        key: "render",
        value: (t = Kr(so.mark(function e() {
          var t, n, r, o, i, a;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = this.config, r = n.props, o = n.paymentInfo, i = document.getElementById(o.currentDomId)) {
                    e.next = 5;
                    break;
                  }
                  return this.handleError(new Error("[onError][Init failed][Cannot find mounted DOM]"), lo.Init), e.abrupt("return", null);
                case 5:
                  return this.domId = "".concat(o.currentDomId, "-contain"), this.element = i, this.logger.log("render start", {
                    data: {
                      config: this.config
                    }
                  }), e.next = 10, this.loadResource();
                case 10:
                  if (e.sent) {
                    e.next = 13;
                    break;
                  }
                  return window[window.__sl_console__ ? "__sl_console__" : "console"].error("load applePay resource failed"), e.abrupt("return");
                case 13:
                  return e.next = 15, this.canMakePayments();
                case 15:
                  if (e.sent) {
                    e.next = 20;
                    break;
                  }
                  return this.handleError(new Error("Cannot use applePay"), lo.Init), window[window.__sl_console__ ? "__sl_console__" : "console"].error("Cannot use applePay"), e.abrupt("return");
                case 20:
                  if (this.beforeInit(), a = $a({
                    node: i,
                    domId: this.domId,
                    height: (null === (t = r.styleOptions) || void 0 === t ? void 0 : t.height) || "",
                    wrapperClass: r.wrapperClass,
                    wrapperStyle: r.wrapperStyle
                  }), this.skeleton = a, this.renderButton(), this.client = new yu(this.config, {
                    logger: this.logger
                  }), this.client) {
                    e.next = 28;
                    break;
                  }
                  return window[window.__sl_console__ ? "__sl_console__" : "console"].error("new Failed to create new Client"), e.abrupt("return");
                case 28:
                  return this.afterInit(), this.bindEvents(), e.abrupt("return", this.client);
                case 31:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return t.apply(this, arguments);
        })
      }, {
        key: "setDisabled",
        value: function value(e) {
          if (this.element) try {
            if (this.disabled = e, e) return void this.element.classList.add(li);
            this.element.classList.remove(li);
          } catch (e) {
            window[window.__sl_console__ ? "__sl_console__" : "console"].error("This error does not affect functionality, no need to address", e);
          }
        }
      }, {
        key: "setLoading",
        value: function value(e) {
          if (this.element) try {
            if (this.disabled = e, e) return void this.element.classList.add(pi);
            this.element.classList.remove(pi);
          } catch (e) {
            window[window.__sl_console__ ? "__sl_console__" : "console"].error("This error does not affect functionality, no need to address", e);
          }
        }
      }]), i;
    }();
  !function (e) {
    e.GooglePay = "googlePay", e.ApplePay = "applePay", e.Link = "link", e.BrowserCard = "browserCard";
  }(gu || (gu = {})), function (e) {
    e.Default = "default", e.Square = "square", e.Rounded = "rounded";
  }(bu || (bu = {}));
  var xu = [gu.ApplePay, gu.GooglePay, gu.Link, gu.BrowserCard],
    Ou = (ro(wu = {}, bu.Default, 4), ro(wu, bu.Rounded, 9999), ro(wu, bu.Square, 0), wu),
    _u = function _u(e, t, n) {
      if (e) {
        var r = e.contains(t);
        n && !r ? e.add(t) : !n && r && e.remove(t);
      }
    },
    Cu = function () {
      function e(t, n) {
        var r = this;
        Jr(this, e), ro(this, "container", void 0), ro(this, "styleElement", null), ro(this, "insertStyle", function (e) {
          if (r.container) {
            var t = document.createElement("style");
            t.innerHTML = "\n      .".concat(pi, " .__PrivateStripeElement {\n        display: none !important;\n        visibility: hidden;\n      }\n    "), e.height && (r.container.style.height = "".concat(e.height, "px")), r.styleElement = t, r.container.parentElement && r.container.parentElement.insertBefore(t, r.container);
          }
        }), ro(this, "destroy", function () {
          r.container.parentElement && r.styleElement && r.container.parentElement.removeChild(r.styleElement);
        }), this.container = t, this.insertStyle(n);
      }
      return Zr(e, [{
        key: "setDisabled",
        value: function value(e) {
          _u(this.container.classList, li, e);
        }
      }, {
        key: "setLoading",
        value: function value(e) {
          _u(this.container.classList, pi, e);
        }
      }]), e;
    }();
  function Eu(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Iu(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Eu(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Eu(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var Su = function Su(e) {
      return (e || "").toLowerCase();
    },
    Pu = function Pu(e, t) {
      return {
        label: "Total",
        amount: e,
        pending: t
      };
    },
    Du = function Du(e) {
      return e === gu.ApplePay;
    },
    ju = function (e) {
      eo(u, di);
      var t,
        n,
        r,
        o,
        i,
        a,
        c,
        s = function (e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();
          return function () {
            var n,
              r = no(e);
            if (t) {
              var o = no(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);
            return to(this, n);
          };
        }(u);
      function u(e) {
        var t, n, r;
        return Jr(this, u), ro($r(r = s.call(this, e)), "config", void 0), ro($r(r), "payChannelData", null), ro($r(r), "instance", null), ro($r(r), "paymentRequest", null), ro($r(r), "prButton", null), ro($r(r), "buttonElement", null), ro($r(r), "styleElement", null), ro($r(r), "paymentMethod", null), ro($r(r), "confirmModalLoadState", null), ro($r(r), "disabled", !1), ro($r(r), "loading", !1), ro($r(r), "initSuccess", !0), ro($r(r), "loadResourceFail", !1), ro($r(r), "initTime", 0), ro($r(r), "logger", void 0), ro($r(r), "destroy", function () {
          try {
            var e, t;
            null === (e = r.buttonElement) || void 0 === e || e.destroy(), r.buttonElement = null, null === (t = r.prButton) || void 0 === t || t.unmount();
            var n,
              o = document.getElementById(r.config.paymentInfo.currentDomId);
            null != o && o.parentElement && r.styleElement && (null == o || null === (n = o.parentElement) || void 0 === n || n.removeChild(r.styleElement), o.innerHTML = ""), r.paymentRequest = null, r.instance = null;
          } catch (e) {
            r.logger.error("stripeOther destroy error", {
              error: e,
              data: {
                channelSdkInitConfig: r.config.paymentInfo.channelSdkInitConfig
              }
            });
          }
        }), r.config = e, Gr.set(null === (t = (n = r.config).loggerFn) || void 0 === t ? void 0 : t.call(n)), r.logger = Gr.get().pipeOwner("payment-common.StripeOther").pipeData({
          domId: "".concat(r.config.props.domId)
        }), r;
      }
      return Zr(u, [{
        key: "render",
        value: (c = Kr(so.mark(function e() {
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return this.beforeInit(), e.next = 3, this.init();
                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return c.apply(this, arguments);
        })
      }, {
        key: "init",
        value: (a = Kr(so.mark(function e() {
          var t, n, r, o;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return this.paymentMethod = gu[this.config.paymentInfo.methodCode] || null, e.next = 3, this.loadChannelJs();
                case 3:
                  if (e.sent) {
                    e.next = 6;
                    break;
                  }
                  return e.abrupt("return");
                case 6:
                  if (this.createStripeInstance(), !this.paymentRequest) {
                    e.next = 23;
                    break;
                  }
                  return t = ri.now(), e.next = 11, this.paymentRequest.canMakePayment();
                case 11:
                  if (n = e.sent, r = ri.now() - t, o = {
                    canMakePaymentResult: n,
                    paymentMethod: this.paymentMethod,
                    taken: r
                  }, this.logger.info("canMakePaymentResult", {
                    data: {
                      logInfo: o
                    }
                  }), window[window.__sl_console__ ? "__sl_console__" : "console"].log("canMakePaymentResult:", o), !(this.paymentMethod && n && n[this.paymentMethod])) {
                    e.next = 21;
                    break;
                  }
                  this.renderButton(), this.afterInit(), e.next = 23;
                  break;
                case 21:
                  return this.handleError(new Error("The current browser does not support this payment method"), lo.Init, {
                    canMakePaymentResult: n
                  }), e.abrupt("return");
                case 23:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return a.apply(this, arguments);
        })
      }, {
        key: "beforeInit",
        value: function value() {
          this.initTime = ri.now(), Qo(this.config.beforeInit) && this.config.beforeInit();
        }
      }, {
        key: "afterInit",
        value: function value() {
          this.initSuccess = !0, this.showButton();
          var e = ri.now() - this.initTime;
          this.logger.log("afterInit", {
            data: {
              duration: e
            }
          }), Qo(this.config.afterInit) && this.config.afterInit();
        }
      }, {
        key: "onChannelModalSuccess",
        value: function value() {
          Qo(this.config.onChannelModalSuccess) && this.config.onChannelModalSuccess(this.config.paymentInfo);
        }
      }, {
        key: "beforeCreateOrder",
        value: (i = Kr(so.mark(function e() {
          var t, n, r, o, i;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (Qo(this.config.beforeCreateOrder)) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return");
                case 2:
                  return e.next = 4, this.confirmModalLoadState;
                case 4:
                  return t = this.config.paymentInfo, n = t.channelCode, r = t.methodCode, o = t.paymentId, e.next = 7, this.config.beforeCreateOrder({
                    channelCode: n,
                    methodCode: r,
                    paymentId: o
                  });
                case 7:
                  return i = e.sent, e.abrupt("return", i);
                case 9:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return i.apply(this, arguments);
        })
      }, {
        key: "afterCreateOrder",
        value: function value(e) {
          Qo(this.config.afterCreateOrder) && this.config.afterCreateOrder(e, {
            channelCode: fo.StripeOther,
            methodCode: this.config.paymentInfo.methodCode
          });
        }
      }, {
        key: "setDisabled",
        value: function value(e) {
          this.disabled = e, this.buttonElement && this.buttonElement.setDisabled(e);
        }
      }, {
        key: "setLoading",
        value: function value(e) {
          this.loading = e, this.buttonElement && this.buttonElement.setLoading(e);
        }
      }, {
        key: "loadChannelJs",
        value: function value() {
          var e = this;
          return new Promise(function (t) {
            da("https://js.stripe.com/v3/").then(function () {
              e.loadResourceFail = !1, t(!0);
            })["catch"](function (n) {
              e.loadResourceFail = !0, e.handleError(new Error("Failed to load channel js resource: ".concat(n)), lo.Init), t(!1);
            });
          });
        }
      }, {
        key: "createStripeInstance",
        value: function value() {
          var e = this;
          try {
            var t = this.config.paymentInfo,
              n = t.configData,
              r = n.publicApiKey,
              o = void 0 === r ? "" : r,
              i = n.stripeApiVersion,
              a = n.accountId,
              c = n.accountCountry,
              s = void 0 === c ? "" : c,
              u = t.channelSdkInitConfig,
              l = this.config.paymentInfo.settleCurrency || "",
              p = xu.filter(function (t) {
                return t !== e.paymentMethod;
              });
            if (!u) return void this.handleError(new Error("channelSdkInitConfig is empty"), lo.Init);
            var d = {};
            try {
              d = JSON.parse(u);
            } catch (e) {
              return void this.handleError(new Error("Failure to parse channel configuration JSON string"), lo.Init, {
                channelSdkInitConfig: u
              });
            }
            this.instance = window.Stripe(o, {
              apiVersion: i,
              stripeAccount: a
            });
            var f = this.instance.paymentRequest(Iu(Iu({}, d), {}, {
              currency: Su(l),
              country: s,
              total: Pu(9999, !0),
              disableWallets: p
            }));
            this.paymentRequest = f;
          } catch (e) {
            this.handleError(new Error("Failed to create channel instance"), lo.Init, {
              channelMsg: e.message
            });
          }
        }
      }, {
        key: "onPaymentAuthorized",
        value: (o = Kr(so.mark(function e(t) {
          var n,
            r,
            o,
            i,
            a,
            c,
            s,
            u,
            l,
            p,
            d,
            f,
            h = this;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = this.config.createOrder, Qo(n)) {
                    e.next = 3;
                    break;
                  }
                  return e.abrupt("return");
                case 3:
                  return r = t.paymentMethod, o = t.shippingAddress, i = t.shippingOption, a = t.payerName, c = t.payerPhone, s = t.payerEmail, u = r.id, l = void 0 === u ? "" : u, p = r.billing_details, d = Iu(Iu({}, this.payChannelData), {}, {
                    paymentMethod: l,
                    billing_details: p,
                    shippingAddress: o,
                    shippingOption: i,
                    payerInfo: {
                      name: a,
                      phone: c,
                      email: s
                    }
                  }), e.prev = 6, e.next = 9, n(this.config.paymentInfo, {
                    payChannelData: d,
                    token: d
                  });
                case 9:
                  if (!(y = f = e.sent) || !Boolean(y.error)) {
                    e.next = 13;
                    break;
                  }
                  throw f.error;
                case 13:
                  return e.next = 15, Zi(f.nextAction, {
                    payOptions: {
                      hooks: {
                        channelConfirm: function channelConfirm(e) {
                          return h.channelConfirm(e, t);
                        }
                      }
                    }
                  });
                case 15:
                  e.next = 22;
                  break;
                case 17:
                  e.prev = 17, e.t0 = e["catch"](6), t.complete("fail"), this.handleError(e.t0, lo.Pay), this.afterCreateOrder(go.Fail);
                case 22:
                case "end":
                  return e.stop();
              }
            }
            var y;
          }, e, this, [[6, 17]]);
        })), function (e) {
          return o.apply(this, arguments);
        })
      }, {
        key: "channelConfirm",
        value: (r = Kr(so.mark(function e(t, n) {
          var r, o, i, a;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (o = (null === (r = t.data) || void 0 === r ? void 0 : r.clientSecret) || "", this.instance) {
                    e.next = 3;
                    break;
                  }
                  throw new Error("stripe instance not found");
                case 3:
                  if (o) {
                    e.next = 9;
                    break;
                  }
                  if (!t.nextAction) {
                    e.next = 8;
                    break;
                  }
                  return e.next = 7, Zi(t.nextAction);
                case 7:
                  return e.abrupt("return");
                case 8:
                  throw new Error("The interface does not return clientSecret, and the sdk`s confirm cannot be called");
                case 9:
                  return e.prev = 9, e.next = 12, this.instance.confirmCardPayment(o);
                case 12:
                  i = e.sent, (a = i.error) ? (n.complete("fail"), this.afterCreateOrder(go.Fail), this.handleError(new Error("confirm error"), lo.Pay, {
                    error: a,
                    clientSecret: o
                  })) : (n.complete("success"), this.afterCreateOrder(go.Success));
                case 15:
                  if (e.prev = 15, !t.nextAction) {
                    e.next = 19;
                    break;
                  }
                  return e.next = 19, Zi(t.nextAction);
                case 19:
                  return e.finish(15);
                case 20:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[9,, 15, 20]]);
        })), function (e, t) {
          return r.apply(this, arguments);
        })
      }, {
        key: "renderButton",
        value: function value() {
          if (this.instance && this.paymentRequest) try {
            var e,
              t,
              n = document.getElementById(this.config.paymentInfo.currentDomId);
            if (!n) throw new Error("Container not found: #".concat(this.config.paymentInfo.currentDomId));
            var r = this.instance.elements(),
              o = null === (e = this.config.props.styleOptions) || void 0 === e ? void 0 : e.height;
            if (Du(this.paymentMethod)) {
              var i,
                a = document.createElement("style");
              a.innerHTML = "\n    .applepay-confirm-modal-header {\n      margin-bottom: 12px;\n    }\n\n    .applepay-confirm-modal-content {\n      font-family: 'Helvetica Neue';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      color: #2c2c2c;\n    }\n\n    .applepay-confirm-modal-action {\n      margin-top: 24px;\n      display: flex;\n      flex-direction: column;\n    }\n\n    .applepay-confirm-modal-action > button {\n      border: 0;\n      text-align: center;\n      border-radius: 4px;\n      cursor: pointer;\n      font-style: normal;\n      line-height: 24px;\n    }\n\n    .applepay-confirm-modal-action-ok {\n      padding: 9px 0;\n      color: #fff;\n      background: #000;\n      font-size: 19px;\n      font-weight: 500;\n    }\n\n    .applepay-confirm-modal-action-ok > span {\n      vertical-align: middle;\n      font-family: 'SF Pro', 'Helvetica Neue';\n    }\n\n    .applepay-confirm-modal-action-ok > svg {\n      vertical-align: middle;\n    }\n\n    .applepay-confirm-modal-action-cancel {\n      padding: 0;\n      margin-top: 24px;\n      color: rgba(44, 44, 44, 0.5);\n      background: transparent;\n      font-size: 16px;\n      font-weight: 500;\n      font-family: 'Helvetica Neue';\n    }\n  ", this.styleElement = a, null === (i = n.parentElement) || void 0 === i || i.insertBefore(a, n);
            }
            var c = null === (t = this.config.props.styleOptions) || void 0 === t ? void 0 : t["border-radius"];
            if (void 0 === c) {
              var s,
                u = document.querySelector("[data-button_style]"),
                l = null == u ? void 0 : u.getAttribute("data-button_style");
              this.logger.info("buttonStyle", {
                data: {
                  buttonStyle: l
                }
              }), c = null !== (s = Ou[l]) && void 0 !== s ? s : Ou["default"];
            }
            var p = {
                height: o ? "".concat(o, "px") : "",
                theme: "dark",
                borderRadius: "".concat(c, "px")
              },
              d = r.create("paymentRequestButton", {
                paymentRequest: this.paymentRequest,
                style: {
                  paymentRequestButton: p
                }
              });
            this.prButton = d, this.initButtonListener(this.paymentRequest, this.prButton), this.buttonElement = new Cu(n, {
              height: o
            }), this.prButton.mount(n);
            var f = n.querySelector(".__PrivateStripeElement");
            f && (f.style.display = "block");
          } catch (e) {
            this.handleError(new Error("Failed to render button"), lo.Init, {
              channelMsg: e.message
            });
          }
        }
      }, {
        key: "initButtonListener",
        value: function value(e, t) {
          var n = this;
          e.on("shippingaddresschange", function (e) {
            var t = e.shippingAddress,
              r = e.updateWith;
            n.handleFormDataChange(bo.ChangeAddress, {
              shippingAddress: t
            }, r);
          }), e.on("shippingoptionchange", function () {
            var e = Kr(so.mark(function e(t) {
              var r, o;
              return so.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      r = t.shippingOption, o = t.updateWith, n.handleFormDataChange(bo.ChangeDeliveryMethod, {
                        shippingOption: r
                      }, o);
                    case 2:
                    case "end":
                      return e.stop();
                  }
                }
              }, e);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }()), e.on("cancel", function () {
            n.logger.info("User closed payment modal");
          }), e.on("paymentmethod", this.onPaymentAuthorized.bind(this)), t.on("click", function (e) {
            e.preventDefault(), n.handleStripeOtherButtonClick();
          });
        }
      }, {
        key: "handleFormDataChange",
        value: (n = Kr(so.mark(function e(t, n, r) {
          var o, i, a, c, s, u, l, p;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.logger.info("handleFormDataChange: ".concat(t), {
                    data: {
                      params: n
                    }
                  }), o = this.config.onFormDataChange, Qo(o)) {
                    e.next = 5;
                    break;
                  }
                  return r({
                    status: "fail"
                  }), e.abrupt("return");
                case 5:
                  return e.prev = 5, e.next = 8, o(Iu(Iu({}, this.payChannelData), n), t);
                case 8:
                  if ((i = e.sent) && !i.error) {
                    e.next = 11;
                    break;
                  }
                  throw new Error(null == i || null === (a = i.error) || void 0 === a ? void 0 : a.message);
                case 11:
                  if (this.payChannelData = i, c = this.payChannelData, s = c.amount, u = void 0 === s ? 0 : s, l = c.shippingOptions, p = c.displayItems, null != l && l.length) {
                    e.next = 16;
                    break;
                  }
                  return r({
                    status: "invalid_shipping_address"
                  }), e.abrupt("return");
                case 16:
                  r({
                    status: "success",
                    total: Pu(u, !1),
                    displayItems: p,
                    shippingOptions: l
                  }), e.next = 23;
                  break;
                case 19:
                  e.prev = 19, e.t0 = e["catch"](5), r({
                    status: "fail"
                  }), this.handleError(new Error("Failed to update abandonedOrder info"), lo.Pay, {
                    error: e.t0
                  });
                case 23:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[5, 19]]);
        })), function (e, t, r) {
          return n.apply(this, arguments);
        })
      }, {
        key: "handleStripeOtherButtonClick",
        value: (t = Kr(so.mark(function e() {
          var t,
            n,
            r,
            o,
            i,
            a,
            c,
            s,
            u = this;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.instance && this.paymentRequest && !this.loading && !this.disabled) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return");
                case 2:
                  return t = this.config.props.expressOptimizationSwitch, n = function n() {
                    var e = null;
                    try {
                      u.paymentRequest && (e = setTimeout(function () {
                        u.onChannelModalSuccess();
                      }, 1e3), u.paymentRequest.show(), u.logger.info("Payment modal launched successfully"));
                    } catch (t) {
                      e && (clearTimeout(e), e = null), u.handleError(new Error("Failed to pull up the channel"), lo.PullUpChannel, {
                        error: t
                      });
                    }
                  }, this.setLoading(!0), Du(this.paymentMethod) && t && setTimeout(function () {
                    n();
                  }), e.next = 8, this.beforeCreateOrder()["catch"](function (e) {
                    u.handleError(e, lo.PullUpChannel);
                  });
                case 8:
                  if (r = e.sent, this.setLoading(!1), (l = r) && !1 !== l.valid && r.paymentConfig && r.paymentConfig.payChannelData) {
                    e.next = 13;
                    break;
                  }
                  return e.abrupt("return");
                case 13:
                  o = r.paymentConfig.payChannelData, i = o.amount, a = o.currency, c = o.shippingOptions, s = o.displayItems, this.payChannelData = Iu({}, o), this.logger.info("Updating payment modal information", {
                    data: {
                      amount: i,
                      shippingOptions: c,
                      displayItems: s
                    }
                  }), this.paymentRequest.update({
                    currency: Su(a),
                    total: Pu(i, !1),
                    shippingOptions: c,
                    displayItems: s
                  }), Du(this.paymentMethod) ? t || Za({
                    ok: n,
                    cancel: function cancel() {
                      u.logger.info("user cancelled payment");
                    }
                  }).then(function (e) {
                    e.show();
                  })["catch"](function (e) {
                    u.handleError(e, lo.Pay);
                  }) : setTimeout(function () {
                    n();
                  });
                case 19:
                case "end":
                  return e.stop();
              }
            }
            var l;
          }, e, this);
        })), function () {
          return t.apply(this, arguments);
        })
      }, {
        key: "handleError",
        value: function value(e, t, n) {
          window[window.__sl_console__ ? "__sl_console__" : "console"].error("Unified Error Handling for StripeOther:", {
            error: e,
            type: t,
            extData: n
          }), t !== lo.CreateExpected && this.logger.error("handleError", {
            action: t,
            error: e,
            data: Iu({}, n)
          }), t === lo.Init && (this.initSuccess = !1, this.hideButton()), Qo(this.config.onError) && this.config.onError(e, t, n);
        }
      }]), u;
    }();
  var Tu = function (e) {
    eo(n, ju);
    var t = function (e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = no(e);
        if (t) {
          var o = no(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return to(this, n);
      };
    }(n);
    function n(e) {
      var r;
      return Jr(this, n), ro($r(r = t.call(this, e)), "name", "GOOGLE_PAY"), r;
    }
    return Zr(n);
  }();
  var Au = function (e) {
    eo(n, ju);
    var t = function (e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = no(e);
        if (t) {
          var o = no(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return to(this, n);
      };
    }(n);
    function n(e) {
      var r;
      return Jr(this, n), ro($r(r = t.call(this, e)), "name", "APPLE_PAY"), r;
    }
    return Zr(n);
  }();
  function Ru(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Lu(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ru(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ru(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var Nu = function Nu(e) {
      var t = e.paymentInfo,
        n = t.configData,
        r = t.channelSdkInitConfig,
        o = t.captureInfo.autoCapture,
        i = e.props.payMode === po.Continue,
        a = e.props.isSubscription,
        c = function (e, t) {
          var n = "",
            r = function r(e) {
              var t = e.key,
                r = e.value;
              n = fi(n, ro({}, t, r));
            };
          return Array.isArray(e) && (null == e || e.forEach(function (e) {
            e.scope === po.All ? r(e) : (t && e.scope === po.Continue && r(e), t || e.scope !== po.PayNow || r(e));
          })), n;
        }(JSON.parse(r), i),
        s = {
          currency: e.paymentInfo.settleCurrency || "USD",
          commit: !i,
          "merchant-id": n.paypalMerchantId,
          "client-id": n.clientId
        };
      return fi(c, Lu(Lu({}, s), a ? {
        intent: "tokenize",
        vault: !0
      } : {
        intent: o ? "capture" : "authorize"
      }));
    },
    Mu = function Mu(e) {
      var t = e;
      if (null != e && e.paymentInfo) {
        var n = e.paymentInfo.configData;
        t.props = Lu(Lu({}, e.props), {}, {
          queryParams: Nu(e)
        }, n);
      }
      return t;
    },
    Bu = function Bu(e, t) {
      var n,
        r = t.props.isSubscription;
      return {
        abandonedOrderInfo: e.abandonedOrderInfo,
        orderFrom: e.orderFrom || e.abandonedOrderInfo.orderFrom,
        channelCode: fo.Paypal,
        spbCurrencyCode: t.paymentInfo.settleCurrency,
        payInfo: {
          cancelUrl: window.location.href,
          returnUrl: e.returnUrl,
          captureInfo: null === (n = t.paymentInfo) || void 0 === n ? void 0 : n.captureInfo,
          paymentScenes: r ? _o.PAY_AND_BIND : _o.PAY_NORMAL
        },
        dataReportReq: e.dataReportReq
      };
    },
    Fu = function Fu(e) {
      var t = Math.floor(e);
      return t >= 5e3 && t <= 1e4 ? "warn" : t > 1e4 ? "error" : "info";
    };
  function Hu(e) {
    var t = !0;
    return e && e.type || (t = !1), t;
  }
  function Uu(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Vu(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Uu(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Uu(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var zu,
    qu = function qu(e) {
      var t,
        n = e.node,
        r = e.domId,
        o = e.height,
        i = e.isContinueMode,
        a = e.isVerticalLayout,
        c = e.wrapperClass,
        s = e.wrapperStyle,
        u = document.createElement("div");
      u.classList.add("paypal__skeleton--animated");
      var l = document.createElement("style");
      if (Gu({
        styleTag: l,
        domId: r,
        height: o,
        isContinueMode: i,
        isVerticalLayout: a
      }), n) {
        if (c && n.classList.add(c), s) {
          var p,
            d = {},
            f = (null === (p = n.getAttribute("style")) || void 0 === p ? void 0 : p.replace(/\s+/g, "")) || "",
            h = function h(e) {
              var t = {};
              return e.split(";").forEach(function (e) {
                var n = $o(e.split(":"), 2),
                  r = n[0],
                  o = n[1],
                  i = null == r ? void 0 : r.replace(/-[^0-9]/g, function (e) {
                    return e.charAt(1).toUpperCase();
                  });
                i && (t[i] = o);
              }), t;
            };
          "string" == typeof s ? d = Vu(Vu({}, h(f)), h(s)) : "object" === lr(s) && (d = Vu(Vu({}, h(f)), s)), n.style = "object" !== lr(y = d) ? "" : Object.entries(y).map(function (e) {
            return e.join(":");
          }).join(";").replace(/[A-Z]/g, function (e) {
            return "-".concat(e.charAt(0).toLowerCase());
          });
        }
        var y;
        return null === (t = n.parentElement) || void 0 === t || t.insertBefore(l, n), n.appendChild(u), u;
      }
    },
    Gu = function Gu(e) {
      var t = e.styleTag,
        n = e.domId,
        r = e.height,
        o = e.isContinueMode,
        i = e.isVerticalLayout;
      t.innerHTML = o && !i ? "\n        #".concat(n, " {\n          overflow: hidden;\n          text-align: center;\n          height: ").concat(r, "px;\n          z-index: 1;\n        }\n        /** paypal background color */\n        #").concat(n, ".paypal__bg::before,\n        #").concat(n, ".paypal__bg::after {\n          content:'';\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          width: calc(50% - 3px);\n          border-radius: 4px;\n        }\n        #").concat(n, ".paypal__bg::after {\n          left: unset;\n          right: 0;\n        }\n        [data-button_style=square] #").concat(n, ".paypal__bg::before,\n        [data-button_style=square] #").concat(n, ".paypal__bg::after{\n          border-radius: 0 !important;\n        }\n        [data-button_style=rounded] #").concat(n, ".paypal__bg{\n          border-radius: 9999px !important;\n        }\n      ") : "\n        #".concat(n, " {\n          min-height: ").concat(r, "px;\n        }\n        ");
      var a = ["90deg", "hsla(0, 0%, 74.5%, 0.2) 25%", "hsla(0, 0%, 50.6%, 0.24) 37%", "hsla(0, 0%, 74.5%, 0.2) 63%"].join(", ");
      t.innerHTML += "\n      #".concat(n, " {\n        position: relative;\n        user-select: none;\n      }\n      #").concat(n, " .paypal__skeleton--animated {\n        margin: 0 auto;\n        border-radius: 4px;\n        width: 100%;\n        height: ").concat(r, "px;\n        position: absolute;\n      }\n\n      .paypal__skeleton--animated {\n        background: linear-gradient(").concat(a, ");\n        background-size: 400% 100%;\n        animation: skeleton 2s linear infinite;\n      }\n\n      ").concat("\n            @keyframes skeleton {\n              0% {\n                background-position: 100% 50%;\n              }\n              100% {\n                background-position: 0 50%;\n              }\n            }\n          ", "\n      ");
    };
  function Wu(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Ku(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Wu(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wu(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function Ju(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Yu(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ju(Object(n), !0).forEach(function (t) {
        ro(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ju(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  !function (e) {
    eo(i, Lo);
    var t,
      n,
      r,
      o = function (e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var n,
            r = no(e);
          if (t) {
            var o = no(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);
          return to(this, n);
        };
      }(i);
    function i(e) {
      var t;
      return Jr(this, i), ro($r(t = o.call(this, e)), "paypalInstance", null), t;
    }
    Zr(i, [{
      key: "initPaypal",
      value: function value() {
        this.paypalInstance = window[this.paypalInstanceName];
      }
    }, {
      key: "getConfig",
      value: (r = Kr(so.mark(function e() {
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.paypalInstance) {
                  e.next = 2;
                  break;
                }
                throw new Error("paypalInstance is not initialized");
              case 2:
                return e.abrupt("return", this.paypalInstance.Applepay().config());
              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "validateMerchant",
      value: (n = Kr(so.mark(function e(t) {
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.paypalInstance) {
                  e.next = 2;
                  break;
                }
                throw new Error("paypalInstance is not initialized");
              case 2:
                return e.abrupt("return", this.paypalInstance.Applepay().validateMerchant(t));
              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return n.apply(this, arguments);
      })
    }, {
      key: "confirmOrder",
      value: (t = Kr(so.mark(function e(t, n) {
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.paypalInstance) {
                  e.next = 2;
                  break;
                }
                throw new Error("paypalInstance is not initialized");
              case 2:
                return e.abrupt("return", this.paypalInstance.Applepay().confirmOrder(Ku({
                  orderId: t
                }, n || {})));
              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, n) {
        return t.apply(this, arguments);
      })
    }, {
      key: "destroy",
      value: function value() {
        this.paypalInstance = null;
      }
    }]);
  }(), function (e) {
    eo(i, Lo);
    var t,
      n,
      r,
      o = function (e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var n,
            r = no(e);
          if (t) {
            var o = no(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);
          return to(this, n);
        };
      }(i);
    function i(e) {
      var t;
      return Jr(this, i), ro($r(t = o.call(this, e)), "paypalInstance", null), t;
    }
    Zr(i, [{
      key: "initPaypal",
      value: function value() {
        this.paypalInstance = window[this.paypalInstanceName];
      }
    }, {
      key: "getConfig",
      value: (r = Kr(so.mark(function e(t) {
        var n, r, o, i;
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.paypalInstance) {
                  e.next = 2;
                  break;
                }
                throw new Error("paypalInstance is not initialized");
              case 2:
                return e.next = 4, this.paypalInstance.Googlepay().config();
              case 4:
                return i = e.sent, "JP" == t && null != i && null !== (n = i.allowedPaymentMethods) && void 0 !== n && null !== (r = n[0]) && void 0 !== r && null !== (o = r.parameters) && void 0 !== o && o.allowedAuthMethods && (i.allowedPaymentMethods[0].parameters.allowedAuthMethods = ["PAN_ONLY"]), e.abrupt("return", i);
              case 7:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "confirmOrder",
      value: (n = Kr(so.mark(function e(t, n) {
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.paypalInstance) {
                  e.next = 2;
                  break;
                }
                throw new Error("paypalInstance is not initialized");
              case 2:
                return e.abrupt("return", this.paypalInstance.Googlepay().confirmOrder({
                  orderId: t,
                  paymentMethodData: n
                }));
              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t) {
        return n.apply(this, arguments);
      })
    }, {
      key: "initiatePayerAction",
      value: (t = Kr(so.mark(function e(t) {
        return so.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.paypalInstance) {
                  e.next = 2;
                  break;
                }
                throw new Error("paypalInstance is not initialized");
              case 2:
                return e.abrupt("return", this.paypalInstance.Googlepay().initiatePayerAction({
                  orderId: t
                }));
              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "destroy",
      value: function value() {
        this.paypalInstance = null;
      }
    }]);
  }();
  var Xu = {
      loadingStatus: vo.Await,
      info: {},
      promise: null
    },
    Zu = function (e) {
      eo(c, di);
      var t,
        n,
        r,
        o,
        i,
        a = function (e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();
          return function () {
            var n,
              r = no(e);
            if (t) {
              var o = no(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);
            return to(this, n);
          };
        }(c);
      function c(e) {
        var t, n;
        return Jr(this, c), ro($r(n = a.call(this, e)), "name", "PAY_PAL"), ro($r(n), "config", void 0), ro($r(n), "payMode", void 0), ro($r(n), "isHidePayPalButton", void 0), ro($r(n), "isRendered", void 0), ro($r(n), "element", null), ro($r(n), "initTimer", void 0), ro($r(n), "initActions", void 0), ro($r(n), "createOrderParams", void 0), ro($r(n), "returnUrl", void 0), ro($r(n), "orderInfoMap", {}), ro($r(n), "initTime", 0), ro($r(n), "skeleton", void 0), ro($r(n), "initSuccess", !0), ro($r(n), "loadResourceFail", !1), ro($r(n), "logger", void 0), ro($r(n), "dynamicJsonpCallback", function (e) {
          Xu = Yu(Yu({}, Xu), {}, {
            info: e,
            loadingStatus: vo.Done
          }), n.handleDynamicNotify(e);
        }), ro($r(n), "destroy", function () {
          try {
            zu && (zu.disconnect(), zu = null), n.element && (n.element.innerHTML = "", n.element = null);
          } catch (e) {
            n.logger.error("paypal destroy error", {
              error: e,
              data: {
                channelSdkInitConfig: n.config.paymentInfo.channelSdkInitConfig
              }
            });
          }
        }), n.payMode = e.props.payMode || po.Continue, n.returnUrl = "", Gr.set(null === (t = e.loggerFn) || void 0 === t ? void 0 : t.call(e)), n.logger = Gr.get().pipeOwner("payment-common.PayPal").pipeData({
          domId: "".concat(e.props.domId)
        }), n.config = Mu(ni(jo, e)), n.handleDomHeight(), n.validate(e) ? n : to(n);
      }
      return Zr(c, [{
        key: "validate",
        value: function value(e) {
          var t = function (e) {
            var t,
              n = (ro(t = {}, "".concat(fo.Paypal, "-").concat(ho.Paypal), {
                validate: function validate() {
                  return e.props && ei(e.props) ? {
                    result: !0
                  } : {
                    result: !1,
                    errorTip: "props illegal"
                  };
                },
                getConfig: function getConfig() {
                  return e;
                },
                component: el
              }), ro(t, "".concat(fo.StripeOther, "-").concat(ho.ApplePay), {
                validate: function validate() {
                  return e.props && ei(e.props) ? {
                    result: !0
                  } : {
                    result: !1,
                    errorTip: "props illegal"
                  };
                },
                getConfig: function getConfig() {
                  return e;
                },
                component: Au
              }), ro(t, "".concat(fo.StripeOther, "-").concat(ho.GooglePay), {
                validate: function validate() {
                  return e.props && ei(e.props) ? {
                    result: !0
                  } : {
                    result: !1,
                    errorTip: "props illegal"
                  };
                },
                getConfig: function getConfig() {
                  return e;
                },
                component: Tu
              }), ro(t, ho.GooglePay, {
                validate: function validate() {
                  return e.props && ei(e.props) ? {
                    result: !0
                  } : {
                    result: !1,
                    errorTip: "props illegal"
                  };
                },
                getConfig: function getConfig() {
                  return e;
                },
                component: ma
              }), ro(t, ho.ApplePay, {
                validate: function validate() {
                  return e.props && ei(e.props) ? {
                    result: !0
                  } : {
                    result: !1,
                    errorTip: "props illegal"
                  };
                },
                getConfig: function getConfig() {
                  return e;
                },
                component: ku
              }), t);
            return tc(e.paymentInfo) || rc(e.paymentInfo) || nc(e.paymentInfo) ? n["".concat(e.paymentInfo.methodCode)] : n["".concat(e.channelCode, "-").concat(e.paymentInfo.methodCode)];
          }(e);
          if (!t) return !1;
          var n = t.validate(),
            r = n.result,
            o = n.errorTip;
          return !!r || (this.logger.error("constructor error ".concat(o)), !1);
        }
      }, {
        key: "handleDomHeight",
        value: function value() {
          var e,
            t = (null === (e = this.config.props.styleOptions) || void 0 === e ? void 0 : e.height) || 45;
          t > 55 && (this.logger.warn("Button height input exception", {
            data: {
              height: t
            }
          }), t = 55), t < 25 && (this.logger.warn("Button height input exception", {
            data: {
              height: t
            }
          }), t = 25), this.config.props.styleOptions = Yu(Yu({}, this.config.props.styleOptions), {}, {
            height: t
          });
        }
      }, {
        key: "isContinueMode",
        get: function get() {
          return this.payMode === po.Continue;
        }
      }, {
        key: "expressButtonConfig",
        get: function get() {
          try {
            var e;
            return JSON.parse((null === (e = this.config.paymentInfo) || void 0 === e ? void 0 : e.expressButtonConfig) || "{}");
          } catch (e) {
            var t;
            this.logger.error("parse expressButtonConfig error", {
              error: e,
              data: {
                expressButtonConfig: null === (t = this.config.paymentInfo) || void 0 === t ? void 0 : t.expressButtonConfig
              }
            });
          }
        }
      }, {
        key: "isVerticalLayout",
        get: function get() {
          var e;
          return "vertical" === (null === (e = this.expressButtonConfig) || void 0 === e ? void 0 : e.layout);
        }
      }, {
        key: "isSubscription",
        get: function get() {
          return this.config.props.isSubscription;
        }
      }, {
        key: "handleError",
        value: function value(e, t, n) {
          this.initTimer && clearTimeout(this.initTimer), t !== lo.CreateExpected && this.logger.error("handleError", {
            action: t,
            error: e,
            data: {
              type: t,
              extData: n
            },
            tags: null == n ? void 0 : n.tags
          }), t === lo.Init && (this.initSuccess = !1, this.hideButton()), Qo(this.config.onError) && this.config.onError(e, t, n);
        }
      }, {
        key: "handleDynamicNotify",
        value: function value(e) {
          var t = (e || {}).paypal;
          this.isHidePayPalButton = !t, t || (Qo(this.config.onDynamicNotify) && this.config.onDynamicNotify(Yu(Yu({}, e), {}, {
            isHidePayPalButton: !0
          })), this.handleError(new Error("Dynamic button loading failed"), lo.Init));
        }
      }, {
        key: "handleDynamic",
        value: (i = Kr(so.mark(function e() {
          var t,
            n,
            r = this;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return ro(t = {}, vo.Done, function () {
                    r.handleDynamicNotify(Xu.info);
                  }), ro(t, vo.Fail, function () {}), ro(t, vo.Pending, Kr(so.mark(function e() {
                    return so.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            return e.next = 2, Xu.promise;
                          case 2:
                            r.handleDynamicNotify(Xu.info);
                          case 3:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }))), ro(t, vo.Await, function () {
                    var e;
                    return Xu.loadingStatus = vo.Pending, window[Do] = r.dynamicJsonpCallback, Xu.promise = So([(e = Do, "https://www.paypal.com/checkoutnow/remembered?callback=".concat(e))], {
                      returnPromise: !0
                    })["catch"](function () {
                      r.loadResourceFail = !0, r.handleError(new Error("[Failed to load remember script]:".concat(Do)), lo.Init);
                    }), Xu.promise;
                  }), n = t[Xu.loadingStatus], e.abrupt("return", n());
                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function () {
          return i.apply(this, arguments);
        })
      }, {
        key: "handlePay",
        value: function value(e) {
          var t = e.nextAction,
            n = e.context,
            r = (void 0 === n ? {
              returnUrl: ""
            } : n).returnUrl;
          if (this.returnUrl = r, this.isSubscription) {
            var o = t.data.popupData.tokenId;
            return this.orderInfoMap[o || ""] = {
              returnUrl: r
            }, o || "";
          }
          var i = t.data.popupData.id;
          return this.orderInfoMap[i || ""] = {
            returnUrl: r
          }, i || "";
        }
      }, {
        key: "continueMode",
        value: (o = Kr(so.mark(function e(t, n) {
          var r, o, i, a, c, s, u, l, p, d, f, h;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.createOrderParams && !1 !== this.createOrderParams.valid) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return", "");
                case 2:
                  return e.prev = 2, s = Bu(this.createOrderParams, this.config), e.next = 6, Xo(s);
                case 6:
                  if (u = e.sent, null == (l = null === (r = u.data) || void 0 === r ? void 0 : r.data) || !l.errorInfo) {
                    e.next = 11;
                    break;
                  }
                  return this.handleError(new Error("Place order failed"), lo.CreateExpected, {
                    errorInfo: null == l ? void 0 : l.errorInfo
                  }), e.abrupt("return", "");
                case 11:
                  if (!(p = (null === (o = u.data) || void 0 === o ? void 0 : o.code) || (null === (i = u.data) || void 0 === i || null === (a = i.data) || void 0 === a || null === (c = a.paymentError) || void 0 === c ? void 0 : c.code)) || "SUCCESS" === p) {
                    e.next = 15;
                    break;
                  }
                  return this.handleError(new Error("prepare-pay request failed"), lo.Pay, {
                    tags: {
                      code: p
                    },
                    res: u.data
                  }), e.abrupt("return", "");
                case 15:
                  if (Hu(d = JSON.parse((null == l ? void 0 : l.nextAction) || "{}"))) {
                    e.next = 19;
                    break;
                  }
                  return this.handleError(new Error("prepare-pay response illegal"), lo.Pay, {
                    res: u.data
                  }), e.abrupt("return", "");
                case 19:
                  return f = {
                    nextAction: d,
                    context: null == l ? void 0 : l.context
                  }, this.logger.info("continueMode", {
                    data: {
                      data: l,
                      payOptions: f,
                      actions: n
                    }
                  }), e.next = 23, this.handlePay(f);
                case 23:
                  return (h = e.sent) && Qo(this.config.onChannelModalSuccess) && this.config.onChannelModalSuccess(this.config.paymentInfo), e.abrupt("return", h);
                case 28:
                  return e.prev = 28, e.t0 = e["catch"](2), this.handleError(e.t0, lo.Pay), e.abrupt("return", "");
                case 32:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[2, 28]]);
        })), function (e, t) {
          return o.apply(this, arguments);
        })
      }, {
        key: "payNowMode",
        value: (r = Kr(so.mark(function e(t, n) {
          var r;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (e.prev = 0, !Qo(this.config.createOrder)) {
                    e.next = 13;
                    break;
                  }
                  return e.next = 4, this.config.createOrder(this.config.paymentInfo, t, n);
                case 4:
                  if (r = e.sent, this.logger.info("payNowMode, createOrder input parameters", {
                    data: Yu({}, r)
                  }), !1 !== r.valid) {
                    e.next = 9;
                    break;
                  }
                  return this.logger.log("Business side input parameter exception, process interrupted", {
                    data: Yu({}, r)
                  }), e.abrupt("return", "");
                case 9:
                  if (Hu(null == r ? void 0 : r.nextAction)) {
                    e.next = 12;
                    break;
                  }
                  return this.handleError(new Error("prepare-pay response illegal"), lo.Pay, {
                    res: r
                  }), e.abrupt("return", "");
                case 12:
                  return e.abrupt("return", this.handlePay(r));
                case 13:
                  return e.abrupt("return", "");
                case 16:
                  return e.prev = 16, e.t0 = e["catch"](0), this.handleError(e.t0, lo.Pay), e.abrupt("return", "");
                case 20:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[0, 16]]);
        })), function (e, t) {
          return r.apply(this, arguments);
        })
      }, {
        key: "handleRenderTimeout",
        value: function value(e) {
          var t,
            n,
            r = this;
          zu && (zu.disconnect(), zu = null), this.initTimer = setTimeout(function () {
            var t, n, o, i;
            r.element && (r.element.innerHTML = "");
            var a = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            zu = new a(function (e) {
              e.forEach(function () {
                r.element && (r.element.innerHTML = "");
              });
            }), r.element && zu.observe(r.element, {
              childList: !0,
              attributes: !1,
              subtree: !1
            }), setTimeout(function () {
              zu && (zu.disconnect(), zu = null);
            }, 5e3), r.handleError(new Error("[Init rendering failed][Call onInit timeout][Current timeout time: ".concat(null === (t = r.config.props) || void 0 === t || null === (n = t.buttonTimeoutConfig) || void 0 === n ? void 0 : n.timeoutMillis, "ms]")), lo.Init), e(new Error("[Init rendering failed][Call onInit timeout][Current timeout time: ".concat(null === (o = r.config.props) || void 0 === o || null === (i = o.buttonTimeoutConfig) || void 0 === i ? void 0 : i.timeoutMillis, "ms]")));
          }, null === (t = this.config.props) || void 0 === t || null === (n = t.buttonTimeoutConfig) || void 0 === n ? void 0 : n.timeoutMillis);
        }
      }, {
        key: "setDisabled",
        value: function value(e) {
          if (this.element) try {
            if (e) return this.initActions && this.initActions.disable(), void this.element.classList.add(li);
            this.initActions && this.initActions.enable(), this.element.classList.remove(li);
          } catch (e) {
            window[window.__sl_console__ ? "__sl_console__" : "console"].error("This error does not affect functionality, no need to address", e);
          }
        }
      }, {
        key: "beforeInit",
        value: function value() {
          this.initTime = ri.now(), Qo(this.config.beforeInit) && this.config.beforeInit();
        }
      }, {
        key: "afterInit",
        value: function value(e, t) {
          try {
            this.initSuccess = !0, this.showButton();
            var n = ri.now() - this.initTime;
            this.logger.info("afterInit", {
              data: {
                data: e,
                actions: t,
                duration: n,
                level: Fu(n)
              }
            }), Qo(this.config.afterInit) && this.config.afterInit();
          } catch (e) {
            this.handleError(e);
          }
        }
      }, {
        key: "beforeCreateOrder",
        value: (n = Kr(so.mark(function e() {
          var t, n, r, o, i;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (Qo(this.config.beforeCreateOrder)) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return");
                case 2:
                  return t = this.config.paymentInfo, n = t.channelCode, r = t.methodCode, o = t.paymentId, e.next = 5, this.config.beforeCreateOrder({
                    channelCode: n,
                    methodCode: r,
                    paymentId: o
                  });
                case 5:
                  return i = e.sent, e.abrupt("return", i);
                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return n.apply(this, arguments);
        })
      }, {
        key: "afterCreateOrder",
        value: function value(e) {
          Qo(this.config.afterCreateOrder) && this.config.afterCreateOrder(e, {
            channelCode: fo.Paypal,
            methodCode: ho.Paypal
          });
        }
      }, {
        key: "removeSkeleton",
        value: function value(e) {
          var t = this,
            n = null;
          n && clearTimeout(n), n = setTimeout(function () {
            e && (t.skeleton && e.removeChild(t.skeleton), t.isContinueMode && e.classList.add("paypal__bg"));
          }, 300);
        }
      }, {
        key: "specialParamsByScenes",
        get: function get() {
          var e,
            t,
            n = this;
          return this.isSubscription ? {
            actions: {
              createBillingAgreement: (e = Kr(so.mark(function e(t, r) {
                var o;
                return so.wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        if (n.logger.log("createBillingAgreement PayPal starting to place order", {
                          data: {
                            data: t,
                            actions: r
                          }
                        }), e.prev = 1, !n.isContinueMode) {
                          e.next = 8;
                          break;
                        }
                        return e.next = 5, n.continueMode(t, r);
                      case 5:
                        e.t1 = e.sent, e.next = 11;
                        break;
                      case 8:
                        return e.next = 10, n.payNowMode(t, r);
                      case 10:
                        e.t1 = e.sent;
                      case 11:
                        if (e.t0 = e.t1, e.t0) {
                          e.next = 14;
                          break;
                        }
                        e.t0 = "";
                      case 14:
                        return o = e.t0, n.afterCreateOrder(o ? go.Success : go.Fail), e.abrupt("return", o);
                      case 19:
                        return e.prev = 19, e.t2 = e["catch"](1), n.afterCreateOrder(go.Fail), e.abrupt("return", "");
                      case 23:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, null, [[1, 19]]);
              })), function (t, n) {
                return e.apply(this, arguments);
              })
            }
          } : {
            actions: {
              createOrder: (t = Kr(so.mark(function e(t, r) {
                var o;
                return so.wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        if (n.logger.log("createOrder PayPal starting to place order", {
                          data: {
                            data: t,
                            actions: r
                          }
                        }), e.prev = 1, !n.isContinueMode) {
                          e.next = 8;
                          break;
                        }
                        return e.next = 5, n.continueMode(t, r);
                      case 5:
                        e.t1 = e.sent, e.next = 11;
                        break;
                      case 8:
                        return e.next = 10, n.payNowMode(t, r);
                      case 10:
                        e.t1 = e.sent;
                      case 11:
                        if (e.t0 = e.t1, e.t0) {
                          e.next = 14;
                          break;
                        }
                        e.t0 = "";
                      case 14:
                        return o = e.t0, n.afterCreateOrder(o ? go.Success : go.Fail), e.abrupt("return", o);
                      case 19:
                        return e.prev = 19, e.t2 = e["catch"](1), n.afterCreateOrder(go.Fail), e.abrupt("return", "");
                      case 23:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, null, [[1, 19]]);
              })), function (e, n) {
                return t.apply(this, arguments);
              })
            }
          };
        }
      }, {
        key: "render",
        value: (t = Kr(so.mark(function e() {
          var t,
            n,
            r,
            o,
            i,
            a,
            c = this;
          return so.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = this.config, r = n.props, o = n.paymentInfo, i = document.getElementById(o.currentDomId), !r.dynamic) {
                    e.next = 5;
                    break;
                  }
                  return e.next = 5, this.handleDynamic();
                case 5:
                  if (!this.isHidePayPalButton) {
                    e.next = 7;
                    break;
                  }
                  return e.abrupt("return", null);
                case 7:
                  if (!this.isRendered) {
                    e.next = 9;
                    break;
                  }
                  return e.abrupt("return", null);
                case 9:
                  if (i) {
                    e.next = 12;
                    break;
                  }
                  return this.handleError(new Error("[onError][Initialization failed][Could not find mounted DOM]"), lo.Init, {
                    domId: o.currentDomId
                  }), e.abrupt("return", null);
                case 12:
                  return this.element = i, a = qu({
                    node: i,
                    domId: o.currentDomId,
                    height: (null === (t = r.styleOptions) || void 0 === t ? void 0 : t.height) || "",
                    isContinueMode: this.isContinueMode,
                    isVerticalLayout: this.isVerticalLayout,
                    wrapperClass: r.wrapperClass,
                    wrapperStyle: r.wrapperStyle
                  }), this.skeleton = a, this.logger.log("render start", {
                    data: {
                      config: this.config
                    }
                  }), this.beforeInit(), e.abrupt("return", new Promise(function (e, t) {
                    r.buttonTimeoutConfig && r.buttonTimeoutConfig.enable && c.handleRenderTimeout(t);
                    var n,
                      a,
                      s,
                      u = null,
                      l = Yu({
                        domId: o.currentDomId,
                        clientId: r.clientId,
                        currency: o.settleCurrency,
                        queryParams: r.queryParams,
                        scriptParams: r.scriptParams,
                        style: Yu(Yu(Yu({}, r.styleOptions), c.expressButtonConfig), {}, {
                          disableMaxWidth: !0
                        }),
                        onInit: function onInit(t, n) {
                          c.logger.info("onInit"), c.afterInit(t, n), c.initTimer && clearTimeout(c.initTimer), c.initActions = n, e(u);
                        },
                        onClick: (s = Kr(so.mark(function e(t, n) {
                          var r, o;
                          return so.wrap(function (e) {
                            for (;;) {
                              switch (e.prev = e.next) {
                                case 0:
                                  return e.next = 2, c.beforeCreateOrder();
                                case 2:
                                  if (o = e.sent, c.logger.log("onClick, user clicked the button", {
                                    data: {
                                      data: t,
                                      params: o,
                                      actions: n
                                    }
                                  }), o) {
                                    e.next = 6;
                                    break;
                                  }
                                  return e.abrupt("return");
                                case 6:
                                  if (!1 !== o.valid) {
                                    e.next = 8;
                                    break;
                                  }
                                  return e.abrupt("return", n.reject());
                                case 8:
                                  null === (r = c.initActions) || void 0 === r || r.enable(), c.isContinueMode && (c.createOrderParams = o);
                                case 10:
                                case "end":
                                  return e.stop();
                              }
                            }
                          }, e);
                        })), function (e, t) {
                          return s.apply(this, arguments);
                        }),
                        onApprove: (a = Kr(so.mark(function e(t, n) {
                          var r, o, i;
                          return so.wrap(function (e) {
                            for (;;) {
                              switch (e.prev = e.next) {
                                case 0:
                                  (o = null === (r = c.orderInfoMap[t.orderID]) || void 0 === r ? void 0 : r.returnUrl) !== c.returnUrl && c.logger.error("Front-end recorded returnUrl does not match this.returnUrl", {
                                    action: lo.Pay,
                                    data: {
                                      orderId: t.orderID,
                                      map: c.orderInfoMap,
                                      url: c.returnUrl
                                    }
                                  }), i = o || c.returnUrl, c.logger.log("onApprove PayPal order placed successfully, triggering callback", {
                                    data: {
                                      data: t,
                                      returnUrl: i,
                                      actions: n
                                    }
                                  }), Qo(c.config.onApprove) && c.config.onApprove(t, n), window.location.href = i;
                                case 6:
                                case "end":
                                  return e.stop();
                              }
                            }
                          }, e);
                        })), function (e, t) {
                          return a.apply(this, arguments);
                        }),
                        onCancel: (n = Kr(so.mark(function e(t, n) {
                          var r;
                          return so.wrap(function (e) {
                            for (;;) {
                              switch (e.prev = e.next) {
                                case 0:
                                  if (c.logger.log("user cancelled payment", {
                                    data: t
                                  }), !Qo(null == n ? void 0 : n.redirect) || !Qo(c.config.onCancel)) {
                                    e.next = 6;
                                    break;
                                  }
                                  return e.next = 4, c.config.onCancel(t);
                                case 4:
                                  r = e.sent, null == n || n.redirect(r);
                                case 6:
                                case "end":
                                  return e.stop();
                              }
                            }
                          }, e);
                        })), function (e, t) {
                          return n.apply(this, arguments);
                        }),
                        onError: function onError(e, n, r) {
                          c.handleError(e, n, r), t(e);
                        }
                      }, c.specialParamsByScenes.actions);
                    (u = new No(l)).render().then(function () {
                      c.loadResourceFail = !1;
                    })["catch"](function (e) {
                      c.loadResourceFail = !0, c.handleError(new Error("Load Paypal resource failed"), lo.Init, {
                        error: e
                      }), t(e);
                    }), u && c.removeSkeleton(i);
                  }));
                case 18:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return t.apply(this, arguments);
        })
      }]), c;
    }();
  Zu = function (e, t, n, r) {
    var o,
      i = arguments.length,
      a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
    if ("object" === ("undefined" == typeof Reflect ? "undefined" : lr(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var c = e.length - 1; c >= 0; c--) {
      (o = e[c]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
    }
    return i > 3 && a && Object.defineProperty(t, n, a), a;
  }([function (e) {
    var t = e.prototype,
      n = {
        validate: t.validate,
        handleError: t.handleError,
        handleDynamicNotify: t.handleDynamicNotify,
        dynamicJsonpCallback: t.dynamicJsonpCallback,
        handleDynamic: t.handleDynamic,
        handleRenderTimeout: t.handleRenderTimeout,
        beforeInit: t.beforeInit,
        beforeCreateOrder: t.beforeCreateOrder,
        afterCreateOrder: t.afterCreateOrder,
        removeSkeleton: t.removeSkeleton
      };
    Object.keys(n).forEach(function (t) {
      e.prototype[t] = function (e) {
        return Kr(so.mark(function t() {
          var r,
            o,
            i,
            a,
            c = arguments;
          return so.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  for (r = "【".concat(e, "】"), t.prev = 1, ci.info("".concat(r, "[execution started]")), o = c.length, i = new Array(o), a = 0; a < o; a++) {
                    i[a] = c[a];
                  }
                  return t.abrupt("return", n[e].apply(this, i));
                case 7:
                  throw t.prev = 7, t.t0 = t["catch"](1), ci.error("".concat(r, "[execution failed]"), {
                    error: t.t0
                  }), t.t0;
                case 11:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[1, 7]]);
        }));
      }(t);
    });
  }], Zu);
  var $u,
    Qu,
    el = Zu;
  function tl(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  !function (e) {
    e.TEXT = "text", e.I18N_CODE = "i18n_code";
  }($u || ($u = {})), function (e) {
    e.NonGray = "NON_GRAY", e.GrayForAbort = "GRAY_FOR_ABORT", e.GrayForTips = "GRAY_FOR_TIPS";
  }(Qu || (Qu = {}));
  var nl = oa.Prod,
    rl = ra.Prod;
  function ol(e) {
    e.env = e.env && pa[e.env] ? e.env : rl;
    var t = function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? tl(Object(n), !0).forEach(function (t) {
          h(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tl(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }({}, pa[e.env]);
    return e.env === rl ? e.host = void 0 : t && (t.host = e.host || t.host, e.host = t.host), Object.freeze(t);
  }
  var il = {
      FPXFooter: "By completing this payment, you agree to the FPX ${serviceTerms}",
      FPXPayGuide: "We'll now redirect you to the bank's page to complete the payment. Once the payment is completed, remember to finish the purchase on the order page. ",
      bankMaintenance: "Bank maintenance until",
      form: {
        footer: {
          agreement: "By completing this payment, you agree to the FPX ${serviceTerms}",
          payGuide: "The next step will be connected to the bank page to make the payment. After completion, please remember to press Confirm payment and return to the order page to confirm that the order is complete.",
          serviceTerms: "Terms of Service"
        },
        select: {
          placeholder: "Select bank"
        }
      },
      selectBank: "Select bank",
      serviceTerms: "Terms of Service"
    },
    al = {
      list: {
        bc_card: "BC",
        citi_card: "Citi",
        hana_card: "Hana",
        hyundai_card: "Hyundai",
        kookmin_card: "Kookmin",
        lotte_card: "Lotte",
        nonghyup_card: "Nonghyup",
        samsung_card: "Samsung",
        shinhan_card: "Shinhan",
        suhyup_card: "Suhyup"
      },
      tips: "After selecting your bank, click to complete your order and you will be redirected to the bank's page to complete the payment."
    },
    cl = {
      form: {
        footer: "After placing the order, a payment request will appear on your OVO App. Confirm the request there to complete the payment.",
        header: "Enter the mobile number you registered on your OVO wallet. ",
        phoneNumber: {
          invalid: "Enter a valid mobile number",
          placeholder: "Mobile number"
        }
      }
    },
    sl = 'After clicking "Complete Order", you will be redirected to Paypay App to complete payment securely.',
    ul = 'After clicking "Complete Order", you will be redirected to Rakuten Pay App to complete payment securely.',
    ll = "The payment is powered by SHOPLINE Payments. SHOPLINE Payments is PCI-DSS Level 1 validated and supports the secure use of domestic ＆ international credit cards.",
    pl = {
      cancel: "Cancel",
      enquire: "Continue order via Apple Pay?",
      paywith: "Pay with"
    },
    dl = 'After clicking "Complete order", you will be redirected to Atome to complete your purchase securely.',
    fl = {
      brand: {
        not_support: "Card brand not support. Please try again with a different card or payment method. "
      }
    },
    hl = "bank card type not supported at this stage",
    yl = "We can't process your payment at this stage. Please try again with a different card.",
    ml = "You've made too many password attempts. Please try again after 24 hours.",
    vl = "You've made too many incorrect CVV/CVC inputs. Please try again with a different card.",
    gl = "We've disabled bank card payment as you've made too many incorrect CVV/CVC inputs. Please try again after 24 hours or use a different payment method",
    bl = "Card information is guaranteed to be safe on PCI DSS standards.",
    wl = {
      cardNumber: {
        errorTips: "Enter a valid card number",
        labelTitle: "Card number",
        placeholder: "",
        tips: "All transactions are secure and encrypted"
      },
      cvc: {
        errorTips: "Enter a valid CVV/CVC",
        labelTitle: "CVV/CVC",
        placeholder: "",
        tips: "The 3-digit numeric code displayed on the back of your card (or the 4-digit code at the front for American Express® users)."
      },
      expDate: {
        errorTips: "Enter a valid expiry date",
        labelTitle: "Expiry date (MM/YY)",
        placeholder: "",
        tips: ""
      },
      expiryDate: {
        errorTips: "Enter a valid expiry date",
        labelTitle: "Expiry date (MM/YY)",
        placeholder: "",
        tips: ""
      },
      firstName: {
        errorTips: "Enter your full name as shown on your bank card",
        labelTitle: "Cardholder name",
        placeholder: "",
        tips: "Separate the first and last names with a blank space"
      },
      number: {
        errorTips: "Enter a valid card number",
        labelTitle: "Card number",
        placeholder: "",
        tips: "All transactions are secure and encrypted"
      },
      submitCarNo: {
        errorTips: "An error has occurred. Please try again later"
      },
      submitCardNo: {
        Tips: "Submit your card number again",
        labelTitle: "Submit card number"
      }
    },
    kl = "Sorry, this browser is not supported, we suggest you to change to IE11/Chrome or other browsers  to try again",
    xl = {
      cancel: "Cancel"
    },
    Ol = "We don't support this payment method at this time. Please choose another method and try again.",
    _l = "Invalid card. Please try again with a different card",
    Cl = "Enter a valid card number to ensure a successful transaction",
    El = "Enter a valid CVV/CVC",
    Il = "Enter card number manually",
    Sl = "Enter a valid expiry date",
    Pl = "Enter your full name as shown on your bank card",
    Dl = "Example: John Doe",
    jl = "Enter a valid card number",
    Tl = "After clicking “Complete order”, you’ll be redirected to your payment app to securely complete your purchase.",
    Al = {
      valid: {
        ccv: "CCV",
        expiry: "period of validity",
        msg: "Incorrect information, please adjust: ${fields}",
        number: "Card number"
      }
    },
    Rl = {
      cvc: {
        tip: "Check your CVV/CVC"
      }
    },
    Ll = {
      FPX: il,
      KoreaCard: al,
      OVO: cl,
      PayPayGuide: sl,
      RakutenPayGuide: ul,
      SLPaymentsFooter: ll,
      applepay: pl,
      atomePayGuide: dl,
      card: fl,
      cardIsNotSupported: hl,
      cardNotProcessedPleaseChangeAnother: yl,
      errorCardNumberTooManyTimesAndAfter24hRetry: ml,
      errorSecurityCodeTooManyTimes: vl,
      errorSecurityCodeTooManyTimesAndAfter24hRetry: gl,
      footer: bl,
      formItems: wl,
      language: "En",
      notSupportBrowser: kl,
      payme: xl,
      paymentMethodNotSupported: Ol,
      pleaseChangeAnotherCard: _l,
      pleaseEnsureCardNumber: Cl,
      pleaseEnterCVV: El,
      pleaseEnterCardNumberManually: Il,
      pleaseEnterExpired: Sl,
      pleaseEnterNameOnCard: Pl,
      pleaseEnterNameOnCardOrBusinessName: Dl,
      pleaseEnterValidCardNumber: jl,
      simpleGuide: Tl,
      tappay: Al,
      verify: Rl
    },
    Nl = Object.freeze({
      __proto__: null,
      FPX: il,
      KoreaCard: al,
      OVO: cl,
      PayPayGuide: sl,
      RakutenPayGuide: ul,
      SLPaymentsFooter: ll,
      applepay: pl,
      atomePayGuide: dl,
      card: fl,
      cardIsNotSupported: hl,
      cardNotProcessedPleaseChangeAnother: yl,
      errorCardNumberTooManyTimesAndAfter24hRetry: ml,
      errorSecurityCodeTooManyTimes: vl,
      errorSecurityCodeTooManyTimesAndAfter24hRetry: gl,
      footer: bl,
      formItems: wl,
      language: "En",
      notSupportBrowser: kl,
      payme: xl,
      paymentMethodNotSupported: Ol,
      pleaseChangeAnotherCard: _l,
      pleaseEnsureCardNumber: Cl,
      pleaseEnterCVV: El,
      pleaseEnterCardNumberManually: Il,
      pleaseEnterExpired: Sl,
      pleaseEnterNameOnCard: Pl,
      pleaseEnterNameOnCardOrBusinessName: Dl,
      pleaseEnterValidCardNumber: jl,
      simpleGuide: Tl,
      tappay: Al,
      verify: Rl,
      "default": Ll
    });
  function Ml(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Bl(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ml(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ml(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var Fl = {
      "zh-CN": "zh-hans-cn",
      "zh-TW": "zh-hant-tw",
      no: "nb"
    },
    Hl = {
      maxCount: 3,
      interval: 100
    },
    Ul = {},
    Vl = function () {
      function e() {
        o(this, e), h(this, "displayLanguage", wt), h(this, "dataMap", {}), h(this, "language", wt), h(this, "env", nl);
      }
      var t, n, i, a, c, u, l, p, d;
      return s(e, [{
        key: "init",
        value: function value(e, t) {
          var n = this;
          this.language = e || wt, this.env = (null == t ? void 0 : t.env) || nl, this.retryOptions = (null == t ? void 0 : t.retryOptions) || Hl;
          var o = this.language;
          this.newLanguage = "string" == typeof o ? {
            extend: o
          } : o, this.newLanguage.extend = this.newLanguage.extend || wt, this.displayLanguage = this.newLanguage.extend;
          var i = Fl[this.displayLanguage] ? Fl[this.displayLanguage] : this.displayLanguage;
          this.i18nLanguage = i, this.languageJson = this.requestJsonData(i)["catch"](function () {
            var e = r(A.mark(function e(t) {
              var r;
              return A.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return Bn.reportErrorData("I18n_request_json_error", {
                        language: i,
                        response: {
                          error: t
                        }
                      }), n.displayLanguage = wt, r = n.getDefaultLanguage(), n.defaultJson = r, e.abrupt("return", r);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }
              }, e);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }());
        }
      }, {
        key: "getDefaultLanguage",
        value: (d = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", {
                    data: Nl
                  });
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function () {
          return d.apply(this, arguments);
        })
      }, {
        key: "setData",
        value: (p = r(A.mark(function e() {
          var t, n;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, this.languageJson;
                case 2:
                  t = e.sent, n = t.data, this.dataMap[this.displayLanguage] = n;
                case 5:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return p.apply(this, arguments);
        })
      }, {
        key: "setDefaultData",
        value: (l = r(A.mark(function e() {
          var t, n;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return this.defaultJson || (this.defaultJson = this.getDefaultLanguage()), e.next = 3, this.defaultJson;
                case 3:
                  t = e.sent, n = t.data, this.defaultData = n;
                case 6:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return l.apply(this, arguments);
        })
      }, {
        key: "requestJsonData",
        value: (u = r(A.mark(function e(t) {
          var n, r, o, i, a;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = "".concat(this.env, "_").concat(t), !(r = Ul[n])) {
                    e.next = 6;
                    break;
                  }
                  return e.next = 5, r;
                case 5:
                  return e.abrupt("return", e.sent);
                case 6:
                  return o = ur(this.env, t), i = {
                    action: Vn.I18n,
                    retryOptions: this.retryOptions
                  }, Ul[n] = sr.get(o, i)["catch"](function (e) {
                    delete Ul[n], Bn.handleError(e, "I18n_request_".concat(t, "_error"), {
                      language: t,
                      response: {
                        error: e
                      }
                    });
                  }), e.next = 11, Ul[n];
                case 11:
                  return a = e.sent, e.abrupt("return", a);
                case 13:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return u.apply(this, arguments);
        })
      }, {
        key: "getVal",
        value: function value(e, t) {
          return t.split(".").reduce(function (e, t) {
            var n;
            return null !== (n = null == e ? void 0 : e[t]) && void 0 !== n ? n : "";
          }, e);
        }
      }, {
        key: "getOne",
        value: (c = r(A.mark(function e(t) {
          var n;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.dataMap[this.displayLanguage]) {
                    e.next = 3;
                    break;
                  }
                  return e.next = 3, this.setData();
                case 3:
                  if ("" !== (n = "" === (n = this.getVal(this.newLanguage, t)) ? this.getVal(this.dataMap[this.displayLanguage], t) : n)) {
                    e.next = 12;
                    break;
                  }
                  if (this.defaultData) {
                    e.next = 9;
                    break;
                  }
                  return e.next = 9, this.setDefaultData();
                case 9:
                  return e.abrupt("return", this.getVal(this.defaultData, t));
                case 12:
                  return e.abrupt("return", n);
                case 13:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return c.apply(this, arguments);
        })
      }, {
        key: "getData",
        value: (a = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.dataMap[this.displayLanguage]) {
                    e.next = 3;
                    break;
                  }
                  return e.next = 3, this.setData();
                case 3:
                  return e.abrupt("return", Bl(Bl({}, this.dataMap[this.displayLanguage]), this.newLanguage));
                case 4:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return a.apply(this, arguments);
        })
      }, {
        key: "get",
        value: (i = r(A.mark(function e(t) {
          var n = this;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!Array.isArray(t)) {
                    e.next = 6;
                    break;
                  }
                  return e.next = 3, Promise.all(t.map(function (e) {
                    return n.getOne(e);
                  }));
                case 3:
                case 8:
                  return e.abrupt("return", e.sent);
                case 6:
                  return e.next = 8, this.getOne(t);
                case 9:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return i.apply(this, arguments);
        })
      }, {
        key: "getDisplayLanguage",
        value: (n = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.dataMap[this.displayLanguage]) {
                    e.next = 3;
                    break;
                  }
                  return e.next = 3, this.setData();
                case 3:
                  return e.abrupt("return", this.displayLanguage);
                case 4:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return n.apply(this, arguments);
        })
      }, {
        key: "getWithValue",
        value: (t = r(A.mark(function e(t) {
          var n,
            r,
            o = arguments;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, e.next = 3, this.getOne(t);
                case 3:
                  return r = e.sent, Object.entries(n).forEach(function (e) {
                    var t = Un(e, 2),
                      n = t[0],
                      o = t[1];
                    r = r.replace("${".concat(n, "}"), o);
                  }), e.abrupt("return", r);
                case 6:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return t.apply(this, arguments);
        })
      }]), e;
    }(),
    zl = new Vl(),
    ql = function ql(e) {
      var t, n;
      return Boolean(null == e || null === (t = e.theme) || void 0 === t || null === (n = t["default"]) || void 0 === n ? void 0 : n.rtl);
    },
    Gl = function Gl(e) {
      return e.split(";").filter(function (e) {
        return e;
      }).map(function (e) {
        return e.split(":").map(function (e) {
          return e.trim();
        });
      }).map(function (e) {
        var t = Un(e, 2),
          n = t[0],
          r = t[1];
        switch (n) {
          case "left":
            n = "right";
            break;
          case "right":
            n = "left";
            break;
          case "padding-left":
            n = "padding-right";
            break;
          case "padding-right":
            n = "padding-left";
        }
        return [n, r];
      }).map(function (e) {
        return e.join(":");
      }).join(";");
    };
  function Wl(e, t) {
    var _n3 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!_n3) {
      if (Array.isArray(e) || (_n3 = function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return Kl(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Kl(e, t);
      }(e)) || t && e && "number" == typeof e.length) {
        _n3 && (e = _n3);
        var r = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return r >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[r++]
            };
          },
          e: function e(_e4) {
            throw _e4;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var i,
      a = !0,
      c = !1;
    return {
      s: function s() {
        _n3 = _n3.call(e);
      },
      n: function n() {
        var e = _n3.next();
        return a = e.done, e;
      },
      e: function e(_e5) {
        c = !0, i = _e5;
      },
      f: function f() {
        try {
          a || null == _n3["return"] || _n3["return"]();
        } finally {
          if (c) throw i;
        }
      }
    };
  }
  function Kl(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }
    return r;
  }
  function Jl(e) {
    var t,
      n,
      r,
      o = 2;
    for ("undefined" != typeof Symbol && (n = Symbol.asyncIterator, r = Symbol.iterator); o--;) {
      if (n && null != (t = e[n])) return t.call(e);
      if (r && null != (t = e[r])) return new Yl(t.call(e));
      n = "@@asyncIterator", r = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
  }
  function Yl(e) {
    function t(e) {
      if (Object(e) !== e) return Promise.reject(new TypeError(e + " is not an object."));
      var t = e.done;
      return Promise.resolve(e.value).then(function (e) {
        return {
          value: e,
          done: t
        };
      });
    }
    return Yl = function Yl(e) {
      this.s = e, this.n = e.next;
    }, Yl.prototype = {
      s: null,
      n: null,
      next: function next() {
        return t(this.n.apply(this.s, arguments));
      },
      "return": function _return(e) {
        var n = this.s["return"];
        return void 0 === n ? Promise.resolve({
          value: e,
          done: !0
        }) : t(n.apply(this.s, arguments));
      },
      "throw": function _throw(e) {
        var n = this.s["return"];
        return void 0 === n ? Promise.reject(e) : t(n.apply(this.s, arguments));
      }
    }, new Yl(e);
  }
  function Xl(e, t, n) {
    return Zl.apply(this, arguments);
  }
  function Zl() {
    return Zl = r(A.mark(function e(t, n, r) {
      var o, i, a, c, s, u, l, p, d, f, h, y, m, v, g, b, w, k, x, O;
      return A.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t && n) {
                e.next = 2;
                break;
              }
              return e.abrupt("return", null);
            case 2:
              if (o = t.content, i = t.props, a = t.children, c = t.onRendered, s = document.createElement(o), !i) {
                e.next = 52;
                break;
              }
              u = !1, l = !1, e.prev = 7, d = Jl(Object.keys(i));
            case 9:
              return e.next = 11, d.next();
            case 11:
              if (!(u = !(f = e.sent).done)) {
                e.next = 36;
                break;
              }
              if (h = f.value, void 0 === i[h]) {
                e.next = 33;
                break;
              }
              if ("innerHTML" !== h) {
                e.next = 18;
                break;
              }
              s.innerHTML = i[h] || "", e.next = 33;
              break;
            case 18:
              if ("i18nKey" !== h) {
                e.next = 25;
                break;
              }
              return y = i[h], e.next = 22, zl.get(y || "");
            case 22:
              s.innerHTML = e.sent, e.next = 33;
              break;
            case 25:
              if ("renderer" !== h) {
                e.next = 32;
                break;
              }
              return m = i[h] || function () {
                return "";
              }, e.next = 29, m();
            case 29:
              s.innerHTML = e.sent, e.next = 33;
              break;
            case 32:
              "style" === h && null != r && r.isRTL ? (v = Gl(i[h]), s.setAttribute(h, v)) : s.setAttribute(h, i[h]);
            case 33:
              u = !1, e.next = 9;
              break;
            case 36:
              e.next = 42;
              break;
            case 38:
              e.prev = 38, e.t0 = e["catch"](7), l = !0, p = e.t0;
            case 42:
              if (e.prev = 42, e.prev = 43, !u || null == d["return"]) {
                e.next = 47;
                break;
              }
              return e.next = 47, d["return"]();
            case 47:
              if (e.prev = 47, !l) {
                e.next = 50;
                break;
              }
              throw p;
            case 50:
              return e.finish(47);
            case 51:
              return e.finish(42);
            case 52:
              if (!Array.isArray(a)) {
                e.next = 86;
                break;
              }
              g = !1, b = !1, e.prev = 55, k = Jl(a);
            case 57:
              return e.next = 59, k.next();
            case 59:
              if (!(g = !(x = e.sent).done)) {
                e.next = 68;
                break;
              }
              if (O = x.value) {
                e.next = 63;
                break;
              }
              return e.abrupt("continue", 65);
            case 63:
              return e.next = 65, Xl(O, s, {
                isRTL: null == r ? void 0 : r.isRTL
              });
            case 65:
              g = !1, e.next = 57;
              break;
            case 68:
              e.next = 74;
              break;
            case 70:
              e.prev = 70, e.t1 = e["catch"](55), b = !0, w = e.t1;
            case 74:
              if (e.prev = 74, e.prev = 75, !g || null == k["return"]) {
                e.next = 79;
                break;
              }
              return e.next = 79, k["return"]();
            case 79:
              if (e.prev = 79, !b) {
                e.next = 82;
                break;
              }
              throw w;
            case 82:
              return e.finish(79);
            case 83:
              return e.finish(74);
            case 84:
              e.next = 97;
              break;
            case 86:
              if ("string" != typeof a) {
                e.next = 90;
                break;
              }
              s.textContent = a, e.next = 97;
              break;
            case 90:
              if (a || null != i && i.innerHTML || null != i && i.i18nKey || null != i && i.renderer) {
                e.next = 94;
                break;
              }
              s.textContent = "", e.next = 97;
              break;
            case 94:
              if (!a) {
                e.next = 97;
                break;
              }
              return e.next = 97, Xl(a, s, {
                isRTL: null == r ? void 0 : r.isRTL
              });
            case 97:
              "img" === o && s.addEventListener("error", function (e) {
                var t = e.target.parentNode;
                Bn.reportErrorData("load_img_error", {
                  src: s.src,
                  parentNode: {
                    nodeName: (null == t ? void 0 : t.nodeName) || "",
                    className: (null == t ? void 0 : t.className) || "",
                    id: (null == t ? void 0 : t.id) || ""
                  }
                });
              }), n.appendChild(s);
              try {
                null == c || c(s);
              } catch (e) {}
              return e.abrupt("return", s);
            case 101:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[7, 38, 42, 52], [43,, 47, 51], [55, 70, 74, 84], [75,, 79, 83]]);
    })), Zl.apply(this, arguments);
  }
  function $l(e, t) {
    if (!e) return null;
    var n = e.content,
      r = e.props,
      o = e.children,
      i = document.createElement(n);
    if (r && Object.keys(r).forEach(function (e) {
      void 0 !== r[e] && ("innerHTML" === e ? i.innerHTML = r[e] || "" : i.setAttribute(e, r[e]));
    }), !t) return null;
    if (Array.isArray(o)) {
      var a,
        c = Wl(o);
      try {
        for (c.s(); !(a = c.n()).done;) {
          var s = a.value;
          s && $l(s, i);
        }
      } catch (e) {
        c.e(e);
      } finally {
        c.f();
      }
    } else "string" == typeof o ? i.textContent = o : o || null != r && r.innerHTML ? o && $l(o, i) : i.textContent = "";
    "img" === n && i.addEventListener("error", function (e) {
      var t = e.target.parentNode;
      Bn.reportErrorData("load_img_error", {
        src: i.src,
        parentNode: {
          nodeName: (null == t ? void 0 : t.nodeName) || "",
          className: (null == t ? void 0 : t.className) || "",
          id: (null == t ? void 0 : t.id) || ""
        }
      });
    }), t.appendChild(i);
  }
  var Ql = [],
    ep = [];
  function tp(e, t) {
    if (e && "undefined" != typeof document) {
      var n,
        r = !0 === t.prepend ? "prepend" : "append",
        o = !0 === t.singleTag,
        i = "string" == typeof t.container ? document.querySelector(t.container) : document.getElementsByTagName("head")[0];
      if (o) {
        var a = Ql.indexOf(i);
        -1 === a && (a = Ql.push(i) - 1, ep[a] = {}), n = ep[a] && ep[a][r] ? ep[a][r] : ep[a][r] = c();
      } else n = c();
      65279 === e.charCodeAt(0) && (e = e.substring(1)), n.styleSheet ? n.styleSheet.cssText += e : n.appendChild(document.createTextNode(e));
    }
    function c() {
      var e = document.createElement("style");
      if (e.setAttribute("type", "text/css"), t.attributes) for (var n = Object.keys(t.attributes), o = 0; o < n.length; o++) {
        e.setAttribute(n[o], t.attributes[n[o]]);
      }
      var a = "prepend" === r ? "afterbegin" : "beforeend";
      return i.insertAdjacentElement(a, e), e;
    }
  }
  tp('.sl-payment .pci-tooltip-wrap {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-tooltip-wrap {\n  left: 0;\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-tooltip-wrap {\n  right: 0;\n}\n\n.sl-payment .pci-tooltip-wrap::after {\n  display: none;\n  position: absolute;\n  top: -14px;\n  content: "";\n  width: 0px;\n  height: 0px;\n  border: 7px solid;\n  border-color: rgba(30, 30, 30, 0.9) transparent transparent transparent;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-tooltip-wrap::after {\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-tooltip-wrap::after {\n  right: 50%;\n  transform: translateX(50%);\n}\n\n.sl-payment .pci-tooltip-content {\n  display: none;\n  position: absolute;\n  bottom: 26px;\n  box-sizing: content-box;\n  width: 180px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  background-color: rgba(30, 30, 30, 0.9);\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-tooltip-content {\n  right: -17px;\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-tooltip-content {\n  left: -17px;\n}\n\n.sl-payment .pci-tooltip-wrap::before{\n  content: \'\';\n  display: block;\n  position: absolute;\n  top: -50%;\n  width: 200%;\n  height: 200%;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-tooltip-wrap::before{\n  left: -50%;\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-tooltip-wrap::before{\n  right: -50%;\n}\n\n.sl-payment .pci-tooltip-wrap:hover::after,\n.sl-payment .pci-tooltip-wrap:hover .pci-tooltip-content {\n  display: block;\n}\n', {});
  var np = function () {
      function e() {
        o(this, e);
      }
      return s(e, [{
        key: "mount",
        value: function value(e, t) {
          $l({
            content: "div",
            props: {
              "class": "pci-tooltip-wrap"
            },
            children: {
              content: "div",
              props: {
                "class": "pci-tooltip-content"
              },
              children: t
            }
          }, e);
        }
      }]), e;
    }(),
    rp = function () {
      var e = r(A.mark(function e(t, n, r) {
        var o, i;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return o = {
                  action: Vn.Confirm,
                  retryOptions: r
                }, e.next = 3, sr.post(t, n, o)["catch"](function (e) {
                  Bn.handleError(e, "order_pay_error", {
                    url: t,
                    response: {
                      error: e
                    }
                  });
                });
              case 3:
                return i = e.sent, e.abrupt("return", i);
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t, n, r) {
        return e.apply(this, arguments);
      };
    }();
  function op(e, t, n) {
    return ip.apply(this, arguments);
  }
  function ip() {
    return (ip = r(A.mark(function e(t, n, r) {
      var o, i;
      return A.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (200 !== t.statusCode) {
                e.next = 8;
                break;
              }
              if (null !== (o = t.data) && void 0 !== o && o.nextAction) {
                e.next = 3;
                break;
              }
              return e.abrupt("return");
            case 3:
              if (!r) {
                e.next = 5;
                break;
              }
              return e.abrupt("return", t.data.nextAction);
            case 5:
              return e.abrupt("return", Ep(null === (i = t.data) || void 0 === i ? void 0 : i.nextAction, {
                payOptions: n
              }));
            case 8:
              Bn.handleError(t, "pay_nextAction_error");
            case 9:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  var ap = function ap(e) {
      return /^https:\/\/([^.]+)?\.myshopline([^.]+)?\.com$/.test(e);
    },
    cp = function cp(e) {
      return new URL(e).origin;
    },
    sp = function () {
      function e(t, n) {
        var r = this;
        o(this, e), h(this, "handlePostmessage", function (e) {
          var t = e.data,
            n = e.origin;
          if (ap(n)) {
            var o = t.success,
              i = t.nextAction || {},
              a = t.nextAction || {},
              c = a.url,
              s = a.type;
            if (Bn.reportData("useepay_3ds_next_action_".concat(s), {
              validateState: JSON.stringify(t)
            }), o) {
              if (s === _.Redirect && c) {
                if (window.removeEventListener("message", r.handlePostmessage, !1), r.domId) {
                  var u = document.getElementById(r.domId);
                  u && u.parentElement && u.parentElement.removeChild(u);
                }
                kp(i, r.payOptions);
              }
              s === _.UseepayChallenge && r.challenge(t.nextAction);
            } else Bn.reportErrorData("useepay_3ds_next_action_".concat(s, "_error"), t);
          }
        }), this.type = t, this.payOptions = n;
      }
      return s(e, [{
        key: "gather",
        value: function value(e) {
          var t = e.url,
            n = e.method,
            r = e.data,
            o = "UseepayGatherIframe-".concat(Date.now()),
            i = document.createElement("iframe");
          i.src = t, i.name = o, i.style.width = "0", i.style.height = "0", i.style.display = "none", document.body.appendChild(i), window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1), wp(t, r, n, o);
        }
      }, {
        key: "challenge",
        value: function value(e) {
          e.type === _.UseepayChallenge && this.iframePost(e, "UseepayChallengeIframe-".concat(Date.now()));
        }
      }, {
        key: "iframePost",
        value: function value(e, t) {
          var n = e.url;
          this.domId = t, $l({
            content: "div",
            props: {
              id: t
            },
            children: [{
              content: "div",
              props: {
                style: "\n            position: fixed;\n            width: 100%;\n            height: 100%;\n            z-index: 1000;\n            top: 0;\n            left: 0;\n            "
              }
            }, {
              content: "div",
              props: {
                style: "\n              position: fixed;\n              width: 100%;\n              height: 100%;\n              z-index: 1000;\n              top: 0;\n              left: 0;\n            "
              },
              children: {
                content: "iframe",
                props: {
                  src: n,
                  name: t,
                  style: "\n                position: relative;\n                width: 100%;\n                height: 100%;\n                top: 50%;\n                left: 50%;\n                transform: translate(-50%, -50%);\n                background: #fff;\n              "
                }
              }
            }]
          }, document.body), window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1);
        }
      }]), e;
    }();
  var up = function up(e) {
    return null == e || !(!Array.isArray(e) || e.length) || "string" == typeof e && !e;
  };
  function lp(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function pp(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? lp(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lp(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function dp(e, t) {
    if (function (e) {
      return void 0 === e;
    }(n = t) || function (e) {
      return null === e;
    }(n)) return $n(e);
    var n;
    if (!Zn(t) || !Zn(e)) return $n(t);
    var r = {};
    return Object.keys(e).map(function (n) {
      r[n] = dp(e[n], t[n]);
    }), Object.keys(t).map(function (e) {
      r[e] || (r[e] = $n(t[e]));
    }), r;
  }
  function fp() {
    return hp.apply(this, arguments);
  }
  function hp() {
    return hp = r(A.mark(function e() {
      var t,
        n,
        r,
        o,
        i,
        a,
        c,
        s,
        u,
        l,
        p,
        d,
        f,
        h,
        y,
        m = arguments;
      return A.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (n = (t = m.length > 0 && void 0 !== m[0] ? m[0] : {}).payOptions, r = t.paymentMethod, o = t.subPaymentMethod, i = t.cardInfo, a = t.extraParams, c = t.channelId, s = t.beforePayData, u = t.binInfo, l = null == n ? void 0 : n.hooks, p = dp(a || {}, {
                additionalData: {
                  language: zl.i18nLanguage
                }
              }), d = Object.assign({}, p, {
                paymentInstrument: {
                  paymentMethod: r || "",
                  subPaymentMethod: o
                },
                channelId: c
              }), "WorldPay" === c && (null == s ? void 0 : s.type) === _.WorldPayGather && (d.additionalData = d.additionalData || {}, d.additionalData.ddcReferenceId = s.SessionId || ""), i && (f = i.first6Last4, h = pp(pp({}, i), {}, {
                bin: null == f ? void 0 : f.slice(0, 6),
                last4: null == f ? void 0 : f.slice(-4),
                binInfo: {
                  bin: null == u ? void 0 : u.bin,
                  brand: null == u ? void 0 : u.brand
                }
              }), d.paymentInstrument.card = h), null == l || !l.extendConfirmParams) {
                e.next = 12;
                break;
              }
              return e.next = 10, l.extendConfirmParams()["catch"](Bn.handleError);
            case 10:
              (y = e.sent) && Zn(y) && (d = dp(d, y));
            case 12:
              return e.abrupt("return", d);
            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), hp.apply(this, arguments);
  }
  var yp,
    mp = function () {
      function e(t, n) {
        var r = this;
        o(this, e), h(this, "timer", null), h(this, "handlePostmessage", function (e) {
          var t = e.data,
            n = e.origin;
          if (!1 !== ap(n)) {
            Fn.reportData("3DS_handlePostmessage", {
              data: t,
              origin: n
            });
            var o = t.success,
              i = t.nextAction || {},
              a = t.nextAction || {},
              c = a.url,
              s = a.type;
            if (r.timer && (clearTimeout(r.timer), r.timer = null), o) {
              if (s === _.Redirect && c) {
                if (window.removeEventListener("message", r.handlePostmessage, !1), r.domId) {
                  var u = document.getElementById(r.domId);
                  u && u.parentElement && u.parentElement.removeChild(u);
                }
                kp(i, r.payOptions);
              }
              s === _.Challenge && r.challenge(t.nextAction), s === _.Gather && r.gather(t.nextAction);
            }
          }
        }), this.type = t, this.payOptions = n;
      }
      return s(e, [{
        key: "handleIframe",
        value: function value(e) {
          var t,
            n = e.type,
            r = e.iframeType,
            o = e.url,
            i = e.renderCode,
            a = e.processingMethod,
            c = e.size,
            s = "".concat(n, "Iframe-").concat(Date.now());
          return this.domId = s, n === _.ThreeDSChannelProcessing ? a === S.RenderCode && (t = function (e, t) {
            var n = document.createElement("iframe");
            return n.src = "", n.name = t, n.style.width = "100%", n.style.height = "100%", n.style.display = "block", n.style.border = "none", n.style.zIndex = "1000", n.setAttribute("srcDoc", e), document.body.appendChild(n), n;
          }(i || "", s)) : r === I.Hidden ? t = function (e, t) {
            var n = document.createElement("iframe");
            return n.src = e, n.name = t, n.style.width = "1px", n.style.height = "1px", n.style.display = "none", n.style.border = "none", document.body.appendChild(n), n;
          }("", s) : r === I.Visible && (t = function (e, t, n) {
            var r,
              o,
              i = document.createElement("iframe");
            i.src = e, i.name = t, i.style.width = (null == n || null === (r = n.size) || void 0 === r ? void 0 : r.width) || "100%", i.style.height = (null == n || null === (o = n.size) || void 0 === o ? void 0 : o.height) || "100%", i.style.display = "block", i.style.border = "none", i.style.zIndex = String(1e3), i.style.position = "fixed", i.style.top = "0", i.style.left = "0", i.style.bottom = "0", i.style.right = "0", i.style.margin = "auto", i.style.background = "#fff";
            var a = document.createElement("div");
            return a.style.position = "fixed", a.style.zIndex = String(999), a.style.width = "100%", a.style.height = "100%", a.style.top = "0", a.style.left = "0", a.style.background = "rgba(0, 0, 0, 0.5)", document.body.appendChild(a), document.body.appendChild(i), i;
          }(o || "", s, {
            size: c
          })), t;
        }
      }, {
        key: "handleForm",
        value: function value(e) {
          var t = e.urlAccessType,
            n = e.url,
            r = e.method,
            o = e.channelData,
            i = e.iframeName,
            a = e.formField,
            c = function c() {
              var e = function (e) {
                var t = e.action,
                  n = e.method,
                  r = void 0 === n ? "POST" : n,
                  o = e.channelData,
                  i = e.formField,
                  a = e.iframeName,
                  c = document.createElement("form");
                for (var s in c.action = t, c.method = r, a && (c.target = a), o) {
                  var u = document.createElement("input");
                  u.name = s, u.value = o[s], u.type = "hidden", c.appendChild(u);
                }
                return i && i.forEach(function (e) {
                  var t = document.createElement(e.element);
                  Object.keys(e.attribute).forEach(function (n) {
                    var r = e.attribute[n];
                    r && t.setAttribute(n, r);
                  }), c.appendChild(t);
                }), document.body.appendChild(c), c;
              }({
                action: n,
                method: r,
                channelData: o,
                iframeName: i,
                formField: a
              });
              Fn.reportData("3DS_handleForm_about_to_trigger_form_submission"), e.submit();
            };
          return (t === E.Form || t === E.Both && r === P.POST) && c(), new Promise(function (e) {
            e();
          });
        }
      }, {
        key: "handleDowngrade",
        value: function value(e) {
          if (e) {
            var t = e.downgradeType,
              n = e.method,
              r = e.url,
              o = void 0 === r ? "" : r,
              i = e.data,
              a = e.timeout;
            this.timer = window.setTimeout(function () {
              Fn.reportData("3DS_handleDowngrade_about_to_trigger_specified_API_request"), t === C.Request && (n === P.GET ? sr.get(o, {
                headers: {
                  Accept: "*/*"
                }
              }) : n === P.POST && sr.post(o, i || {}));
            }, a);
          }
        }
      }, {
        key: "gather",
        value: function value(e) {
          var t = this;
          Fn.reportData("3DS_gather_start", {
            nextAction: e
          });
          var n = e.data,
            r = e.method,
            o = void 0 === r ? P.GET : r,
            i = e.url,
            a = e.type,
            c = JSON.parse((null == n ? void 0 : n.additionalData) || "")[a] || {},
            s = c.urlAccessType,
            u = c.iframeType,
            l = c.formField,
            p = c.closePolling,
            d = void 0 !== p && p,
            f = c.listenMessageFromChannel,
            h = void 0 !== f && f,
            y = c.channelMessageTimeout,
            m = this.handleIframe({
              type: a,
              iframeType: u,
              url: i,
              method: o
            }),
            v = null == m ? void 0 : m.getAttribute("name");
          if (!d) {
            var g = e.nextAction;
            !0 === h && g ? this.gatherFromChannel(g, {
              timeout: y,
              origin: cp(i)
            }) : (window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1));
          }
          this.handleForm({
            urlAccessType: s,
            url: i,
            method: o,
            channelData: null == n ? void 0 : n.channelData,
            iframeName: v,
            formField: l
          }).then(function () {
            t.handleDowngrade(null == n ? void 0 : n.downgradeData);
          });
        }
      }, {
        key: "gatherFromChannel",
        value: function value(e, t) {
          var n = this,
            r = function r(o) {
              var i = o.data,
                a = o.origin;
              a === t.origin && (Fn.reportData("3DS_handleChannelMessage", {
                data: i,
                origin: a
              }), n.timer && (clearTimeout(n.timer), n.timer = null), window.removeEventListener("message", r, !1), Ep(e, {
                channelInfoData: i
              }));
            };
          "number" == typeof t.timeout && t.timeout > 0 ? this.timer = window.setTimeout(function () {
            window.removeEventListener("message", r, !1), Fn.reportErrorData("3DS_gatherFromChannel_timeout", {
              options: t,
              nestNextAction: e
            }), Ep(e, {
              channelInfoData: {}
            });
          }, t.timeout) : Fn.reportErrorData("3DS_gatherFromChannel_timeout_value_error", {
            options: t,
            nestNextAction: e
          }), window.addEventListener("message", r, !1);
        }
      }, {
        key: "challenge",
        value: function value(e) {
          var t = this;
          Fn.reportData("3DS_challenge_start", {
            nextAction: e
          });
          var n = e.data,
            r = e.method,
            o = void 0 === r ? P.GET : r,
            i = e.url,
            a = e.type,
            c = JSON.parse((null == n ? void 0 : n.additionalData) || "")[a] || {},
            s = c.urlAccessType,
            u = c.iframeType,
            l = c.formField,
            p = c.closePolling,
            d = void 0 !== p && p,
            f = this.handleIframe({
              type: a,
              iframeType: u,
              url: i,
              method: o,
              size: null == n ? void 0 : n.size
            }),
            h = null == f ? void 0 : f.getAttribute("name");
          d || (window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1)), this.handleForm({
            urlAccessType: s,
            url: i,
            method: o,
            channelData: null == n ? void 0 : n.channelData,
            iframeName: h,
            formField: l
          }).then(function () {
            t.handleDowngrade(null == n ? void 0 : n.downgradeData);
          });
        }
      }, {
        key: "channelProcessing",
        value: function value(e) {
          Fn.reportData("3DS_channelProcessing_start", {
            nextAction: e
          });
          var t,
            n,
            r = e.data,
            o = e.type,
            i = JSON.parse((null == r ? void 0 : r.additionalData) || "{}")[o] || {},
            a = i.processingMethod,
            c = i.iframeType,
            s = i.closePolling,
            u = void 0 !== s && s;
          a === S.RenderCode && (null === (n = this.handleIframe({
            type: o,
            iframeType: c,
            processingMethod: a,
            renderCode: null == r || null === (t = r.channelData) || void 0 === t ? void 0 : t.redirectParam
          })) || void 0 === n || n.getAttribute("name"));
          u || (window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1));
        }
      }]), e;
    }();
  function vp(e) {
    return function (e) {
      return /\/\/ec-payment(-prev)?\.myshopline(dev|stg)?\.com\/payment-static/.test(e) || /\/\/cashiers(-prev\d?)?\.myshopline?\.com\/gateway/.test(e);
    }(e) && zl.i18nLanguage ? function (e, t) {
      var n = e.indexOf("#"),
        r = -1 === n ? "" : e.substr(n);
      return e = -1 === n ? e : e.substr(0, n), Object.entries(t).forEach(function (t) {
        var n = Un(t, 2),
          r = n[0],
          o = n[1],
          i = new RegExp("([?&])".concat(r, "=.*?(&|$)"), "i"),
          a = -1 !== e.indexOf("?") ? "&" : "?";
        null === o ? ("?" === (e = e.replace(new RegExp("([?&]?)".concat(r, "=[^&]*"), "i"), "")).slice(-1) && (e = e.slice(0, -1)), -1 === e.indexOf("?") && (e = e.replace(/&/, "?"))) : e = e.match(i) ? e.replace(i, "$1".concat(r, "=").concat(o, "$2")) : "".concat(e + a + r, "=").concat(o);
      }), e + r;
    }(e, {
      clientLang: zl.i18nLanguage
    }) : e;
  }
  function gp(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function bp(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? gp(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gp(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function wp(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "post",
      r = arguments.length > 3 ? arguments[3] : void 0,
      o = document.createElement("form");
    for (var i in o.style.display = "none", o.method = n, o.action = e, r && (o.target = r), t) {
      var a = document.createElement("input");
      a.name = i, a.value = t[i] || "", o.appendChild(a);
    }
    document.body.appendChild(o), o.submit();
  }
  function kp(e, t) {
    return xp.apply(this, arguments);
  }
  function xp() {
    return xp = r(A.mark(function t(n, o) {
      var i, a, c, s, u, l, p, d, f, h, y, m;
      return A.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return c = n.method, s = void 0 === c ? "GET" : c, u = n.url, l = n.data, p = n.target, d = null == o || null === (i = o.hooks) || void 0 === i ? void 0 : i.beforeRedirect, f = null == o || null === (a = o.hooks) || void 0 === a ? void 0 : a.afterRedirect, h = (null == o ? void 0 : o.redirectAction) || e.RedirectActionType.REDIRECT, y = new Promise(function () {
                var e = r(A.mark(function e(t) {
                  return A.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          if (!d) {
                            e.next = 9;
                            break;
                          }
                          return e.prev = 1, e.next = 4, d(p || "Merchant");
                        case 4:
                          e.next = 9;
                          break;
                        case 6:
                          e.prev = 6, e.t0 = e["catch"](1), Bn.reportErrorData("before_redirect_error", {
                            nextAction: n,
                            error: e.t0
                          });
                        case 9:
                          t(null);
                        case 10:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e, null, [[1, 6]]);
                }));
                return function (t) {
                  return e.apply(this, arguments);
                };
              }()), m = new Promise(function (e) {
                setTimeout(e, 3e3);
              }), t.abrupt("return", Promise.race([y, m]).then(function () {
                if ("POST" === s) wp(u, l);else if ("GET" === s) {
                  var t = vp(u);
                  if (h === e.RedirectActionType.OPEN) return void window.open(t);
                  if (window.location.assign(t), f) try {
                    f(t);
                  } catch (e) {
                    Bn.reportErrorData("after_redirect_error", {
                      nextAction: n,
                      error: e,
                      redirectUrl: t
                    });
                  }
                }
              }));
            case 7:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), xp.apply(this, arguments);
  }
  function Op(e) {
    return _p.apply(this, arguments);
  }
  function _p() {
    return (_p = r(A.mark(function e(t) {
      var n, r, o, i, a, c;
      return A.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r = t.method, o = void 0 === r ? "GET" : r, i = t.url, a = t.data, o !== P.GET) {
                e.next = 7;
                break;
              }
              return e.next = 4, sr.get(i);
            case 4:
              c = e.sent, e.next = 11;
              break;
            case 7:
              if (o !== P.POST) {
                e.next = 11;
                break;
              }
              return e.next = 10, sr.post(i, a || {});
            case 10:
              c = e.sent;
            case 11:
              return e.abrupt("return", null === (n = c) || void 0 === n ? void 0 : n.data);
            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function Cp(e) {
    var t,
      n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      o = n.payOptions,
      i = null == o ? void 0 : o.hooks;
    return h(t = {}, _.Confirm, r(A.mark(function t() {
      var r, a;
      return A.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (t.t0 = null == i ? void 0 : i.beforeConfirm, !t.t0) {
                t.next = 4;
                break;
              }
              return t.next = 4, i.beforeConfirm()["catch"](Bn.handleError);
            case 4:
              return t.next = 6, fp(n);
            case 6:
              return r = t.sent, t.next = 9, rp(e.url, r, null == o ? void 0 : o.retryOptions)["catch"](Bn.handleError);
            case 9:
              if (a = t.sent, t.t1 = null == i ? void 0 : i.afterConfirm, !t.t1) {
                t.next = 14;
                break;
              }
              return t.next = 14, i.afterConfirm()["catch"](Bn.handleError);
            case 14:
              return t.abrupt("return", op(a, o, n.isOnceAction));
            case 15:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), h(t, _.Redirect, r(A.mark(function t() {
      return A.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, kp(e, o)["catch"](Bn.handleError);
            case 2:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), h(t, _.QrCode, r(A.mark(function t() {
      return A.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, kp(e, o)["catch"](Bn.handleError);
            case 2:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), h(t, _.WorldPayChallenge, function () {}), h(t, _.WorldPayGather, function () {}), h(t, _.UseepayChallenge, function () {
      new sp(e.type, o).challenge(e);
    }), h(t, _.UseepayGather, function () {
      new sp(e.type, o).gather(e);
    }), h(t, _.Gather, function () {
      new mp(e.type, o).gather(e);
    }), h(t, _.Challenge, function () {
      new mp(e.type, o).challenge(e);
    }), h(t, _.ContinueGetNextAction, r(A.mark(function t() {
      var r;
      return A.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, Op(e);
            case 2:
              if (r = t.sent) {
                t.next = 5;
                break;
              }
              return t.abrupt("return");
            case 5:
              return t.next = 7, Ep(r, n);
            case 7:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), h(t, _.ThreeDSChannelProcessing, function () {
      new mp(e.type, o).channelProcessing(e);
    }), h(t, _.ChannelInfoUpdate, r(A.mark(function t() {
      var r, o, i;
      return A.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return e.data && (null != n && n.data && (e.data = bp(bp({}, e.data), n.data)), null != n && n.channelInfoData && null !== (r = e.data) && void 0 !== r && null !== (o = r.channelInfoJsonData) && void 0 !== o && o.includes("@@channelInfoData@@") && (e.data.channelInfoJsonData = e.data.channelInfoJsonData.replace("@@channelInfoData@@", JSON.stringify(null == n ? void 0 : n.channelInfoData)))), t.next = 3, Op(e);
            case 3:
              if (null != (i = t.sent) && i.nextAction) {
                t.next = 6;
                break;
              }
              return t.abrupt("return");
            case 6:
              return t.next = 8, Ep(i.nextAction, n);
            case 8:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), h(t, _.ChannelConfirm, r(A.mark(function t() {
      return A.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (null == i || !i.channelConfirm) {
                t.next = 3;
                break;
              }
              return t.next = 3, i.channelConfirm(e);
            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), t;
  }
  function Ep(e) {
    return Ip.apply(this, arguments);
  }
  function Ip() {
    return Ip = r(A.mark(function e(t) {
      var n,
        r,
        o,
        i,
        a,
        c = arguments;
      return A.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r = c.length > 1 && void 0 !== c[1] ? c[1] : {}, o = t.type, i = Cp(t, r)[o], !Qo(i)) {
                e.next = 10;
                break;
              }
              return e.next = 6, i();
            case 6:
              if (e.t0 = e.sent, e.t0) {
                e.next = 9;
                break;
              }
              e.t0 = void 0;
            case 9:
              return e.abrupt("return", e.t0);
            case 10:
              if (!(a = null == r || null === (n = r.payOptions) || void 0 === n ? void 0 : n.hooks) || null == a || !a.handlePayAction) {
                e.next = 13;
                break;
              }
              return e.abrupt("return", a.handlePayAction(t));
            case 13:
              Bn.reportErrorData("handle_nextAction_notFound_error", {
                nextAction: t
              });
            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), Ip.apply(this, arguments);
  }
  !function (e) {
    e.NOLINE = "no_line";
  }(yp || (yp = {}));
  var Sp = window.CSS && window.CSS.supports && window.CSS.supports("(--foo: red)");
  function Pp() {
    if (!Sp) {
      Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector);
      var e,
        t = [],
        n = document,
        r = !1;
      document.addEventListener("DOMContentLoaded", function () {
        r = !0;
      }), "classList" in Element.prototype || j("classList", HTMLElement.prototype, Element.prototype), "innerHTML" in Element.prototype || j("innerHTML", HTMLElement.prototype, Element.prototype), "runtimeStyle" in Element.prototype || j("runtimeStyle", HTMLElement.prototype, Element.prototype), "undefined" == typeof SVGStyleElement || "sheet" in SVGStyleElement.prototype || Object.defineProperty(SVGStyleElement.prototype, "sheet", {
        get: function get() {
          for (var e, t = document.styleSheets, n = 0; e = t[n++];) {
            if (e.ownerNode === this) return e;
          }
        }
      });
      var o = {},
        i = new Set(),
        a = !1,
        c = !1,
        s = /([\s{;])(--([A-Za-z0-9-_]*)\s*:([^;!}{]+)(!important)?)(?=\s*([;}]|$))/g,
        u = /([{;]\s*)([A-Za-z0-9-_]+\s*:[^;}{]*var\([^!;}{]+)(!important)?(?=\s*([;}$]|$))/g,
        l = /-ieVar-([^:]+):/g,
        p = /-ie-([^};]+)/g,
        d = /:(hover|active|focus|target|visited|link|:before|:after|:first-letter|:first-line)/;
      I("style:not([iecp-ignore])", T), I("link[rel=stylesheet]:not([iecp-ignore])", T), I("[ie-style]", function (e) {
        var t = A("{" + e.getAttribute("ie-style")).substr(1);
        e.style.cssText += ";" + t;
        var n = R(e.style);
        n.getters && M(e, n.getters, "%styleAttr"), n.setters && F(e, n.setters);
      });
      var f = {
          hover: {
            on: "mouseenter",
            off: "mouseleave"
          },
          focus: {
            on: "focusin",
            off: "focusout"
          },
          active: {
            on: "CSSActivate",
            off: "CSSDeactivate"
          }
        },
        h = null;
      document.addEventListener("mousedown", function (e) {
        setTimeout(function () {
          if (e.target === document.activeElement) {
            var t = document.createEvent("Event");
            t.initEvent("CSSActivate", !0, !0), (h = e.target).dispatchEvent(t);
          }
        });
      }), document.addEventListener("mouseup", function () {
        if (h) {
          var e = document.createEvent("Event");
          e.initEvent("CSSDeactivate", !0, !0), h.dispatchEvent(e), h = null;
        }
      });
      var y = 0,
        m = new MutationObserver(function (e) {
          if (!c) for (var t, n = 0; t = e[n++];) {
            "iecp-needed" !== t.attributeName && G(t.target);
          }
        });
      setTimeout(function () {
        m.observe(document, {
          attributes: !0,
          subtree: !0
        });
      });
      var v = location.hash;
      addEventListener("hashchange", function () {
        var e = document.getElementById(location.hash.substr(1));
        if (e) {
          var t = document.getElementById(v.substr(1));
          G(e), G(t);
        } else G(document);
        v = location.hash;
      });
      var g = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "style"),
        b = g.get;
      g.get = function () {
        var e = b.call(this);
        return e.owningElement = this, e;
      }, Object.defineProperty(HTMLElement.prototype, "style", g);
      var w = getComputedStyle;
      window.getComputedStyle = function (e) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
          n[r - 1] = arguments[r];
        }
        var o = w.apply(this, [e].concat(n));
        return o.computedFor = e, o;
      };
      var k = CSSStyleDeclaration.prototype,
        x = k.getPropertyValue;
      k.getPropertyValue = function (e) {
        this.lastPropertyServedBy = !1, e = e.trim();
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
          n[r - 1] = arguments[r];
        }
        if ("-" !== e[0] || "-" !== e[1]) return x.apply(this, [e].concat(n));
        var o = e.substr(2),
          i = "-ie-" + o,
          a = "-ie-❗" + o,
          c = this[a] || this[i];
        if (this.computedFor) {
          if (void 0 === c || O[c]) {
            if (O[c] || !C[e] || C[e].inherits) for (var s = this.computedFor.parentNode; s && 1 === s.nodeType;) {
              var u = getComputedStyle(s),
                l = u[a] || u[i];
              if (void 0 !== l) {
                c = K(this, l), this.lastPropertyServedBy = s;
                break;
              }
              s = s.parentNode;
            }
          } else c = K(this, c), this.lastPropertyServedBy = this.computedFor;
          if ("initial" === c) return "";
        }
        return void 0 === c && C[e] && (c = C[e].initialValue), void 0 === c ? "" : c;
      };
      var O = {
          inherit: 1,
          revert: 1,
          unset: 1
        },
        _ = k.setProperty;
      k.setProperty = function (e, t, n) {
        for (var r = arguments.length, o = new Array(r > 3 ? r - 3 : 0), i = 3; i < r; i++) {
          o[i - 3] = arguments[i];
        }
        if ("-" !== e[0] || "-" !== e[1]) return _.apply(this, [e, t, n].concat(o));
        var a = this.owningElement;
        a && (a.ieCP_setters || (a.ieCP_setters = {}), a.ieCP_setters[e] = 1), e = "-ie-" + ("important" === n ? "❗" : "") + e.substr(2), this.cssText += "; " + e + ":" + t + ";", a && G(a);
      }, window.CSS || (window.CSS = {});
      var C = {};
      CSS.registerProperty = function (e) {
        C[e.name] = e;
      };
    }
    function E(e, t) {
      try {
        return e.querySelectorAll(t);
      } catch (e) {
        return [];
      }
    }
    function I(r, o) {
      for (var i, a = {
          selector: r,
          callback: o,
          elements: new WeakMap()
        }, c = E(n, a.selector), s = 0; i = c[s++];) {
        a.elements.set(i, !0), a.callback.call(i, i);
      }
      t.push(a), e || (e = new MutationObserver(D)).observe(n, {
        childList: !0,
        subtree: !0
      }), S(a);
    }
    function S(e, t) {
      var o,
        i = 0,
        a = [];
      try {
        t && t.matches(e.selector) && a.push(t);
      } catch (e) {
        window[window.__sl_console__ ? "__sl_console__" : "console"].error(e);
      }
      for (r && Array.prototype.push.apply(a, E(t || n, e.selector)); o = a[i++];) {
        e.elements.has(o) || (e.elements.set(o, !0), e.callback.call(o, o));
      }
    }
    function P(e) {
      for (var n, r = 0; n = t[r++];) {
        S(n, e);
      }
    }
    function D(e) {
      for (var t, n, r, o, i = 0; n = e[i++];) {
        for (r = n.addedNodes, t = 0; o = r[t++];) {
          1 === o.nodeType && P(o);
        }
      }
    }
    function j(e, t, n) {
      var r = Object.getOwnPropertyDescriptor(t, e) || {};
      Object.defineProperty(n, e, r);
    }
    function T(e) {
      if (!e.ieCP_polyfilled && !e.ieCP_elementSheet && e.sheet) {
        if (e.href) return function (e, t) {
          var n = new XMLHttpRequest();
          n.open("GET", e), n.overrideMimeType("text/css"), n.onload = function () {
            n.status >= 200 && n.status < 400 && t(n.responseText);
          }, n.send();
        }(e.href, function (t) {
          var n = A(t);
          t !== n && L(e, n);
        });
        var t = e.innerHTML,
          n = A(t);
        t !== n && L(e, n);
      }
    }
    function A(e) {
      return e.replace(s, function (e, t, n, r, o, i) {
        return t + "-ie-" + (i ? "❗" : "") + r + ":" + o;
      }).replace(u, function (e, t, n, r) {
        return t + "-ieVar-" + (r ? "❗" : "") + n + "; " + n;
      });
    }
    function R(e) {
      var t,
        n,
        r = e.cssText,
        i = r.match(l),
        a = [];
      if (i) for (t = 0; n = i[t++];) {
        var c = n.slice(7, -1);
        "❗" === c[0] && (c = c.substr(1)), a.push(c), o[c] || (o[c] = []), o[c].push(e);
      }
      var s = r.match(p),
        u = {};
      if (s) for (t = 0; n = s[t++];) {
        var d = n.substr(4).split(":"),
          f = d[0],
          h = d[1];
        "❗" === f[0] && (f = f.substr(1)), u[f] = h;
      }
      return {
        getters: a,
        setters: u
      };
    }
    function L(e, t) {
      e.sheet.cssText = t, e.ieCP_polyfilled = !0;
      for (var n, r = e.sheet.rules, o = 0; n = r[o++];) {
        var i = R(n.style);
        i.getters && N(n.selectorText, i.getters), i.setters && B(n.selectorText, i.setters);
        var a = n.parentRule && n.parentRule.media && n.parentRule.media.mediaText;
        a && (i.getters || i.setters) && matchMedia(a).addListener(function () {
          G(document.documentElement);
        });
      }
      H();
    }
    function N(e, t) {
      U(e), I(V(e), function (n) {
        M(n, t, e), z(n);
      });
    }
    function M(e, t, n) {
      var r,
        o,
        i = 0,
        a = n.split(",");
      for (e.setAttribute("iecp-needed", !0), e.ieCPSelectors || (e.ieCPSelectors = {}); r = t[i++];) {
        for (o = 0; n = a[o++];) {
          var c = n.trim().split("::");
          e.ieCPSelectors[r] || (e.ieCPSelectors[r] = []), e.ieCPSelectors[r].push({
            selector: c[0],
            pseudo: c[1] ? "::" + c[1] : ""
          });
        }
      }
    }
    function B(e, t) {
      U(e), I(V(e), function (e) {
        F(e, t);
      });
    }
    function F(e, t) {
      for (var n in e.ieCP_setters || (e.ieCP_setters = {}), t) {
        e.ieCP_setters["--" + n] = 1;
      }
      G(e);
    }
    function H() {
      for (var e in o) {
        for (var t, n = o[e], r = 0; t = n[r++];) {
          if (!t.owningElement) {
            var i = t["-ieVar-" + e];
            if (i && "" !== (i = K(getComputedStyle(document.documentElement), i))) try {
              t[e] = i;
            } catch (e) {
              window[window.__sl_console__ ? "__sl_console__" : "console"].error(e);
            }
          }
        }
      }
    }
    function U(e) {
      e = e.split(",")[0];
      var t = function t() {
        var t = e.split(":" + n);
        if (t.length > 1) {
          var r = t[1].match(/^[^\s]*/),
            o = V(t[0] + r),
            i = f[n];
          I(o, function (e) {
            null == e || e.addEventListener(i.on, W), null == e || e.addEventListener(i.off, W);
          });
        }
      };
      for (var n in f) {
        t();
      }
    }
    function V(e) {
      return e.replace(d, "").replace(":not()", "");
    }
    function z(e) {
      i.add(e), a || (a = !0, requestAnimationFrame(function () {
        a = !1, c = !0, i.forEach(q), i.clear(), setTimeout(function () {
          c = !1;
        });
      }));
    }
    function q(e) {
      e.ieCP_unique || (e.ieCP_unique = ++y, e.classList.add("iecp-u" + e.ieCP_unique));
      var t = getComputedStyle(e),
        n = "";
      for (var r in e.runtimeStyle.cssText = "", e.ieCPSelectors) {
        var o = t["-ieVar-❗" + r],
          i = o || t["-ieVar-" + r];
        if (i) {
          var a = {},
            c = K(t, i, a);
          o && (c += " !important");
          for (var s, u = 0; s = e.ieCPSelectors[r][u++];) {
            "%styleAttr" === s.selector && (e.style[r] = c), (o || !1 === a.allByRoot) && (s.pseudo ? n += s.selector + ".iecp-u" + e.ieCP_unique + s.pseudo + "{" + r + ":" + c + "}\n" : e.runtimeStyle[r] = c);
          }
        }
      }
      !function (e, t) {
        if (!e.ieCP_styleEl && t) {
          var n = document.createElement("style");
          n.ieCP_elementSheet = 1, document.head.appendChild(n), e.ieCP_styleEl = n;
        }
        e.ieCP_styleEl && (e.ieCP_styleEl.innerHTML = t);
      }(e, n);
    }
    function G(e) {
      if (e) {
        e === document.documentElement && H();
        var t = e.querySelectorAll("[iecp-needed]");
        e.hasAttribute && e.hasAttribute("iecp-needed") && z(e);
        for (var n, r = 0; n = t[r++];) {
          z(n);
        }
      }
    }
    function W(e) {
      G(e.target);
    }
    function K(e, t, n) {
      return function (e, t) {
        for (var n, r, o = 0, i = null, a = 0, c = "", s = 0; n = e[s++];) {
          if ("(" === n && (++o, null === i && e[s - 4] + e[s - 3] + e[s - 2] === "var" && (i = o, c += e.substring(a, s - 4), a = s), e[s - 5] + e[s - 4] + e[s - 3] + e[s - 2] === "calc" && (r = o)), ")" === n && i === o) {
            var u = e.substring(a, s - 1).trim(),
              l = void 0,
              p = u.indexOf(",");
            -1 !== p && (l = u.slice(p + 1), u = u.slice(0, p)), c += t(u, l, r), a = s, i = null;
          }
          ")" === n && r === --o && (r = null);
        }
        return c + e.substring(a);
      }(t, function (t, r, o) {
        var i = e.getPropertyValue(t);
        return o && (i = i.replace(/^calc\(/, "(")), n && e.lastPropertyServedBy !== document.documentElement && (n.allByRoot = !1), "" === i && r && (i = K(e, r, n)), i;
      });
    }
  }
  var Dp,
    jp = function jp(e) {
      var t,
        n,
        r,
        o = e.container,
        i = e.id,
        a = e.className,
        c = e.type,
        s = e.content,
        u = e.show,
        l = e.contentClassName,
        p = o.querySelector("#".concat(i));
      if (p) {
        var d,
          f = p.parentElement,
          h = f ? f.parentElement : null,
          y = f && null !== (t = f.getAttribute("class")) && void 0 !== t ? t : "",
          m = h && null !== (n = null == h ? void 0 : h.getAttribute("class")) && void 0 !== n ? n : "";
        if ("error" === c && (p.textContent = s || ""), s || !0 === u) null !== (d = y) && void 0 !== d && d.includes(a) || (y += " ".concat(a), "error" === c && (m += " ".concat(l))), f && (f.style.height = "".concat(p.offsetHeight, "px"));else "" !== s && !1 !== u || null === (r = y) || void 0 === r || !r.includes("".concat(a)) || (f && (f.style.height = "0px"), y = y.replace(" ".concat(a), ""), "error" === c && (m = m ? m.replace(" ".concat(l), "") : ""));
        null == f || f.setAttribute("class", y || ""), "error" === c && (null == h || h.setAttribute("class", m || ""));
      }
    },
    Tp = function Tp(e, t) {
      var n = e.querySelector("#pci-number-icon");
      if (n) {
        var r = n.querySelector(".pci-tip-icon"),
          o = n.querySelector(".pci-brand-icon"),
          i = n.querySelector(".pci-tooltip-wrap"),
          a = function a(e) {
            e ? (null == o || o.classList.remove("payment-sdk-hidden"), null == r || r.classList.add("payment-sdk-hidden"), null == i || i.classList.add("payment-sdk-hidden")) : (null == o || o.classList.add("payment-sdk-hidden"), null == r || r.classList.remove("payment-sdk-hidden"), null == i || i.classList.remove("payment-sdk-hidden"));
          };
        if (o && (o.onerror = function () {
          a(!1);
        }, o.onload = function () {
          a(!0);
        }), t) {
          var c = "".concat("https://img.myshopline.com", "/pay/felogo/").concat(encodeURIComponent(t), ".svg");
          null == o || o.setAttribute("src", c), a(!0);
        } else a(!1);
      }
    },
    Ap = function Ap(e) {
      var t,
        n = e.name,
        r = e.formItems,
        o = e.options,
        i = "outside" === (null == o ? void 0 : o.labelPosition),
        a = {
          content: "label",
          props: {
            "class": "pci-input-label pci-input-label-".concat(i ? "outside" : "inside"),
            id: "pci-input-".concat(n, "-label")
          }
        },
        c = {
          content: "div",
          props: {
            "class": "pci-input-container ".concat(r.includes(n) ? "" : "pci-input-container-hidden"),
            id: "pci-input-".concat(n, "-container")
          },
          children: [i ? a : null, {
            content: "div",
            props: {
              "class": "pci-input-box".concat(null != o && o.borderType ? " pci-input-box-".concat(null == o ? void 0 : o.borderType) : "")
            },
            children: [i ? null : a, {
              content: "div",
              props: {
                "data-pci": n,
                "class": "pci-input-content",
                id: "pci-input-".concat(n, "-content")
              }
            }]
          }]
        };
      if (n === Ve.FirstName) {
        var s,
          u = {
            content: "div",
            props: {
              "class": "pci-input-tip"
            },
            children: {
              content: "div",
              props: {
                id: "pci-input-name-tip"
              }
            }
          };
        null == c || null === (s = c.children) || void 0 === s || s.push(u);
      }
      var l = function (e) {
        return {
          content: "div",
          props: {
            "class": "pci-error-tip pci-input-tip"
          },
          children: {
            content: "div",
            props: {
              id: "pci-".concat(e, "-error")
            }
          }
        };
      }(n);
      return null == c || null === (t = c.children) || void 0 === t || t.push(l), c;
    },
    Rp = function Rp(e, t) {
      var n = Ap({
          name: Ve.Number,
          formItems: e,
          options: t
        }),
        r = null;
      e.includes(Ve.FirstName) && (r = Ap({
        name: Ve.FirstName,
        formItems: e,
        options: t
      }));
      var o = Ap({
          name: Ve.ExpDate,
          formItems: e,
          options: t
        }),
        i = Ap({
          name: Ve.Cvc,
          formItems: e,
          options: t
        });
      return [n, r, {
        content: "div",
        props: {
          "class": "".concat(e.includes(Ve.FirstName) ? "pci-dateAndCvc-box" : "")
        },
        children: [o, i]
      }].filter(Boolean);
    },
    Lp = function Lp(e) {
      return e.imgSrc ? {
        content: "img",
        props: {
          "class": e.className,
          src: e.imgSrc
        }
      } : e.svg ? {
        content: "div",
        props: {
          "class": e.className,
          innerHTML: e.svg
        }
      } : null;
    },
    Np = function Np(e) {
      var t = Lp({
        imgSrc: e.imgSrc,
        svg: e.svg,
        className: "pci-tip-icon"
      });
      return {
        content: "div",
        props: {
          id: "pci-".concat(e.name, "-icon"),
          "class": "pci-icon pci-".concat(e.name, "-icon")
        },
        children: [t, {
          content: "img",
          props: {
            "class": "pci-brand-icon payment-sdk-hidden"
          }
        }]
      };
    },
    Mp = function Mp(e, t) {
      var n = e.querySelectorAll(".pci-input-box-focus");
      [].slice.call(n).forEach(function (e) {
        e.classList.remove("pci-input-box-focus");
      }), Object.keys(t).forEach(function (n) {
        if (t[n].validateResult.isEmpty) {
          var r,
            o = null === (r = e.querySelector("#pci-input-".concat(n, "-content"))) || void 0 === r ? void 0 : r.parentElement;
          null == o || o.classList.remove("pci-input-box-not-empty");
        }
      });
    },
    Bp = function Bp(e, t, n) {
      var r = "pci-".concat(t, "-error");
      jp({
        container: e,
        id: r,
        type: "error",
        className: "pci-input-tip-show",
        content: n,
        contentClassName: "pci-input-valid-error-box"
      });
    },
    Fp = function Fp(e) {
      return e === kt ? "SLPaymentsFooter" : "footer";
    },
    Hp = {
      4455: {
        name: Ve.Number,
        key: "pleaseEnterValidCardNumber"
      },
      3001: {
        name: Ve.Number,
        key: "pleaseChangeAnotherCard"
      },
      4459: {
        name: Ve.ExpDate,
        key: "pleaseEnterExpired"
      },
      4453: {
        name: Ve.Cvc,
        key: "pleaseEnterCVV"
      }
    },
    Up = function Up(e) {
      return Hp[e] || {};
    };
  tp('.sl-payment.pci-container * {\n  margin: 0;\n}\n\n.sl-payment.pci-container {\n  margin: 0 auto;\n}\n\n.sl-payment .pci-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sl-payment .pci-content-form {\n  position: relative;\n  flex: 0 1 100%;\n}\n\n.sl-payment .pci-content-loading .pci-input-container {\n  background-color: var(--input-font-color);\n  opacity: 0.05;\n  border-radius: var(--input-border-radius);\n  height: var(--input-height);\n}\n\n.sl-payment .pci-content-loading .pci-input-box,\n.sl-payment .pci-content-loading .pci-icon {\n  display: none;\n}\n\n.sl-payment .pci-dateAndCvc-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.sl-payment.pci-pc-style .pci-dateAndCvc-box .pci-input-container {\n  width: 50%;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-dateAndCvc-box > .pci-input-container:first-child {\n  margin-right: var(--form-item-gutter);\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-dateAndCvc-box > .pci-input-container:first-child {\n  margin-left: var(--form-item-gutter);\n}\n\n.sl-payment .pci-input-container {\n  position: relative;\n  width: 100%;\n  margin-bottom: var(--form-item-gutter);\n  overflow: visible;\n  transition: all 0.3s ease;\n}\n\n.sl-payment .pci-input-box {\n  position: relative;\n  box-sizing: border-box;\n  overflow: visible;\n  z-index: 1;\n  background-color: var(--input-background);\n  height: var(--input-height);\n  border-width: 1px;\n  border-style: solid;\n  border-color: var(--input-border-color);\n  border-radius: var(--input-border-radius);\n  box-shadow: 0 0 0 0 var(--input-error-border-color);\n  transition: box-shadow 0.2s ease-in-out, border 0.2s ease-in-out;\n}\n\n.sl-payment .pci-input-box.pci-input-box-none {\n  border-color: transparent;\n}\n\n.sl-payment .pci-input-box.pci-input-box-block_end {\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n  border-radius: 0;\n}\n\n.sl-payment .pci-input-box.pci-input-box-block_end.pci-input-box-focus {\n  box-shadow: 0 1px 0 0 var(--input-focus-border-color);\n}\n\n.sl-payment .pci-input-valid-error-box .pci-input-box.pci-input-box-block_end {\n  box-shadow: 0 1px 0 0 var(--input-error-border-color);\n}\n\n.sl-payment .pci-input-box.pci-input-box-focus {\n  box-shadow: 0 0 0 1px var(--input-focus-border-color);\n  border-color: var(--input-focus-border-color);\n}\n\n.sl-payment .pci-input-box-not-empty .pci-input-label {\n  font-size: var(--input-label-focus-font-size);\n  transform: translateY(-9px);\n  transition: all 0.3s ease;\n}\n\n.sl-payment .pci-input-box-not-empty .pci-input-content {\n  transition: all 0.3s ease;\n  height: var(--input-height);\n}\n\n.sl-payment .pci-input-box-not-empty .pci-input-content input {\n  transition: all 0.3s ease;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-input-box-not-empty .pci-input-content input {\n  padding: calc(\n      var(--input-padding-top) + var(--input-label-small-line-height) + var(--input-label-gutter)\n    )\n    0 var(--input-padding-bottom) var(--input-padding-left);\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-input-box-not-empty .pci-input-content input {\n  padding: calc(\n      var(--input-padding-top) + var(--input-label-small-line-height) + var(--input-label-gutter)\n    )\n    var(--input-padding-left) var(--input-padding-bottom) 0;\n}\n\n.sl-payment .pci-input-valid-error-box .pci-input-box {\n  box-shadow: 0 0 0 1px var(--input-error-border-color);\n  border-color: var(--input-error-border-color);\n}\n\n.sl-payment .pci-input-content {\n  height: 100%;\n  background-color: transparent;\n}\n\n[ecp-dir="ltr"] .sl-payment #pci-input-number-content,\n[ecp-dir="ltr"] .sl-payment #pci-input-firstName-content,\n[ecp-dir="ltr"] .sl-payment #pci-input-cvc-content {\n  margin-right: 40px;\n}\n\n[ecp-dir="rtl"] .sl-payment #pci-input-number-content,\n[ecp-dir="rtl"] .sl-payment #pci-input-firstName-content,\n[ecp-dir="rtl"] .sl-payment #pci-input-cvc-content {\n  margin-left: 40px;\n}\n\n.sl-payment .pci-number-icon,\n.sl-payment .pci-firstName-icon,\n.sl-payment .pci-cvc-icon {\n  position: absolute;\n  top: calc(var(--input-height) / 2 - 16px / 2);\n  width: 16px;\n  height: 16px;\n  z-index: 10;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-number-icon,\n[ecp-dir="ltr"] .sl-payment .pci-firstName-icon,\n[ecp-dir="ltr"] .sl-payment .pci-cvc-icon {\n  right: var(--input-padding-right);\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-number-icon,\n[ecp-dir="rtl"] .sl-payment .pci-firstName-icon,\n[ecp-dir="rtl"] .sl-payment .pci-cvc-icon {\n  left: var(--input-padding-right);\n}\n\n.sl-payment .pci-input-label {\n  line-height: var(--input-label-line-height);\n  color: var(--input-label-color);\n  white-space: nowrap;\n}\n\n.sl-payment .pci-input-label.pci-input-label-outside {\n  font-size: 12px;\n  margin-bottom: 8px;\n  display: inline-block;\n}\n\n.sl-payment .pci-input-label.pci-input-label-inside {\n  position: absolute;\n  top: calc(var(--input-height) / 2 - var(--input-label-line-height) / 2);\n  font-size: 14px;\n  transition: all 0.3s ease;\n  pointer-events: none;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-input-label.pci-input-label-inside {\n  left: var(--input-padding-left);\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-input-label.pci-input-label-inside {\n  right: var(--input-padding-left);\n}\n\n.sl-payment .pci-tip-icon {\n  color: var(--input-icon-color);\n  width: 16px;\n  height: 16px;\n}\n\n.sl-payment .pci-tip-icon svg {\n  vertical-align: top;\n}\n\n.sl-payment .pci-number-icon .pci-brand-icon {\n  width: 38px;\n  height: 24px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-number-icon .pci-brand-icon {\n  right: 0;\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-number-icon .pci-brand-icon {\n  left: 0;\n}\n\n.sl-payment .pci-input-tip {\n  height: 0;\n  font-size: 14px;\n  line-height: 16px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  margin-top: var(--input-tip-gutter);\n  color: var(--input-tip-color);\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-input-tip {\n  margin-left: 1px;\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-input-tip {\n  margin-right: 1px;\n}\n\n.sl-payment .pci-input-tip:not(.pci-input-tip-show) {\n  margin-top: 0 !important;\n}\n\n.sl-payment .pci-error-tip {\n  color: var(--input-error-font-color);\n}\n\n.sl-payment .pci-card {\n  flex: 0 1 316px;\n  height: 176px;\n  padding: 24px 24px 0;\n  box-sizing: border-box;\n  box-shadow: inset 0px 0px 10px rgba(255, 255, 255, 0.25);\n  border-radius: 4px;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-card {\n  background: linear-gradient(180deg, #cfcfcf 0%, #c4c3c3 100%);\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-card {\n  background: linear-gradient(-180deg, #cfcfcf 0%, #c4c3c3 100%);\n}\n\n.sl-payment .pci-card-logo {\n  width: 64px;\n  height: 40px;\n  margin-bottom: 24px;\n  background: #ffffff;\n  opacity: 0.4;\n  border-radius: 2px;\n}\n\n.sl-payment .pci-card-number {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.sl-payment .pci-card-number-dot-list {\n  width: 48px;\n  height: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sl-payment .pci-card-number-dot-item {\n  width: 6px;\n  height: 6px;\n  border-radius: 6px;\n  background-color: #fff;\n}\n\n.sl-payment .pci-card-nameAndExpDate {\n  display: flex;\n  justify-content: space-between;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-card-name,\n[ecp-dir="ltr"] .sl-payment .pci-card-expDate {\n  float: right;\n  text-align: right;\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-card-name,\n[ecp-dir="rtl"] .sl-payment .pci-card-expDate {\n  float: left;\n  text-align: left;\n}\n\n.sl-payment .pci-card-name p,\n.sl-payment .pci-card-expDate p {\n  margin: 0 0 8px 0;\n  font-size: 12px;\n  line-height: 14px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-card-name .pci-card-number-dot-list {\n  float: left;\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-card-name .pci-card-number-dot-list {\n  float: right;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-card-expDate .pci-card-number-dot-list {\n  float: right;\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-card-expDate .pci-card-number-dot-list {\n  float: left;\n}\n\n.sl-payment .pci-footer {\n  font-size: 11px;\n  line-height: 16px;\n  display: flex;\n}\n\n.sl-payment .pci-footer a,\n.sl-payment .pci-footer a:hover,\n.sl-payment .pci-footer a:active {\n  color: var(--footer-link-color);\n  text-decoration: none;\n}\n\n.sl-payment .pci-footer-tips {\n  color: var(--footer-font-color);\n  word-break: break-word;\n}\n\n.sl-payment .pci-footer-icon {\n  color: var(--footer-icon-color);\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n[ecp-dir="ltr"] .sl-payment .pci-footer-icon {\n  margin-right: 4px;\n}\n\n[ecp-dir="rtl"] .sl-payment .pci-footer-icon {\n  margin-left: 4px;\n}\n\n.sl-payment .pci-footer-tips img {\n  max-width: 100%;\n}\n\n.sl-payment .pci-footer-loading {\n  background-color: var(--input-font-color);\n  opacity: 0.05;\n  border-radius: 4px;\n  height: 10px;\n}\n\n.sl-payment .pci-footer-loading .pci-footer-tips {\n  display: none;\n}\n\n.sl-payment.pci-mobile-style {\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Don\'t display card on small screens */\n\n.sl-payment.pci-mobile-style .pci-container,\n.sl-payment.pci-mobile-style {\n  max-width: 100%;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.sl-payment.pci-mobile-style .pci-content-form {\n  flex: auto;\n}\n\n.sl-payment.pci-mobile-style .pci-bind-card-container {\n  width: 100%;\n}\n\n.sl-payment.pci-mobile-style .pci-name-box {\n  margin-bottom: 0;\n}\n\n.sl-payment.pci-mobile-style .pci-dateAndCvc-box {\n  display: block;\n}\n\n.sl-payment.pci-mobile-style .pci-input-box {\n  margin-bottom: 0;\n}\n\n.sl-payment.pci-mobile-style .pci-input-container {\n  width: 100%;\n}\n\n[ecp-dir="ltr"] .sl-payment.pci-mobile-style .pci-dateAndCvc-box .pci-input-container {\n  margin-right: 0;\n}\n\n[ecp-dir="rtl"] .sl-payment.pci-mobile-style .pci-dateAndCvc-box .pci-input-container {\n  margin-left: 0;\n}\n\n.sl-payment.pci-mobile-style .pci-card {\n  display: none;\n}\n\n/* .pci-container .pci-content-select{\n  margin-bottom: 0;\n  @apply mb-form-item;\n} */\n\n.sl-payment .pci-input-container-hidden {\n  display: none;\n}\n\n.sl-payment .payment-sdk-hidden {\n  display: none;\n}\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n}\n', {}), function (e) {
    e.Default = "", e.Pending = "PENDING", e.Support = "SUPPORT", e.ChannelNoSupport = "CHANNEL_NO_SUPPORT", e.UnknownBrand = "UNKNOWN_BRAND";
  }(Dp || (Dp = {}));
  var Vp = [Dp.ChannelNoSupport, Dp.UnknownBrand],
    zp = function zp(e) {
      return !1 === Vp.includes(e);
    },
    qp = function qp(e, t) {
      var n = "".concat(t, "/v1/api/cashier/cardBrandCheck");
      return sr.post(n, e).then(function (e) {
        var t;
        return null == e || null === (t = e.data) || void 0 === t ? void 0 : t.data;
      });
    };
  function Gp(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Wp(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Gp(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gp(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var Kp = s(function e(t) {
    var n = this;
    o(this, e), h(this, "validateStatus", Dp.Default), h(this, "prevId", 0), h(this, "check", function () {
      var e = r(A.mark(function e(t) {
        var r, o, i, a, c, s;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (r = {
                  drop: !0
                }, o = t.bin, i = t.brand, n.enableCheckCardBrand) {
                  e.next = 5;
                  break;
                }
                return n.onBrandChange({
                  brand: i
                }), e.abrupt("return", r);
              case 5:
                if (a = n.prevId += 1, o) {
                  e.next = 10;
                  break;
                }
                return n.validateStatus = Dp.Default, n.onBrandChange({
                  brand: i
                }), e.abrupt("return", r);
              case 10:
                return n.validateStatus = Dp.Pending, c = {
                  cardBinBrand: i,
                  cardBin: t.bin
                }, e.next = 14, n.cardBrandCheck(c);
              case 14:
                if (s = e.sent, a === n.prevId) {
                  e.next = 17;
                  break;
                }
                return e.abrupt("return", r);
              case 17:
                return Fn.reportData("checkCardBrand_start", {
                  result: s,
                  params: c
                }), zp(s.brandMatchDescription) || Fn.reportData("checkCardBrand_no_support", {
                  result: s,
                  params: c
                }), n.validateStatus = s.brandMatchDescription, n.onBrandChange({
                  brand: s.cardBinBrand
                }), r.drop = !1, e.abrupt("return", r);
              case 24:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), h(this, "validate", r(A.mark(function e() {
      var t, r;
      return A.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!(t = zp(n.validateStatus))) {
                e.next = 5;
                break;
              }
              e.t0 = "", e.next = 8;
              break;
            case 5:
              return e.next = 7, null == zl ? void 0 : zl.get("card.brand.not_support");
            case 7:
              e.t0 = e.sent;
            case 8:
              return r = e.t0, e.abrupt("return", {
                success: t,
                errorTips: r,
                skip: n.skipCardBrandError
              });
            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), h(this, "cardBrandCheck", function () {
      var e = r(A.mark(function e(t) {
        var r, o, i, a, c, s, u, l, p, d, f, h;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = n.channelInfo, o = r.merchantId, i = r.channelId, a = Wp(Wp({}, t), {}, {
                  merchantId: o,
                  channelId: i
                }), e.next = 4, qp(a, n.envConfig.host)["catch"](function (e) {
                  return Fn.handleError(e, "card_brand_check_error", {
                    request: {
                      params: a
                    },
                    response: {
                      error: e
                    }
                  });
                });
              case 4:
                return c = e.sent, u = (s = c || {}).brandMatchDescription, l = void 0 === u ? Dp.Default : u, p = s.cardBinBrand, d = void 0 === p ? "" : p, f = s.brandInfo, h = void 0 === f ? null : f, e.abrupt("return", {
                  brandMatchDescription: l,
                  cardBinBrand: d,
                  brandInfo: h
                });
              case 7:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }());
    var i = t.onBrandChange,
      a = t.grayscaleConfig,
      c = t.channelInfo,
      s = t.envConfig;
    this.onBrandChange = Qo(i) ? i : function () {}, this.enableCheckCardBrand = function (e) {
      return !!e && [Qu.GrayForTips, Qu.GrayForAbort].includes(e.cardBrandCheckConfig);
    }(a), this.skipCardBrandError = function (e) {
      return (null == e ? void 0 : e.cardBrandCheckConfig) === Qu.GrayForTips;
    }(a), this.channelInfo = c, this.envConfig = s, Fn.reportData("grayscaleConfig", {
      skipCardBrandError: this.skipCardBrandError,
      enableCheckCardBrand: this.enableCheckCardBrand
    });
  });
  function Jp(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Yp(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Jp(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jp(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function Xp(e, t) {
    var _n4 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!_n4) {
      if (Array.isArray(e) || (_n4 = function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return Zp(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Zp(e, t);
      }(e)) || t && e && "number" == typeof e.length) {
        _n4 && (e = _n4);
        var r = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return r >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[r++]
            };
          },
          e: function e(_e6) {
            throw _e6;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var i,
      a = !0,
      c = !1;
    return {
      s: function s() {
        _n4 = _n4.call(e);
      },
      n: function n() {
        var e = _n4.next();
        return a = e.done, e;
      },
      e: function e(_e7) {
        c = !0, i = _e7;
      },
      f: function f() {
        try {
          a || null == _n4["return"] || _n4["return"]();
        } finally {
          if (c) throw i;
        }
      }
    };
  }
  function Zp(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }
    return r;
  }
  var $p = function () {
      function e(t, n, i) {
        var a = this,
          c = i.initResult;
        o(this, e), h(this, "formItemInfo", {
          number: {
            validateResult: {}
          },
          cvc: {
            validateResult: {}
          },
          firstName: {
            validateResult: {}
          },
          expDate: {
            validateResult: {}
          }
        }), h(this, "card", {}), h(this, "createEventListener", r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  a.pciSdk.create({
                    placeholder: {},
                    onInit: a.pciSdkInit,
                    onFocus: a.handleFocusInput,
                    onFieldValidChange: a.onFieldValidChange,
                    onCardBinChange: a.onCardBinChange
                  });
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }))), h(this, "needShowPcStyle", function (e) {
          a.isPc = e;
          var t = a.container.querySelector("#pci-container");
          if (t) {
            var n,
              r = t.getAttribute("class");
            r = null === (n = r) || void 0 === n ? void 0 : n.replace(/(\s*pci-mobile-style)|(\s*pci-pc-style)/g, ""), r += " ".concat(e ? "pci-pc-style" : "pci-mobile-style"), t.setAttribute("class", r || ""), xt.forEach(function (e) {
              var t = a.container.querySelector("#pci-".concat(e, "-error"));
              if (t) {
                var n = null == t ? void 0 : t.textContent,
                  r = null == t ? void 0 : t.parentElement;
                n && r && (r.style.height = "".concat(t.offsetHeight, "px"));
              }
            });
          }
        }), h(this, "insertLanguage", r(A.mark(function e() {
          var t, n, r, o, i, c, s, u, l, p, d, f, h, y, m;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  a.hasTipsArray = [], t = Xp(xt), e.prev = 2, t.s();
                case 4:
                  if ((n = t.n()).done) {
                    e.next = 26;
                    break;
                  }
                  if (r = n.value, o = a.container.querySelector("#pci-input-".concat(r, "-label")), i = a.container.querySelector("#pci-input-".concat(r, "-container .pci-input-box")), !o) {
                    e.next = 12;
                    break;
                  }
                  return e.next = 11, zl.get("formItems.".concat(r, ".labelTitle"));
                case 11:
                  o.textContent = e.sent;
                case 12:
                  return e.next = 14, zl.get("formItems.".concat(r, ".tips"));
                case 14:
                  if ((c = e.sent) && a.hasTipsArray.push({
                    key: r,
                    content: c
                  }), a.formItemInfo[r].validateResult = {
                    isValid: void 0,
                    isEmpty: !0
                  }, c && (s = a.theme.getInputIcon(r), u = s.imgSrc, l = s.svg, $l(Np({
                    name: r,
                    imgSrc: u,
                    svg: l
                  }), i)), r !== Ve.FirstName) {
                    e.next = 24;
                    break;
                  }
                  return e.next = 21, zl.get("pleaseEnterNameOnCardOrBusinessName");
                case 21:
                  p = e.sent, (d = a.container.querySelector("#pci-input-name-tip")) && (d.textContent = p || null);
                case 24:
                  e.next = 4;
                  break;
                case 26:
                  e.next = 31;
                  break;
                case 28:
                  e.prev = 28, e.t0 = e["catch"](2), t.e(e.t0);
                case 31:
                  return e.prev = 31, t.f(), e.finish(31);
                case 34:
                  return a.hasTipsArray.length > 0 && (f = new np(), a.hasTipsArray.forEach(function (e) {
                    var t = a.container.querySelector("#pci-".concat(e.key, "-icon"));
                    f.mount(t, e.content);
                  })), h = new Lt(), e.t2 = "", e.next = 39, zl.get("content.creditCard.serviceTips");
                case 39:
                  if (e.t3 = e.sent, e.t3) {
                    e.next = 42;
                    break;
                  }
                  e.t3 = "";
                case 42:
                  return e.t4 = e.t3, e.t1 = e.t2.concat.call(e.t2, e.t4), e.next = 46, zl.get(Fp(a.channelId || "") || "");
                case 46:
                  if (e.t5 = e.sent, e.t5) {
                    e.next = 49;
                    break;
                  }
                  e.t5 = "";
                case 49:
                  return e.t6 = e.t5, (y = e.t1.concat.call(e.t1, e.t6)) && (null === (m = a.container.querySelector(".pci-footer-tips")) || void 0 === m || m.appendChild(h.autoParseToDom(y))), a.pciSdk.mount(".pci-content-form-".concat(a.uuid)), e.abrupt("return", new Promise(function (e) {
                    a.memoryResolve = e;
                  }));
                case 54:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[2, 28, 31, 34]]);
        }))), h(this, "pciSdkInit", function () {
          var e;
          Fn.reportData("pciSdkInit_finished"), null === (e = a.memoryResolve) || void 0 === e || e.call(a, !0);
        }), h(this, "removeLoading", r(A.mark(function e() {
          var t, n, r, o, i, c, s, u, l, p, d, f;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  r = a.container.querySelector("#pci-content-form"), o = null == r || null === (t = r.getAttribute("class")) || void 0 === t ? void 0 : t.replace(" pci-content-loading", ""), null == r || r.setAttribute("class", o || ""), i = a.container.querySelector(".pci-footer"), c = null == i || null === (n = i.getAttribute("class")) || void 0 === n ? void 0 : n.replace(" pci-footer-loading", ""), null == i || i.setAttribute("class", c || ""), s = "outside" === a.theme.getCreditCardThemeValue("inputLabelPosition"), u = s ? a.theme.getCreditCardThemeValue("inputPaddingTop") : "calc(".concat(a.theme.getCreditCardThemeValue("inputPaddingTop"), " + ").concat(a.theme.getCreditCardThemeValue("inputLabelGutter"), " + ").concat(a.theme.getCreditCardThemeValue("inputLabelSmallLineHeight"), ")"), l = {
                    padding: "".concat(u, " 0 ").concat(a.theme.getCreditCardThemeValue("inputPaddingBottom"), " ").concat(a.theme.getCreditCardThemeValue("inputPaddingLeft")),
                    fontWeight: a.theme.getCreditCardThemeValue("inputFontWeight"),
                    fontSize: a.theme.getCreditCardThemeValue("inputFontSize"),
                    letterSpacing: a.theme.getCreditCardThemeValue("inputFontLetterSpacing"),
                    color: a.theme.getCreditCardThemeValue("inputFontColor"),
                    rtl: ql(a.initData)
                  }, p = a.theme.handleDefaultThemeValidate(), d = a.theme.getDefaultFontLib(), f = a.theme.getDefaultFontFamily(), p ? (l.fontLib = d, l.fontFamily = f) : (Fn.reportErrorData("pci_form_setStyle_font_error", {
                    fontLib: d,
                    fontFamily: f
                  }), window[window.__sl_console__ ? "__sl_console__" : "console"].warn("Please check if the initTheme.fontLib or initTheme.fontFamily value is incorrect")), xt.forEach(function (e) {
                    a.pciSdk.setStyle({
                      style: l,
                      type: "base",
                      fieldName: e
                    });
                  });
                case 14:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }))), h(this, "handleError", function () {
          var e = r(A.mark(function e(t, n) {
            return A.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    Bp(a.container, t, n);
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t, n) {
            return e.apply(this, arguments);
          };
        }()), h(this, "handleFocusInput", function () {
          var e = r(A.mark(function e(t) {
            var n, r, o;
            return A.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    n = t.fieldName, r = t.isEmpty, o = t.isFocus, a.changeFormItemsInfo({
                      fieldName: n,
                      status: {
                        isEmpty: r,
                        isFocus: o
                      }
                    });
                  case 2:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()), h(this, "onFieldValidChange", function (e) {
          var t = e.fieldName,
            n = e.isEmpty,
            r = e.isValid,
            o = a.formItemInfo[t].validateResult;
          o.isEmpty === n && o.isValid === r || Fn.reportData("onFieldValidChange", {
            fieldName: t,
            isEmpty: n,
            isValid: r
          }), a.changeFormItemsInfo({
            fieldName: t,
            status: {
              isEmpty: n,
              isValid: r
            }
          }), e.isEmpty && a.handleError(t, "");
        }), h(this, "onBrandChange", function (e) {
          var t = e.brand;
          t && "Other" !== t ? (a.card.cardBrand = t, Tp(a.container, t)) : (a.card.cardBrand = "", Tp(a.container, ""));
        }), h(this, "onCardBinChange", function () {
          var e = r(A.mark(function e(t) {
            var n, r, o, i, c, s, u;
            return A.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return r = null !== (n = null == t ? void 0 : t.binInfo) && void 0 !== n ? n : {}, o = r.brand, i = r.bin, a.card.binInfo = r, e.next = 5, a.cardBrandChecker.check({
                      brand: o,
                      bin: i
                    });
                  case 5:
                    if (c = e.sent, !c.drop) {
                      e.next = 9;
                      break;
                    }
                    return e.abrupt("return");
                  case 9:
                    return e.next = 11, a.cardBrandChecker.validate();
                  case 11:
                    s = e.sent, u = s.errorTips, Fn.reportData("onCardBinChange", {
                      brand: o,
                      bin: i,
                      errorTips: u
                    }), a.changeFormItemsInfo({
                      fieldName: Ve.Number,
                      errorTips: u
                    });
                  case 15:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()), h(this, "handleInteraction", function () {
          var e = r(A.mark(function e(t) {
            var n, r, o, i, c, s, u, l, p, d, f, h, y, m, v, g, b, w;
            return A.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (i = t.fieldName, c = t.status, s = t.errorTips, u = a.formItemInfo[i].validateResult, l = (null == c ? void 0 : c.isValid) || u.isValid, p = (null == c ? void 0 : c.isEmpty) || u.isEmpty, d = (null == c ? void 0 : c.isFocus) || u.isFocus, !s) {
                      e.next = 8;
                      break;
                    }
                    return a.handleError(i, s), e.abrupt("return");
                  case 8:
                    return f = null === (n = a.container.querySelector("#pci-input-".concat(i, "-content"))) || void 0 === n ? void 0 : n.parentElement, h = null == f ? void 0 : f.getAttribute("class"), y = !1, p && !d || null !== (r = h) && void 0 !== r && r.includes("pci-input-box-not-empty") ? !d && p && null !== (o = h) && void 0 !== o && o.includes("pci-input-box-not-empty") && (h = h.replace(" pci-input-box-not-empty", "")) : h += " pci-input-box-not-empty", d ? (Mp(a.container, a.formItemInfo), null !== (m = h) && void 0 !== m && m.includes("pci-input-box-focus") || (h += " pci-input-box-focus"), a.handleError(i, ""), y = !0) : (y = !1, h = null === (v = h) || void 0 === v ? void 0 : v.replace(" pci-input-box-focus", "")), i === Ve.FirstName && jp({
                      container: a.container,
                      id: "pci-input-name-tip",
                      type: "tip",
                      className: "pci-input-tip-show",
                      show: y,
                      contentClassName: "pci-input-valid-error-box"
                    }), g = "", e.next = 17, a.cardBrandChecker.validate();
                  case 17:
                    if (b = e.sent, d || p) {
                      e.next = 33;
                      break;
                    }
                    if (w = !1, i !== Ve.Number || b.success) {
                      e.next = 25;
                      break;
                    }
                    w = !1, g = b.errorTips, e.next = 32;
                    break;
                  case 25:
                    if (!l) {
                      e.next = 29;
                      break;
                    }
                    w = !0, e.next = 32;
                    break;
                  case 29:
                    return e.next = 31, null == zl ? void 0 : zl.get("formItems.".concat(i, ".errorTips"));
                  case 31:
                    g = e.sent;
                  case 32:
                    w ? a.handleError(i, "") : a.handleError(i, g || "");
                  case 33:
                    null == f || f.setAttribute("class", h || "");
                  case 34:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()), h(this, "changeFormItemsInfo", function () {
          var e = r(A.mark(function e(t) {
            var n, r;
            return A.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return n = t.fieldName, r = t.status, a.formItemInfo[n].validateResult = Yp(Yp({}, a.formItemInfo[n].validateResult), r), e.next = 4, a.handleInteraction(t);
                  case 4:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()), h(this, "validate", r(A.mark(function e() {
          var t, n, r, o, i, c, s, u, l, p;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (t = !0, !(n = a.formItems)) {
                    e.next = 33;
                    break;
                  }
                  return e.next = 5, a.cardBrandChecker.validate();
                case 5:
                  r = e.sent, o = Xp(n), e.prev = 7, o.s();
                case 9:
                  if ((i = o.n()).done) {
                    e.next = 25;
                    break;
                  }
                  if (c = i.value, s = a.formItemInfo[c].validateResult, u = "", !s.isEmpty && s.isValid) {
                    e.next = 21;
                    break;
                  }
                  return e.next = 16, null == zl ? void 0 : zl.get("formItems.".concat(c, ".errorTips"));
                case 16:
                  u = e.sent, Fn.reportData("validate_fieldValue_failed", Yp(Yp({
                    filedName: c
                  }, s), {}, {
                    errorTips: u
                  })), t = !1, e.next = 22;
                  break;
                case 21:
                  c !== Ve.Number || r.success || (l = r.skip, u = r.errorTips, Fn.reportData("validate_carBrandCheck_failed", {
                    filedName: c,
                    isSkipCardBrandValidate: l,
                    errorTips: u
                  }), l || (t = !1));
                case 22:
                  a.handleError(c, u || "");
                case 23:
                  e.next = 9;
                  break;
                case 25:
                  e.next = 30;
                  break;
                case 27:
                  e.prev = 27, e.t0 = e["catch"](7), o.e(e.t0);
                case 30:
                  return e.prev = 30, o.f(), e.finish(30);
                case 33:
                  if (!t) {
                    e.next = 38;
                    break;
                  }
                  return e.next = 36, a.pciSdk.validate(n)["catch"](function (e) {
                    return Fn.handleError(e, "pci_validate_error");
                  });
                case 36:
                  p = e.sent, t = Boolean(p);
                case 38:
                  return e.abrupt("return", t);
                case 39:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[7, 27, 30, 33]]);
        }))), h(this, "setErrorByCode", function () {
          var e = r(A.mark(function e(t) {
            var n, r, o, i;
            return A.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (null != (n = Up(t)) && n.key) {
                      e.next = 3;
                      break;
                    }
                    return e.abrupt("return");
                  case 3:
                    return r = n.name, o = n.key, e.next = 6, zl.get(o);
                  case 6:
                    (i = e.sent) && a.changeFormItemsInfo({
                      fieldName: r,
                      status: {
                        isValid: !1
                      },
                      errorTips: i
                    });
                  case 8:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()), h(this, "getBeforePayData", function () {
          var e = r(A.mark(function e(t) {
            return A.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", a.pciSdk.getBeforePayData(t));
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()), this.envConfig = t, this.initData = n, this.channelId = n.channelId, this.uuid = function (e) {
          var t = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
          e === yp.NOLINE && (t = t.replace(/[-]/g, ""));
          var n = new Date().getTime(),
            r = t.replace(/[xy]/g, function (e) {
              var t = (n + 16 * Math.random()) % 16 | 0;
              return n = Math.floor(n / 16), ("x" == e ? t : 3 & t | 8).toString(16);
            });
          return r;
        }(), this.pciSdk = new ft({
          env: t.env,
          channelId: this.channelId,
          eventTrackingConfig: Bn.getEventTrackingConfig(null == n ? void 0 : n.eventTrackingConfig)
        }), this.cardBrandChecker = new Kp({
          grayscaleConfig: null == c ? void 0 : c.grayscaleConfig,
          onBrandChange: this.onBrandChange,
          channelInfo: {
            merchantId: null == n ? void 0 : n.merchantId,
            channelId: null == n ? void 0 : n.channelId
          },
          envConfig: {
            host: this.envConfig.host
          }
        }), this.theme = new qt(n.theme), this.createEventListener();
      }
      var t, n, a, c, u, l;
      return s(e, [{
        key: "render",
        value: (l = r(A.mark(function e(t, n) {
          var r, o, i, a, c;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return this.container = t, t.setAttribute("ontouchstart", ""), this.mutationObserver(), r = this.theme.getStyle(k.CreditCard), o = this.theme.getInputIcon("footer"), i = o.imgSrc, a = o.svg, c = {
                    content: "div",
                    props: {
                      id: "pci-container",
                      "class": "pci-container sl-payment ".concat(this.isPc ? "pci-pc-style" : "pci-mobile-style"),
                      style: Sp ? r : void 0,
                      "ie-style": Sp ? void 0 : r
                    },
                    children: [{
                      content: "div",
                      props: {
                        "class": "pci-content"
                      },
                      children: {
                        content: "div",
                        props: {
                          "class": "pci-content-form pci-content-loading pci-content-form-".concat(this.uuid),
                          id: "pci-content-form"
                        },
                        children: Rp(n, {
                          borderType: this.theme.getCreditCardThemeValue("inputBorderType"),
                          labelPosition: this.theme.getCreditCardThemeValue("inputLabelPosition")
                        })
                      }
                    }, {
                      content: "div",
                      props: {
                        "class": "pci-footer pci-footer-loading",
                        id: "pci-footer"
                      },
                      children: [Lp({
                        imgSrc: i,
                        svg: a,
                        className: "pci-footer-icon"
                      }), {
                        content: "div",
                        props: {
                          "class": "pci-footer-tips"
                        }
                      }]
                    }]
                  }, e.next = 8, $l(c, t);
                case 8:
                  this.formItems = n;
                case 9:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t) {
          return l.apply(this, arguments);
        })
      }, {
        key: "updateRender",
        value: (u = r(A.mark(function e(t, n) {
          var r,
            o = this;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  this.container === t && (n.forEach(function (e) {
                    var t;
                    if (null === (t = o.formItems) || void 0 === t || !t.includes(e)) {
                      var n,
                        r = null === (n = o.container) || void 0 === n ? void 0 : n.querySelector("#pci-input-".concat(e, "-container"));
                      null == r || r.classList.remove("pci-input-container-hidden");
                    }
                  }), null === (r = this.formItems) || void 0 === r || r.forEach(function (e) {
                    if (!n.includes(e)) {
                      var t,
                        r = null === (t = o.container) || void 0 === t ? void 0 : t.querySelector("#pci-input-".concat(e, "-container"));
                      null == r || r.classList.add("pci-input-container-hidden");
                    }
                  })), this.formItems = Et(n), this.changeFormItemsInfo({
                    fieldName: Ve.Number
                  });
                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t) {
          return u.apply(this, arguments);
        })
      }, {
        key: "mutationObserver",
        value: function value() {
          var e = this,
            t = this.initData.needAdaptive,
            n = void 0 === t || t,
            r = i(n) === Ve.Number ? n : 600;
          this.isPc = this.container.offsetWidth >= Number(r);
          var o = null;
          if (!n && 0 !== n) return null;
          window.addEventListener("resize", function () {
            o && (clearTimeout(o), o = null), o = window.setTimeout(function () {
              var t = getComputedStyle(e.container).getPropertyValue("width").replace("px", "");
              e.needShowPcStyle(Number(t) > Number(r));
            }, 200);
          });
        }
      }, {
        key: "getCardToken",
        value: (c = r(A.mark(function e(t) {
          var n, r, o, i, a, c;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return r = (n = t || {}).resourceId, o = n.host, e.prev = 1, e.next = 4, this.pciSdk.getCardToken({
                    resourceId: r,
                    pciHost: o,
                    partnerId: Ke.SL2,
                    paymentMethod: "CreditCard"
                  });
                case 4:
                  return i = e.sent, a = JSON.stringify({
                    host: o,
                    token: null == i ? void 0 : i.token
                  }), c = Yp({
                    data: a,
                    type: D.SL_PCI
                  }, i), Fn.reportData("getCardToken", {
                    cardInfo: c
                  }), e.abrupt("return", c);
                case 11:
                  e.prev = 11, e.t0 = e["catch"](1), Fn.handleError(e.t0, "getCardToken_error");
                case 14:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[1, 11]]);
        })), function (e) {
          return c.apply(this, arguments);
        })
      }, {
        key: "pay",
        value: (a = r(A.mark(function e(t, n, r) {
          var o, i, a, c, s, u, l, p;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return o = this.initData, i = o.paymentMethod, a = o.channelId, e.next = 3, this.beforePay()["catch"](Fn.handleError);
                case 3:
                  if (e.t0 = e.sent, e.t0) {
                    e.next = 6;
                    break;
                  }
                  e.t0 = null;
                case 6:
                  if (c = e.t0, e.prev = 7, !(s = t.pciInfo)) {
                    e.next = 13;
                    break;
                  }
                  return e.next = 12, this.getCardToken(s);
                case 12:
                  u = e.sent;
                case 13:
                  return e.next = 15, Ep(t, {
                    cardInfo: u,
                    payOptions: r,
                    extraParams: n,
                    paymentMethod: i,
                    beforePayData: c,
                    channelId: a,
                    binInfo: this.card.binInfo
                  });
                case 15:
                  return e.abrupt("return", e.sent);
                case 18:
                  if (e.prev = 18, e.t1 = e["catch"](7), null === (l = e.t1.data) || void 0 === l || !l.code) {
                    e.next = 23;
                    break;
                  }
                  return e.next = 23, this.setErrorByCode((null === (p = e.t1.data) || void 0 === p ? void 0 : p.code) || "");
                case 23:
                  Fn.handleError(e.t1);
                case 24:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[7, 18]]);
        })), function (e, t, n) {
          return a.apply(this, arguments);
        })
      }, {
        key: "beforePay",
        value: (n = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if ("WorldPay" !== this.channelId) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return", this.worldPayBeforePay());
                case 2:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return n.apply(this, arguments);
        })
      }, {
        key: "worldPayBeforePay",
        value: (t = r(A.mark(function e() {
          var t, n, r, o, i, a, c, s, u, l, p, d, f;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return l = function l(e) {
                    return !(null == e || !e.type);
                  }, t = this.initData, n = t.merchantId, r = t.paymentMethod, o = t.channelId, i = {
                    merchantId: n,
                    paymentMethod: r,
                    channelId: o
                  }, a = "".concat(this.envConfig.host, "/v1/api/cashier/channel/info"), e.next = 6, sr.post(a, i)["catch"](function (e) {
                    return Fn.handleError(e, "cashier_channel_info_error", {
                      url: a,
                      request: {
                        params: i
                      },
                      response: {
                        error: e
                      }
                    });
                  });
                case 6:
                  if (c = e.sent, s = null == c ? void 0 : c.data, u = null == s ? void 0 : s.type, !l(s) || u !== _.Confirm) {
                    e.next = 13;
                    break;
                  }
                  return e.abrupt("return", s);
                case 13:
                  if (!l(s) || u !== _.WorldPayGather) {
                    e.next = 20;
                    break;
                  }
                  return e.next = 16, this.pciSdk.getBeforePayData(s)["catch"](function (e) {
                    Fn.handleError(e, "cashier_pci_ddc_error", {
                      response: {
                        error: e
                      }
                    });
                  });
                case 16:
                  return p = e.sent, e.abrupt("return", Yp(Yp({}, p), {}, {
                    type: u
                  }));
                case 20:
                  throw d = "'NextAction' type not support: ".concat(u), (f = new Yt(d, Vt.InnerSDKError, "NextActionTypeNotSupport")).data = {
                    code: Vt.InnerSDKError,
                    msg: d
                  }, f;
                case 24:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return t.apply(this, arguments);
        })
      }]), e;
    }(),
    Qp = function () {
      function e(t, n, i) {
        var a = this;
        o(this, e), h(this, "pciModule", null), h(this, "container", null), h(this, "insertLanguage", r(A.mark(function e() {
          var t;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", null === (t = a.pciModule) || void 0 === t ? void 0 : t.insertLanguage());
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }))), h(this, "removeLoading", r(A.mark(function e() {
          var t;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", null === (t = a.pciModule) || void 0 === t ? void 0 : t.removeLoading());
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }))), this.env = t, this.initData = n, this.initResult = null == i ? void 0 : i.initResult;
      }
      var t, n, i, a;
      return s(e, [{
        key: "beforeRender",
        value: (a = r(A.mark(function e(t) {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  this.container = t, this.pciModule = new $p(this.env, this.initData, {
                    initResult: this.initResult
                  });
                case 2:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return a.apply(this, arguments);
        })
      }, {
        key: "render",
        value: (i = r(A.mark(function e(t) {
          var n, r, o, i;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return this.beforeRender(t), e.abrupt("return", null === (n = this.pciModule) || void 0 === n ? void 0 : n.render(t, Ot(null === (r = this.initResult) || void 0 === r || null === (o = r.channelInfo) || void 0 === o || null === (i = o.data) || void 0 === i ? void 0 : i.notCollectCardHolderNameFlag)));
                case 2:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return i.apply(this, arguments);
        })
      }, {
        key: "validate",
        value: (n = r(A.mark(function e() {
          var t;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", null === (t = this.pciModule) || void 0 === t ? void 0 : t.validate());
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return n.apply(this, arguments);
        })
      }, {
        key: "pay",
        value: (t = r(A.mark(function e(t, n, r) {
          var o;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, null === (o = this.pciModule) || void 0 === o ? void 0 : o.pay(t, n, r);
                case 2:
                  return e.abrupt("return", e.sent);
                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, n, r) {
          return t.apply(this, arguments);
        })
      }]), e;
    }();
  function ed(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = f(e);
      if (t) {
        var o = f(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);
      return d(this, n);
    };
  }
  var td = function (e) {
    p(i, e);
    var t,
      n = ed(i);
    function i() {
      return o(this, i), n.apply(this, arguments);
    }
    return s(i, [{
      key: "render",
      value: (t = r(A.mark(function e(t) {
        var n, r, o, i;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return this.beforeRender(t), e.abrupt("return", null === (n = this.pciModule) || void 0 === n ? void 0 : n.render(t, Ot(null === (r = this.initResult) || void 0 === r || null === (o = r.channelInfo) || void 0 === o || null === (i = o.data) || void 0 === i ? void 0 : i.notCollectCardHolderNameFlag)));
              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }]), i;
  }(Qp);
  function nd(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function rd(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? nd(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nd(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var od = function () {
      function e(t, n) {
        o(this, e), h(this, "containerElement", null), h(this, "pciUiInstance", null), this.env = t, this.initData = n;
      }
      var t, n, i, a;
      return s(e, [{
        key: "validate",
        value: (a = r(A.mark(function e() {
          var t, n;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, null === (t = this.pciUiInstance) || void 0 === t ? void 0 : t.validate();
                case 2:
                  return n = e.sent, e.abrupt("return", Boolean(n));
                case 4:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return a.apply(this, arguments);
        })
      }, {
        key: "pay",
        value: (i = r(A.mark(function e(t, n, r) {
          var o;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, null === (o = this.pciUiInstance) || void 0 === o ? void 0 : o.pay(t, n, r);
                case 2:
                  return e.abrupt("return", e.sent);
                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t, n) {
          return i.apply(this, arguments);
        })
      }, {
        key: "render",
        value: (n = r(A.mark(function e(t, n) {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!(!t && !this.containerElement || t && this.containerElement)) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return");
                case 2:
                  return this.containerElement = t, this.pciUiInstance = new td(this.env, rd({}, this.initData), {
                    initResult: n
                  }), e.next = 6, this.pciUiInstance.render(t)["catch"](function (e) {
                    Fn.handleError(e, "pci_render_error");
                  });
                case 6:
                  return e.next = 8, this.pciUiInstance.insertLanguage()["catch"](Fn.handleError);
                case 8:
                  return e.next = 10, this.pciUiInstance.removeLoading();
                case 10:
                  return e.abrupt("return", Pp());
                case 11:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t) {
          return n.apply(this, arguments);
        })
      }, {
        key: "destroy",
        value: function value() {
          this.containerElement && (this.containerElement.innerHTML = ""), this.pciUiInstance = null;
        }
      }, {
        key: "needRenderWidget",
        value: (t = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", !0);
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function () {
          return t.apply(this, arguments);
        })
      }, {
        key: "updateInitData",
        value: function value(e) {}
      }]), e;
    }(),
    id = function () {
      function e(t, n) {
        o(this, e), this.initData = n, this.reporter = new Hn(n);
      }
      var t, n;
      return s(e, [{
        key: "validate",
        value: (n = r(A.mark(function e() {
          var t;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", null !== (t = this.cardInfo) && void 0 !== t && t.token ? Promise.resolve(!0) : Promise.reject(new Error("cardToken is required.")));
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return n.apply(this, arguments);
        })
      }, {
        key: "pay",
        value: (t = r(A.mark(function e(t, n, r) {
          var o, i, a, c;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return o = this.initData, i = o.paymentMethod, a = o.channelId, e.prev = 1, e.next = 4, Ep(t, {
                    cardInfo: this.cardInfo,
                    payOptions: r,
                    extraParams: n,
                    paymentMethod: i,
                    channelId: a
                  });
                case 4:
                  return c = e.sent, e.abrupt("return", c);
                case 8:
                  return e.prev = 8, e.t0 = e["catch"](1), this.reporter.handleError(e.t0), e.abrupt("return", Promise.reject(e.t0));
                case 12:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[1, 8]]);
        })), function (e, n, r) {
          return t.apply(this, arguments);
        })
      }, {
        key: "render",
        value: function value() {
          return Promise.reject(new Error('headless mode should not call the "render" method.'));
        }
      }, {
        key: "destroy",
        value: function value() {
          return Promise.reject(new Error('headless mode should not call the "destroy" method.'));
        }
      }, {
        key: "needRenderWidget",
        value: function value() {
          return Promise.reject(new Error('headless mode should not call the "needRenderWidget" method.'));
        }
      }, {
        key: "updateInitData",
        value: function value(e) {
          this.cardInfo = e;
        }
      }]), e;
    }();
  tp(".sl-payment.payment-sdk-simple-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.sl-payment.payment-sdk-simple-container .payment-sdk-simple-image {\n  width: 137px;\n  height: auto;\n  max-width: 100%;\n}\n\n.sl-payment.payment-sdk-simple-container .payment-sdk-simple-space {\n  margin-top: 24px;\n}\n\n.sl-payment.payment-sdk-simple-container .payment-sdk-simple-text {\n  width: 100%;\n  text-align: center;\n  font-size: 12px;\n  line-height: 18px;\n  word-break: break-word;\n  color: var(--simple-font-color);\n}\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n}", {});
  var ad = function () {
      function e(t, n) {
        o(this, e), h(this, "container", null), h(this, "CONTAINER_ID", "payment-sdk-simple"), h(this, "descriptionConfig", {
          image: "https://cdn.myshopline.com/pay/fe-prod/payment-sdk/images/guide-simple.png",
          description: "simpleGuide"
        }), this.env = t, this.initData = n, this.theme = new qt(n.theme);
      }
      var t;
      return s(e, [{
        key: "getImageElement",
        value: function value() {
          return {
            content: "img",
            props: {
              "class": "payment-sdk-simple-image",
              src: this.descriptionConfig.image
            }
          };
        }
      }, {
        key: "getTextElement",
        value: function value(e) {
          return e ? {
            content: "div",
            props: {
              "class": "payment-sdk-simple-text payment-sdk-simple-space"
            },
            children: e
          } : null;
        }
      }, {
        key: "render",
        value: (t = r(A.mark(function e(t) {
          var n, r;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return this.container = t, n = this.theme.getStyle(k.Simple), e.next = 4, zl.get("".concat(this.initData.paymentMethod, "Guide"));
                case 4:
                  if (r = e.sent) {
                    e.next = 9;
                    break;
                  }
                  return e.next = 8, zl.get(this.descriptionConfig.description);
                case 8:
                  r = e.sent;
                case 9:
                  $l({
                    content: "div",
                    props: {
                      id: this.CONTAINER_ID,
                      "class": "sl-payment payment-sdk-simple-container",
                      style: Sp ? n : void 0,
                      "ie-style": Sp ? void 0 : n
                    },
                    children: [this.getImageElement(), this.getTextElement(r)]
                  }, t), Pp();
                case 12:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return t.apply(this, arguments);
        })
      }, {
        key: "destroy",
        value: function value() {
          var e;
          this.container && (null === (e = this.container.querySelector("#".concat(this.CONTAINER_ID))) || void 0 === e || e.remove());
        }
      }]), e;
    }(),
    cd = function () {
      function e(t, n) {
        o(this, e), h(this, "containerElement", null), h(this, "paymentMethodInfo", null), h(this, "simpleUI", null), h(this, "updateInitData", function () {
          throw new Error("SceneSimple does not need to call the updateInitData method");
        }), this.env = t, this.initData = n;
      }
      var t, n, i, a;
      return s(e, [{
        key: "validate",
        value: (a = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", !0);
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function () {
          return a.apply(this, arguments);
        })
      }, {
        key: "setPaymentMethodInfo",
        value: function value(e) {
          e && (this.paymentMethodInfo = e);
        }
      }, {
        key: "render",
        value: (i = r(A.mark(function e(t) {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (t || this.containerElement) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return");
                case 2:
                  return t && (this.containerElement = t), this.simpleUI = new ad(this.env, this.initData), e.next = 6, this.simpleUI.render(this.containerElement);
                case 6:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return i.apply(this, arguments);
        })
      }, {
        key: "pay",
        value: (n = r(A.mark(function e(t, n, r) {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Ep(t, {
                    payOptions: r,
                    paymentMethod: this.initData.paymentMethod,
                    extraParams: n
                  }));
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t, r) {
          return n.apply(this, arguments);
        })
      }, {
        key: "destroy",
        value: function value() {
          this.simpleUI && (this.simpleUI.destroy(), this.simpleUI = null);
        }
      }, {
        key: "needRenderWidget",
        value: (t = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", !0);
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function () {
          return t.apply(this, arguments);
        })
      }]), e;
    }();
  tp(".sl-payment.payment-sdk-block-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n}\n\n.sl-payment.payment-sdk-block-container .block-img {\n  width: 200px;\n  height: 113px;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  margin-bottom: 16px;\n  color: var(--block-img-color);\n}\n\n.sl-payment.payment-sdk-block-container .block-tips {\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--block-font-color);\n}\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n}\n", {});
  var sd = "payment-sdk-block-container",
    ud = function () {
      function e(t, n) {
        var i = this;
        o(this, e), h(this, "mount", function () {
          var e = r(A.mark(function e(t, n) {
            var r, o;
            return A.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return Fn.addReportData(n), i.container = t, e.next = 4, zl.get("paymentMethodNotSupported")["catch"](function (e) {
                      return Fn.handleError(e);
                    });
                  case 4:
                    r = e.sent, o = i.theme.getStyle(k.Block), $l({
                      content: "div",
                      props: {
                        "class": "".concat(sd, " sl-payment"),
                        style: Sp ? o : void 0,
                        "ie-style": Sp ? void 0 : o
                      },
                      children: [{
                        content: "div",
                        props: {
                          "class": "block-img",
                          innerHTML: Mt
                        }
                      }, {
                        content: "div",
                        props: {
                          "class": "block-tips"
                        },
                        children: r
                      }]
                    }, t), Pp();
                  case 9:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t, n) {
            return e.apply(this, arguments);
          };
        }()), this.env = t, this.theme = new qt(n);
      }
      return s(e, [{
        key: "destroy",
        value: function value() {
          if (this.container) {
            var e = this.container.querySelector(".".concat(sd));
            e && e.remove();
          }
        }
      }]), e;
    }();
  function ld() {
    var e = navigator.userAgent,
      t = -1 !== e.indexOf("MSIE"),
      n = /Windows\sNT ([0-9.]+).*?Trident\/7\.0.*rv:([0-9.]+).*\).*Gecko$/.exec(e),
      r = n ? Number(n[1]) : null,
      o = n ? Number(n[2]) : null;
    return t || !!(n && o && o <= 11 && r && r <= 7);
  }
  function pd(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function dd(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? pd(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pd(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  e.PluginScene = void 0, (e.PluginScene || (e.PluginScene = {})).PCI = "pci";
  var fd,
    hd,
    yd,
    md,
    vd,
    gd = function gd(e, t) {
      return Boolean(((null == e ? void 0 : e.info.channelId) && e.info.channelId === t.channelId || (null == e ? void 0 : e.info.accessMode) && e.info.accessMode === t.accessMode) && e.info.paymentMethod && e.info.paymentMethod === t.paymentMethod);
    },
    bd = function () {
      function t(e, n) {
        var r = this;
        o(this, t), h(this, "containerElement", null), h(this, "plugin", null), h(this, "subScene", null), h(this, "blockRender", null), h(this, "updateInitData", function (e) {
          r.applyHook("updateInitData", e);
        }), this.initData = n, this.config = e, this.theme = new qt(n.theme), this.findPlugin(), Fn.reportData("plugin_init");
      }
      var n, i, a, c, u, l, p, d, f, y;
      return s(t, [{
        key: "findPlugin",
        value: function value() {
          var t = this.initData.plugins;
          if (t && Array.isArray(t)) for (var n = t.length, r = 0; r < n; r++) {
            var o = t[r],
              i = Array.isArray(o),
              a = i ? o[0] : o,
              c = i ? o[1] : void 0;
            if (gd(a, this.initData) && !this.plugin) {
              if (this.plugin = new a(dd(dd({}, c), {}, {
                reporter: Fn,
                envConfig: this.config,
                initData: this.initData
              })), a.info.scene === e.PluginScene.PCI) {
                if (ld()) throw Fn.reportData("plugin_not_support_browser"), new Yt("The browser version is too low and incompatible, payment failed", Vt.NotSupportBrowser, "NotSupportBrowser");
                this.subScene = this.initData.headless ? new id(this.config, this.initData) : new od(this.config, this.initData);
              }
              break;
            }
          }
        }
      }, {
        key: "applyHook",
        value: (y = r(A.mark(function e(t) {
          var n,
            r,
            o,
            i,
            a,
            c,
            s,
            u,
            l = arguments;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.plugin) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return");
                case 2:
                  for (e.prev = 2, Fn.reportData("plugin_applyHook_".concat(t, "_start")), r = l.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) {
                    o[i - 1] = l[i];
                  }
                  if (!this.subScene || !this.subScene[t]) {
                    e.next = 11;
                    break;
                  }
                  return e.next = 8, (a = this.subScene)[t].apply(a, o);
                case 8:
                  n = e.sent, e.next = 16;
                  break;
                case 11:
                  if (!this.plugin || !this.plugin[t]) {
                    e.next = 16;
                    break;
                  }
                  return s = (o || []).map(function (e) {
                    return $n(e);
                  }), e.next = 15, (c = this.plugin)[t].apply(c, Et(s));
                case 15:
                  n = e.sent;
                case 16:
                  return Fn.reportData("plugin_applyHook_".concat(t, "_end")), e.abrupt("return", n);
                case 20:
                  e.prev = 20, e.t0 = e["catch"](2), u = "plugin_applyHook_".concat(t, "_error"), Fn.reportData(u), Fn.handleError(e.t0, u);
                case 25:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[2, 20]]);
        })), function (e) {
          return y.apply(this, arguments);
        })
      }, {
        key: "needRenderWidget",
        value: (f = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", !0);
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function () {
          return f.apply(this, arguments);
        })
      }, {
        key: "beforeInit",
        value: (d = r(A.mark(function e(t) {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, this.applyHook("beforeInit", t);
                case 2:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return d.apply(this, arguments);
        })
      }, {
        key: "afterInit",
        value: (p = r(A.mark(function e(t, n) {
          var r, o;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return Fn.reportData("plugin_scene_afterInit_start"), r = this.theme.getTheme(), e.next = 4, zl.getData();
                case 4:
                  return o = e.sent, e.t0 = this, e.t1 = Object, e.t2 = {}, e.t3 = t, e.t4 = r, e.next = 12, zl.getDisplayLanguage();
                case 12:
                  return e.t5 = e.sent, e.t6 = o, e.t7 = this.config.env, e.t8 = this.config.host, e.t9 = this.initData.clientId, e.t10 = {
                    theme: e.t4,
                    displayLanguage: e.t5,
                    languageObj: e.t6,
                    env: e.t7,
                    host: e.t8,
                    clientId: e.t9
                  }, e.t11 = e.t1.assign.call(e.t1, e.t2, e.t3, e.t10), e.t12 = null == n ? void 0 : n.channelInfo, e.t13 = n, e.next = 23, e.t0.applyHook.call(e.t0, "afterInit", e.t11, e.t12, e.t13);
                case 23:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t) {
          return p.apply(this, arguments);
        })
      }, {
        key: "render",
        value: (l = r(A.mark(function e(t, n) {
          var r, o;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return r = t, "string" == typeof t && (r = document.querySelector(t)), t && (this.containerElement = r), e.prev = 3, e.next = 6, this.applyHook("beforeRender", t);
                case 6:
                  return e.next = 8, this.applyHook("render", t, n);
                case 8:
                  e.next = 18;
                  break;
                case 10:
                  return e.prev = 10, e.t0 = e["catch"](3), o = new ud(this.config, this.initData.theme), this.blockRender = o, e.next = 16, o.mount(r, this.initData);
                case 16:
                  Fn.reportData("plugin_applyHook_render_error"), Fn.handleError(e.t0);
                case 18:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[3, 10]]);
        })), function (e, t) {
          return l.apply(this, arguments);
        })
      }, {
        key: "validate",
        value: (u = r(A.mark(function e() {
          var t;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!this.blockRender) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return", !1);
                case 2:
                  return e.next = 4, this.applyHook("validate");
                case 4:
                  return t = e.sent, e.abrupt("return", Boolean(t));
                case 6:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return u.apply(this, arguments);
        })
      }, {
        key: "getNextAction",
        value: (c = r(A.mark(function e(t, n, r) {
          var o, i;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.prev = 0, o = this.createHooks(["beforeConfirm", "extendConfirmParams", "afterConfirm", "handlePayAction"]), i = dd(dd({}, r), {}, {
                    hooks: o
                  }), e.next = 5, Ep(t, {
                    payOptions: i,
                    paymentMethod: this.initData.paymentMethod,
                    extraParams: n,
                    isOnceAction: !0
                  });
                case 5:
                  return e.abrupt("return", e.sent);
                case 8:
                  e.prev = 8, e.t0 = e["catch"](0), Fn.handleError(e.t0, "plugin_getNextAction_error");
                case 11:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[0, 8]]);
        })), function (e, t, n) {
          return c.apply(this, arguments);
        })
      }, {
        key: "afterSubmit",
        value: (a = r(A.mark(function e(t) {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, this.applyHook("afterSubmit", t);
                case 2:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return a.apply(this, arguments);
        })
      }, {
        key: "pay",
        value: (i = r(A.mark(function e(t, n, r) {
          var o;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (e.prev = 0, o = this.createHooks(["beforeConfirm", "extendConfirmParams", "afterConfirm", "handlePayAction"]), r && (r.hooks = o), !this.subScene || !this.subScene.pay) {
                    e.next = 5;
                    break;
                  }
                  return e.abrupt("return", this.subScene.pay(t, n, r));
                case 5:
                  return e.next = 7, Ep(t, {
                    payOptions: r,
                    paymentMethod: this.initData.paymentMethod,
                    extraParams: n
                  });
                case 7:
                  return e.abrupt("return", e.sent);
                case 10:
                  e.prev = 10, e.t0 = e["catch"](0), Fn.handleError(e.t0, "plugin_pay_error");
                case 13:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[0, 10]]);
        })), function (e, t, n) {
          return i.apply(this, arguments);
        })
      }, {
        key: "createHooks",
        value: function value(e) {
          var t = this,
            n = {};
          return e.map(function (e) {
            n[e] = function () {
              var n = r(A.mark(function n(r) {
                return A.wrap(function (n) {
                  for (;;) {
                    switch (n.prev = n.next) {
                      case 0:
                        return n.next = 2, t.applyHook(e, r);
                      case 2:
                        return n.abrupt("return", n.sent);
                      case 3:
                      case "end":
                        return n.stop();
                    }
                  }
                }, n);
              }));
              return function (e) {
                return n.apply(this, arguments);
              };
            }();
          }), n;
        }
      }, {
        key: "destroy",
        value: (n = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!this.blockRender) {
                    e.next = 5;
                    break;
                  }
                  this.blockRender.destroy(), Fn.reportData("plugin_destroy_block_fail"), e.next = 7;
                  break;
                case 5:
                  return e.next = 7, this.applyHook("destroy", this.containerElement);
                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return n.apply(this, arguments);
        })
      }], [{
        key: "checkHasPlugin",
        value: function value(e) {
          var t = e.plugins;
          if (!t || !Array.isArray(t)) return !1;
          for (var n = t.length, r = 0; r < n; r++) {
            var o = t[r],
              i = Array.isArray(o) ? o[0] : o;
            if (gd(i, e)) return !0;
          }
          return !1;
        }
      }]), t;
    }();
  tp('.sl-payment .form-content-loading {\n  width: 100%;\n}\n\n/* Skeleton screen */\n\n.sl-payment .form-content-loading .form-content-container-item,\n.sl-payment .form-content-loading .form-content-header,\n.sl-payment .form-content-loading .form-content-footer {\n  background-color: var(--input-font-color);\n  opacity: 0.05;\n  border-radius: var(--input-border-radius);\n  height: var(--input-height);\n}\n\n.sl-payment .form-content-loading .form-content-header,\n.sl-payment .form-content-loading .form-content-footer {\n  height: 20px;\n}\n\n/* Chrome, Safari, Edge, Opera */\n\n.sl-payment input::-webkit-outer-spin-button,\n.sl-payment input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.sl-payment input:-webkit-autofill,\n.sl-payment input:-webkit-autofill:focus {\n  -webkit-transition: background-color 600000s 0s, color 600000s 0s;\n  transition: background-color 600000s 0s, color 600000s 0s;\n  -webkit-box-shadow: none;\n}\n\n/* Firefox */\n\n.sl-payment input[type=\'number\'] {\n  -moz-appearance: textfield;\n}\n\n.sl-payment p {\n  margin: 0;\n}\n\n.sl-payment .form-content {\n  margin: 0;\n}\n\n.sl-payment .form-content {\n  max-width: 100%;\n  width: 100%;\n  margin: 0 auto;\n}\n\n/* header */\n\n.sl-payment .form-content-header {\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  color: rgba(44, 44, 44, 0.75);\n  margin-bottom: var(--form-item-gutter);\n}\n\n/* footer */\n\n.sl-payment .form-content-footer {\n  font-size: 12px;\n  line-height: 20px;\n  display: flex;\n  color: rgba(44, 44, 44, 0.5);\n  margin-top: 6px;\n}\n\n.sl-payment .form-content-footer svg,\n.sl-payment .form-content-footer img {\n  vertical-align: middle;\n}\n\n/** container */\n\n.sl-payment .form-content-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n  flex: 0 1 100%;\n}\n\n.sl-payment .form-content-container-item {\n  position: relative;\n  width: 100%;\n  overflow: visible;\n  transition: all 0.3s ease;\n}\n\n.sl-payment .form-content-container-item + .form-content-container-item {\n  margin-top: var(--form-item-gutter);\n}\n\n.sl-payment .form-content-container-item-focus .form-content-container-item-content {\n  box-shadow: 0 0 0 1px var(--input-focus-border-color);\n  border-color: var(--input-focus-border-color);\n}\n\n.sl-payment .form-content-container-item-error-box .form-content-container-item-content {\n  box-shadow: 0 0 0 1px var(--input-error-border-color);\n  border-color: var(--input-error-border-color);\n}\n\n.sl-payment .form-content-container-item-box {\n  flex: 1;\n  position: relative;\n  box-sizing: border-box;\n  z-index: 1;\n  height: var(--input-height);\n}\n\n.sl-payment .form-content-container-item-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n}\n\n.sl-payment .form-content-container-item-box-label {\n  position: absolute;\n  top: calc(var(--input-height) / 2 - var(--input-label-line-height) / 2);\n  font-size: 14px;\n  line-height: var(--input-label-line-height);\n  color: var(--input-label-color);\n  pointer-events: none;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n[ecp-dir="ltr"] .sl-payment .form-content-container-item-box-label {\n  left: var(--form-input-padding-left);\n}\n\n[ecp-dir="rtl"] .sl-payment .form-content-container-item-box-label {\n  right: var(--form-input-padding-left);\n}\n\n.sl-payment .form-content-container-item-error-tip {\n  color: var(--input-error-font-color);\n}\n\n/** AddonBefore AddonAfter */\n\n.sl-payment .form-content-container-item-content {\n  display: flex;\n  height: var(--input-height);\n  border-width: 1px;\n  border-style: solid;\n  border-color: var(--input-border-color);\n  border-radius: var(--input-border-radius);\n  background-color: var(--input-background);\n  box-sizing: border-box;\n  transition: box-shadow 0.2s ease-in-out, border 0.2s ease-in-out;\n}\n\n.sl-payment .form-content-container-item-content.form-content-container-item-content-block_end {\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n  border-radius: 0;\n}\n\n.sl-payment .form-content-container-item-focus .form-content-container-item-content-block_end {\n  box-shadow: 0 1px 0 0 var(--input-focus-border-color);\n}\n\n.sl-payment .form-content-container-item-error-box .form-content-container-item-content-block_end {\n  box-shadow: 0 1px 0 0 var(--input-error-border-color);\n}\n\n.sl-payment .form-content-container-item-content-none {\n  border-color: transparent;\n}\n\n.sl-payment .form-content-container-item-content-label {\n  font-size: 12px;\n  margin-bottom: 8px;\n  display: inline-block;\n  line-height: var(--input-label-line-height);\n  color: var(--input-label-color);\n  white-space: nowrap;\n}\n\n.sl-payment .form-content-container-item-AddonBefore .form-content-container-item-content {\n  margin-bottom: 0;\n}\n\n[ecp-dir="ltr"] .sl-payment .form-content-container-item-AddonBefore .form-content-container-item-content {\n  margin-right: -4px;\n  border-right: 0;\n}\n\n[ecp-dir="rtl"] .sl-payment .form-content-container-item-AddonBefore .form-content-container-item-content {\n  margin-left: -4px;\n  border-left: 0;\n}\n\n.sl-payment .form-content-container-item-AddonBefore + .form-content-container-item-box::before {\n  content: \'\';\n  position: absolute;\n  display: block;\n  width: 1px;\n  height: calc(var(--input-height) / 2);\n  z-index: 2;\n  background: var(--input-border-color);\n  top: 0;\n  bottom: 0;\n  margin: auto;\n}\n\n[ecp-dir="ltr"] .sl-payment .form-content-container-item-AddonBefore + .form-content-container-item-box::before {\n  left: 0;\n}\n\n[ecp-dir="rtl"] .sl-payment .form-content-container-item-AddonBefore + .form-content-container-item-box::before {\n  right: 0;\n}\n\n/** error-tip */\n\n.sl-payment .form-content-container-item-tip {\n  height: 0;\n  font-size: 14px;\n  line-height: 16px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  margin-top: var(--input-tip-gutter);\n  margin-top: var(--input-tip-gutter);\n  color: var(--input-tip-color);\n}\n\n[ecp-dir="ltr"] .sl-payment .form-content-container-item-tip {\n  margin-left: 1px;\n}\n\n[ecp-dir="rtl"] .sl-payment .form-content-container-item-tip {\n  margin-right: 1px;\n}\n\n.sl-payment .form-content-container-item:not(.form-content-container-item-error-box)\n  .form-content-container-item-tip {\n  margin-top: 0;\n}\n\n.sl-payment .form-content-container-item-error-box .form-content-container-item-tip {\n  color: var(--input-error-font-color);\n}\n\n/** Hide */\n\n.sl-payment .hidden {\n  display: none;\n}\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n}\n', {}), function (e) {
    e.Input = "input", e.Select = "select", e.Label = "label";
  }(fd || (fd = {})), function (e) {
    e.String = "string", e.Number = "number", e.PhoneNumber = "PhoneNumber", e.Multiple = "Multiple";
  }(hd || (hd = {})), function (e) {
    e.Succeed = "Succeed", e.Failed = "Failed";
  }(yd || (yd = {})), function (e) {
    e.AddonBefore = "AddonBefore", e.AddonAfter = "AddonAfter";
  }(md || (md = {})), function (e) {
    e.Focus = "focus", e.Input = "input", e.Composition = "composition";
  }(vd || (vd = {}));
  var wd = function wd(e, t, n) {
      return e === hd.Number || e === hd.PhoneNumber ? function (e, t) {
        return up(e) ? "" : e.replace(/[^\d]/g, "").slice(0, (null == t ? void 0 : t.max) || 0);
      }(t, n) : t;
    },
    kd = function kd(e, t, n) {
      var r, o;
      return {
        messageKey: null !== (r = e.messageKey) && void 0 !== r ? r : "",
        message: null !== (o = e.message) && void 0 !== o ? o : "",
        value: t,
        key: n
      };
    },
    xd = function xd(e, t, n) {
      e.required && up(t) && n.push(kd(e, t, "required"));
    },
    Od = function Od(e) {
      return !up(e) && "number" == typeof e;
    },
    _d = function _d(e, t, n) {
      var r = 0;
      if (r = Array.isArray(t) ? t.length : function (e, t) {
        return "string" == typeof t || "string" === e.type;
      }(e, t) ? String(t).length : Number(t), Od(r)) {
        var o = e.min,
          i = e.max;
        Od(o) && r < o && n.push(kd(e, t, "min")), Od(i) && r > i && n.push(kd(e, t, "max"));
      }
    },
    Cd = function Cd(e, t, n) {
      up(e.startWith) || Array.isArray(t) || 0 === String(t).indexOf(String(e.startWith)) || n.push(kd(e, t, "startWith"));
    },
    Ed = function Ed(e, t, n) {
      e.validator && "function" == typeof e.validator && !e.validator(t) && n.push(kd(e, t, "validator"));
    },
    Id = Object.freeze({
      __proto__: null,
      required: xd,
      range: _d,
      startWith: Cd,
      custom: Ed
    });
  function Sd(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Pd(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Sd(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Sd(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function Dd(e, t) {
    var _n5 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!_n5) {
      if (Array.isArray(e) || (_n5 = function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return jd(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return jd(e, t);
      }(e)) || t && e && "number" == typeof e.length) {
        _n5 && (e = _n5);
        var r = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return r >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[r++]
            };
          },
          e: function e(_e8) {
            throw _e8;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var i,
      a = !0,
      c = !1;
    return {
      s: function s() {
        _n5 = _n5.call(e);
      },
      n: function n() {
        var e = _n5.next();
        return a = e.done, e;
      },
      e: function e(_e9) {
        c = !0, i = _e9;
      },
      f: function f() {
        try {
          a || null == _n5["return"] || _n5["return"]();
        } finally {
          if (c) throw i;
        }
      }
    };
  }
  function jd(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }
    return r;
  }
  var Td,
    Ad,
    Rd = function Rd(e) {
      var t,
        n = [];
      if (!Zn(t = e) || !Object.keys(t).length) return n;
      var r = function r() {
        xd.apply(Id, arguments), up(arguments.length <= 1 ? void 0 : arguments[1]) || (_d.apply(Id, arguments), Cd.apply(Id, arguments), Ed.apply(Id, arguments));
      };
      return r && n.push({
        rule: e,
        validator: r
      }), n;
    },
    Ld = function () {
      var e = r(A.mark(function e(t, n, r) {
        var o, i, a, c, s, u, l, p, d, f, h, y;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (o = (r || {}).first, i = [], Array.isArray(t) && t.length) {
                  e.next = 4;
                  break;
                }
                return e.abrupt("return", i);
              case 4:
                a = Dd(t), e.prev = 5, a.s();
              case 7:
                if ((c = a.n()).done) {
                  e.next = 34;
                  break;
                }
                if (s = c.value, u = Pd({}, s), (l = Rd(u)).length) {
                  e.next = 13;
                  break;
                }
                return e.abrupt("continue", 32);
              case 13:
                p = Dd(l), e.prev = 14, p.s();
              case 16:
                if ((d = p.n()).done) {
                  e.next = 24;
                  break;
                }
                return f = d.value, h = f.rule, y = f.validator, e.next = 20, y(h, n, i);
              case 20:
                if (!o || !i.length) {
                  e.next = 22;
                  break;
                }
                return e.abrupt("return", [i[0]]);
              case 22:
                e.next = 16;
                break;
              case 24:
                e.next = 29;
                break;
              case 26:
                e.prev = 26, e.t0 = e["catch"](14), p.e(e.t0);
              case 29:
                return e.prev = 29, p.f(), e.finish(29);
              case 32:
                e.next = 7;
                break;
              case 34:
                e.next = 39;
                break;
              case 36:
                e.prev = 36, e.t1 = e["catch"](5), a.e(e.t1);
              case 39:
                return e.prev = 39, a.f(), e.finish(39);
              case 42:
                return e.abrupt("return", i);
              case 43:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[5, 36, 39, 42], [14, 26, 29, 32]]);
      }));
      return function (t, n, r) {
        return e.apply(this, arguments);
      };
    }();
  !function (e) {
    e.EMPTY = "isEmpty", e.ERROR = "isError", e.FOCUS = "isFocus";
  }(Td || (Td = {})), function (e) {
    e.FIELD_STATUS_CHANGE = "fieldStatusChange", e.UPDATE = "update", e.VALIDATE = "validate";
  }(Ad || (Ad = {}));
  var Nd = function () {
      function e() {
        var t = this;
        o(this, e), h(this, "formData", {}), h(this, "dispatch", function (e, n) {
          var r,
            o,
            i = t.fieldRenderMap,
            a = n.name,
            c = n.payload;
          switch (e) {
            case Ad.FIELD_STATUS_CHANGE:
              null === (r = i[a]) || void 0 === r || r.onFieldStatusChange(a, c);
              break;
            case Ad.UPDATE:
              t.updateValue(a, c);
              break;
            case Ad.VALIDATE:
              null === (o = i[a]) || void 0 === o || o.onValidate(a, c);
          }
        }), h(this, "fieldRenderMap", {}), h(this, "registerFieldWatch", function (e, n) {
          t.fieldRenderMap[e] = n;
        }), h(this, "setFieldValue", function (e, n) {
          var r;
          null === (r = t.fieldRenderMap[e]) || void 0 === r || r.setFieldValue(e, n);
        }), h(this, "setFieldsValue", function (e) {
          var n = t.formData;
          Object.entries(e).forEach(function (e) {
            var r = Un(e, 2),
              o = r[0],
              i = r[1];
            o in n && t.setFieldValue(o, i);
          });
        }), h(this, "getFieldsValue", function () {
          return t.formData;
        }), h(this, "validateFields", r(A.mark(function e() {
          var n, r, o, i, a;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  n = t.fieldRenderMap, r = t.formData, o = !0, e.t0 = A.keys(n);
                case 3:
                  if ((e.t1 = e.t0()).done) {
                    e.next = 11;
                    break;
                  }
                  return i = e.t1.value, e.next = 7, null === (a = n[i]) || void 0 === a ? void 0 : a.onValidate(i, r[i] || "");
                case 7:
                  !1 === e.sent && (o = !1), e.next = 3;
                  break;
                case 11:
                  return e.abrupt("return", o);
                case 12:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })));
      }
      return s(e, [{
        key: "updateValue",
        value: function value(e, t) {
          this.formData[e] = t;
        }
      }]), e;
    }(),
    Md = "form-content-container-item",
    Bd = "form-content-container-item-focus",
    Fd = "form-content-container-item-not-empty",
    Hd = "form-content-container",
    Ud = function () {
      function e(t, n, r) {
        o(this, e), h(this, "render", function () {
          return null;
        }), this.data = t, this.formStore = n, this.isRTL = null == r ? void 0 : r.isRTL, this.renderOptions = r, this.name = t.name, n.formData[t.name] = "";
      }
      return s(e, [{
        key: "onRendered",
        value: function value(e) {}
      }, {
        key: "setValue",
        value: function value(e) {
          return !0;
        }
      }]), e;
    }();
  function Vd(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = f(e);
      if (t) {
        var o = f(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);
      return d(this, n);
    };
  }
  tp('.sl-payment .form-content-container-item-box-input {\n  height: 100%;\n  background-color: transparent;\n  color: var(--input-font-color);\n  font-family: var(--form-font-family);\n  outline: none;\n  width: 100%;\n  border: none;\n  font-size: 14px;\n  background: transparent;\n  box-sizing: border-box;\n}\n\n[ecp-dir="ltr"] .sl-payment .form-content-container-item-box-input {\n  padding: calc(\n      var(--form-input-padding-top) + var(--input-label-small-line-height) +\n        var(--input-label-gutter)\n    )\n    0 var(--form-input-padding-bottom) var(--form-input-padding-left);\n}\n\n[ecp-dir="rtl"] .sl-payment .form-content-container-item-box-input {\n  padding: calc(\n      var(--form-input-padding-top) + var(--input-label-small-line-height) +\n        var(--input-label-gutter)\n    )\n    var(--form-input-padding-left) var(--form-input-padding-bottom) 0;\n}\n\n[ecp-dir="ltr"] .sl-payment .form-content-container-item-box-input-outside {\n  padding: var(--form-input-padding-top) 0 var(--form-input-padding-bottom)\n    var(--form-input-padding-left);\n}\n\n[ecp-dir="rtl"] .sl-payment .form-content-container-item-box-input-outside {\n  padding: var(--form-input-padding-top) var(--form-input-padding-left) var(--form-input-padding-bottom)\n    0;\n}\n\n.sl-payment .form-content-container-item-not-empty .form-content-container-item-box-input {\n  transition: all 0.3s ease;\n  height: var(--input-height);\n}\n\n.sl-payment .form-content-container-item-not-empty .form-content-container-item-box-label {\n  font-size: var(--form-input-label-focus-font-size);\n  transform: translateY(-9px);\n  transition: all 0.3s ease;\n}\n\n.sl-payment [id$=\'-error\'] {\n  display: block;\n}\n', {});
  var zd = function (e) {
    p(n, e);
    var t = Vd(n);
    function n() {
      var e;
      o(this, n);
      for (var i = arguments.length, a = new Array(i), c = 0; c < i; c++) {
        a[c] = arguments[c];
      }
      return h(u(e = t.call.apply(t, [this].concat(a))), "inputDom", null), h(u(e), "bindEvent", function (t) {
        if (!t) throw new Error("Can`t find the dom node");
        null == t || t.addEventListener("input", function (t) {
          return e.handleInput(vd.Input, {
            event: t
          });
        }), window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? (null == t || t.addEventListener("touchend", function (t) {
          return e.handleInput(vd.Focus, {
            event: t
          });
        }), null == t || t.addEventListener("mouseout", function (t) {
          return e.handleInput(vd.Focus, {
            event: t
          });
        })) : (null == t || t.addEventListener("focus", function (t) {
          return e.handleInput(vd.Focus, {
            event: t
          });
        }), null == t || t.addEventListener("blur", function (t) {
          return e.handleInput(vd.Focus, {
            event: t
          });
        })), null == t || t.addEventListener("compositionstart", function (t) {
          return e.handleInput(vd.Composition, {
            status: !0,
            event: t
          });
        }), null == t || t.addEventListener("compositionupdate", function (t) {
          return e.handleInput(vd.Composition, {
            status: !0,
            event: t
          });
        }), null == t || t.addEventListener("compositionend", function (t) {
          return e.handleInput(vd.Composition, {
            status: !1,
            event: t
          });
        });
      }), h(u(e), "isOnComposition", !1), h(u(e), "oldValue", ""), h(u(e), "handleInput", function () {
        var t = r(A.mark(function t(n, r) {
          var o, i, a, c, s, l, p, d, f, h;
          return A.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (o = r.event, i = r.status, a = u(e), c = a.data, s = a.formStore, l = c.format ? c.format(null == o || null === (p = o.target) || void 0 === p ? void 0 : p.value, e.oldValue) : wd(c.mode || "string", null == o || null === (d = o.target) || void 0 === d ? void 0 : d.value, null == c ? void 0 : c.rules[0]), e.oldValue = l, f = ["focus", "touchend"].indexOf(o.type) > -1, h = up(l), n !== vd.Focus) {
                    t.next = 11;
                    break;
                  }
                  s.dispatch(Ad.FIELD_STATUS_CHANGE, {
                    name: e.name,
                    payload: {
                      isFocus: f,
                      isEmpty: h && !f,
                      isError: !1
                    }
                  }), f || h || s.dispatch(Ad.VALIDATE, {
                    name: e.name,
                    payload: l
                  }), t.next = 19;
                  break;
                case 11:
                  if (n !== vd.Input) {
                    t.next = 18;
                    break;
                  }
                  if (!e.isOnComposition) {
                    t.next = 14;
                    break;
                  }
                  return t.abrupt("return");
                case 14:
                  o.target.value = l, s.dispatch(Ad.UPDATE, {
                    name: e.name,
                    payload: l
                  }), t.next = 19;
                  break;
                case 18:
                  n === vd.Composition && (e.isOnComposition = i || !1, i || e.handleInput(vd.Input, {
                    event: o
                  }));
                case 19:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }));
        return function (e, n) {
          return t.apply(this, arguments);
        };
      }()), h(u(e), "onRendered", function (t) {
        e.inputDom = t, e.bindEvent(t);
      }), h(u(e), "render", function () {
        var t = u(e),
          n = t.data,
          r = t.renderOptions,
          o = "".concat(Hd, "-").concat(n.name, "-").concat(null == n ? void 0 : n.elementType),
          i = "outside" === (null == r ? void 0 : r.labelPosition);
        return {
          content: "div",
          props: {
            "class": "".concat(Md, "-box"),
            id: "".concat(o, "-box")
          },
          children: [{
            content: "input",
            props: {
              "class": "".concat(Md, "-box-input ").concat(i ? "".concat(Md, "-box-input-outside") : ""),
              value: "",
              id: o,
              type: null == n ? void 0 : n.mode
            },
            onRendered: e.onRendered
          }, i || !n.placeholder && !n.placeholderKey ? null : {
            content: "label",
            props: {
              "class": "".concat(Md, "-box-label"),
              i18nKey: n.placeholderKey,
              innerHTML: n.placeholder
            }
          }]
        };
      }), h(u(e), "setValue", function (t) {
        var n = u(e),
          r = n.formStore,
          o = n.inputDom;
        return !!o && (o.value = t, r.dispatch(Ad.FIELD_STATUS_CHANGE, {
          name: e.name,
          payload: {
            isEmpty: !t
          }
        }), !0);
      }), e;
    }
    return s(n);
  }(Ud);
  function qd(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = f(e);
      if (t) {
        var o = f(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);
      return d(this, n);
    };
  }
  var Gd = function (e) {
    p(n, e);
    var t = qd(n);
    function n() {
      var e;
      o(this, n);
      for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) {
        i[a] = arguments[a];
      }
      return h(u(e = t.call.apply(t, [this].concat(i))), "labelDom", null), h(u(e), "onRendered", function (t) {
        e.labelDom = t;
      }), h(u(e), "render", function () {
        return {
          content: "div",
          props: {
            "class": "".concat(Md, "-box ").concat(Md, "-label")
          },
          onRendered: e.onRendered
        };
      }), h(u(e), "setValue", function (t) {
        return !!e.labelDom && (e.labelDom.innerHTML = t, !0);
      }), e;
    }
    return s(n);
  }(Ud);
  function Wd(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = f(e);
      if (t) {
        var o = f(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);
      return d(this, n);
    };
  }
  tp('.sl-payment .form-content-container-item-box-select {\n  height: 100%;\n  width: 100%;\n}\n\n.sl-payment .select {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sl-payment .select-input-main {\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  font-size: 0;\n  display: flex;\n  align-items: center;\n}\n\n[ecp-dir="ltr"] .sl-payment .select-input-main {\n  padding: var(--form-select-padding-top) var(--form-select-padding-right)\n    var(--form-select-padding-bottom) var(--form-select-padding-left);\n}\n\n[ecp-dir="rtl"] .sl-payment .select-input-main {\n  padding: var(--form-select-padding-top) var(--form-select-padding-left)\n    var(--form-select-padding-bottom) var(--form-select-padding-right);\n}\n\n.sl-payment .select-input-main-label {\n  margin: 0;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--select-font-color);\n}\n\n.sl-payment .select-input-main-display:not(:empty) + .select-input-main-label {\n  display: none;\n}\n\n.sl-payment .select-input-suffix {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  height: 100%;\n  color: var(--select-icon-color);\n}\n\n[ecp-dir="ltr"] .sl-payment .select-input-suffix {\n  right: 15px;\n}\n\n[ecp-dir="rtl"] .sl-payment .select-input-suffix {\n  left: 15px;\n}\n\n.sl-payment .select-input-line {\n  height: 20px;\n  color: transparent;\n}\n\n[ecp-dir="ltr"] .sl-payment .select-input-line {\n  margin-right: 30px;\n  border-left: 1px solid transparent;\n  border-left-color: var(--form-select-dividing-line-color);\n}\n\n[ecp-dir="rtl"] .sl-payment .select-input-line {\n  margin-left: 30px;\n  border-right: 1px solid transparent;\n  border-right-color: var(--form-select-dividing-line-color);\n}\n\n.sl-payment .select-list {\n  position: absolute;\n  /* top: calc(var(--input-height) + 2px); */\n  margin-top: 2px;\n  width: 100%;\n  box-sizing: border-box;\n  max-height: 0;\n  min-width: 100px;\n  z-index: 2043;\n  overflow-y: scroll;\n  box-shadow: 0px 1px 3px rgb(54 62 81 / 20%), 0px 0px 16px rgb(54 62 81 / 10%);\n  border-radius: 6px;\n  transition: max-height 0.15s linear;\n  color: var(--options-font-color);\n  background-color: var(--options-background, #fff);\n}\n\n[ecp-dir="ltr"] .sl-payment .select-list {\n  left: 0;\n}\n\n[ecp-dir="rtl"] .sl-payment .select-list {\n  right: 0;\n}\n\n.sl-payment .select-list[data-show=\'1\'] {\n  max-height: 431px;\n}\n\n.sl-payment .select-option-item {\n  position: relative;\n  display: flex;\n  height: 62px;\n  line-height: 38px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n[ecp-dir="ltr"] .sl-payment .select-option-item {\n  padding: var(--form-select-padding-top) var(--form-select-padding-right)\n    var(--form-select-padding-bottom) var(--form-select-padding-left);\n}\n\n[ecp-dir="rtl"] .sl-payment .select-option-item {\n  padding: var(--form-select-padding-top) var(--form-select-padding-left)\n    var(--form-select-padding-bottom) var(--form-select-padding-right);\n}\n\n.sl-payment .select-option-item.disabled {\n  background-color: var(--options-disabled-background, #f7f8fb);\n  color: var(--options-disabled-font-color, #b8becc);\n}\n\n.sl-payment .select-option-item-mask {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.sl-payment .select-option-item-info {\n  display: flex;\n  flex: 1;\n  font-size: 14px;\n}\n\n[ecp-dir="ltr"] .sl-payment .select-option-item-info {\n  margin-left: 10px;\n}\n\n[ecp-dir="rtl"] .sl-payment .select-option-item-info {\n  margin-right: 10px;\n}\n\n.sl-payment .select-option-item-info-name {\n  flex: 1;\n  white-space: nowrap;\n}\n\n[ecp-dir="ltr"] .sl-payment .select-option-item-info-name {\n  margin-right: 10px;\n}\n\n[ecp-dir="rtl"] .sl-payment .select-option-item-info-name {\n  margin-left: 10px;\n}\n\n/* https://sl-ued-banana.myshopline.com/#/report/1365-14959 */\n\n.sl-payment .form-content-container-item-focus .form-content-container-item-box .select-input-suffix,\n.sl-payment .form-content-container-item-error .form-content-container-item-box .select-input-suffix {\n  top: -1px;\n}\n\n[ecp-dir="ltr"] .sl-payment .form-content-container-item-focus .form-content-container-item-box .select-input-suffix,\n[ecp-dir="ltr"] .sl-payment .form-content-container-item-error .form-content-container-item-box .select-input-suffix {\n  margin-right: 1px;\n}\n\n[ecp-dir="rtl"] .sl-payment .form-content-container-item-focus .form-content-container-item-box .select-input-suffix,\n[ecp-dir="rtl"] .sl-payment .form-content-container-item-error .form-content-container-item-box .select-input-suffix {\n  margin-left: 1px;\n}\n\n.sl-payment .form-content-container-item-focus .form-content-container-item-box .select-input-line,\n.sl-payment .form-content-container-item-error .form-content-container-item-box .select-input-line {\n  top: -1px;\n  position: relative;\n}\n\n[ecp-dir="ltr"] .sl-payment .form-content-container-item-focus .form-content-container-item-box .select-input-line,\n[ecp-dir="ltr"] .sl-payment .form-content-container-item-error .form-content-container-item-box .select-input-line {\n  left: -1px;\n}\n\n[ecp-dir="rtl"] .sl-payment .form-content-container-item-focus .form-content-container-item-box .select-input-line,\n[ecp-dir="rtl"] .sl-payment .form-content-container-item-error .form-content-container-item-box .select-input-line {\n  right: -1px;\n}\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n}\n', {});
  var Kd,
    Jd = function (e) {
      p(n, e);
      var t = Wd(n);
      function n() {
        var e;
        o(this, n);
        for (var i = arguments.length, a = new Array(i), c = 0; c < i; c++) {
          a[c] = arguments[c];
        }
        return h(u(e = t.call.apply(t, [this].concat(a))), "selectDisplay", null), h(u(e), "selectList", null), h(u(e), "options", []), h(u(e), "render", function () {
          var t = u(e),
            n = t.data,
            r = t.renderOptions,
            o = "".concat(Md, "-box-select"),
            i = "".concat(Hd, "-").concat(n.name, "-").concat(null == n ? void 0 : n.elementType),
            a = n.options,
            c = n.renderContent,
            s = "outside" === (null == r ? void 0 : r.labelPosition);
          return {
            content: "div",
            props: {
              "class": o,
              id: i
            },
            onRendered: e.onRendered,
            children: [{
              content: "div",
              props: {
                "class": "".concat(Md, "-box select")
              },
              children: [{
                content: "div",
                props: {
                  "class": "select-input-mask"
                }
              }, {
                content: "div",
                props: {
                  "class": "select-input-main"
                },
                children: [{
                  content: "div",
                  props: {
                    "class": "select-input-main-display"
                  },
                  onRendered: function onRendered(t) {
                    e.selectDisplay = t;
                  }
                }, s || !n.placeholder && !n.placeholderKey ? null : {
                  content: "label",
                  props: {
                    "class": "select-input-main-label",
                    i18nKey: n.placeholderKey,
                    innerHTML: n.placeholder
                  }
                }]
              }, n.disabled ? null : {
                content: "div",
                props: {
                  "class": "select-input-line",
                  innerHTML: Bt
                }
              }, n.disabled ? null : {
                content: "div",
                props: {
                  "class": "select-input-suffix",
                  innerHTML: Bt
                }
              }]
            }, {
              content: "div",
              props: {
                "class": "select-list"
              },
              onRendered: function onRendered(t) {
                e.selectList = t;
              },
              children: e.createSelectList(a, c)
            }]
          };
        }), h(u(e), "createSelectList", function (t, n) {
          return t ? (e.options = t, t.map(function (e) {
            var t = "select-option-item";
            return {
              content: "div",
              props: {
                "class": "".concat(t).concat(e.disabled ? " disabled" : "")
              },
              children: [{
                content: "div",
                props: {
                  key: e.key,
                  value: e.value,
                  "class": "".concat(t, "-mask")
                }
              }, n ? n(e.key, e.value) : {
                content: "div",
                props: {
                  "class": "".concat(t, "-info")
                },
                children: [{
                  content: "div",
                  props: {
                    "class": "".concat(t, "-info-name")
                  },
                  children: e.value
                }]
              }]
            };
          })) : null;
        }), h(u(e), "bindEvent", function (t) {
          var n,
            r = u(e).formStore;
          t.addEventListener("click", function () {
            if (e.selectList) {
              var t,
                n,
                o = +((null === (t = e.selectList.dataset) || void 0 === t ? void 0 : t.show) || "0");
              null === (n = e.selectList) || void 0 === n || n.setAttribute("data-show", "".concat(1 - o)), r.dispatch(Ad.FIELD_STATUS_CHANGE, {
                name: e.name,
                payload: {
                  isFocus: !o,
                  isEmpty: !1,
                  isError: !1
                }
              });
            }
          }), null === (n = e.selectList) || void 0 === n || n.addEventListener("click", function (t) {
            var n,
              r = t.target;
            e.setValue(null !== (n = null == r ? void 0 : r.getAttribute("key")) && void 0 !== n ? n : "");
          });
        }), h(u(e), "onRendered", function (t) {
          e.bindEvent(t);
        }), h(u(e), "renderItem", function (t) {
          var n = t.key,
            r = t.value,
            o = u(e).data,
            i = o.renderSelected,
            a = o.renderContent,
            c = i || a;
          return c ? c(n, r) : r;
        }), h(u(e), "setDisplay", function () {
          var t = r(A.mark(function t(n) {
            var r, o, i;
            return A.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (r = u(e), o = r.formStore, !(i = r.selectDisplay)) {
                      t.next = 10;
                      break;
                    }
                    if ("string" != typeof n) {
                      t.next = 6;
                      break;
                    }
                    i.innerHTML = n, t.next = 9;
                    break;
                  case 6:
                    return i.innerHTML = "", t.next = 9, Xl(n, i, {
                      isRTL: e.isRTL
                    });
                  case 9:
                    o.dispatch(Ad.FIELD_STATUS_CHANGE, {
                      name: e.name,
                      payload: {
                        isFocus: !1,
                        isEmpty: !n,
                        isError: !1
                      }
                    });
                  case 10:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          }));
          return function (e) {
            return t.apply(this, arguments);
          };
        }()), h(u(e), "setValue", function (t) {
          var n = u(e),
            r = n.formStore,
            o = n.options,
            i = n.renderItem,
            a = o.find(function (e) {
              return e.key === t;
            });
          return !!a && (e.setDisplay(i(a)), r.dispatch(Ad.UPDATE, {
            name: e.name,
            payload: t
          }), !0);
        }), e;
      }
      return s(n);
    }(Ud),
    Yd = (h(Kd = {}, fd.Input, zd), h(Kd, fd.Select, Jd), h(Kd, fd.Label, Gd), Kd),
    Xd = s(function e(t, n, i) {
      var a = this;
      o(this, e), h(this, "data", null), h(this, "fieldFormDom", null), h(this, "fieldItemMap", {}), h(this, "getContentNodeData", function (e) {
        var t = Yd[e.elementType];
        if (t) {
          var n = new t(e, a.formStore, a.renderOptions);
          return a.fieldItemMap[e.name] = {
            render: n,
            data: e
          }, a.formStore.registerFieldWatch(e.name, a), n.render();
        }
        return null;
      }), h(this, "getRenderData", function (e, t) {
        if (!e) return null;
        var n = a.getContentNodeData,
          r = t ? "".concat(Md, " ").concat(Md, "-").concat(t) : Md;
        e.addonBefore && (r += " ".concat(Md, "-hasAddonBefore")), e.addonAfter && (r += " ".concat(Md, "-hasAddonAfter"));
        var o = n(e);
        return t ? {
          content: "div",
          props: {
            "class": "".concat(r),
            id: "".concat(e.name, "-form-content"),
            style: e.style
          },
          children: [o]
        } : o;
      }), h(this, "getFieldData", function (e) {
        var t = a.getRenderData,
          n = a.renderOptions,
          r = "".concat(e.name, "-form"),
          o = Md;
        null != e && e.addonBefore && (o += " ".concat(Md, "-hasAddonBefore")), null != e && e.addonAfter && (o += " ".concat(Md, "-hasAddonAfter"));
        var i = "outside" === (null == n ? void 0 : n.labelPosition),
          c = null == n ? void 0 : n.borderType;
        return {
          content: "div",
          props: {
            "class": "".concat(o),
            id: "".concat(e.name, "-form-content"),
            style: e.style
          },
          onRendered: function onRendered(e) {
            a.fieldFormDom = e;
          },
          children: [i && (e.placeholder || e.placeholderKey) ? {
            content: "label",
            props: {
              "class": "".concat(Md, "-content-label"),
              i18nKey: e.placeholderKey,
              innerHTML: e.placeholder
            }
          } : null, {
            content: "div",
            props: {
              "class": "".concat(Md, "-content ").concat(c ? "".concat(Md, "-content-").concat(c) : "")
            },
            children: [t(e.addonBefore, md.AddonBefore), t(e), t(e.addonAfter, md.AddonAfter)]
          }, {
            content: "div",
            props: {
              "class": "".concat(Md, "-tip")
            },
            children: {
              content: "div",
              props: {
                id: "".concat(r, "-error")
              }
            }
          }]
        };
      }), h(this, "handleToggleError", function (e, t) {
        var n = "".concat(e, "-form-error");
        if (!a.fieldFormDom) throw new Error("Setup error failed, container not found");
        jp({
          container: a.fieldFormDom,
          id: n,
          type: "error",
          className: "".concat(Md, "-tip-show"),
          content: t,
          contentClassName: "form-content-container-item-error-box"
        });
      }), h(this, "render", function () {
        return a.data ? a.getFieldData(a.data) : null;
      }), h(this, "onFormReady", function () {
        var e = a.fieldItemMap;
        Object.entries(e).forEach(function (e) {
          var t = Un(e, 2),
            n = t[0],
            r = t[1].data;
          if (r) {
            var o = r.defaultValue;
            o && a.setFieldValue(n, o);
          }
        });
      }), h(this, "addClass", function (e) {
        var t = a.fieldFormDom;
        null != t && t.classList.contains(e) || null == t || t.classList.add(e);
      }), h(this, "removeClass", function (e) {
        var t = a.fieldFormDom;
        null != t && t.classList.contains(e) && (null == t || t.classList.remove(e));
      }), h(this, "onFieldStatusChange", function (e, t) {
        a.fieldFormDom && (t[Td.EMPTY] ? a.removeClass(Fd) : !1 === t[Td.EMPTY] && a.addClass(Fd), t[Td.FOCUS] ? a.addClass(Bd) : !1 === t[Td.FOCUS] && a.removeClass(Bd), !1 === t[Td.ERROR] && a.handleToggleError(e, ""));
      }), h(this, "handleValidate", function () {
        var e = r(A.mark(function e(t, n) {
          var r, o, i, c, s, u, l;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (r = a.fieldItemMap, o = r[t]) {
                    e.next = 4;
                    break;
                  }
                  return e.abrupt("return", !0);
                case 4:
                  return i = o.data, e.next = 7, Ld((null == i ? void 0 : i.rules) || [], n, {
                    first: !0
                  });
                case 7:
                  if ((c = e.sent).length) {
                    e.next = 12;
                    break;
                  }
                  a.handleToggleError(t, ""), e.next = 17;
                  break;
                case 12:
                  return s = c[0] || {}, u = s.messageKey, e.next = 15, zl.get(u || "");
                case 15:
                  l = e.sent, a.handleToggleError(t, l || "");
                case 17:
                  return e.abrupt("return", !c.length);
                case 18:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t, n) {
          return e.apply(this, arguments);
        };
      }()), h(this, "onValidate", function () {
        var e = r(A.mark(function e(t, n) {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, a.handleValidate(t, n);
                case 2:
                  return e.abrupt("return", e.sent);
                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t, n) {
          return e.apply(this, arguments);
        };
      }()), h(this, "setFieldValue", function () {
        var e = r(A.mark(function e(t, n) {
          var r, o, i, c, s, u;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (r = a.fieldFormDom, o = a.fieldItemMap, i = o[t]) {
                    e.next = 4;
                    break;
                  }
                  return e.abrupt("return");
                case 4:
                  if (c = i.data, s = (null == c ? void 0 : c.rules) || [], !r) {
                    e.next = 15;
                    break;
                  }
                  return u = wd(c.mode || "string", n, s[0]), e.next = 10, i.render.setValue(u);
                case 10:
                  if (!e.sent) {
                    e.next = 15;
                    break;
                  }
                  return a.formStore.updateValue(t, n), e.next = 15, a.handleValidate(t, n);
                case 15:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t, n) {
          return e.apply(this, arguments);
        };
      }()), this.formStore = n, this.data = t, this.isRTL = null == i ? void 0 : i.isRTL, this.renderOptions = i;
    });
  var Zd,
    $d,
    Qd = function Qd(e) {
      return (null == e ? void 0 : e.systemCode) === x.BOGUS_GATEWAY;
    },
    ef = function ef(e) {
      var t = ((e || {}).channelInfo || {}).data.fpxBanks.map(function (e) {
        return {
          key: e.id,
          value: e.name
        };
      });
      return [{
        elementType: fd.Select,
        name: "subPaymentMethod",
        placeholderKey: "FPX.form.select.placeholder",
        options: t,
        rules: [{
          type: "string",
          required: !0,
          messageKey: "FPX.form.select.placeholder"
        }],
        renderContent: function renderContent(e, t) {
          return {
            content: "div",
            props: {
              style: "display: flex; align-items: center;position: relative;"
            },
            children: [{
              content: "img",
              props: {
                style: "position: absolute;left: 0; top: 0; width: 38px",
                src: "https://img.myshopline.com/pay/felogo/fpx/bank-".concat(e, ".svg")
              }
            }, {
              content: "p",
              props: {
                style: "font-size: 14px;line-height: 20px;padding-left: 48px;",
                innerHTML: t
              }
            }]
          };
        },
        renderSelected: function renderSelected(e, t) {
          return {
            content: "div",
            props: {
              style: "display: flex; align-items: center;position: relative;"
            },
            children: [{
              content: "img",
              props: {
                style: "position: absolute;left: 0; top: 0; width: 20px",
                src: "https://img.myshopline.com/pay/felogo/fpx/bank-".concat(e, ".svg")
              }
            }, {
              content: "span",
              props: {
                style: "font-size: 14px;line-height: 20px;padding-left: 30px;",
                innerHTML: t
              }
            }]
          };
        }
      }];
    },
    tf = {
      content: "div",
      props: {
        id: "form-content-footer",
        "class": "form-content-footer-container"
      },
      children: [{
        content: "p",
        props: {
          i18nKey: "FPX.form.footer.payGuide",
          style: "margin: 4px 0 12px 0;line-height: 18px;color: var(--next-step-tip-font-color)"
        }
      }, {
        content: "div",
        props: {
          style: "display: flex;align-items: center;line-height: 16px;"
        },
        children: [{
          content: "span",
          props: {
            style: "font-size: 12px; color: var(--footer-icon-color)",
            innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path\nd="M10.8773 5.33337H10.1557C9.99882 5.33337 9.84958 5.40529 9.75727 5.52856L7.33873 8.72793L6.24331 7.27795C6.151 7.15613 6.0033 7.08275 5.84484 7.08275H5.12328C5.02327 7.08275 4.96481 7.19136 5.02327 7.26914L6.94026 9.80515C6.98554 9.86545 7.04524 9.91458 7.11441 9.94847C7.18357 9.98236 7.26021 10 7.33796 10C7.41572 10 7.49235 9.98236 7.56152 9.94847C7.63068 9.91458 7.69038 9.86545 7.73567 9.80515L10.9758 5.51976C11.0358 5.44198 10.9773 5.33337 10.8773 5.33337V5.33337Z"\nfill="currentColor"></path><path\nd="M13.25 3.46888V9.59634C13.25 10.0143 13.0411 10.4046 12.6934 10.6364L8.13867 13.6729C8.0547 13.7289 7.9453 13.7289 7.86132 13.6729L3.30662 10.6364C2.95888 10.4046 2.75 10.0143 2.75 9.59634V3.46888C2.75 3.3517 2.83138 3.25025 2.94577 3.22483L7.94577 2.11372C7.98149 2.10578 8.01851 2.10578 8.05423 2.11372L13.0542 3.22483C13.1686 3.25025 13.25 3.3517 13.25 3.46888Z"\nstroke="currentColor" stroke-width="1.5"></path>\n</svg>'
          }
        }, {
          content: "p",
          props: {
            renderer: ($d = r(A.mark(function e() {
              var t, n;
              return A.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, zl.get("FPX.form.footer.serviceTerms");
                    case 2:
                      return t = e.sent, e.next = 5, zl.getWithValue("FPX.form.footer.agreement", {
                        serviceTerms: '<a href="https://www.mepsfpx.com.my/FPXMain/termsAndConditions.jsp" target="_blank" style="color: var(--footer-link-color)">'.concat(t, "</a>")
                      });
                    case 5:
                      return n = e.sent, e.abrupt("return", n);
                    case 7:
                    case "end":
                      return e.stop();
                  }
                }
              }, e);
            })), function () {
              return $d.apply(this, arguments);
            }),
            style: "color: var(--footer-font-color);"
          }
        }]
      }]
    },
    nf = [{
      elementType: fd.Input,
      mode: hd.PhoneNumber,
      name: "mobileNumber",
      placeholderKey: "OVO.form.phoneNumber.placeholder",
      rules: [{
        type: "string",
        min: 10,
        max: 13,
        startWith: "8",
        required: !0,
        messageKey: "OVO.form.phoneNumber.invalid"
      }],
      addonBefore: {
        elementType: fd.Label,
        style: "width: 52px;direction: ltr;",
        name: "OVOFormMobilePhoneNumberAddonBeforeSelect",
        defaultValue: "+62",
        disabled: !0
      }
    }],
    rf = [{
      elementType: fd.Input,
      mode: hd.Number,
      name: "cardNo",
      placeholderKey: "formItems.number.labelTitle",
      rules: [{
        type: "number",
        min: 0,
        max: 1,
        required: !0,
        messageKey: "formItems.number.errorTips"
      }, {
        validator: function validator(e) {
          return ["1", "2", "3"].includes(e);
        },
        messageKey: "formItems.number.errorTips"
      }]
    }, {
      elementType: fd.Input,
      mode: hd.String,
      name: "expDate",
      placeholderKey: "formItems.expiryDate.labelTitle",
      format: function format(e, t) {
        return function (e, t) {
          var n = e.replace(/[^\d/]/g, "").replace(/\/+/g, "/");
          if (function (e, t) {
            for (var n = e, r = 0; r < t.length; r++) {
              var o = t[r];
              n = n.replace(o, "");
            }
            return /^\/+$/.test(n);
          }(n, t)) n = t;else if (function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "/";
            return e.split(t).length - 1;
          }(n) > 1) n = t;else if (-1 !== n.indexOf("/")) {
            var r = n.split("/");
            if (r[0].length > 2 || r[1].length > 2) {
              var o = r[0].slice(0, 2);
              o = 1 === o.length ? "0".concat(o) : o, n = 4 === r[1].length ? "".concat(o, "/").concat(r[1].slice(2, 4)) : "".concat(o, "/").concat(r[1].slice(0, 2));
            }
            "" === r[1] && (n = n.replace("/", ""));
          } else n = e.replace(/[^\d]/g, ""), /^[2-9]{1}/.test(n) && (n = "0".concat(n).slice(0, 4)), n.length >= 3 && (n = n.replace(/(\d{2})/, "$1/"));
          return n;
        }(e, t);
      },
      rules: [{
        type: "string",
        required: !0,
        min: 5,
        messageKey: "formItems.expiryDate.errorTips"
      }, {
        validator: function validator(e) {
          var t = e;
          if (t.length < 5 || t.indexOf("/") < 0) return !1;
          var n = Un(t.split("/"), 2),
            r = n[0],
            o = n[1],
            i = !0,
            a = new Date(),
            c = +a.getFullYear().toString().slice(2),
            s = a.getMonth() + 1;
          return (c > Number(o) || s > Number(r) && c === Number(o)) && (i = !1), i;
        },
        messageKey: "formItems.expiryDate.errorTips"
      }]
    }, {
      elementType: fd.Input,
      mode: hd.Number,
      name: "cvc",
      placeholderKey: "formItems.cvc.labelTitle",
      rules: [{
        type: "number",
        min: 0,
        max: 4,
        required: !0,
        messageKey: "formItems.cvc.errorTips"
      }]
    }],
    of = (h(Zd = {}, e.PaymentMethod.OVO, {
      name: "XenditOVOForm",
      fields: nf,
      header: {
        content: "div",
        props: {
          id: "form-content-header",
          "class": "form-content-header-container",
          i18nKey: "OVO.form.header"
        }
      },
      footer: {
        content: "div",
        props: {
          id: "form-content-footer",
          "class": "form-content-footer-container",
          i18nKey: "OVO.form.footer"
        }
      },
      formatePayData: function formatePayData(e) {
        var t = e.mobileNumber,
          n = e.OVOFormMobilePhoneNumberAddonBeforeSelect;
        return {
          mobileNumber: "".concat(n).concat(t)
        };
      }
    }), h(Zd, e.PaymentMethod.FPX, function (e) {
      return {
        name: "FPXForm",
        fields: ef(e),
        footer: tf
      };
    }), Zd),
    af = {
      name: "BogusGatewayForm",
      fields: rf
    },
    cf = function cf(e, t) {
      if (Qd(e)) return af;
      var n = of[e.paymentMethod];
      return n && "function" == typeof n ? n(t) : n;
    },
    sf = function () {
      function e(t, n) {
        var i = this;
        o(this, e), h(this, "container", null), h(this, "skeletonDom", null), h(this, "formDom", null), h(this, "fieldMap", {}), h(this, "formStore", new Nd()), h(this, "style", ""), h(this, "removeLoading", r(A.mark(function e() {
          var t, n, r, o, a, c;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  r = null === (t = i.container) || void 0 === t ? void 0 : t.querySelector("[name=".concat(null === (n = i.config) || void 0 === n ? void 0 : n.name, "]")), i.skeletonDom && r && (null === (o = i.container) || void 0 === o || o.removeChild(i.skeletonDom), c = null == r || null === (a = r.getAttribute("class")) || void 0 === a ? void 0 : a.replace(" hidden", ""), null == r || r.setAttribute("class", c || ""));
                case 2:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }))), h(this, "getSkeletonNodeData", function () {
          return {
            content: "div",
            props: {
              "class": "sl-payment",
              style: i.style,
              "ie-style": void 0
            },
            children: {
              content: "form",
              props: {
                name: "form-skeleton",
                "class": "form-content-loading"
              },
              children: [{
                content: "div",
                props: {
                  "class": "form-content-header",
                  innerHTML: ""
                }
              }, {
                content: "div",
                props: {
                  "class": "form-content-container",
                  innerHTML: ""
                },
                children: {
                  content: "div",
                  props: {
                    "class": "form-content-container-item",
                    innerHTML: ""
                  }
                }
              }]
            }
          };
        }), h(this, "getFieldData", function (e) {
          var t = new Xd(e, i.formStore, {
            isRTL: ql(i.initData),
            labelPosition: i.theme.getCreditCardThemeValue("inputLabelPosition"),
            borderType: i.theme.getCreditCardThemeValue("inputBorderType")
          });
          return i.fieldMap[e.name] = t, t.render();
        }), h(this, "getFields", function () {
          var e,
            t = i.config,
            n = i.getFieldData,
            r = null === (e = t.fields) || void 0 === e ? void 0 : e.map(function (e) {
              return n(e);
            }),
            o = null == r ? void 0 : r.filter(function (e) {
              return e;
            });
          return {
            content: "div",
            props: {
              "class": "form-content-container",
              id: "".concat(t.name, "-form-content-container")
            },
            children: o
          };
        }), h(this, "renderLoading", r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, Xl(i.getSkeletonNodeData(), i.container, {
                    isRTL: ql(i.initData)
                  });
                case 2:
                  i.skeletonDom = e.sent;
                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }))), h(this, "onFormRendered", function () {
          var e = i.fieldMap;
          Object.entries(e).forEach(function (e) {
            Un(e, 2)[1].onFormReady();
          });
        }), h(this, "getForm", function () {
          var e = i.config,
            t = i.style,
            n = i.getFields,
            r = i.onFormRendered,
            o = n();
          return {
            content: "div",
            props: {
              "class": "sl-payment",
              id: "".concat(e.name, "-form"),
              style: t,
              "ie-style": void 0
            },
            children: {
              content: "form",
              props: {
                "class": "form-content hidden",
                name: e.name
              },
              children: [e.header ? {
                content: "div",
                props: {
                  "class": "form-content-header"
                },
                children: e.header
              } : null, o, e.footer ? {
                content: "div",
                props: {
                  "class": "form-content-footer"
                },
                children: e.footer
              } : null]
            },
            onRendered: r
          };
        }), h(this, "renderForm", r(A.mark(function e() {
          var t;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return t = i.getForm(), e.next = 3, Xl(t, i.container, {
                    isRTL: ql(i.initData)
                  });
                case 3:
                  i.formDom = e.sent;
                case 4:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }))), h(this, "getFieldsValue", function () {
          var e,
            t,
            n,
            r = i.formStore.getFieldsValue();
          return {
            data: null !== (e = null === (t = i.config) || void 0 === t || null === (n = t.formatePayData) || void 0 === n ? void 0 : n.call(t, r)) && void 0 !== e ? e : r
          };
        }), this.initData = t, this.theme = new qt(t.theme);
        var a = cf(t, n);
        if (!a) throw new Error("There is no corresponding form configuration to render");
        this.config = a;
      }
      var t, n, i;
      return s(e, [{
        key: "render",
        value: (i = r(A.mark(function e(t) {
          var n;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return n = this.theme.getStyle([k.CreditCard, k.Form]), this.container = t, this.style = n, e.next = 5, this.renderLoading();
                case 5:
                  return t.setAttribute("ontouchstart", ""), e.next = 8, this.renderForm();
                case 8:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return i.apply(this, arguments);
        })
      }, {
        key: "setDefaultFields",
        value: (n = r(A.mark(function e(t) {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  this.formStore.setFieldsValue(t);
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return n.apply(this, arguments);
        })
      }, {
        key: "validate",
        value: (t = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, this.formStore.validateFields();
                case 2:
                  return e.abrupt("return", e.sent);
                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return t.apply(this, arguments);
        })
      }]), e;
    }();
  function uf(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function lf(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? uf(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : uf(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var pf = function () {
      function e(t) {
        o(this, e), h(this, "containerElement", null), h(this, "form", null), this.initData = t, Fn.reportData("form_init");
      }
      var t, n, i, a, c;
      return s(e, [{
        key: "validate",
        value: (c = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.form) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return", !1);
                case 2:
                  return e.next = 4, this.form.validate();
                case 4:
                  return e.abrupt("return", e.sent);
                case 5:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return c.apply(this, arguments);
        })
      }, {
        key: "render",
        value: (a = r(A.mark(function e(t, n) {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (t) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return");
                case 2:
                  return t && (this.containerElement = t), this.form = new sf(this.initData, n), e.next = 6, this.form.render(t)["catch"](function (e) {
                    return Fn.handleError(e, "form_render_error");
                  });
                case 6:
                  this.form.removeLoading()["catch"](function (e) {
                    return Fn.handleError(e, "form_remove_loading_error");
                  });
                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t) {
          return a.apply(this, arguments);
        })
      }, {
        key: "pay",
        value: (i = r(A.mark(function e(t, n, r) {
          var o, i, a, c, s, u, l;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, null === (o = this.form) || void 0 === o ? void 0 : o.getFieldsValue();
                case 2:
                  if ((a = e.sent) || Fn.handleError({
                    message: "Unable to get form results",
                    name: "Failed to retrieve form results"
                  }, "form_pay_error"), c = lf(lf({}, n.additionalData), null == a ? void 0 : a.data), null !== (i = t.data) && void 0 !== i && i.additionalData) try {
                    u = JSON.parse(null === (s = t.data) || void 0 === s ? void 0 : s.additionalData), Object.assign(c, u);
                  } catch (e) {
                    Fn.handleError(e, "form_pay_error", {
                      additionalData: null === (l = t.data) || void 0 === l ? void 0 : l.additionalData
                    });
                  }
                  return e.abrupt("return", Ep(t, {
                    payOptions: r,
                    paymentMethod: this.initData.paymentMethod,
                    extraParams: lf(lf({}, n), {}, {
                      additionalData: c
                    })
                  }));
                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t, n) {
          return i.apply(this, arguments);
        })
      }, {
        key: "destroy",
        value: function value() {
          this.containerElement && (this.containerElement.innerHTML = ""), this.form = null;
        }
      }, {
        key: "needRenderWidget",
        value: (n = r(A.mark(function e() {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", !0);
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function () {
          return n.apply(this, arguments);
        })
      }, {
        key: "setDefaultFields",
        value: (t = r(A.mark(function e(t) {
          var n;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  null === (n = this.form) || void 0 === n || n.setDefaultFields(t);
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return t.apply(this, arguments);
        })
      }, {
        key: "create",
        value: function value() {
          throw new Error("The create method does not exist, please check the sceneRoute condition to see if there is an error");
        }
      }, {
        key: "updateInitData",
        value: function value() {
          throw new Error("The updateInitData method does not exist, please check the sceneRoute condition to see if there is an error");
        }
      }]), e;
    }(),
    df = function df(t, n) {
      if (Qd(n)) return new pf(n);
      if (bd.checkHasPlugin(n)) return new bd(t, n);
      var r;
      switch (n.paymentMethod) {
        case e.PaymentMethod.CreditCard:
          r = n.headless ? new id(t, n) : new od(t, n);
          break;
        case e.PaymentMethod.OVO:
        case e.PaymentMethod.FPX:
          r = new pf(n);
          break;
        default:
          r = new cd(t, n);
      }
      return r;
    };
  function ff(e, t) {
    var n = "\n    <div style='width: 780px;padding: 153px 24px 24px;box-sizing:border-box;background: url(".concat("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjExMyIgdmlld0JveD0iMCAwIDIwMCAxMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNDggOTZINTFDNDcuNjg2MyA5NiA0NSA5My4zMTM3IDQ1IDkwVjI0QzQ1IDIwLjY4NjMgNDcuNjg2MyAxOCA1MSAxOEgxNDhDMTUxLjMxNCAxOCAxNTQgMjAuNjg2MyAxNTQgMjRWOTBDMTU0IDkzLjMxMzcgMTUxLjMxNCA5NiAxNDggOTZaIiBzdHJva2U9IiNEOEQ4RDgiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNMTI2IDUxLjgwOVY4MC43MzM3QzEyNiA4MC44NDgxIDEyNi4wMDIgODAuOTU5NiAxMjYuMDEzIDgxLjA3MzVDMTI2LjE2MiA4Mi41OTIxIDEyNy44ODMgOTQuMDMwNiAxNDYuMzM2IDEwMC4zMzdDMTQ3LjY4IDEwMC43OTYgMTQ5LjEyNyAxMDAuODMyIDE1MC40NjkgMTAwLjM2N0MxNTUuMjkxIDk4LjY5NzYgMTY3LjEwMyA5My40NDE1IDE2OS45OTggODEuMjk4MkMxNzAuMDAzIDgxLjI2NjcgMTY5Ljk5OCA1MS44MDg3IDE2OS45OTggNTEuODA4N0wxNTAuMTExIDQ3LjM4MDJDMTQ4Ljk4NiA0Ny4xMjk3IDE0Ny44MiA0Ny4xMjUyIDE0Ni42OTMgNDcuMzY3MUwxMjYgNTEuODA5WiIgZmlsbD0iI0Y4RkFGQiIgc3Ryb2tlPSIjRDhEOEQ4IiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQxIDY4LjM4NDZDMTQxIDY0IDE0NC4xMzQgNjEgMTQ4IDYxQzE1MS44NjYgNjEgMTU1IDY0IDE1NSA2OC4zODQ2QzE1NSA3Mi40NjMgMTUxLjA2MiA3NS4zMDc3IDE0OCA3NS43NjkyQzE0OCA3Ny4xNTM4IDE0OCA3OSAxNDggNzkiIHN0cm9rZT0iI0Q4RDhEOCIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGNpcmNsZSBjeD0iMTQ4IiBjeT0iODYiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPHBhdGggZD0iTTQ3IDMzSDE1MyIgc3Ryb2tlPSIjRDhEOEQ4IiBzdHJva2Utd2lkdGg9IjQiLz4KPGNpcmNsZSBjeD0iMTMwIiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPGNpcmNsZSBjeD0iMTM4IiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPGNpcmNsZSBjeD0iMTQ2IiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPC9zdmc+Cg==", ") no-repeat center 40px/200px 113px;'>\n      <p style='margin: 0;padding: 0;text-align: center;font-size: 12px;line-height: 16px;color: #1e1e1e;opacity: 0.8'>").concat(t, "</p>\n    </div>\n  ");
    e.innerHTML = n;
  }
  var hf,
    yf,
    mf = [/Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/, /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/, /MSIE\s(7\.0)/];
  function vf(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function gf(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? vf(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vf(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  !function (e) {
    e.Success = "SUCCESS", e.Fail = "FAIL";
  }(hf || (hf = {})), function (e) {
    e.SUCCESS = "cashier_check_success", e.ERROR = "error";
  }(yf || (yf = {}));
  var bf = function () {
    function e(t, n, r) {
      if (o(this, e), !t) throw new Error("payment object is required in Checker constructor.");
      this.payment = t, this.options = r, this.reporter = n;
    }
    var t, n;
    return s(e, [{
      key: "getResultOrCheck",
      value: (n = r(A.mark(function e() {
        var t = arguments;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (t.length > 0 && void 0 !== t[0] && !t[0]) {
                  e.next = 8;
                  break;
                }
                if (e.t0 = this.result, e.t0) {
                  e.next = 7;
                  break;
                }
                return e.next = 6, this.remote();
              case 6:
                e.t0 = e.sent;
              case 7:
                return e.abrupt("return", e.t0);
              case 8:
                return e.next = 10, this.remote();
              case 10:
                return e.abrupt("return", e.sent);
              case 11:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return n.apply(this, arguments);
      })
    }, {
      key: "isNotSupportBrowser",
      get: function get() {
        return function () {
          var e = navigator.userAgent;
          return mf.every(function (t) {
            var n = t.exec(e);
            return !!(n && Number(n[1]) < 11);
          });
        }();
      }
    }, {
      key: "isInSupportBrowser",
      value: function value() {
        if (this.isNotSupportBrowser) throw new Yt("no support browser", Vt.NotSupportBrowser, "NotSupportBrowser");
        return !0;
      }
    }, {
      key: "getRemoteUrl",
      value: function value(e) {
        var t;
        return "".concat((null === (t = this.payment.config) || void 0 === t ? void 0 : t.host) || "").concat(e);
      }
    }, {
      key: "getRequestData",
      value: function value() {
        var e = this.payment.initData;
        return e ? {
          merchantId: e.merchantId,
          countryCode: e.countryCode,
          paymentMethod: e.paymentMethod,
          currency: e.currency,
          channelId: e.channelId
        } : {};
      }
    }, {
      key: "getRequestOptions",
      value: function value() {
        var e,
          t = {
            action: Vn.Init
          };
        return null !== (e = this.options) && void 0 !== e && e.retryOptions && (t.retryOptions = this.options.retryOptions), t;
      }
    }, {
      key: "getReportData",
      value: function value() {
        return Bn.formatReportData(this.getRequestData());
      }
    }, {
      key: "remote",
      value: (t = r(A.mark(function e() {
        var t,
          n,
          r,
          o = this;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (t = this.payment.initData, !Qd(t)) {
                  e.next = 3;
                  break;
                }
                return e.abrupt("return", {
                  status: hf.Success
                });
              case 3:
                return n = this.getRemoteUrl("/v1/api/cashier/init"), e.next = 6, sr.post(n, this.getRequestData(), this.getRequestOptions()).then(function (e) {
                  var t, r;
                  null === (t = o.reporter) || void 0 === t || t.reportData(yf.SUCCESS, {
                    url: n,
                    request: {
                      params: o.getReportData()
                    },
                    response: gf(gf({}, e.data), {}, {
                      channelInfo: null
                    })
                  });
                  var i = gf({}, (null == e ? void 0 : e.data) || {
                    status: (null == e || null === (r = e.data) || void 0 === r ? void 0 : r.status) || hf.Fail
                  });
                  return e.data && (i.status = hf.Success), i;
                })["catch"](function (e) {
                  var t = gf(gf({}, e.data || {}), {}, {
                    status: hf.Fail
                  });
                  return Bn.reportErrorData(yf.ERROR, {
                    url: n,
                    request: {
                      params: o.getReportData()
                    },
                    response: {
                      error: e
                    }
                  }), t;
                });
              case 6:
                return r = e.sent, this.result = r, e.abrupt("return", r);
              case 9:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }]), e;
  }();
  function wf(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = f(e);
      if (t) {
        var o = f(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);
      return d(this, n);
    };
  }
  var kf = function (e) {
      p(n, e);
      var t = wf(n);
      function n(e, i, a) {
        var c;
        return o(this, n), h(u(c = t.call(this, a, Fn)), "blockRender", null), h(u(c), "renderFail", function () {
          var e = r(A.mark(function e(t) {
            var n;
            return A.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return n = new ud(c.config, c.initData.theme), c.blockRender = n, e.next = 4, n.mount(t, c.initData)["catch"](function (e) {
                      var t;
                      null === (t = c.reporter) || void 0 === t || t.handleError(e, "render_fail_error");
                    });
                  case 4:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()), h(u(c), "destroy", function () {
          var e;
          null === (e = c.blockRender) || void 0 === e || e.destroy(), c.blockRender = null;
        }), c.config = e, c.initData = i, c;
      }
      return s(n);
    }(bf),
    xf = function xf(e) {
      return e && "string" == typeof e && e.split("/").pop() || "";
    },
    Of = function Of() {
      var e = {},
        t = window.navigator,
        n = t.userAgent,
        r = t.language,
        o = window.screen,
        i = o.colorDepth,
        a = o.width,
        c = o.height,
        s = window.navigator.javaEnabled().toString();
      return e.client = {
        transactionWebSite: window.location.href,
        javaEnabled: s,
        colorDepth: i.toString(),
        screenHeight: a.toString(),
        screenWidth: c.toString(),
        timeZoneOffset: new Date().getTimezoneOffset().toString(),
        accept: "application/json",
        userAgent: n,
        language: r,
        javaScriptEnabled: "true"
      }, e;
    },
    _f = function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        o(this, e), h(this, "options", {}), this.options = t;
      }
      return s(e, [{
        key: "beforeInit",
        value: function value(e) {}
      }, {
        key: "afterInit",
        value: function value(e, t) {}
      }, {
        key: "beforeRender",
        value: function value(e) {}
      }, {
        key: "render",
        value: function value(e) {}
      }, {
        key: "validate",
        value: function value() {
          return !0;
        }
      }, {
        key: "beforeConfirm",
        value: function value() {}
      }, {
        key: "extendConfirmParams",
        value: function value() {
          return {};
        }
      }, {
        key: "afterConfirm",
        value: function value() {}
      }, {
        key: "afterSubmit",
        value: function value(e) {}
      }, {
        key: "handlePayAction",
        value: function value(e) {}
      }, {
        key: "destroy",
        value: function value(e) {}
      }]), e;
    }();
  h(_f, "info", {
    channelId: "",
    paymentMethod: ""
  });
  var Cf = [];
  function Ef(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  var If = function () {
    function e(t, n) {
      o(this, e), h(this, "request", sr);
      var r,
        i = this.initReporter(t);
      this.checker = new bf(this, i, n);
      try {
        i.reportData("constructor_start", t);
        var a = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ef(Object(n), !0).forEach(function (t) {
              h(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ef(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }({}, t);
        "boolean" == typeof (null == a ? void 0 : a.useRetry) && this.request.setOptions({
          useRetry: a.useRetry
        }), a.plugins = [].concat(Et(Cf), Et(t.plugins || [])), this.config = ol(a), jn.setTag("env", this.config.env), a.channelId = void 0 !== a.channelId ? a.channelId : kt, a.host = (r = a.host) && !/^https?/.test(r) ? "https://".concat(r) : r, this.initData = Object.freeze(a);
        var c = this.initData,
          s = c.currency,
          u = c.countryCode,
          l = c.channelId,
          p = c.paymentMethod,
          d = c.merchantId,
          f = c.systemCode;
        this.metaData = Object.freeze({
          currency: s,
          countryCode: u,
          channelId: l,
          paymentMethod: p,
          merchantId: d,
          systemCode: f
        }), i.reportData("constructor_end", a);
      } catch (e) {
        i.handleError(e, "constructor_error");
      }
      this.reporter = i;
    }
    return s(e, [{
      key: "initReporter",
      value: function value(e) {
        return Bn.init(e), Fn = new Hn(e);
      }
    }]), e;
  }();
  function Sf(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Pf(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Sf(Object(n), !0).forEach(function (t) {
        h(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Sf(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function Df(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = f(e);
      if (t) {
        var o = f(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);
      return d(this, n);
    };
  }
  var jf = function (e) {
    p(c, e);
    var t,
      n,
      i,
      a = Df(c);
    function c(e, t, n) {
      var i;
      o(this, c), h(u(i = a.call(this, e, n)), "isNotSupportBrowser", !0), h(u(i), "checkIsInSupportBrowser", function () {
        var e;
        if (i.renderChecker.isInSupportBrowser(), i.scene instanceof od && ld()) throw null === (e = i.reporter) || void 0 === e || e.reportData("init_not_support_browser"), new Yt("The browser version is too low and incompatible, payment failed", Vt.NotSupportBrowser, "NotSupportBrowser");
        i.isNotSupportBrowser = !1;
      }), h(u(i), "init", function () {
        var e = r(A.mark(function e(t) {
          var n, r, o, a;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (e.prev = 0, null === (n = i.reporter) || void 0 === n || n.reportData("init_start"), !i.scene || !i.scene.beforeInit) {
                    e.next = 5;
                    break;
                  }
                  return e.next = 5, i.scene.beforeInit(Object.assign({}, i.metaData, {
                    language: i.parseLanguage()
                  }));
                case 5:
                  return e.next = 7, i.renderChecker.getResultOrCheck();
                case 7:
                  return zl.init(null === (r = i.initData) || void 0 === r ? void 0 : r.language, {
                    env: null === (o = i.config) || void 0 === o ? void 0 : o.slI18nEnv,
                    retryOptions: null == t ? void 0 : t.retryOptions
                  }), i.checkIsInSupportBrowser(), e.next = 11, i.initRender();
                case 11:
                  return e.abrupt("return", u(i));
                case 14:
                  e.prev = 14, e.t0 = e["catch"](0), null === (a = i.reporter) || void 0 === a || a.handleError(e.t0, "init_error");
                case 17:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[0, 14]]);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }()), h(u(i), "renderWidget", function () {
        var e = r(A.mark(function e(t) {
          var n, r, o, a, c, s, u, l, p;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (e.prev = 0, null === (n = i.reporter) || void 0 === n || n.reportData("renderWidget_start"), c = i.getRenderElement(t), !i.isNotSupportBrowser) {
                    e.next = 10;
                    break;
                  }
                  return e.next = 6, zl.get("notSupportBrowser");
                case 6:
                  return u = e.sent, ff(c, u), null === (s = i.reporter) || void 0 === s || s.reportData("renderWidget_notSupportBrowser_end"), e.abrupt("return");
                case 10:
                  return e.next = 12, null === (r = i.scene) || void 0 === r ? void 0 : r.needRenderWidget()["catch"](null === (o = i.reporter) || void 0 === o ? void 0 : o.handleError);
                case 12:
                  if (!e.sent) {
                    e.next = 18;
                    break;
                  }
                  return e.next = 16, i.render(c);
                case 16:
                  e.next = 19;
                  break;
                case 18:
                  window[window.__sl_console__ ? "__sl_console__" : "console"].warn('Payment method "'.concat(null === (l = i.metaData) || void 0 === l ? void 0 : l.paymentMethod, '" does not require rendering a widget'));
                case 19:
                  null === (a = i.reporter) || void 0 === a || a.reportData("renderWidget_end"), e.next = 25;
                  break;
                case 22:
                  e.prev = 22, e.t0 = e["catch"](0), null === (p = i.reporter) || void 0 === p || p.handleError(e.t0, "renderWidget_error");
                case 25:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[0, 22]]);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }()), h(u(i), "needRenderWidget", r(A.mark(function e() {
        var t, n, r, o, a, c, s, u, l, p;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, null === (t = i.reporter) || void 0 === t || t.reportData("needRenderWidget_start"), e.next = 4, null === (n = i.renderChecker) || void 0 === n ? void 0 : n.getResultOrCheck()["catch"](null === (r = i.reporter) || void 0 === r ? void 0 : r.handleError);
              case 4:
                if ((null == (c = e.sent) ? void 0 : c.status) !== hf.Fail) {
                  e.next = 8;
                  break;
                }
                return null === (s = i.reporter) || void 0 === s || s.reportData("needRenderWidget_checkResult_fail_end"), e.abrupt("return", !0);
              case 8:
                if (!i.isNotSupportBrowser) {
                  e.next = 11;
                  break;
                }
                return null === (u = i.reporter) || void 0 === u || u.reportData("needRenderWidget_notSupportBrowser_fail_end"), e.abrupt("return", !1);
              case 11:
                return e.next = 13, null === (o = i.scene) || void 0 === o ? void 0 : o.needRenderWidget();
              case 13:
                return l = e.sent, null === (a = i.reporter) || void 0 === a || a.reportData("needRenderWidget_end", {
                  needRenderWidget: l
                }), e.abrupt("return", l);
              case 18:
                e.prev = 18, e.t0 = e["catch"](0), null === (p = i.reporter) || void 0 === p || p.handleError(e.t0, "needRenderWidget_error");
              case 21:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[0, 18]]);
      }))), h(u(i), "validate", r(A.mark(function e() {
        var t, n, r, o, a, c, s, u, l;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, null === (t = i.reporter) || void 0 === t || t.reportData("validate_start"), e.next = 4, null === (n = i.renderChecker) || void 0 === n ? void 0 : n.getResultOrCheck()["catch"](null === (r = i.reporter) || void 0 === r ? void 0 : r.handleError);
              case 4:
                if ((null == (c = e.sent) ? void 0 : c.status) !== hf.Fail) {
                  e.next = 8;
                  break;
                }
                return null === (s = i.reporter) || void 0 === s || s.reportData("validate_checkResult_fail_end"), e.abrupt("return", !1);
              case 8:
                return e.next = 10, null === (o = i.scene) || void 0 === o ? void 0 : o.validate();
              case 10:
                return u = e.sent, null === (a = i.reporter) || void 0 === a || a.reportData("validate_end", {
                  validateResult: u
                }), e.abrupt("return", u);
              case 15:
                e.prev = 15, e.t0 = e["catch"](0), null === (l = i.reporter) || void 0 === l || l.handleError(e.t0, "validate_error");
              case 18:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[0, 15]]);
      }))), h(u(i), "getNextAction", function () {
        var e = r(A.mark(function e(t, n) {
          var r, o, a, c, s, u, l, p, d, f, h, y, m, v, g, b, w, k, x;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.prev = 0, u = "", (s = t).type === _.Confirm && (u = xf(s.url), null === (l = i.reporter) || void 0 === l || l.addReportData({
                    orderId: u
                  })), null === (r = i.reporter) || void 0 === r || r.reportData("call_getNextAction_start", {
                    nextAction: t
                  }), p = Of(), e.next = 8, null === (o = i.scene) || void 0 === o || null === (a = o.getNextAction) || void 0 === a ? void 0 : a.call(o, t, p, Pf({}, n))["catch"](function (e) {
                    var n;
                    null === (n = i.reporter) || void 0 === n || n.handleError(e, "scene_getNextAction_error", {
                      nextAction: t
                    });
                  });
                case 8:
                  if (d = e.sent) {
                    e.next = 11;
                    break;
                  }
                  throw {
                    code: Vt.InnerSDKError,
                    msg: "inner SDK error",
                    channelCode: "",
                    channelMsg: ""
                  };
                case 11:
                  return f = Pf(Pf({}, d), {}, {
                    tradeOrderId: u
                  }), null === (c = i.reporter) || void 0 === c || c.reportData("call_getNextAction_end_success", f), e.abrupt("return", f);
                case 16:
                  return e.prev = 16, e.t0 = e["catch"](0), m = "call_getNextAction_end_with_error", v = e.t0.data || {}, g = v.code, b = v.msg, w = v.channelCode, k = v.channelMsg, x = {
                    paymentError: {
                      code: g || Vt.RevealError,
                      msg: b || "Payment failed due to unknown error",
                      channelCode: w || "",
                      channelMsg: k || ""
                    }
                  }, null === (h = i.reporter) || void 0 === h || h.reportData(m, {
                    payResult: x
                  }), null === (y = i.reporter) || void 0 === y || y.reportError(e.t0, m, {
                    payResult: x,
                    nextAction: t
                  }), e.abrupt("return", x);
                case 24:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[0, 16]]);
        }));
        return function (t, n) {
          return e.apply(this, arguments);
        };
      }()), h(u(i), "afterSubmit", function () {
        var e = r(A.mark(function e(t) {
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (e.prev = 0, i.reporter.reportData("afterSubmit_start"), i.scene) {
                    e.next = 4;
                    break;
                  }
                  return e.abrupt("return");
                case 4:
                  if (!i.scene.afterSubmit) {
                    e.next = 7;
                    break;
                  }
                  return e.next = 7, i.scene.afterSubmit(t);
                case 7:
                  i.reporter.reportData("afterSubmit_end"), e.next = 13;
                  break;
                case 10:
                  e.prev = 10, e.t0 = e["catch"](0), i.reporter.handleError(e.t0, "afterSubmit_error");
                case 13:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[0, 10]]);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }()), h(u(i), "pay", function () {
        var e = r(A.mark(function e(t, n) {
          var o, a, c, s, u, l, p, d, f, h, y, m, v, g, b, w, k;
          return A.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.prev = 0, (s = t).type === _.Confirm && (l = xf(s.url), null === (u = i.reporter) || void 0 === u || u.addReportData({
                    orderId: l
                  })), null === (o = i.reporter) || void 0 === o || o.reportData("call_pay_start", {
                    nextAction: Bn.formatReportData(t)
                  }), p = Of(), e.next = 7, null === (a = i.scene) || void 0 === a ? void 0 : a.pay(t, p, Pf(Pf({}, n), {}, {
                    hooks: {
                      beforeRedirect: function () {
                        var e = r(A.mark(function e(r) {
                          var o, a;
                          return A.wrap(function (e) {
                            for (;;) {
                              switch (e.prev = e.next) {
                                case 0:
                                  if (null === (o = i.reporter) || void 0 === o || o.reportData("call_pay_end_with_before_redirect", {
                                    nextAction: t,
                                    target: r
                                  }), !n || null == n || null === (a = n.hooks) || void 0 === a || !a.beforeRedirect) {
                                    e.next = 3;
                                    break;
                                  }
                                  return e.abrupt("return", n.hooks.beforeRedirect(r));
                                case 3:
                                case "end":
                                  return e.stop();
                              }
                            }
                          }, e);
                        }));
                        return function (t) {
                          return e.apply(this, arguments);
                        };
                      }(),
                      afterRedirect: function afterRedirect(e) {
                        var r, o;
                        if (null === (r = i.reporter) || void 0 === r || r.reportData("call_pay_end_with_after_redirect", {
                          nextAction: t,
                          url: e
                        }), n && null != n && null !== (o = n.hooks) && void 0 !== o && o.afterRedirect) return n.hooks.afterRedirect(e);
                      }
                    }
                  }))["catch"](function (e) {
                    var n;
                    return null === (n = i.reporter) || void 0 === n ? void 0 : n.handleError(e, "scene_pay_error", {
                      nextAction: t
                    });
                  });
                case 7:
                  null === (c = i.reporter) || void 0 === c || c.reportData("call_pay_end_no_error"), e.next = 18;
                  break;
                case 10:
                  return e.prev = 10, e.t0 = e["catch"](0), h = "call_pay_end_with_error", y = e.t0.data || {}, m = y.code, v = y.msg, g = y.channelCode, b = y.channelMsg, w = y.tag, k = {
                    paymentError: {
                      code: m || Vt.RevealError,
                      msg: v || "Payment failed due to unknown error",
                      channelCode: g || "",
                      channelMsg: b || "",
                      tag: w
                    }
                  }, null === (d = i.reporter) || void 0 === d || d.reportData(h, {
                    payResult: k
                  }), null === (f = i.reporter) || void 0 === f || f.reportError(e.t0, h, {
                    payResult: k,
                    nextAction: Bn.formatReportData(t)
                  }), e.abrupt("return", k);
                case 18:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[0, 10]]);
        }));
        return function (t, n) {
          return e.apply(this, arguments);
        };
      }()), h(u(i), "destroy", function () {
        try {
          var e, t, n, r;
          if (null === (e = i.reporter) || void 0 === e || e.reportData("destroy_start"), i.isRenderFail) null === (n = i.reporter) || void 0 === n || n.reportData("destroy_checkResult_fail"), i.renderChecker.destroy();else null === (r = i.scene) || void 0 === r || r.destroy();
          null === (t = i.reporter) || void 0 === t || t.reportData("destroy_end");
        } catch (e) {
          var o;
          null === (o = i.reporter) || void 0 === o || o.handleError(e, "destroy_error");
        }
      }), h(u(i), "setDefaultFields", function (e) {
        i.scene instanceof pf && i.scene.setDefaultFields(e);
      });
      try {
        if (i.isRenderFail = !1, i.element = t, !i.config) throw new Error("config  is required.");
        i.scene = df(i.config, i.initData), i.renderChecker = new kf(i.config, e, u(i)), i.checkIsInSupportBrowser();
      } catch (e) {
        var s;
        null === (s = i.reporter) || void 0 === s || s.handleError(e, "constructor_error");
      }
      return i;
    }
    return s(c, [{
      key: "initRender",
      value: (i = r(A.mark(function e() {
        var t, n, r, o;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, null === (t = this.renderChecker) || void 0 === t ? void 0 : t.getResultOrCheck()["catch"](null === (n = this.reporter) || void 0 === n ? void 0 : n.handleError);
              case 2:
                if (r = e.sent, !this.scene || !this.scene.afterInit) {
                  e.next = 6;
                  break;
                }
                return e.next = 6, this.scene.afterInit(Object.assign({}, this.metaData, {
                  language: this.parseLanguage()
                }), r)["catch"](null === (o = this.reporter) || void 0 === o ? void 0 : o.handleError);
              case 6:
                if (e.t0 = this.element, !e.t0) {
                  e.next = 10;
                  break;
                }
                return e.next = 10, this.renderWidget(this.element);
              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return i.apply(this, arguments);
      })
    }, {
      key: "parseLanguage",
      value: function value() {
        var e = (this.initData || {}).language,
          t = void 0 === e ? wt : e;
        return "string" == typeof t ? t : (null == t ? void 0 : t.extend) || wt;
      }
    }, {
      key: "render",
      value: (n = r(A.mark(function e(t) {
        var n,
          r,
          o,
          i,
          a,
          c,
          s,
          u,
          l = this;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return o = ql(this.initData), null == t || t.setAttribute("ecp-dir", o ? j.RTL : j.LTR), e.next = 4, null === (n = this.renderChecker) || void 0 === n ? void 0 : n.getResultOrCheck()["catch"](null === (r = this.reporter) || void 0 === r ? void 0 : r.handleError);
              case 4:
                if ((null == (i = e.sent) ? void 0 : i.status) !== hf.Success) {
                  e.next = 17;
                  break;
                }
                if (this.scene && this.scene.setPaymentMethodInfo && this.scene.setPaymentMethodInfo(i.paymentMethodInfo), !(this.scene instanceof od || this.scene instanceof bd)) {
                  e.next = 12;
                  break;
                }
                return e.next = 10, this.scene.render(t, {
                  status: hf.Success,
                  merchantCountry: i.merchantCountry,
                  slPciStaticHost: i.slPciStaticHost,
                  grayscaleConfig: i.grayscaleConfig,
                  channelInfo: i.channelInfo
                })["catch"](function (e) {
                  var t;
                  return null === (t = l.reporter) || void 0 === t ? void 0 : t.handleError(e, "scene_render_pci_error");
                });
              case 10:
                e.next = 14;
                break;
              case 12:
                return e.next = 14, null === (c = this.scene) || void 0 === c ? void 0 : c.render(t, i)["catch"](function (e) {
                  var t;
                  return null === (t = l.reporter) || void 0 === t ? void 0 : t.handleError(e, "scene_render_error");
                });
              case 14:
                null === (a = this.reporter) || void 0 === a || a.reportData("render_success"), e.next = 23;
                break;
              case 17:
                if ((null == i ? void 0 : i.status) !== hf.Fail) {
                  e.next = 23;
                  break;
                }
                return this.isRenderFail = !0, e.next = 21, this.renderChecker.renderFail(t)["catch"](null === (s = this.reporter) || void 0 === s ? void 0 : s.handleError);
              case 21:
                throw null === (u = this.reporter) || void 0 === u || u.reportData("render_fail"), new Jt(i.msg || "RenderFail", Vt.RenderFail, "RenderFail");
              case 23:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return n.apply(this, arguments);
      })
    }, {
      key: "getRenderElement",
      value: function value(e) {
        var t = e;
        return "string" == typeof e && (t = document.querySelector(e)), t || (window[window.__sl_console__ ? "__sl_console__" : "console"].error("Please check if element ".concat(e, " exists. Note: id needs '#' prefix, class needs '.' prefix")), Bn.reportError(new Yt("render element does not exist"), "getRenderElement_error")), t;
      }
    }], [{
      key: "handleNextAction",
      value: (t = r(A.mark(function e(t, n) {
        var r, o, i, a, c, s, u, l;
        return A.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, Bn.init({
                  orderId: t.tradeOrderId
                }), delete t.tradeOrderId, Bn.reportData("call_handleNextAction_start", {
                  nextAction: t
                }), r = Of(), e.next = 7, Ep(t, {
                  payOptions: n,
                  extraParams: r
                });
              case 7:
                return e.abrupt("return", e.sent);
              case 10:
                return e.prev = 10, e.t0 = e["catch"](0), o = e.t0.data || {}, i = o.code, a = o.msg, c = o.channelCode, s = o.channelMsg, u = {
                  paymentError: {
                    code: i || Vt.RevealError,
                    msg: a || "Payment failed due to unknown error",
                    channelCode: c || "",
                    channelMsg: s || ""
                  }
                }, l = "call_handleNextAction_end_with_error", Bn.reportData(l, {
                  payResult: u
                }), Bn.reportError(e.t0, l, {
                  payResult: u,
                  nextAction: t
                }), e.abrupt("return", u);
              case 18:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[0, 10]]);
      })), function (e, n) {
        return t.apply(this, arguments);
      })
    }]), c;
  }(If);
  e.Payment = jf, e.PaymentSDKPlugin = _f, e.version = Xt, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});